(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  function track() {
    var toElement = window.event.currentTarget;
    var goal = toElement.dataset["goal"] ? toElement.dataset["goal"] : "";
    var outcome = toElement.dataset["outcome"] ? toElement.dataset["outcome"] : "";
    var data = {
      goal: goal,
      outcome: outcome
    };
    _jquery.default.ajax({
      type: "POST",
      url: "/api/sitecore/AbaAnalytics/TriggerGoalOrOutcome",
      contentType: "application/json",
      data: JSON.stringify(data)
    }).done(function (e) {}).fail(function (jqXHR, textStatus, errorThrown) {
      console.log(errorThrown);
    });
  }
  (0, _jquery.default)("a[data-goal], a[data-outcome], button[data-goal], button[data-outcome], img[data-goal], input[data-goal]").click(track);
};

},{"jquery":"jquery"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewProductDetails = exports.getTimestamp = exports.getPageData = exports.dlPush = exports.addToCartInit = exports.addToCartComplete = void 0;
var dlPush = exports.dlPush = function dlPush(obj) {
  if (window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push(obj);
  }
};
var getPageData = exports.getPageData = function getPageData() {
  var metadataEl = document.querySelector(".js-ga-metadata");
  var pageData = {};
  if (metadataEl) {
    pageData.userLoginState = metadataEl.dataset.userLoginState;
    pageData.userId = metadataEl.dataset.userId;
    pageData.pageName = metadataEl.dataset.pageName;
  }
  return pageData;
};
var getTimestamp = exports.getTimestamp = function getTimestamp() {
  var date = new Date();
  return date.toLocaleTimeString('en-US', {
    hour12: false
  });
};
var viewProductDetails = exports.viewProductDetails = function viewProductDetails(product) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    ecommerce: null
  }); // Clear the previous ecommerce object.
  dataLayer.push({
    event_data: null
  }); // Clear the previous event_data object.
  dataLayer.push({
    page_data: null
  }); // Clear the previous page_data object.
  dataLayer.push({
    user_data: null
  }); // Clear the previous user_data object.
  var pageData = getPageData();
  var price;
  if (product.ProductType === "Manual") {
    price = product.HasAgnosticPrice ? product.AgnosticPrice : product.DisplayPrice;
  } else {
    price = product.DisplayPrice;
  }
  var obj = {
    "event": product.ProductType === "Manual" ? "view_item_manual" : "view_item",
    "detailed_event": product.ProductType === "Manual" ? "Manual View Item" : "Product Viewed",
    "ecommerce": {
      "coupon": null,
      "currency": "USD",
      "items": [{
        "affiliation": product.IsMember ? "ABA Member" : "Non Member",
        "event_id": product.EventNimblePrimaryKey,
        "item_brand": product.Brand,
        "item_category": product.Category,
        "item_category2": product.WebProductCategory,
        "item_category3": product.Fulfillment,
        "item_category4": null,
        "item_id": product.ProductType === "Manual" ? product.SitecoreItemName : product.ProductId,
        "item_name": product.ProductType === "Manual" ? product.Name : product.ExternalProviderName,
        "item_variant": product.Variant,
        "quantity": "1",
        "price": price
      }],
      "value": null
    },
    "event_data": {
      "user_login_state": pageData.userLoginState
    },
    "page_data": {
      "name": pageData.pageName
    }
  };
  if (pageData.userId) {
    obj.user_data = {
      "user_id": pageData.userId
    };
  }
  dataLayer.push(obj);
};
var addToCartInit = exports.addToCartInit = function addToCartInit(product) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    ecommerce: null
  }); // Clear the previous ecommerce object.
  dataLayer.push({
    event_data: null
  }); // Clear the previous event_data object.
  dataLayer.push({
    page_data: null
  }); // Clear the previous page_data object.
  dataLayer.push({
    user_data: null
  }); // Clear the previous user_data object.
  var pageData = getPageData();
  var price;
  if (product.ProductType === "Manual") {
    price = product.HasAgnosticPrice ? product.AgnosticPrice : product.DisplayPrice;
  } else {
    price = product.DisplayPrice;
  }
  var obj = {
    "event": product.ProductType === "Manual" ? "add_to_cart_initiate_manual" : "add_to_cart_initiate",
    "detailed_event": product.ProductType === "Manual" ? "Add to Cart Initiate Manual" : "Add to Cart Initiate",
    "ecommerce": {
      "coupon": null,
      "currency": "USD",
      "items": [{
        "affiliation": product.IsMember ? "ABA Member" : "Non Member",
        "event_id": product.EventNimblePrimaryKey,
        "item_brand": product.Brand,
        "item_category": product.Category,
        "item_category2": product.WebProductCategory,
        "item_category3": product.Fulfillment,
        "item_category4": null,
        "item_id": product.ProductType === "Manual" ? product.SitecoreItemName : product.ProductId,
        "item_name": product.ProductType === "Manual" ? product.Name : product.ExternalProviderName,
        "item_variant": product.Variant,
        "quantity": "1",
        "price": price
      }],
      "value": null
    },
    "event_data": {
      "timestamp": getTimestamp(),
      "user_login_state": pageData.userLoginState
    },
    "page_data": {
      "name": pageData.pageName
    }
  };
  if (pageData.userId) {
    obj.user_data = {
      "user_id": pageData.userId
    };
  }
  dataLayer.push(obj);
};
var addToCartComplete = exports.addToCartComplete = function addToCartComplete(product) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    ecommerce: null
  }); // Clear the previous ecommerce object.
  dataLayer.push({
    event_data: null
  }); // Clear the previous event_data object.
  dataLayer.push({
    page_data: null
  }); // Clear the previous page_data object.
  dataLayer.push({
    user_data: null
  }); // Clear the previous user_data object.
  var pageData = getPageData();
  var price;
  if (product.ProductType === "Manual") {
    price = product.HasAgnosticPrice ? product.AgnosticPrice : product.DisplayPrice;
  } else {
    price = product.DisplayPrice;
  }
  var obj = {
    "event": "add_to_cart",
    "detailed_event": "Add to Cart",
    "ecommerce": {
      "coupon": null,
      "currency": "USD",
      "items": [{
        "affiliation": product.IsMember ? "ABA Member" : "Non Member",
        "event_id": product.EventNimblePrimaryKey,
        "item_brand": product.Brand,
        "item_category": product.Category,
        "item_category2": product.WebProductCategory,
        "item_category3": product.Fulfillment,
        "item_category4": null,
        "item_id": product.ProductType === "Manual" ? product.SitecoreItemName : product.ProductId,
        "item_name": product.ProductType === "Manual" ? product.Name : product.ExternalProviderName,
        "item_variant": product.Variant,
        "quantity": "1",
        "price": price
      }],
      "value": null
    },
    "event_data": {
      "timestamp": getTimestamp(),
      "user_login_state": pageData.userLoginState
    },
    "page_data": {
      "name": pageData.pageName
    }
  };
  if (pageData.userId) {
    obj.user_data = {
      "user_id": pageData.userId
    };
  }
  dataLayer.push(obj);
};

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQSValue = void 0;
var getQSValue = exports.getQSValue = function getQSValue(name, url) {
  if (!url) url = window.location.href;
  if (name === undefined || name === null) {
    var sepIndex = url.indexOf("?");
    if (sepIndex < 0) return "";else return url.substr(sepIndex + 1);
  } else {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&#]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    if (results === null) return "";else return decodeURIComponent(results[1].replace(/\+/g, " "));
  }
};

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = void 0;
var hasValue = exports.hasValue = function hasValue(val) {
  return typeof val !== "undefined" && val !== undefined && val !== null && val.length > 0;
};

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePrevious;
var _react = require("react");
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = (0, _react.useRef)();

  // Store current value in ref
  (0, _react.useEffect)(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

},{"react":"react"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSearchValues;
var R = _interopRequireWildcard(require("ramda"));
var _queryString = _interopRequireDefault(require("query-string"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULTS = {
  q: "",
  sort: "asc"
};
function useSearchValues() {
  var _window = window,
    location = _window.location;
  var search = location.search;
  var searchValues = _objectSpread(_objectSpread({}, DEFAULTS), parseSearch(search));

  // remove any values that are the default values
  // (we don't want to clutter the url)
  var removeDefaultValues = R.compose(R.fromPairs, R.reject(function (pair) {
    var _pair = _slicedToArray(pair, 2),
      key = _pair[0],
      value = _pair[1];
    return DEFAULTS[key] === value;
  }), R.toPairs);

  // function to get an href for some new values
  // eg. with url of /?bedrooms=1
  // getLocationFor({ page: 2 }) => /?bedrooms=1&page=2
  var getLocationFor = function getLocationFor(values) {
    return _objectSpread(_objectSpread({}, location), {}, {
      search: R.compose(function (s) {
        return "?".concat(s);
      }, function (obj) {
        return _queryString.default.stringify(obj, {
          arrayFormat: "comma"
        });
      }, removeDefaultValues, R.mergeLeft(values), parseSearch)(search)
    });
  };
  var apiQueryString = R.compose(function (s) {
    return "?".concat(s);
  }, function (obj) {
    return _queryString.default.stringify(obj, {
      arrayFormat: "comma"
    });
  },
  // page is base 0 for the api call
  R.over(R.lensProp("p"), function (p) {
    return R.isNil(p) || p === 0 ? 0 : p - 1;
  }), parseSearch)(search);
  return {
    searchValues: searchValues,
    getLocationFor: getLocationFor,
    apiQueryString: apiQueryString
  };
}
function parseValue(value) {
  if (!Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
    return Number(value);
  }
  if (value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
    return value.toLowerCase() === "true";
  }
  return value;
}
var parseSearch = function parseSearch(search) {
  return R.compose(R.map(parseValue), function (string) {
    return _queryString.default.parse(string, {
      arrayFormat: "comma"
    });
  })(search);
};

},{"query-string":"query-string","ramda":"ramda"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### SECONDARY NAV ACCORDION #################### */
  (0, _jquery.default)(".secondary-nav__trigger").click(function () {
    (0, _jquery.default)(this).parent().toggleClass("secondary-nav--open");
  });

  /* #################### TEXT LIST ACCORDION #################### */
  (0, _jquery.default)(".text-list .accordion-trigger").click(function () {
    (0, _jquery.default)(this).parent().toggleClass("text-list--accordion-open");
  });

  /* #################### TEXT WITH ACCORDION #################### */
  (0, _jquery.default)(".text-with-accordion .accordion-trigger").click(function () {
    (0, _jquery.default)(this).parent().toggleClass("text-with-accordion--accordion-open");
  });
  (0, _jquery.default)(".accordion-trigger").keyup(function (event) {
    //Enter key code
    if (event.keyCode === 13) {
      (0, _jquery.default)(this).click();
      var $accordion = (0, _jquery.default)(this).parent();
      var $firstHiddenItem = $accordion.find(".text-list__items__accordion-item, .text-with-accordion__accordion-item").first();
      $firstHiddenItem.addClass("show-focus");
      $firstHiddenItem.on("blur", function () {
        $firstHiddenItem.removeClass("show-focus");
      });
      $firstHiddenItem.focus();
    }
  });
};

},{"jquery":"jquery"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### BACK TO TOP #################### */
  /* ########## CLICK ########## */
  (0, _jquery.default)(".back-to-top__trigger").click(function () {
    (0, _jquery.default)("html,body").animate({
      scrollTop: 0
    }, 300);
  });

  /* ########## SCROLL ########## */
  (0, _jquery.default)(window).scroll(function () {
    var scrollAmount = (0, _jquery.default)(window).scrollTop();
    if (scrollAmount >= (0, _jquery.default)(window).innerHeight()) {
      (0, _jquery.default)(".back-to-top").addClass("back-to-top--visible");
    } else {
      (0, _jquery.default)(".back-to-top").removeClass("back-to-top--visible");
    }
  });

  /* ########## KEYBOARD/A11Y ########## */
  (0, _jquery.default)(".back-to-top__trigger").keyup(function (event) {
    //Enter & spacebar key code
    if (event.keyCode === 13 || event.keyCode === 32) {
      (0, _jquery.default)(this).click();
      (0, _jquery.default)('html,body').animate({
        scrollTop: 0
      }, 300);
    }
  });
};

},{"jquery":"jquery"}],9:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _formik = require("formik");
var _validationSchema = _interopRequireWildcard(require("../validationSchema.js"));
var _StepOne = _interopRequireDefault(require("./StepOne.jsx"));
var _StepTwo = _interopRequireDefault(require("./StepTwo.jsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var propTypes = {};
var BankerPairingForm = function BankerPairingForm(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: _validationSchema.initialValues,
    validateOnBlur: false,
    validationSchema: _validationSchema.default
  }, function (props) {
    return /*#__PURE__*/_react.default.createElement(_formik.Form, {
      className: "banker-pairing-form aba-container aba-container--100"
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.MemoryRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/"
    }, /*#__PURE__*/_react.default.createElement(_StepOne.default, props)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "/confirmation"
    }, /*#__PURE__*/_react.default.createElement(_StepTwo.default, props)))));
  });
};
BankerPairingForm.propTypes = propTypes;
var _default = exports.default = BankerPairingForm;

},{"../validationSchema.js":16,"./StepOne.jsx":10,"./StepTwo.jsx":11,"formik":"formik","react":"react","react-router-dom":"react-router-dom"}],10:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactRouterDom = require("react-router-dom");
var _BankerPairingFormContext = require("../context/BankerPairingFormContext.jsx");
var _formik = require("formik");
var _FormField = _interopRequireDefault(require("../../Form/FormField/FormField.jsx"));
var _ErrorMessage = _interopRequireDefault(require("../../Form/ErrorMessage/ErrorMessage.jsx"));
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  history: _propTypes.object,
  setFieldValue: _propTypes.func,
  // Formik prop
  values: _propTypes.object,
  // Formik prop
  validateForm: _propTypes.func,
  // Formik prop
  dirty: _propTypes.bool // Formik prop
};
var StepOne = function StepOne(props) {
  var _useBankerPairingForm = (0, _BankerPairingFormContext.useBankerPairingFormContext)(),
    dictionary = _useBankerPairingForm.dictionary,
    _useBankerPairingForm2 = _useBankerPairingForm.constants,
    api = _useBankerPairingForm2.api,
    sourceId = _useBankerPairingForm2.sourceId,
    fields = _useBankerPairingForm.data.fields;
  var ProgramEventRequestor = fields.ProgramEventRequestor,
    ProgramEventRequestorPairingModules = fields.ProgramEventRequestorPairingModules;
  var history = props.history,
    values = props.values,
    validateForm = props.validateForm,
    dirty = props.dirty;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isValidating = _useState2[0],
    setIsValidating = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  (0, _react.useEffect)(function () {
    document.title = "Banker Pairing Form";
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);
  var alertUser = function alertUser(e) {
    if (dirty) {
      e.preventDefault();
      e.returnValue = "Are you sure you want to leave?";
    }
  };
  (0, _react.useEffect)(function () {
    window.addEventListener("beforeunload", alertUser);
    return function () {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, [dirty]);
  var handleContinue = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsValidating(true);
            setIsLoading(true);
            _context.n = 1;
            return validateForm().then(function (errors) {
              if (!R.isEmpty(errors)) {
                setIsLoading(false);
                setTimeout(function () {
                  var error = document.querySelector(".aba-form__field--invalid");
                  if (error) {
                    error.querySelector("input, select").focus({
                      preventScroll: true
                    });
                    error.scrollIntoView({
                      behavior: "smooth",
                      block: "start"
                    });
                  }
                }, 0);
              } else {
                fetch(api.SUBMIT, {
                  method: "POST",
                  body: JSON.stringify({
                    Accepts: values.Accepts,
                    Reason: values.Reason,
                    PairingId: fields.Id,
                    DatasourceId: sourceId
                  }),
                  headers: {
                    "Content-Type": "application/json"
                  }
                }).then(function (response) {
                  return response.json();
                }).then(function (data) {
                  if (data.Success) {
                    setIsLoading(false);
                    history.push("/confirmation");
                  } else {
                    setIsLoading(false);
                    setErrorMessage(data.Errors.ErrorMessage);
                  }
                }).catch(function (error) {
                  setIsLoading(false);
                  console.error(error);
                });
              }
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleContinue() {
      return _ref.apply(this, arguments);
    };
  }();
  var groupedPrograms = R.compose(R.groupBy(R.prop("ProgramEventName")), R.map(R.prop("ProgramEventModule")))(ProgramEventRequestorPairingModules.ProgramEventModules);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-pairing-form__description",
    dangerouslySetInnerHTML: {
      __html: dictionary.Introduction
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-pairing-form__section"
  }, /*#__PURE__*/_react.default.createElement("h2", null, dictionary.RequestDetailsHeader), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.RequestDetailsDescription
    }
  }), /*#__PURE__*/_react.default.createElement("h3", null, dictionary.AboutRequestorLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-pairing-form__data"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.FirstName, " ", ProgramEventRequestor.LastName), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.CompanyName), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.CompanyType), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.AddressLine1), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.AddressLine2), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.City, ", ", ProgramEventRequestor.State, " ", ProgramEventRequestor.ZipCode), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.Phone), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.Email))), /*#__PURE__*/_react.default.createElement("h3", null, dictionary.RequestedEventLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-pairing-form__data"
  }, /*#__PURE__*/_react.default.createElement("ul", null, Object.keys(groupedPrograms).map(function (programName) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", null, programName, /*#__PURE__*/_react.default.createElement("ul", null, groupedPrograms[programName].map(function (program) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: program.Id
      }, program.Name);
    }))));
  }), fields.EstimatedEventDate && /*#__PURE__*/_react.default.createElement("li", null, dictionary.EventDateLabel, ": ", fields.EstimatedEventDate), /*#__PURE__*/_react.default.createElement("li", null, dictionary.EventLocationLabel, ": ", fields.CityState), /*#__PURE__*/_react.default.createElement("li", null, dictionary.EventAttendeesLabel, ": ", fields.EstimatedAttendees), fields.AdditionalInformation && /*#__PURE__*/_react.default.createElement("li", null, dictionary.EventAdditionalInformationLabel, ":", " ", fields.AdditionalInformation)), ProgramEventRequestor.ServeLowToModerate && /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.ServesLowToModerateDescription
    }
  })), /*#__PURE__*/_react.default.createElement("h3", null, dictionary.ResponseLabel), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    type: "radiogroup",
    name: "Accepts",
    isValidating: isValidating
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "Accepts",
    type: "radio",
    value: "true"
  }), /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: dictionary.AcceptText
    }
  })), /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    id: "UserResponseDecline",
    name: "Accepts",
    type: "radio",
    value: "false"
  }), /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: dictionary.DeclineText
    }
  }))), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    name: "Reason",
    disabled: values.Accepts !== "false",
    isValidating: isValidating,
    "aria-labelledby": "UserResponseDecline"
  })), /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
    errorMessage: errorMessage
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "btn btn-primary",
    onClick: handleContinue,
    disabled: isLoading
  }, isLoading ? "Saving..." : "Save"));
};
StepOne.propTypes = propTypes;
var _default = exports.default = (0, _reactRouterDom.withRouter)(StepOne);

},{"../../Form/ErrorMessage/ErrorMessage.jsx":60,"../../Form/FormField/FormField.jsx":61,"../context/BankerPairingFormContext.jsx":12,"formik":"formik","prop-types":"prop-types","ramda":"ramda","react":"react","react-router-dom":"react-router-dom"}],11:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _BankerPairingFormContext = require("../context/BankerPairingFormContext.jsx");
var _helpers = require("../helpers.js");
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var propTypes = {
  values: _propTypes.object // Formik prop
};
var StepTwo = function StepTwo(props) {
  var _useBankerPairingForm = (0, _BankerPairingFormContext.useBankerPairingFormContext)(),
    dictionary = _useBankerPairingForm.dictionary,
    fields = _useBankerPairingForm.data.fields;
  var values = props.values;
  var ProgramEventRequestor = fields.ProgramEventRequestor,
    ProgramEventRequestorPairingModules = fields.ProgramEventRequestorPairingModules;
  (0, _react.useEffect)(function () {
    (0, _helpers.setTitle)("Confirmation");
  }, []);
  var userDeclined = values.Accepts === "false";
  var groupedPrograms = R.compose(R.groupBy(R.prop("ProgramEventName")), R.map(R.prop("ProgramEventModule")))(ProgramEventRequestorPairingModules.ProgramEventModules);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: !userDeclined ? dictionary.ConfirmationText : dictionary.DeclineStepTextHeader
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-pairing-form__section"
  }, userDeclined && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, dictionary.DeclineLabel), /*#__PURE__*/_react.default.createElement("p", null, values.Reason)), /*#__PURE__*/_react.default.createElement("h3", null, dictionary.AboutRequestorLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-pairing-form__data"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.FirstName, " ", ProgramEventRequestor.LastName), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.CompanyName), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.CompanyType), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.AddressLine1), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.AddressLine2), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.City, ", ", ProgramEventRequestor.State, " ", ProgramEventRequestor.ZipCode), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.Phone), /*#__PURE__*/_react.default.createElement("li", null, ProgramEventRequestor.Email))), /*#__PURE__*/_react.default.createElement("h3", null, dictionary.RequestedEventLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-pairing-form__data"
  }, /*#__PURE__*/_react.default.createElement("ul", null, Object.keys(groupedPrograms).map(function (programName) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", null, programName, /*#__PURE__*/_react.default.createElement("ul", null, groupedPrograms[programName].map(function (program) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: program.Id
      }, program.Name);
    }))));
  }), fields.EstimatedEventDate && /*#__PURE__*/_react.default.createElement("li", null, dictionary.EventDateLabel, ": ", fields.EstimatedEventDate), /*#__PURE__*/_react.default.createElement("li", null, dictionary.EventLocationLabel, ": ", fields.CityState), /*#__PURE__*/_react.default.createElement("li", null, dictionary.EventAttendeesLabel, ": ", fields.EstimatedAttendees), fields.AdditionalInformation && /*#__PURE__*/_react.default.createElement("li", null, dictionary.EventAdditionalInformationLabel, ":", " ", fields.AdditionalInformation)), ProgramEventRequestor.ServeLowToModerate && /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.ServesLowToModerateDescription
    }
  }))));
};
StepTwo.propTypes = propTypes;
var _default = exports.default = StepTwo;

},{"../context/BankerPairingFormContext.jsx":12,"../helpers.js":14,"prop-types":"prop-types","ramda":"ramda","react":"react"}],12:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBankerPairingFormContext = exports.BankerPairingFormProvider = exports.BankerPairingFormContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _actionHandlers = require("./actionHandlers.js");
var R = _interopRequireWildcard(require("ramda"));
var _excluded = ["dictionary", "data", "api", "sourceId"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var BankerPairingFormContext = exports.BankerPairingFormContext = /*#__PURE__*/(0, _react.createContext)();
var propTypes = {
  dictionary: _propTypes.object,
  data: _propTypes.object,
  api: _propTypes.object,
  sourceId: _propTypes.string
};
var initialState = {};
var stateReducer = function stateReducer(state, action) {
  // console.log(action.type, action.payload);

  if (_actionHandlers.actionHandlers[action.type]) {
    return _actionHandlers.actionHandlers[action.type].reducer(state, action);
  }

  // if an action wasn't found, log a warning
  console.warn("Action not found!", action);
  return state;
};
var BankerPairingFormProvider = exports.BankerPairingFormProvider = function BankerPairingFormProvider(props) {
  var dictionary = props.dictionary,
    data = props.data,
    api = props.api,
    sourceId = props.sourceId,
    rest = _objectWithoutProperties(props, _excluded);
  var _useReducer = (0, _react.useReducer)(stateReducer, _objectSpread(_objectSpread({}, initialState), rest)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var context = {
    dictionary: dictionary,
    state: state,
    constants: {
      api: api,
      sourceId: sourceId
    },
    data: data,
    actions: R.compose(R.map(function (fn) {
      return function () {
        return dispatch(fn.apply(void 0, arguments));
      };
    }), R.pluck("action"))(_actionHandlers.actionHandlers)
  };
  return /*#__PURE__*/_react.default.createElement(BankerPairingFormContext.Provider, _extends({
    value: context
  }, props));
};
var useBankerPairingFormContext = exports.useBankerPairingFormContext = function useBankerPairingFormContext() {
  return (0, _react.useContext)(BankerPairingFormContext);
};
BankerPairingFormProvider.propTypes = propTypes;

},{"./actionHandlers.js":13,"prop-types":"prop-types","ramda":"ramda","react":"react"}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionHandlers = void 0;
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var actionHandlers = exports.actionHandlers = {
  setCurrentStep: {
    action: function action(currentStep) {
      return {
        type: "setCurrentStep",
        payload: {
          currentStep: currentStep
        }
      };
    },
    reducer: function reducer(state, action) {
      var currentStep = action.payload.currentStep;
      return _objectSpread(_objectSpread({}, state), {}, {
        currentStep: currentStep - 1
      });
    }
  },
  setTopics: {
    action: function action(topics) {
      return {
        type: "setTopics",
        payload: {
          topics: topics
        }
      };
    },
    reducer: function reducer(state, action) {
      var topics = action.payload.topics;
      return _objectSpread(_objectSpread({}, state), {}, {
        topics: topics
      });
    }
  },
  setBankLocations: {
    action: function action(bankLocations) {
      return {
        type: "setBankLocations",
        payload: {
          bankLocations: bankLocations
        }
      };
    },
    reducer: function reducer(state, action) {
      var bankLocations = action.payload.bankLocations;
      return _objectSpread(_objectSpread({}, state), {}, {
        bankLocations: bankLocations
      });
    }
  }
};

},{"ramda":"ramda"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTitle = void 0;
var setTitle = exports.setTitle = function setTitle(title) {
  document.title = title;
  var pageBannerEl = document.querySelector(".page-banner ul:not(.breadcrumbs) > li");
  if (pageBannerEl) {
    pageBannerEl.innerHTML = title;
  }
};

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireDefault(require("react"));
var _BankerPairingForm = _interopRequireDefault(require("./components/BankerPairingForm.jsx"));
var _BankerPairingFormContext = require("./context/BankerPairingFormContext.jsx");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var initBankerPairingForm = function initBankerPairingForm() {
  document.querySelectorAll(".js-banker-pairing-form-mount").forEach(function (mount) {
    if (mount) {
      _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_BankerPairingFormContext.BankerPairingFormProvider, {
        dictionary: JSON.parse(mount.dataset.dictionary),
        data: {
          fields: JSON.parse(mount.dataset.fields)
        },
        sourceId: mount.dataset.datasourceid,
        api: {
          SUBMIT: mount.dataset.submiturl
        }
      }, /*#__PURE__*/_react.default.createElement(_BankerPairingForm.default, null)), mount);
    }
  });
};
var _default = exports.default = initBankerPairingForm;

},{"./components/BankerPairingForm.jsx":9,"./context/BankerPairingFormContext.jsx":12,"react":"react","react-dom":"react-dom"}],16:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports.default = void 0;
var Yup = _interopRequireWildcard(require("yup"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var initialValues = exports.initialValues = {
  Accepts: ""
};
var CommunityOrganizerFormSchema = Yup.object().shape({
  Accepts: Yup.string().required("Field is required."),
  Reason: Yup.mixed().when("Accepts", {
    is: "false",
    then: Yup.string().required("Field is required.")
  })
});
var _default = exports.default = CommunityOrganizerFormSchema;

},{"yup":"yup"}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("prop-types");
var _reactRouterDom = require("react-router-dom");
var _StepOne = _interopRequireDefault(require("./StepOne.jsx"));
var _StepTwo = _interopRequireDefault(require("./StepTwo.jsx"));
var _StepThree = _interopRequireDefault(require("./StepThree.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var propTypes = {};
var BankerRegistrationForm = function BankerRegistrationForm(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-registration-form aba-container aba-container--100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "content__jump",
    "aria-hidden": "false",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.MemoryRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/_react.default.createElement(_StepOne.default, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/step-2"
  }, /*#__PURE__*/_react.default.createElement(_StepTwo.default, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/confirmation"
  }, /*#__PURE__*/_react.default.createElement(_StepThree.default, null)))));
};
BankerRegistrationForm.propTypes = propTypes;
var _default = exports.default = BankerRegistrationForm;

},{"./StepOne.jsx":21,"./StepThree.jsx":22,"./StepTwo.jsx":23,"prop-types":"prop-types","react":"react","react-router-dom":"react-router-dom"}],18:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _formik = require("formik");
var _validationSchema = require("../validationSchema.js");
var _GoogleMapsSearch = _interopRequireDefault(require("../../Form/GoogleMapsSearch/GoogleMapsSearch.jsx"));
var _ErrorMessage = _interopRequireDefault(require("../../Form/ErrorMessage/ErrorMessage.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  program: _propTypes.object,
  location: _propTypes.object,
  handleSaveLocation: _propTypes.func.isRequired,
  handleDeleteLocation: _propTypes.func.isRequired,
  handleCancel: _propTypes.func.isRequired,
  isSavingLocation: _propTypes.bool,
  errorMessage: _propTypes.string
};
var LocationSubForm = function LocationSubForm(props) {
  var program = props.program,
    location = props.location,
    handleSaveLocation = props.handleSaveLocation,
    handleDeleteLocation = props.handleDeleteLocation,
    handleCancel = props.handleCancel,
    isSavingLocation = props.isSavingLocation,
    errorMessage = props.errorMessage;
  var _useState = (0, _react.useState)(location),
    _useState2 = _slicedToArray(_useState, 2),
    locationState = _useState2[0],
    setLocationState = _useState2[1];
  var City = location.City,
    State = location.State,
    Presentations = location.Presentations,
    Attendees = location.Attendees,
    EmployeesVolunteers = location.EmployeesVolunteers,
    GeoLocationLatitude = location.GeoLocationLatitude,
    GeoLocationLongitude = location.GeoLocationLongitude;
  (0, _react.useEffect)(function () {
    if (location.City || location.State) {
      setLocationState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          cityState: "".concat(location.City, ", ").concat(location.State)
        });
      });
    }
  }, [location]);
  var onSaveLocation = function onSaveLocation() {
    handleSaveLocation({
      Id: locationState.Id || null,
      Attendees: locationState.Attendees,
      ProgramEventUserId: program.ProgramEventUserId,
      EmployeesVolunteers: locationState.EmployeesVolunteers,
      GeoLocationLatitude: locationState.GeoLocationLatitude,
      GeoLocationLongitude: locationState.GeoLocationLongitude,
      Name: null,
      Presentations: locationState.Presentations,
      RawLocationQuery: locationState.RawLocationQuery
    });
  };
  var onDeleteLocation = function onDeleteLocation() {
    handleDeleteLocation(location.Id);
  };
  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: {
      cityState: City || State ? "".concat(City, ", ").concat(State) : "",
      Presentations: Presentations || "",
      Attendees: Attendees || "",
      EmployeesVolunteers: EmployeesVolunteers || "",
      GeoLocationLatitude: GeoLocationLatitude || null,
      GeoLocationLongitude: GeoLocationLongitude || null,
      RawLocationQuery: City || State ? "".concat(City, ", ").concat(State) : ""
    }
  }, function (_ref) {
    var values = _ref.values,
      setFieldValue = _ref.setFieldValue,
      validateForm = _ref.validateForm,
      errors = _ref.errors,
      touched = _ref.touched;
    var updateField = function updateField(name, value) {
      setLocationState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, value));
      });
      setFieldValue(name, value);
    };
    var hasError = function hasError(key) {
      return isSavingLocation && errors[key] || touched[key] && errors[key];
    };
    var displayError = function displayError(key) {
      return hasError(key) ? errors[key] : null;
    };
    var onClickSave = function onClickSave() {
      validateForm().then(function (e) {
        if (R.isEmpty(e)) {
          onSaveLocation();
        } else {
          document.querySelector(".aba-form__field--invalid label").focus();
        }
      });
    };
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("aba-form__field", {
        "aba-form__field--invalid": hasError("RawLocationQuery")
      })
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "RawLocationQuery"
    }, program.CityStateLabel), /*#__PURE__*/_react.default.createElement("p", {
      id: "cityState-instructions"
    }, program.CityStateDescription), /*#__PURE__*/_react.default.createElement(_formik.Field, {
      className: "form-control",
      id: "RawLocationQuery",
      name: "RawLocationQuery",
      placeholder: "",
      "aria-invalid": hasError("cityState") ? "true" : null,
      "aria-describedby": hasError("RawLocationQuery") ? "RawLocationQuery-error" : "RawLocationQuery-instructions",
      onChange: function onChange(e) {
        return updateField("RawLocationQuery", e.target.value);
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      id: "cityState-error",
      className: "aba-form__error-message",
      "aria-atomic": "true",
      "aria-hidden": errors.cityState ? false : true
    }, displayError("cityState"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "aba-form__fields--inline"
    }, !program.DisablePresentationForm && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("aba-form__field", {
        "aba-form__field--invalid": hasError("Presentations")
      })
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "presentations"
    }, program.PresentationLabel), /*#__PURE__*/_react.default.createElement(_formik.Field, {
      id: "presentations",
      name: "Presentations",
      type: "number",
      className: "form-control",
      validate: _validationSchema.validateGreaterThanZero,
      "aria-invalid": hasError("Presentations") ? "true" : null,
      "aria-describedby": hasError("Presentations") ? "presentations-error" : null,
      onChange: function onChange(e) {
        return updateField("Presentations", parseFloat(e.target.value));
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      id: "presentations-error",
      className: "aba-form__error-message",
      "aria-atomic": "true",
      "aria-hidden": errors.Presentations ? false : true,
      role: "alert"
    }, displayError("Presentations"))), !program.DisableAttendeesForm && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("aba-form__field", {
        "aba-form__field--invalid": hasError("Attendees")
      })
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "attendees"
    }, program.AttendeesLabel), /*#__PURE__*/_react.default.createElement(_formik.Field, {
      id: "attendees",
      name: "Attendees",
      type: "number",
      className: "form-control",
      validate: _validationSchema.validateGreaterThanZero,
      "aria-invalid": hasError("Attendees") ? "true" : null,
      "aria-describedby": hasError("Attendees") ? "attendees-error" : null,
      onChange: function onChange(e) {
        return updateField("Attendees", parseFloat(e.target.value));
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      id: "attendees-error",
      className: "aba-form__error-message",
      "aria-atomic": "true",
      "aria-hidden": errors.Attendees ? false : true,
      role: "alert"
    }, displayError("Attendees"))), !program.DisableEmployeeForm && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("aba-form__field", {
        "aba-form__field--invalid": hasError("EmployeesVolunteers")
      })
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "employeesVolunteers"
    }, program.EmployeeLabel), /*#__PURE__*/_react.default.createElement(_formik.Field, {
      id: "employeesVolunteers",
      name: "EmployeesVolunteers",
      type: "number",
      className: "form-control",
      validate: _validationSchema.validateGreaterThanZero,
      "aria-invalid": hasError("EmployeesVolunteers") ? "true" : null,
      "aria-describedby": hasError("EmployeesVolunteers") ? "employeesVolunteers-error" : null,
      onChange: function onChange(e) {
        return updateField("EmployeesVolunteers", parseFloat(e.target.value));
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      id: "employeesVolunteers-error",
      className: "aba-form__error-message",
      "aria-atomic": "true",
      "aria-hidden": errors.EmployeesVolunteers ? false : true
    }, displayError("EmployeesVolunteers")))), /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
      errorMessage: errorMessage
    }), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "btn btn-primary",
      onClick: onClickSave
    }, isSavingLocation ? "Saving..." : "Save"), !R.isEmpty(location) && /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "btn btn-outline",
      onClick: onDeleteLocation
    }, "Delete"), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "btn btn-outline",
      onClick: handleCancel
    }, "Cancel"));
  });
};
LocationSubForm.propTypes = propTypes;
var _default = exports.default = LocationSubForm;

},{"../../Form/ErrorMessage/ErrorMessage.jsx":60,"../../Form/GoogleMapsSearch/GoogleMapsSearch.jsx":62,"../validationSchema.js":28,"classnames":"classnames","formik":"formik","prop-types":"prop-types","ramda":"ramda","react":"react"}],19:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  location: (0, _propTypes.shape)({
    City: _propTypes.string,
    State: _propTypes.string,
    Presentations: _propTypes.number,
    Attendees: _propTypes.number,
    EmployeesVolunteers: _propTypes.number
  }),
  onClickEdit: _propTypes.func
};
var LocationSummary = function LocationSummary(props) {
  var location = props.location,
    onClickEdit = props.onClickEdit;
  var renderText = function renderText() {
    var dictionary = {
      presentation: location.Presentations,
      attendee: location.Attendees,
      volunteer: location.EmployeesVolunteers
    };
    return R.compose(function (s) {
      return s.join(", ");
    }, R.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];
      return val === 1 ? "".concat(val, " ").concat(key) : "".concat(val, " ").concat(key, "s");
    }), R.filter(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];
      return val;
    }), R.toPairs)(dictionary);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "location-summary"
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    className: "link",
    onClick: function onClick() {
      return onClickEdit(location);
    },
    onKeyPress: function onKeyPress() {
      return onClickEdit(location);
    },
    tabIndex: "0"
  }, location.City, ", ", location.State), /*#__PURE__*/_react.default.createElement("p", null, renderText()));
};
LocationSummary.propTypes = propTypes;
var _default = exports.default = LocationSummary;

},{"prop-types":"prop-types","ramda":"ramda","react":"react"}],20:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _formik = require("formik");
var _BankerRegistrationFormContext = require("../context/BankerRegistrationFormContext.jsx");
var _Checkbox = _interopRequireDefault(require("../../Form/Checkbox/Checkbox.jsx"));
var _LocationSummary = _interopRequireDefault(require("./LocationSummary.jsx"));
var _LocationSubForm = _interopRequireDefault(require("./LocationSubForm.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _lodash = _interopRequireDefault(require("lodash.uniqueid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  program: _propTypes.object
};
var ParticipatingLocations = function ParticipatingLocations(props) {
  var _useBankerRegistratio = (0, _BankerRegistrationFormContext.useBankerRegistrationFormContext)(),
    api = _useBankerRegistratio.constants.api,
    selectedPrograms = _useBankerRegistratio.state.selectedPrograms,
    _useBankerRegistratio2 = _useBankerRegistratio.actions,
    updateProgram = _useBankerRegistratio2.updateProgram,
    selectPrograms = _useBankerRegistratio2.selectPrograms;
  var program = props.program;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showLocationForm = _useState4[0],
    setShowLocationForm = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSavingLocation = _useState6[0],
    setIsSavingLocation = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];

  // Initialize default values
  (0, _react.useEffect)(function () {
    selectPrograms(selectedPrograms.map(function (program) {
      return _objectSpread(_objectSpread({}, program), {}, {
        AcceptsProgramParticipation: !program.FinEdLinkDescription ? false : program.AcceptsProgramParticipation || !program.IsRegistered || false,
        Locations: program.Locations || []
      });
    }));
  }, []);
  var toggleAddLocation = function toggleAddLocation() {
    setLocation({});
    setShowLocationForm(true);
  };
  var toggleEditLocation = function toggleEditLocation(location) {
    setLocation(location);
    setShowLocationForm(true);
  };

  // Add/Edit Api
  var saveLocation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(location) {
      var locations;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsSavingLocation(true);
            locations = program.Locations;
            return _context.a(2, fetch(api.ADD_LOCATION, {
              method: "POST",
              body: JSON.stringify(location),
              headers: {
                "Content-Type": "application/json"
              }
            }).then(function (response) {
              return response.json();
            }).then(function (data) {
              // const randId = uniqid();
              if (data.Success) {
                var locationWithId = _objectSpread(_objectSpread({}, location), {}, {
                  Id: data.Result.Id
                });
                locationWithId.City = data.Result.City;
                locationWithId.State = data.Result.State;

                // const locationWithId = { ...location, Id: randId };

                var index = R.findIndex(R.propEq("Id", location.Id), locations);
                if (index >= 0) {
                  locations[index] = locationWithId;
                } else {
                  locations = [].concat(_toConsumableArray(program.Locations), [locationWithId]);
                }

                // Update program with new locations arr
                var updatedProgram = R.compose(R.set(R.lensProp("Locations"), locations), R.find(R.propEq("Id", program.Id)))(selectedPrograms);
                updateProgram(updatedProgram);
                setErrorMessage(null);
                setIsSavingLocation(false);
                setShowLocationForm(false);
                props.onSave(program);
              } else {
                setIsSavingLocation(false);
                setErrorMessage(data.Errors.ErrorMessage);
              }
            }).catch(function (error) {
              setIsSavingLocation(false);
              console.error(error);
            }));
        }
      }, _callee);
    }));
    return function saveLocation(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  // Delete Api
  var deleteLocation = function deleteLocation(locationId) {
    fetch(api.DELETE_LOCATION, {
      method: "POST",
      body: JSON.stringify({
        locationId: locationId
      }),
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.Success) {
        // Update program with new locations arr
        var updatedProgram = R.compose(R.set(R.lensProp("Locations"), R.filter(function (l) {
          return l.Id !== location.Id;
        }, program.Locations)), R.find(R.propEq("Id", program.Id)))(selectedPrograms);
        updateProgram(updatedProgram);
        setErrorMessage(null);
        setShowLocationForm(false);
      } else {
        setErrorMessage(data.Errors.ErrorMessage);
      }
    }).catch(function (error) {
      setShowLocationForm(false);
      console.error(error);
    });
  };
  var cancel = function cancel() {
    setShowLocationForm(false);
    setErrorMessage(null);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, program.Title), program.FinEdLinkDescription && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    name: "".concat(program.Title, "_program-participation"),
    label: "Show our bank in FinEdLink for ".concat(program.Title, ", so community organizers can find us and request presentations. (You can always refuse individual requests.)")
    /*label={program.FinEdLinkDescription} */,
    checked: R.find(R.propEq("Id", program.Id), selectedPrograms).AcceptsProgramParticipation ? true : false,
    onChange: function onChange() {
      return updateProgram(_objectSpread(_objectSpread({}, program), {}, {
        AcceptsProgramParticipation: !program.AcceptsProgramParticipation
      }));
    }
  }), showLocationForm && /*#__PURE__*/_react.default.createElement(_LocationSubForm.default, {
    program: program,
    location: location,
    handleSaveLocation: saveLocation,
    handleDeleteLocation: deleteLocation,
    handleCancel: cancel,
    isSavingLocation: isSavingLocation,
    errorMessage: errorMessage
  }), !showLocationForm && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !R.isEmpty(program.Locations) && !R.isNil(program.Locations) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "participating-locations__label"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Participating Locations"), /*#__PURE__*/_react.default.createElement("p", null, "Click a location to edit or remove it. Or, use the button below to add new locations.")), program.Locations.map(function (location, idx) {
    return /*#__PURE__*/_react.default.createElement(_LocationSummary.default, {
      key: idx,
      location: location,
      onClickEdit: toggleEditLocation
    });
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-outline",
    onClick: toggleAddLocation,
    "aria-label": " Add a participating location for ".concat(program.Title)
  }, "Add a Participating Location")));
};
ParticipatingLocations.propTypes = propTypes;
var _default = exports.default = (0, _formik.connect)(ParticipatingLocations);

},{"../../Form/Checkbox/Checkbox.jsx":58,"../context/BankerRegistrationFormContext.jsx":24,"./LocationSubForm.jsx":18,"./LocationSummary.jsx":19,"formik":"formik","lodash.uniqueid":"lodash.uniqueid","prop-types":"prop-types","ramda":"ramda","react":"react"}],21:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactRouterDom = require("react-router-dom");
var _BankerRegistrationFormContext = require("../context/BankerRegistrationFormContext.jsx");
var _helpers = require("../helpers.js");
var _Checkbox = _interopRequireDefault(require("../../Form/Checkbox/Checkbox.jsx"));
var _CheckboxGroup = _interopRequireDefault(require("../../Form/Checkbox/CheckboxGroup.jsx"));
var _ErrorMessage = _interopRequireDefault(require("../../Form/ErrorMessage/ErrorMessage.jsx"));
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  registerUrl: _propTypes.string,
  history: _propTypes.object
};
var StepOne = function StepOne(props) {
  var _useBankerRegistratio = (0, _BankerRegistrationFormContext.useBankerRegistrationFormContext)(),
    dictionary = _useBankerRegistratio.dictionary,
    _useBankerRegistratio2 = _useBankerRegistratio.constants,
    api = _useBankerRegistratio2.api,
    sourceId = _useBankerRegistratio2.sourceId,
    _useBankerRegistratio3 = _useBankerRegistratio.state,
    user = _useBankerRegistratio3.user,
    programs = _useBankerRegistratio3.programs,
    selectedPrograms = _useBankerRegistratio3.selectedPrograms,
    _useBankerRegistratio4 = _useBankerRegistratio.actions,
    selectProgram = _useBankerRegistratio4.selectProgram,
    setUser = _useBankerRegistratio4.setUser,
    setPrograms = _useBankerRegistratio4.setPrograms,
    setDictionary = _useBankerRegistratio4.setDictionary,
    selectPrograms = _useBankerRegistratio4.selectPrograms,
    updateProgram = _useBankerRegistratio4.updateProgram;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDisabled = _useState4[0],
    setIsDisabled = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var history = props.history;
  (0, _react.useEffect)(function () {
    (0, _helpers.setTitle)("Step 1 of 2");
  }, []);
  var getDefaultPrograms = R.filter(function (p) {
    return p.ProgramEventUserId !== null;
  });
  (0, _react.useEffect)(function () {
    selectPrograms(getDefaultPrograms(programs));
    setIsDisabled(true);
    if (history.location.state) {
      selectPrograms(history.location.state.selectedPrograms);
    }
    fetch("".concat(api.FETCH, "?datasourceId=").concat(sourceId), {
      method: "GET",
      credentials: "include"
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      setIsDisabled(false);
      setUser(data.UserProfile);
      setPrograms(data.Programs);
      setDictionary(data.Fields);
      selectPrograms(getDefaultPrograms(data.Programs));
    }).catch(function (error) {
      setIsDisabled(false);
      console.error(error);
    });
  }, []);
  var handleChange = function handleChange(id) {
    var program = R.find(R.propEq("Id", id), programs);
    selectProgram(program);
    setErrorMessage(null);
  };
  var handleContinue = function handleContinue() {
    setIsLoading(true);
    var defaultPrograms = getDefaultPrograms(programs);
    var additions = R.compose(R.map(function (p) {
      return {
        ProgramEventId: p.ActiveRegistrationPageEvent
      };
    }), R.difference(selectedPrograms))(defaultPrograms);
    var deletions = R.compose(R.map(function (p) {
      return {
        ProgramEventId: p.ActiveRegistrationPageEvent,
        ProgramEventUserId: p.ProgramEventUserId
      };
    }), R.difference(defaultPrograms))(selectedPrograms);
    if (!R.isEmpty(additions) || !R.isEmpty(deletions)) {
      fetch(api.REGISTER, {
        method: "POST",
        body: JSON.stringify({
          Additions: additions,
          Deletions: deletions
        }),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.Success) {
          setIsLoading(false);
          setErrorMessage(null);

          // If user has deselected all previously selected programs, redirect them to confirmation
          if (R.isEmpty(R.path(["Result", "SelectedEvents"], data)) && R.isEmpty(selectedPrograms)) {
            history.push("/confirmation");
          } else {
            selectedPrograms.map(function (p) {
              var matchingProgram = R.find(R.propEq("ProgramEventId", p.ActiveRegistrationPageEvent), data.Result.SelectedEvents);
              if (matchingProgram) {
                updateProgram(_objectSpread(_objectSpread({}, p), {}, {
                  ProgramEventUserId: matchingProgram.ProgramEventUserId
                }));
              }
            });
            history.push("/step-2");
          }
        } else {
          setIsLoading(false);
          setErrorMessage(data.Errors.ErrorMessage);
        }
      }).catch(function (error) {
        setIsLoading(false);
        console.error(error);
      });
    }
    // Validate if new user has made a selection
    else if (R.isEmpty(selectedPrograms) && R.find(R.propEq("ProgramEventUserId", null), programs)) {
      setIsLoading(false);
      setErrorMessage("Please make a selection before continuing.");
    }
    // Do nothing if no changes were made
    else {
      setIsLoading(false);
      setErrorMessage(null);
      history.push("/step-2");
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-registration-form__description",
    dangerouslySetInnerHTML: {
      __html: dictionary.Description
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-registration-form__section"
  }, /*#__PURE__*/_react.default.createElement("h2", null, dictionary.ContactHeader), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.ContactDescription
    }
  }), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("strong", null, dictionary.ContactName), " ", user.FirstName, " ", user.LastName), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("strong", null, dictionary.ContactTitle), " ", user.Title), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("strong", null, dictionary.ContactCompany), " ", user.Company), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("strong", null, dictionary.ContactNumber), " ", user.Phone), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("strong", null, dictionary.ContactEmail), " ", user.Email)), /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-outline link--external",
    href: dictionary.ProfileLink,
    target: "__blank",
    onClick: function onClick() {
      return alert("You are now being taken to another page.");
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "icon",
    focusable: "false",
    "aria-hidden": "true",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-133.000000, -574.000000)",
    fill: "#0060B9",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M149,590 L135,590 L135,576 L142,576 L142,574 L135,574 C133.89,574 133,574.9 133,576 L133,590 C133,591.1 133.89,592 135,592 L149,592 C150.1,592 151,591.1 151,590 L151,583 L149,583 L149,590 Z M144,574 L144,576 L147.59,576 L137.76,585.83 L139.17,587.24 L149,577.41 L149,581 L151,581 L151,574 L144,574 Z",
    id: "external-link"
  })))), "Update Profile")), /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-registration-form__section"
  }, /*#__PURE__*/_react.default.createElement("h2", null, dictionary.ProgramHeader), /*#__PURE__*/_react.default.createElement(_CheckboxGroup.default, {
    legend: dictionary.ProgramDescription
  }, programs.map(function (p, idx) {
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      key: idx,
      name: p.Id,
      label: p.Title,
      value: p.Id,
      disabled: isDisabled,
      checked: R.find(R.propEq("Id", p.Id), selectedPrograms) ? true : false,
      onChange: function onChange() {
        return handleChange(p.Id);
      }
    });
  }))), /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
    errorMessage: errorMessage
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary",
    onClick: handleContinue,
    disabled: isDisabled || isLoading
  }, isLoading ? "Loading..." : "Continue"));
};
StepOne.propTypes = propTypes;
var _default = exports.default = (0, _reactRouterDom.withRouter)(StepOne);

},{"../../Form/Checkbox/Checkbox.jsx":58,"../../Form/Checkbox/CheckboxGroup.jsx":59,"../../Form/ErrorMessage/ErrorMessage.jsx":60,"../context/BankerRegistrationFormContext.jsx":24,"../helpers.js":26,"prop-types":"prop-types","ramda":"ramda","react":"react","react-router-dom":"react-router-dom"}],22:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _BankerRegistrationFormContext = require("../context/BankerRegistrationFormContext.jsx");
var _helpers = require("../helpers.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var propTypes = {
  values: _propTypes.object
};
var StepThree = function StepThree(props) {
  var _useBankerRegistratio = (0, _BankerRegistrationFormContext.useBankerRegistrationFormContext)(),
    selectedPrograms = _useBankerRegistratio.state.selectedPrograms,
    dictionary = _useBankerRegistratio.dictionary;
  (0, _react.useEffect)(function () {
    (0, _helpers.setTitle)("Confirmation");
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.ConfirmationMessage
    }
  }), /*#__PURE__*/_react.default.createElement("a", {
    href: dictionary.FoundationLink,
    className: "btn btn-primary"
  }, "Go to Foundation Home"));
};
StepThree.propTypes = propTypes;
var _default = exports.default = StepThree;

},{"../context/BankerRegistrationFormContext.jsx":24,"../helpers.js":26,"prop-types":"prop-types","react":"react"}],23:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactRouterDom = require("react-router-dom");
var _BankerRegistrationFormContext = require("../context/BankerRegistrationFormContext.jsx");
var _helpers = require("../helpers.js");
var _ParticipatingLocations = _interopRequireDefault(require("./ParticipatingLocations.jsx"));
var _ErrorMessage = _interopRequireDefault(require("../../Form/ErrorMessage/ErrorMessage.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  history: _propTypes.object
};
var StepTwo = function StepTwo(props) {
  var _useBankerRegistratio = (0, _BankerRegistrationFormContext.useBankerRegistrationFormContext)(),
    dictionary = _useBankerRegistratio.dictionary,
    _useBankerRegistratio2 = _useBankerRegistratio.constants,
    api = _useBankerRegistratio2.api,
    sourceId = _useBankerRegistratio2.sourceId,
    selectedPrograms = _useBankerRegistratio.state.selectedPrograms;
  var history = props.history;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var locationErrorMessage = "Please add at least one participating location for each program above.";
  (0, _react.useEffect)(function () {
    (0, _helpers.setTitle)("Step 2 of 2");
  }, []);
  var updateLocationError = function updateLocationError(programAdded) {
    var clear = true;
    for (var i = 0; i < selectedPrograms.length; i++) {
      var program = selectedPrograms[i];
      if (!program.Locations.length && program.Id != programAdded.Id) {
        clear = false;
        break;
      }
    }
    if (clear && errorMessage === locationErrorMessage) {
      setErrorMessage(null);
    }
  };
  var handleSubmit = function handleSubmit() {
    setIsLoading(true);
    var formattedPrograms = selectedPrograms.map(function (p) {
      return {
        ProgramName: p.Name,
        ProgramResourcePage: p.ProgramResourceLink,
        ProgramEventUserId: p.ProgramEventUserId,
        AcceptsProgramParticipation: p.AcceptsProgramParticipation,
        ProgramManagerName: p.ProgramManagerName,
        ProgramManagerEmail: p.ProgramManagerEmail,
        ProgramManagerPhone: p.ProgramManagerPhone,
        Locations: p.Locations
      };
    });
    for (var i = 0; i < formattedPrograms.length; i++) {
      var program = formattedPrograms[i];
      if (!program.Locations.length) {
        setErrorMessage(locationErrorMessage);
        setIsLoading(false);
        return;
      }
    }
    fetch(api.SUBMIT, {
      method: "POST",
      body: JSON.stringify({
        Programs: formattedPrograms,
        Datasourceid: sourceId
      }),
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.Success) {
        setIsLoading(false);
        setErrorMessage(null);
        history.push("/confirmation");
      } else {
        setIsLoading(false);
        setErrorMessage(data.Errors.ErrorMessage);
      }
    }).catch(function (error) {
      setIsLoading(false);
      console.error(error);
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "banker-registration-form__section"
  }, /*#__PURE__*/_react.default.createElement("h2", null, dictionary.ParticipatingLocationsHeader), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.ParticipatingLocationsDescription
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "participating-locations"
  }, selectedPrograms.map(function (program, idx) {
    return /*#__PURE__*/_react.default.createElement(_ParticipatingLocations.default, {
      key: idx,
      program: program,
      onSave: updateLocationError
    });
  })), /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
    errorMessage: errorMessage
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary",
    onClick: function onClick() {
      return history.push({
        pathname: "/",
        state: {
          selectedPrograms: selectedPrograms
        }
      });
    }
  }, "Back"), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary",
    onClick: handleSubmit
  }, isLoading ? "Submitting..." : "Submit")));
};
StepTwo.propTypes = propTypes;
var _default = exports.default = (0, _reactRouterDom.withRouter)(StepTwo);

},{"../../Form/ErrorMessage/ErrorMessage.jsx":60,"../context/BankerRegistrationFormContext.jsx":24,"../helpers.js":26,"./ParticipatingLocations.jsx":20,"prop-types":"prop-types","react":"react","react-router-dom":"react-router-dom"}],24:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBankerRegistrationFormContext = exports.BankerRegistrationFormProvider = exports.BankerRegistrationFormContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _actionHandlers = require("./actionHandlers.js");
var R = _interopRequireWildcard(require("ramda"));
var _excluded = ["dictionary", "api", "sourceId"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var BankerRegistrationFormContext = exports.BankerRegistrationFormContext = /*#__PURE__*/(0, _react.createContext)();
var propTypes = {
  dictionary: _propTypes.object,
  api: _propTypes.object,
  sourceId: _propTypes.string
};
var initialState = {
  data: {},
  currentStep: {},
  selectedPrograms: []
};
var stateReducer = function stateReducer(state, action) {
  // console.log(action.type, action.payload);

  if (_actionHandlers.actionHandlers[action.type]) {
    return _actionHandlers.actionHandlers[action.type].reducer(state, action);
  }

  // if an action wasn't found, log a warning
  console.warn("Action not found!", action);
  return state;
};
var BankerRegistrationFormProvider = exports.BankerRegistrationFormProvider = function BankerRegistrationFormProvider(props) {
  var dictionary = props.dictionary,
    api = props.api,
    sourceId = props.sourceId,
    rest = _objectWithoutProperties(props, _excluded);
  var _useReducer = (0, _react.useReducer)(stateReducer, _objectSpread(_objectSpread({}, initialState), rest)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var context = {
    dictionary: dictionary,
    constants: {
      api: api,
      sourceId: sourceId
    },
    state: state,
    actions: R.compose(R.map(function (fn) {
      return function () {
        return dispatch(fn.apply(void 0, arguments));
      };
    }), R.pluck("action"))(_actionHandlers.actionHandlers)
  };
  return /*#__PURE__*/_react.default.createElement(BankerRegistrationFormContext.Provider, _extends({
    value: context
  }, props));
};
var useBankerRegistrationFormContext = exports.useBankerRegistrationFormContext = function useBankerRegistrationFormContext() {
  return (0, _react.useContext)(BankerRegistrationFormContext);
};
BankerRegistrationFormProvider.propTypes = propTypes;

},{"./actionHandlers.js":25,"prop-types":"prop-types","ramda":"ramda","react":"react"}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionHandlers = void 0;
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var actionHandlers = exports.actionHandlers = {
  setUser: {
    action: function action(user) {
      return {
        type: "setUser",
        payload: {
          user: user
        }
      };
    },
    reducer: function reducer(state, action) {
      var user = action.payload.user;
      return _objectSpread(_objectSpread({}, state), {}, {
        user: user
      });
    }
  },
  setPrograms: {
    action: function action(programs) {
      return {
        type: "setPrograms",
        payload: {
          programs: programs
        }
      };
    },
    reducer: function reducer(state, action) {
      var programs = action.payload.programs;
      return _objectSpread(_objectSpread({}, state), {}, {
        programs: programs
      });
    }
  },
  setDictionary: {
    action: function action(dictionary) {
      return {
        type: "setDictionary",
        payload: {
          dictionary: dictionary
        }
      };
    },
    reducer: function reducer(state, action) {
      var dictionary = action.payload.dictionary;
      return _objectSpread(_objectSpread({}, state), {}, {
        dictionary: dictionary
      });
    }
  },
  selectProgram: {
    action: function action(selectedProgram) {
      return {
        type: "selectProgram",
        payload: {
          selectedProgram: selectedProgram
        }
      };
    },
    reducer: function reducer(state, action) {
      var selectedProgram = action.payload.selectedProgram;
      var programs = state.programs;
      var selectedPrograms = state.selectedPrograms;
      var index = R.findIndex(R.propEq("Id", selectedProgram.Id), selectedPrograms);
      if (index >= 0) {
        selectedPrograms = selectedPrograms.filter(function (p) {
          return p.Id !== selectedProgram.Id;
        });
      } else {
        selectedPrograms = [].concat(_toConsumableArray(selectedPrograms), [selectedProgram]).sort(function (a, b) {
          return R.findIndex(R.propEq("Id", a.Id), programs) - R.findIndex(R.propEq("Id", b.Id), programs);
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedPrograms: selectedPrograms
      });
    }
  },
  selectPrograms: {
    action: function action(selectedPrograms) {
      return {
        type: "selectPrograms",
        payload: {
          selectedPrograms: selectedPrograms
        }
      };
    },
    reducer: function reducer(state, action) {
      var selectedPrograms = action.payload.selectedPrograms;
      var programs = state.programs;
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedPrograms: selectedPrograms.sort(function (a, b) {
          return R.findIndex(R.propEq("Id", a.Id), programs) - R.findIndex(R.propEq("Id", b.Id), programs);
        })
      });
    }
  },
  updateProgram: {
    action: function action(program) {
      return {
        type: "updateProgram",
        payload: {
          program: program
        }
      };
    },
    reducer: function reducer(state, action) {
      var program = action.payload.program;
      var programs = state.programs,
        selectedPrograms = state.selectedPrograms;
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedPrograms: [].concat(_toConsumableArray(selectedPrograms.filter(function (v) {
          return v.Id !== program.Id;
        })), [program]).sort(function (a, b) {
          return R.findIndex(R.propEq("Id", a.Id), programs) - R.findIndex(R.propEq("Id", b.Id), programs);
        })
      });
    }
  }
};

},{"ramda":"ramda"}],26:[function(require,module,exports){
arguments[4][14][0].apply(exports,arguments)
},{"dup":14}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireDefault(require("react"));
var _BankerRegistrationForm = _interopRequireDefault(require("./components/BankerRegistrationForm.jsx"));
var _BankerRegistrationFormContext = require("./context/BankerRegistrationFormContext.jsx");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var initBankerRegistrationForm = function initBankerRegistrationForm() {
  document.querySelectorAll(".js-banker-registration-form-mount").forEach(function (mount) {
    if (mount) {
      _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_BankerRegistrationFormContext.BankerRegistrationFormProvider, {
        user: JSON.parse(mount.dataset.user),
        dictionary: JSON.parse(mount.dataset.dictionary),
        programs: JSON.parse(mount.dataset.programs),
        sourceId: mount.dataset.datasourceid,
        api: {
          REGISTER: mount.dataset.registerurl,
          ADD_LOCATION: mount.dataset.locationaddurl,
          DELETE_LOCATION: mount.dataset.locationdeleteurl,
          SUBMIT: mount.dataset.submiturl,
          FETCH: mount.dataset.fetchprofileurl
        }
      }, /*#__PURE__*/_react.default.createElement(_BankerRegistrationForm.default, null)), mount);
    }
  });
};
var _default = exports.default = initBankerRegistrationForm;

},{"./components/BankerRegistrationForm.jsx":17,"./context/BankerRegistrationFormContext.jsx":24,"react":"react","react-dom":"react-dom"}],28:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateRequired = exports.validateGreaterThanZero = exports.validateGeoLocation = exports.locationSchema = void 0;
var Yup = _interopRequireWildcard(require("yup"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var locationSchema = exports.locationSchema = Yup.object().shape({
  numPresentations: Yup.number().min(1, "Greater than 1").required("Required"),
  numMaxAttendees: Yup.number().min(1, "Greater than 1"),
  numEmployeeVolunteers: Yup.number().min(1, "Greater than 1")
});
var validateRequired = exports.validateRequired = function validateRequired(value) {
  if (!value) {
    return "This field is required";
  }
};
var validateGreaterThanZero = exports.validateGreaterThanZero = function validateGreaterThanZero(value) {
  if (!value || value < 0) {
    return "Value of 1 or greater is required";
  }
};
var validateGeoLocation = exports.validateGeoLocation = function validateGeoLocation(values) {
  var error;
  if (!values.GeoLocationLongitude && !values.GeoLocationLatitude) {
    error = "Please select a predetermined location.";
  }
  return error;
};

},{"yup":"yup"}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### MULTI DOWNLOAD BUTTON #################### */
  (0, _jquery.default)(".btn-multi-downloads--trigger").click(function () {
    (0, _jquery.default)(this).parent().toggleClass("btn-multi-downloads--open");
  });

  /* #################### IN THIS TOPIC DROPDOWN TOGGLE #################### */
  (0, _jquery.default)(".in-this-topic__trigger").click(function () {
    (0, _jquery.default)(this).parent().toggleClass("in-this-topic--dropdown-open");
  });

  /* #################### SEARCH OPEN/CLOSE #################### */
  (0, _jquery.default)(".podcast-transcript__trigger").click(function () {
    (0, _jquery.default)(this).parent().toggleClass("podcast-transcript--open");
  });

  /* #################### CLOSE ALERT #################### */
  (0, _jquery.default)(".alert-box--green__close").click(function () {
    (0, _jquery.default)(this).closest(".alert-box--green").css("display", "none");
  });

  /* #################### LINKED DIV #################### */
  (0, _jquery.default)(".linkedDiv").click(function () {
    window.location = (0, _jquery.default)(this).find("a").attr("href");
    return false;
  });

  /* #################### DOWNLOAD CONFIRMATION #################### */
  (0, _jquery.default)(function () {
    console.log("Download confirmation test initialized ✅");
    (0, _jquery.default)(document).on("click.testDownloadMessage", "a", function (e) {
      var href = (0, _jquery.default)(this).attr("href") || "";
      var downloadExtensions = [".zip", ".xls", ".xlsx", ".csv", ".doc", ".docx"];
      var isDownload = downloadExtensions.some(function (ext) {
        return href.toLowerCase().includes(ext);
      });
      if (isDownload) {
        console.log("Clicked download link:", href);

        // Prevent multiple messages for same button
        if ((0, _jquery.default)(this).next(".download-notification").length === 0) {
          var message = window.downloadConfirmationMessage || "Your file is downloading. Please check your downloads folder.";
          var $msg = (0, _jquery.default)("<span>").addClass("download-notification").text(message).css({
            marginLeft: "10px",
            color: "#0071bc",
            fontWeight: "bold"
          });
          (0, _jquery.default)(this).after($msg);
          console.log("✅ Message added:", message);
        } else {
          console.log("ℹ️ Message already exists, not adding again.");
        }
      }
    });
  });
};

},{"jquery":"jquery"}],30:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _mockData = _interopRequireDefault(require("./mockData.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var initCartButtonCount = function initCartButtonCount() {
  var cartCountEl = document.querySelector(".js-cart-count");
  if (!cartCountEl) return;
  var nmblAccountEl = document.querySelector(".js-nmbl-account");
  if (!nmblAccountEl) return;
  var calcCart = function calcCart(data) {
    return R.compose(R.reduce(R.add, 0), R.map(R.prop("Quantity")), R.pathOr([], ["Result", "Products"]))(data);
  };
  var renderCount = function renderCount(count) {
    if (count === 0 || isNaN(count)) return false;
    cartCountEl.innerHTML = count;
    cartCountEl.setAttribute("aria-label", "".concat(count, " item").concat(count !== 1 ? "s" : "", " in cart"));
    cartCountEl.style.display = "inline-block";
  };
  var applyAccount = function applyAccount(id) {
    nmblAccountEl.setAttribute("content", "".concat(id));
  };
  fetch("/api/sitecore/Product/GetCart", {
    credentials: "same-origin"
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data.Success) {
      renderCount(calcCart(data));
      applyAccount(data.Result.AccountId);
      return true;
    }
    return false;
  });
};
var _default = exports.default = initCartButtonCount;

},{"./mockData.js":31,"ramda":"ramda"}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var mockData = {
  Success: true,
  result: {
    Products: [{
      Quantity: 0,
      ProductPrice: 95.0,
      ProductName: "Money & Banking 3rd Edition",
      ProductID: "a1B2i000001Lzj4EAC",
      LOID: "3ec0b9d1-9744-4cb8-907c-8ffb3c09d39e"
    }, {
      Quantity: 0,
      ProductPrice: 750.0,
      ProductName: "CRCM Exam & Application Fee",
      ProductID: "a1B2i000001OgdjEAC",
      LOID: "7a38830f-7270-4c57-8d44-97fe33a6db97"
    }],
    CSODNumID: null,
    CartSubtotal: 845.0,
    CartID: "a0I2i000000VXWcEAO",
    AccountId: "0012i00000LivvHAAR"
  },
  errors: null
};
var _default = exports.default = mockData;

},{}],32:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _formik = require("formik");
var _validationSchema = _interopRequireWildcard(require("../validationSchema.js"));
var _CommunityOrganizerFormContext = require("../context/CommunityOrganizerFormContext.jsx");
var _StepOne = _interopRequireDefault(require("./StepOne.jsx"));
var _StepTwo = _interopRequireDefault(require("./StepTwo.jsx"));
var _StepThree = _interopRequireDefault(require("./StepThree.jsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var propTypes = {};
var CommunityOrganizerForm = function CommunityOrganizerForm(props) {
  var _useCommunityOrganize = (0, _CommunityOrganizerFormContext.useCommunityOrganizerFormContext)(),
    currentStep = _useCommunityOrganize.state.currentStep;
  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: _validationSchema.initialValues,
    validateOnBlur: false,
    validationSchema: _validationSchema.default[currentStep]
  }, function (props) {
    return /*#__PURE__*/_react.default.createElement(_formik.Form, {
      className: "community-organizer-form  aba-container aba-container--100"
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.MemoryRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/"
    }, /*#__PURE__*/_react.default.createElement(_StepOne.default, props)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "/step-2"
    }, /*#__PURE__*/_react.default.createElement(_StepTwo.default, props)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "/confirmation"
    }, /*#__PURE__*/_react.default.createElement(_StepThree.default, null)))));
  });
};
CommunityOrganizerForm.propTypes = propTypes;
var _default = exports.default = CommunityOrganizerForm;

},{"../context/CommunityOrganizerFormContext.jsx":36,"../validationSchema.js":41,"./StepOne.jsx":33,"./StepThree.jsx":34,"./StepTwo.jsx":35,"formik":"formik","react":"react","react-router-dom":"react-router-dom"}],33:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactRouterDom = require("react-router-dom");
var _CommunityOrganizerFormContext = require("../context/CommunityOrganizerFormContext.jsx");
var _helpers = require("../helpers.js");
var _formik = require("formik");
var _FormField = _interopRequireDefault(require("../../Form/FormField/FormField.jsx"));
var _GoogleMapsSearch = _interopRequireDefault(require("../../Form/GoogleMapsSearch/GoogleMapsSearch.jsx"));
var _ErrorMessage = _interopRequireDefault(require("../../Form/ErrorMessage/ErrorMessage.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _communityOrganizerFormService = require("../service/communityOrganizerFormService.js");
var _validationSchema = require("../validationSchema.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  history: _propTypes.object,
  setFieldValue: _propTypes.func,
  // Formik prop
  values: _propTypes.object,
  // Formik prop
  validateForm: _propTypes.func,
  // Formik prop
  dirty: _propTypes.bool // Formik prop
};
var StepOne = function StepOne(props) {
  var _useCommunityOrganize = (0, _CommunityOrganizerFormContext.useCommunityOrganizerFormContext)(),
    dictionary = _useCommunityOrganize.dictionary,
    api = _useCommunityOrganize.constants.api,
    _useCommunityOrganize2 = _useCommunityOrganize.data,
    targetAudiences = _useCommunityOrganize2.targetAudiences,
    organizationTypes = _useCommunityOrganize2.organizationTypes,
    states = _useCommunityOrganize2.states,
    _useCommunityOrganize3 = _useCommunityOrganize.actions,
    setCurrentStep = _useCommunityOrganize3.setCurrentStep,
    setTopics = _useCommunityOrganize3.setTopics,
    setBankLocations = _useCommunityOrganize3.setBankLocations;
  var history = props.history,
    values = props.values,
    validateForm = props.validateForm,
    setFieldValue = props.setFieldValue,
    dirty = props.dirty;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isValidating = _useState2[0],
    setIsValidating = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  (0, _react.useEffect)(function () {
    (0, _helpers.setTitle)("Step 1 of 2");
    setCurrentStep(1);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);
  var alertUser = function alertUser(e) {
    if (dirty) {
      e.preventDefault();
      e.returnValue = "Are you sure you want to leave?";
    }
  };
  (0, _react.useEffect)(function () {
    window.addEventListener("beforeunload", alertUser);
    return function () {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, [dirty]);
  var fetchData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var programEventId, longitude, latitude, eventCity, topics, locations;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            programEventId = R.path(["TargetAudience"], values);
            longitude = R.path(["Longitude"], values);
            latitude = R.path(["Latitude"], values);
            eventCity = R.path(["EventCity"], values);
            _context.n = 1;
            return (0, _communityOrganizerFormService.fetchTopics)(api, {
              programEventId: programEventId
            });
          case 1:
            topics = _context.v;
            _context.n = 2;
            return (0, _communityOrganizerFormService.fetchBankLocations)(api, {
              programEventId: programEventId,
              longitude: longitude,
              latitude: latitude,
              eventCity: eventCity
            });
          case 2:
            locations = _context.v;
            if (topics && locations) {
              setTopics(topics);
              setBankLocations(locations);
              setErrorMessage(null);
              setIsLoading(false);
              setIsValidating(false);
              history.push("/step-2");
            } else {
              setErrorMessage("An error has occurred. Please try again later.");
              setIsLoading(false);
              setIsValidating(false);
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function fetchData() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleContinue = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            setIsValidating(true);
            _context2.n = 1;
            return validateForm().then(function (errors) {
              if (!R.isEmpty(errors)) {
                setTimeout(function () {
                  var error = document.querySelector(".aba-form__field--invalid");
                  if (error) {
                    error.querySelector("input, select").focus({
                      preventScroll: true
                    });
                    error.scrollIntoView({
                      behavior: "smooth",
                      block: "start"
                    });
                  }
                }, 0);
              } else {
                setIsLoading(true);
                fetchData();
              }
            });
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function handleContinue() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "community-organizer-form__description",
    dangerouslySetInnerHTML: {
      __html: dictionary.Description
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "community-organizer-form__section"
  }, /*#__PURE__*/_react.default.createElement("h2", null, dictionary.ContactHeader), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.ContactDescription
    }
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.FirstNameLabel,
    name: "FirstName",
    isValidating: isValidating,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.LastNameLabel,
    name: "LastName",
    isValidating: isValidating,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.TelephoneLabel,
    name: "Telephone",
    isValidating: isValidating,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.EmailLabel,
    name: "Email",
    isValidating: isValidating,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.OrganizationNameLabel,
    name: "OrganizationName",
    isValidating: isValidating,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.OrganizationTypeLabel,
    name: "OrganizationType",
    as: "select",
    isValidating: isValidating,
    disabled: isLoading
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true
  }, "Please make a selection"), organizationTypes.map(function (o) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: o.Id,
      value: o.Id
    }, o.Name);
  })), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.AddressLine1label,
    name: "AddressLine1",
    isValidating: isValidating,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.AddressLine2label,
    name: "AddressLine2",
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.CityLabel,
    name: "City",
    isValidating: isValidating,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    as: "select",
    label: dictionary.StateLabel,
    name: "State",
    isValidating: isValidating,
    disabled: isLoading
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true
  }, "Please make a selection"), states.map(function (s) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: s.Code,
      value: s.Code
    }, s.Name);
  })), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.ZipCodeLabel,
    name: "ZipCode",
    isValidating: isValidating,
    disabled: isLoading
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "community-organizer-form__section"
  }, /*#__PURE__*/_react.default.createElement("h2", null, dictionary.EventHeader), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.EventDescription
    }
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    type: "radiogroup",
    name: "TargetAudience",
    label: dictionary.TargetAudienceLabel,
    description: dictionary.TargetAudienceDescription,
    isValidating: isValidating
  }, targetAudiences.map(function (t) {
    return /*#__PURE__*/_react.default.createElement("label", {
      key: t.ActiveRegistrationPageEvent
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      name: "TargetAudience",
      type: "radio",
      value: t.ActiveRegistrationPageEvent,
      disabled: isLoading
    }), t.Title);
  })), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    label: dictionary.EventCityStateLabel,
    name: "EventCity",
    isValidating: isValidating,
    disabled: isLoading
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    fieldType: "date",
    label: dictionary.EventDateLabel,
    description: dictionary.EventDateDescription,
    name: "EventDate",
    isValidating: isValidating,
    disabled: isLoading
  })), /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
    errorMessage: errorMessage
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: handleContinue,
    disabled: isLoading
  }, isLoading ? "Loading..." : "Continue"));
};
StepOne.propTypes = propTypes;
var _default = exports.default = (0, _reactRouterDom.withRouter)(StepOne);

},{"../../Form/ErrorMessage/ErrorMessage.jsx":60,"../../Form/FormField/FormField.jsx":61,"../../Form/GoogleMapsSearch/GoogleMapsSearch.jsx":62,"../context/CommunityOrganizerFormContext.jsx":36,"../helpers.js":38,"../service/communityOrganizerFormService.js":40,"../validationSchema.js":41,"formik":"formik","prop-types":"prop-types","ramda":"ramda","react":"react","react-router-dom":"react-router-dom"}],34:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("prop-types");
var _CommunityOrganizerFormContext = require("../context/CommunityOrganizerFormContext.jsx");
var _helpers = require("../helpers.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var propTypes = {};
var StepThree = function StepThree(props) {
  var _useCommunityOrganize = (0, _CommunityOrganizerFormContext.useCommunityOrganizerFormContext)(),
    dictionary = _useCommunityOrganize.dictionary;
  (0, _react.useEffect)(function () {
    (0, _helpers.setTitle)("Confirmation");
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", null, dictionary.ConfirmationHeader), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.ConfirmationDescription
    }
  }));
};
StepThree.propTypes = propTypes;
var _default = exports.default = StepThree;

},{"../context/CommunityOrganizerFormContext.jsx":36,"../helpers.js":38,"prop-types":"prop-types","react":"react"}],35:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactRouterDom = require("react-router-dom");
var _CommunityOrganizerFormContext = require("../context/CommunityOrganizerFormContext.jsx");
var _helpers = require("../helpers.js");
var _formik = require("formik");
var _FormField = _interopRequireDefault(require("../../Form/FormField/FormField.jsx"));
var _Checkbox = _interopRequireDefault(require("../../Form/Checkbox/Checkbox.jsx"));
var _ErrorMessage = _interopRequireDefault(require("../../Form/ErrorMessage//ErrorMessage.jsx"));
var _validationSchema = require("../validationSchema.js");
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  history: _propTypes.object,
  validateForm: _propTypes.func,
  // Formik prop
  values: _propTypes.object,
  // Formik prop
  setFieldValue: _propTypes.func,
  // Formik prop
  dirty: _propTypes.bool // Formik prop
};
var StepTwo = function StepTwo(props) {
  var _useCommunityOrganize = (0, _CommunityOrganizerFormContext.useCommunityOrganizerFormContext)(),
    dictionary = _useCommunityOrganize.dictionary,
    _useCommunityOrganize2 = _useCommunityOrganize.constants,
    api = _useCommunityOrganize2.api,
    sourceId = _useCommunityOrganize2.sourceId,
    _useCommunityOrganize3 = _useCommunityOrganize.data,
    targetAudiences = _useCommunityOrganize3.targetAudiences,
    educationalOfferings = _useCommunityOrganize3.educationalOfferings,
    organizationTypes = _useCommunityOrganize3.organizationTypes,
    _useCommunityOrganize4 = _useCommunityOrganize.state,
    currentStep = _useCommunityOrganize4.currentStep,
    topics = _useCommunityOrganize4.topics,
    bankLocations = _useCommunityOrganize4.bankLocations,
    setCurrentStep = _useCommunityOrganize.actions.setCurrentStep;
  var history = props.history,
    validateForm = props.validateForm,
    values = props.values,
    setFieldValue = props.setFieldValue,
    dirty = props.dirty;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isValidating = _useState2[0],
    setIsValidating = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmitting = _useState4[0],
    setIsSubmitting = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setSubmitErrorMessage = _useState6[1];
  (0, _react.useEffect)(function () {
    (0, _helpers.setTitle)("Step 2 of 2");
    setCurrentStep(2);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);
  (0, _react.useEffect)(function () {
    window.addEventListener("beforeunload", alertUser);
    return function () {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);
  var alertUser = function alertUser(e) {
    if (dirty) {
      e.preventDefault();
      e.returnValue = "Are you sure you want to leave?";
    }
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var locationId, populatedLocation, populatedTopics, populatedTargetAudience, populatedOrganizationType, populatedData;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsSubmitting(true);
            locationId = R.prop("BankGeoLocation", values);
            populatedLocation = bankLocations.find(function (loc) {
              return R.path(["ProgramEventParticipant", "AccountName", "Id"], loc) === locationId;
            });
            populatedTopics = R.map(function (id) {
              var populatedTopic = R.find(R.propEq("Id", id), topics);
              return {
                Name: populatedTopic.Name,
                Id: populatedTopic.Id
              };
            }, values.Topics);
            populatedTargetAudience = R.find(R.propEq("ActiveRegistrationPageEvent", values.TargetAudience), targetAudiences);
            populatedOrganizationType = R.find(R.propEq("Id", values.OrganizationType), organizationTypes);
            populatedData = _objectSpread(_objectSpread({}, values), {}, {
              Topics: populatedTopics,
              SelectedBank: R.path(["ProgramEventParticipant", "AccountName"], populatedLocation),
              OrganizationTypeName: R.prop("Name", populatedOrganizationType),
              BankGeoLocation: R.prop("GeoLocation", populatedLocation),
              BceProgramEventParticipantState: R.prop("Id", populatedLocation),
              ServeLowToModerate: R.prop("ServeLowToModerate", values) === "true",
              SitecoreProgramId: R.prop("SitecoreProgramId", populatedTargetAudience),
              DatasourceId: sourceId
            });
            fetch(api.SUBMIT, {
              method: "POST",
              body: JSON.stringify(populatedData),
              headers: {
                credentials: "include",
                "Content-Type": "application/json"
              }
            }).then(function (response) {
              return response.json();
            }).then(function (data) {
              if (data.Success) {
                setIsSubmitting(false);
                history.push("/confirmation");
              } else {
                setIsSubmitting(false);
                setSubmitErrorMessage(data.Errors.ErrorMessage);
              }
            }).catch(function (error) {
              setIsSubmitting(false);
              console.error(error.message);
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onClickBack = function onClickBack() {
    setFieldValue("Topics", "");
    setFieldValue("NumAttendees", "");
    setFieldValue("AdditionalInformation", "");
    setFieldValue("BankGeoLocation", "");
    setFieldValue("WhereDidYouHear", "");
    setFieldValue("ServeLowToModerate", "");
    history.push("/");
  };
  var onClickSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            setIsValidating(true);
            _context2.n = 1;
            return validateForm().then(function (errors) {
              if (!R.isEmpty(errors)) {
                setTimeout(function () {
                  var error = document.querySelector(".aba-form__field--invalid");
                  if (error) {
                    error.querySelector("input, select, div > textArea").focus({
                      preventScroll: true
                    });
                    error.scrollIntoView({
                      behavior: "smooth",
                      block: "start"
                    });
                  }
                }, 0);
              } else {
                setIsValidating(false);
                handleSubmit(values);
              }
            });
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function onClickSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var additionalInformationCharacterLimit = 500;
  var nonStatewide = bankLocations.filter(function (value) {
    return value.City !== "Statewide" && !value.ProgramEventParticipant.AccountName.Name.toLowerCase().includes("not found");
  });
  var statewide = bankLocations.filter(function (value) {
    return value.City === "Statewide";
  });
  var notFound = bankLocations.filter(function (value) {
    return value.ProgramEventParticipant.AccountName.Name.toLowerCase().includes("not found");
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "registration-form__section"
  }, /*#__PURE__*/_react.default.createElement("h2", null, dictionary.EventDetailLabel), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: dictionary.EventDetailDescription
    }
  }), !R.isEmpty(topics) && /*#__PURE__*/_react.default.createElement(_FormField.default, {
    type: "checkboxgroup",
    name: "Topics",
    label: dictionary.TopicSelectionLabel,
    isValidating: isValidating,
    disabled: isSubmitting
  }, topics.map(function (topic, idx) {
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      key: topic.Id,
      name: "Topics",
      value: topic.Id,
      as: _formik.Field,
      label: topic.Name
    });
  })), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    name: "NumAttendees",
    fieldType: "number",
    label: dictionary.AttendeesLabel,
    isValidating: isValidating,
    disabled: isSubmitting
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    name: "AdditionalInformation",
    label: dictionary.AdditionalInformationLabel,
    type: "textarea",
    disabled: isSubmitting,
    validate: function validate(v) {
      return (0, _validationSchema.validateAdditionalInformation)(v, values, additionalInformationCharacterLimit);
    },
    characterLimit: additionalInformationCharacterLimit
  }), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    type: "radiogroup",
    name: "BankGeoLocation",
    label: dictionary.BankSelectionLabel,
    description: dictionary.BankSelectionDescription,
    isValidating: isValidating
  }, nonStatewide.map(function (loc, idx) {
    return /*#__PURE__*/_react.default.createElement("label", {
      key: idx
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      name: "BankGeoLocation",
      type: "radio",
      value: R.path(["ProgramEventParticipant", "AccountName", "Id"], loc),
      disabled: isSubmitting
    }), R.path(["ProgramEventParticipant", "AccountName", "PrimaryAffiliationName"], loc), " (", Math.round(loc.Distance * 10) / 10, " miles)");
  }), statewide.map(function (loc, idx) {
    return /*#__PURE__*/_react.default.createElement("label", {
      key: idx
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      name: "BankGeoLocation",
      type: "radio",
      value: R.path(["ProgramEventParticipant", "AccountName", "Id"], loc),
      disabled: isSubmitting
    }), R.path(["ProgramEventParticipant", "AccountName", "PrimaryAffiliationName"], loc), " (Offers presentations statewide)");
  }), notFound.map(function (loc, idx) {
    return /*#__PURE__*/_react.default.createElement("label", {
      key: idx
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      name: "BankGeoLocation",
      type: "radio",
      value: R.path(["ProgramEventParticipant", "AccountName", "Id"], loc),
      disabled: isSubmitting
    }), R.path(["ProgramEventParticipant", "AccountName", "PrimaryAffiliationName"], loc));
  })), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    type: "select",
    name: "WhereDidYouHear",
    label: dictionary.ProgramDiscoverySourceLabel,
    isValidating: isValidating,
    disabled: isSubmitting
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true
  }, "Please make a selection"), educationalOfferings.map(function (o, idx) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: idx,
      value: o
    }, o);
  })), /*#__PURE__*/_react.default.createElement(_FormField.default, {
    type: "radiogroup",
    label: dictionary.LowIncomeLabel
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "ServeLowToModerate",
    type: "radio",
    value: "true",
    disabled: isSubmitting
  }), "Yes"), /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "ServeLowToModerate",
    type: "radio",
    value: "false",
    disabled: isSubmitting
  }), "No")), /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
    errorMessage: errorMessage
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary",
    onClick: onClickBack
  }, "Back"), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary",
    type: "submit",
    onClick: onClickSubmit,
    disabled: isSubmitting
  }, isSubmitting ? "Submitting Request..." : "Submit Request")));
};
StepTwo.propTypes = propTypes;
var _default = exports.default = (0, _reactRouterDom.withRouter)(StepTwo);

},{"../../Form/Checkbox/Checkbox.jsx":58,"../../Form/ErrorMessage//ErrorMessage.jsx":60,"../../Form/FormField/FormField.jsx":61,"../context/CommunityOrganizerFormContext.jsx":36,"../helpers.js":38,"../validationSchema.js":41,"formik":"formik","prop-types":"prop-types","ramda":"ramda","react":"react","react-router-dom":"react-router-dom"}],36:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCommunityOrganizerFormContext = exports.CommunityOrganizerFormProvider = exports.CommunityOrganizerFormContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _actionHandlers = require("./actionHandlers.js");
var R = _interopRequireWildcard(require("ramda"));
var _excluded = ["dictionary", "data", "api", "sourceId"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CommunityOrganizerFormContext = exports.CommunityOrganizerFormContext = /*#__PURE__*/(0, _react.createContext)();
var propTypes = {
  dictionary: _propTypes.object,
  data: _propTypes.object,
  api: _propTypes.object,
  sourceId: _propTypes.string
};
var initialState = {
  currentStep: {},
  topics: [],
  bankLocations: []
};
var stateReducer = function stateReducer(state, action) {
  // console.log(action.type, action.payload);

  if (_actionHandlers.actionHandlers[action.type]) {
    return _actionHandlers.actionHandlers[action.type].reducer(state, action);
  }

  // if an action wasn't found, log a warning
  console.warn("Action not found!", action);
  return state;
};
var CommunityOrganizerFormProvider = exports.CommunityOrganizerFormProvider = function CommunityOrganizerFormProvider(props) {
  var dictionary = props.dictionary,
    data = props.data,
    api = props.api,
    sourceId = props.sourceId,
    rest = _objectWithoutProperties(props, _excluded);
  var _useReducer = (0, _react.useReducer)(stateReducer, _objectSpread(_objectSpread({}, initialState), rest)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var context = {
    dictionary: dictionary,
    constants: {
      api: api,
      sourceId: sourceId
    },
    state: state,
    data: data,
    actions: R.compose(R.map(function (fn) {
      return function () {
        return dispatch(fn.apply(void 0, arguments));
      };
    }), R.pluck("action"))(_actionHandlers.actionHandlers)
  };
  return /*#__PURE__*/_react.default.createElement(CommunityOrganizerFormContext.Provider, _extends({
    value: context
  }, props));
};
var useCommunityOrganizerFormContext = exports.useCommunityOrganizerFormContext = function useCommunityOrganizerFormContext() {
  return (0, _react.useContext)(CommunityOrganizerFormContext);
};
CommunityOrganizerFormProvider.propTypes = propTypes;

},{"./actionHandlers.js":37,"prop-types":"prop-types","ramda":"ramda","react":"react"}],37:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13,"ramda":"ramda"}],38:[function(require,module,exports){
arguments[4][14][0].apply(exports,arguments)
},{"dup":14}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireDefault(require("react"));
var _CommunityOrganizerForm = _interopRequireDefault(require("./components/CommunityOrganizerForm.jsx"));
var _CommunityOrganizerFormContext = require("./context/CommunityOrganizerFormContext.jsx");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var initCommunityOrganizerForm = function initCommunityOrganizerForm() {
  document.querySelectorAll(".js-community-organizer-form-mount").forEach(function (mount) {
    if (mount) {
      _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_CommunityOrganizerFormContext.CommunityOrganizerFormProvider, {
        dictionary: JSON.parse(mount.dataset.dictionary),
        data: {
          targetAudiences: JSON.parse(mount.dataset.targetaudience),
          organizationTypes: JSON.parse(mount.dataset.organizationtypes),
          educationalOfferings: JSON.parse(mount.dataset.educationalofferings),
          states: JSON.parse(mount.dataset.states)
        },
        sourceId: mount.dataset.datasourceid,
        api: {
          GEOLOCATION: mount.dataset.geolocationurl,
          TOPICS: mount.dataset.topicurl,
          SUBMIT: mount.dataset.submit
        }
      }, /*#__PURE__*/_react.default.createElement(_CommunityOrganizerForm.default, null)), mount);
    }
  });
};
var _default = exports.default = initCommunityOrganizerForm;

},{"./components/CommunityOrganizerForm.jsx":32,"./context/CommunityOrganizerFormContext.jsx":36,"react":"react","react-dom":"react-dom"}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTopics = exports.fetchBankLocations = void 0;
var fetchTopics = exports.fetchTopics = function fetchTopics(api, params) {
  var programEventId = params.programEventId;
  var url = "".concat(api.TOPICS, "?programEventId=").concat(programEventId);
  return fetch(url, {
    method: "GET",
    credentials: "include"
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data.Success) {
      return data.Result;
    }
  }).catch(function (error) {
    console.error(error);
  });
};
var fetchBankLocations = exports.fetchBankLocations = function fetchBankLocations(api, params) {
  var programEventId = params.programEventId,
    eventCity = params.eventCity;
  var url = "".concat(api.GEOLOCATION, "?programEventId=").concat(programEventId, "&eventcity=").concat(eventCity);
  return fetch(url, {
    method: "GET",
    credentials: "include"
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data.Success) {
      return data.Result;
    }
  }).catch(function (error) {
    console.error(error);
  });
};

},{}],41:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateGeoLocation = exports.validateAdditionalInformation = exports.initialValues = exports.default = void 0;
var Yup = _interopRequireWildcard(require("yup"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var zipRegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;
var phoneRegExp = /^(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?$/;
var phoneRegExp2 = /^[0-9]{10}$/;
var initialValues = exports.initialValues = {
  FirstName: "",
  LastName: "",
  Telephone: "",
  Email: "",
  OrganizationName: "",
  OrganizationType: "",
  AddressLine1: "",
  AddressLine2: "",
  City: "",
  State: "",
  ZipCode: "",
  TargetAudience: "",
  EventCity: "",
  EventDate: "",
  Topics: [],
  NumAttendees: "",
  AdditionalInformation: "",
  BankGeoLocation: "",
  WhereDidYouHear: "",
  ServeLowToModerate: null
};
var CommunityOrganizerFormSchema = [Yup.object().shape({
  FirstName: Yup.string().required("Field is required."),
  LastName: Yup.string().required("Field is required."),
  Telephone: Yup.string().matches(phoneRegExp, "Please provide valid phone number.").matches(phoneRegExp2, "Please enter only numbers (no hyphens, spaces, or other punctuation).").required("Field is required."),
  Email: Yup.string().email("Please provide valid email.").required("Field is required."),
  OrganizationName: Yup.string().required("Field is required."),
  OrganizationType: Yup.string().required("Field is required."),
  AddressLine1: Yup.string().required("Field is required."),
  City: Yup.string().required("Field is required."),
  State: Yup.string().required("Field is required."),
  ZipCode: Yup.string().matches(zipRegExp, "Must be 5 or 9 digits.").required("Field is required."),
  TargetAudience: Yup.string().required("Field is required."),
  EventCity: Yup.string().required("Field is required.")
}), Yup.object().shape({
  Topics: Yup.array().min(1, "Please select at least one.").required("Field is required."),
  NumAttendees: Yup.string().required("Field is required."),
  BankGeoLocation: Yup.string().required("Field is required."),
  WhereDidYouHear: Yup.string().required("Field is required.")
})];
var validateGeoLocation = exports.validateGeoLocation = function validateGeoLocation(value, values) {
  var error;
  if (!values.Longitude && !values.Latitude) {
    error = "Please select a predetermined location.";
  } else if (value === "Statewide") {
    error = "Statewide is not available. Please select an event city.";
  }
  return error;
};
var validateAdditionalInformation = exports.validateAdditionalInformation = function validateAdditionalInformation(value, values, characterLimit) {
  var error;
  var len = value.length;
  if (len > characterLimit) {
    error = "You cannot exceed " + characterLimit + " characters.";
  }
  return error;
};
var _default = exports.default = CommunityOrganizerFormSchema;

},{"yup":"yup"}],42:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _Listing = _interopRequireDefault(require("./components/Listing.jsx"));
var _ListingContainer = _interopRequireDefault(require("./components/ListingContainer.jsx"));
var _mockData = _interopRequireWildcard(require("./mockData.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  dictionary: (0, _propTypes.shape)({
    loginUrl: _propTypes.string,
    loginCta: _propTypes.string,
    errorMessage: _propTypes.string
  })
};
var ProfileListing = function ProfileListing(props) {
  var _props$dictionary = props.dictionary,
    loginUrl = _props$dictionary.loginUrl,
    loginCta = _props$dictionary.loginCta,
    errorMessage = _props$dictionary.errorMessage;
  var returnUrl = props.returnUrl,
    noActiveProfilesMessage = props.noActiveProfilesMessage;
  var url = "/api/sitecore/AbaAccount/GetDirectLMSProfile";

  // Development use only
  // const url = `http://echoapi.velir.com/?json=${JSON.stringify(mockData)}`;
  // const errorurl = `http://echoapi.velir.com/?json=${JSON.stringify(error)}`;

  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var listingRef = (0, _react.useRef)(null);
  var controller = new AbortController();
  var signal = controller.signal;
  (0, _react.useEffect)(function () {
    fetch(url, {
      credentials: "same-origin",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.Result) {
        setResult(data.Result);
      } else {
        setResult(null);
      }
      setIsLoading(false);
      return data;
    }).catch(function (err) {
      console.log("err", err);
      setIsLoading(false);
      setResult(null);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement(_ListingContainer.default, {
    isLoading: isLoading,
    className: "profile-listing"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "profile-listing__wrapper",
    ref: listingRef
  }, result && result.Profiles && _toConsumableArray(result.Profiles).length > 0 && _toConsumableArray(result.Profiles).map(function (i, k) {
    return /*#__PURE__*/_react.default.createElement(_Listing.default, {
      item: _objectSpread({}, i),
      index: k,
      className: i.className,
      username: i.Username,
      errorMessage: /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: errorMessage
        }
      }),
      returnUrl: returnUrl
    });
  }), result === null && /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-padding-m"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: " aba-container aba-container--100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container__col"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: errorMessage
    }
  }))))), result && ((result.Profiles && result.Profiles.length) === 0 || result.Profiles === null) && /*#__PURE__*/_react.default.createElement("div", {
    className: "listing-item\"}",
    "aria-live": "polite"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--100 list-item__content",
    dangerouslySetInnerHTML: {
      __html: noActiveProfilesMessage
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--100 profile-listing__link-container"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "profile-listing__login-link",
    href: loginUrl
  }, loginCta)));
};
ProfileListing.propTypes = propTypes;
var _default = exports.default = ProfileListing;

},{"./components/Listing.jsx":43,"./components/ListingContainer.jsx":44,"./mockData.js":46,"prop-types":"prop-types","react":"react"}],43:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _mockData = require("../mockData.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  item: (0, _propTypes.shape)({
    email: _propTypes.string,
    domain: _propTypes.string,
    profilePrice: _propTypes.number,
    profileId: _propTypes.string,
    description: _propTypes.string,
    btnText: _propTypes.string,
    className: _propTypes.string
  }),
  onCreateProfile: _propTypes.func,
  className: _propTypes.string,
  index: _propTypes.number,
  username: _propTypes.string,
  errorMessage: _propTypes.node
};
var Listing = function Listing(props) {
  var item = props.item,
    className = props.className,
    index = props.index,
    username = props.username,
    errorMessage = props.errorMessage,
    returnUrl = props.returnUrl;
  var DomainName = item.DomainName,
    IsProductAvailable = item.IsProductAvailable,
    createNewProfile = item.createNewProfile;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetching = _useState2[0],
    setIsFetching = _useState2[1];
  var _useState3 = (0, _react.useState)("Use This Profile"),
    _useState4 = _slicedToArray(_useState3, 2),
    buttonText = _useState4[0],
    setButtonText = _useState4[1];
  var listItem = (0, _react.useRef)(null);
  var controller = new AbortController();
  var signal = controller.signal;
  var url = "/api/sitecore/AbaAccount/SelectDirectLMSProfile";

  // Development use only
  // const url = `http://echoapi.velir.com/?json=${JSON.stringify(
  //   selectionDataError,
  // )}`;

  var handleSelection = function handleSelection(item, isFetching) {
    if (isFetching) {
      controller.abort();
    } else {
      setIsFetching(true);
      fetch(url, {
        method: "POST",
        body: JSON.stringify(item),
        headers: {
          "Content-Type": "application/json"
        },
        signal: signal
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.Success) {
          window.location.href = returnUrl;
        } else {
          listItem.current.classList.add("is-error");
          setIsFetching(false);
        }
      });
    }
  };
  var BtnTxt = function BtnTxt(isFetching) {
    return isFetching ? /*#__PURE__*/_react.default.createElement("svg", {
      className: "flashing-loader",
      viewBox: "0 0 50 100",
      "aria-label": "Loading",
      focusable: "false",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      cx: "-47",
      cy: "50",
      r: "28",
      fill: "currentColor"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      cx: "26",
      cy: "50",
      r: "28",
      fill: "currentColor"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      cx: "97",
      cy: "50",
      r: "28",
      fill: "currentColor"
    })) : /*#__PURE__*/_react.default.createElement("span", null, buttonText);
  };
  (0, _react.useEffect)(function () {
    if (className) {
      setTimeout(function () {
        //scroll to this item if it has new-item class
        listItem.current.querySelector("button").focus({
          preventScroll: true
        });
        listItem.current.scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      }, 1000);
    }
  }, [className]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "listing-item ".concat(className ? className : ""),
    "aria-live": "polite"
    // aria-label={`Profile ${index + 1}`}
    ,
    ref: listItem
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--100 list-item__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--30-30-30 list-item__main"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container__col"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "listing-item__title"
  }, "Profile ", index + 1), /*#__PURE__*/_react.default.createElement("p", {
    className: "listing-item__description"
  }, username && /*#__PURE__*/_react.default.createElement("span", null, "Username: ", username), username && DomainName && /*#__PURE__*/_react.default.createElement("br", null), DomainName && /*#__PURE__*/_react.default.createElement("span", null, "Domain: ", DomainName))), /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container__col list-item__btn-container"
  }, /*#__PURE__*/_react.default.createElement("button", _extends({
    className: (0, _classnames.default)("btn", {
      "btn-primary": !isFetching,
      "is-loading": isFetching
    }),
    onClick: function onClick() {
      handleSelection(item || null, isFetching);
    }
  }, !createNewProfile && {
    "aria-label": "Use Profile ".concat(index + 1)
  }), /*#__PURE__*/_react.default.createElement("span", null, BtnTxt(isFetching)))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container list-item__action"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__error",
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__error-content icon-error"
  }, errorMessage))));
};
Listing.propTypes = propTypes;
var _default = exports.default = Listing;

},{"../mockData.js":46,"classnames":"classnames","prop-types":"prop-types","react":"react"}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _excluded = ["isLoading", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  isLoading: _propTypes.bool,
  children: _propTypes.node
};
var ListingContainer = function ListingContainer(props) {
  var isLoading = props.isLoading,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("section", otherProps, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("profile-listing__loader", {
      "is-loading": isLoading
    }),
    "aria-hidden": !isLoading
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "circle-loader profile-listing__loader-svg",
    viewBox: "0 0 100 100",
    "aria-label": "Loading",
    focusable: "true",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Loading"), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45"
  }))), children);
};
ListingContainer.propTypes = propTypes;
var _default = exports.default = ListingContainer;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireDefault(require("react"));
var _ProfileListing = _interopRequireDefault(require("./ProfileListing.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var initProfileListing = function initProfileListing() {
  document.querySelectorAll(".js-direct-profile-listing-mount").forEach(function (mount) {
    if (mount) {
      _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_ProfileListing.default, {
        dictionary: JSON.parse(mount.dataset.dictionary),
        returnUrl: mount.dataset.returnUrl,
        noActiveProfilesMessage: mount.dataset.noActiveProfilesMessage
      }), mount);
    }
  });
};
var _default = exports.default = initProfileListing;

},{"./ProfileListing.jsx":42,"react":"react","react-dom":"react-dom"}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectionDataError = exports.error = exports.dictionary = exports.default = void 0;
var mockData = {
  Success: true,
  Result: {
    CanCreateNewProfile: true,
    Username: "lmscsodtest@velir.com",
    profilePrice: 0,
    regularPrice: 750.0,
    savings: 0,
    Profiles: [{
      Wsuid: null,
      Username: "lmscsodtest@velir.com",
      UserId: "lmscsodtest@velir.com",
      DomainName: "ABA Knowledge Center Self Registration",
      DomainID: "ORG01296_358041",
      CSODNumID: "797140",
      WorkStatus: false,
      IsProductAvailable: true
    }]
  },
  Errors: null
};
var error = exports.error = {
  Success: false,
  Errors: {
    ErrorMessage: "sadsadsad asdsad asds asd asd adas sadsad a<button>button</button>"
  }
};
var selectionDataError = exports.selectionDataError = {
  Success: false,
  Result: {
    RedirectUrl: null,
    MakePurchase: false,
    PurchaseURL: null
  },
  Errors: {
    ErrorMessage: "CSOD Profile is null or invalid. The operation failed. Please retry later.\nIf you have any questions, please call us at 1-800-BANKERS (800-226-5377) or email support@aba.com.",
    ErrorCode: "CSODError-InvalidProfile"
  }
};
var _default = exports.default = mockData;
var dictionary = exports.dictionary = {
  loginUrl: "/",
  loginCta: "Or, log out and try a different email address.",
  errorMessage: "<p>Oops! We had a problem creating your new LMS profile. Please contact us for help: <p><a href='#' class='btn btn-primary'>call us: 8888888888</a> or <a href='#' class='btn btn-primary'>em us: fakeemail@emai.com</a></p>"
};

},{}],47:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Lookup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _mockData = _interopRequireDefault(require("./mockData.js"));
var _propTypes = require("prop-types");
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  url: _propTypes.string.isRequired
};
var Lookup = exports.Lookup = function Lookup(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    company = _useState2[0],
    setCompany = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasError = _useState8[0],
    setHasError = _useState8[1];
  var resEl = (0, _react.useRef)(null);
  var inputEl = (0, _react.useRef)(null);
  var url = props.url;
  var reset = function reset() {
    setCompany(null);
    setErrorMessage(null);
  };
  var goToRef = function goToRef() {
    //go to result element and focus
    resEl.current.focus();
    resEl.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
    // });
  };
  var handleChange = function handleChange(e) {
    //input changed
    if (inputEl.current.value && hasError) {
      setHasError(false);
    }
  };
  var handleSubmit = function handleSubmit(e) {
    //before we do anything lets reset results
    reset();
    e.preventDefault();
    setIsLoading(true);
    if (inputEl.current.value) {
      fetch("".concat(url, "?fdic=").concat(inputEl.current.value), {
        method: "POST"
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.Success) {
          setIsLoading(false);
          setCompany(data.Result[0]);
        } else {
          setIsLoading(false);
          setErrorMessage(data.Errors.ErrorMessage);
        }
        goToRef();
      }).catch(function (error) {
        setIsLoading(false);
        setErrorMessage("Something went wrong, please try again later.");
        goToRef();
      });
    } else {
      //submitted w/o data
      setIsLoading(false);
      setHasError(true);
      inputEl.current.focus();
    }
  };
  var submitText = function submitText() {
    return isLoading ? /*#__PURE__*/_react.default.createElement("span", null, "Loading...") : /*#__PURE__*/_react.default.createElement("span", null, "Submit");
  };
  var companyDisplay = function companyDisplay(co) {
    if (R.isNil(co)) return false;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        "is-visible": co
      })
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "h2"
    }, "Your FDIC Lookup Result:"), /*#__PURE__*/_react.default.createElement("div", {
      className: "fdic__company"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "fdic__result-label"
    }, "Company Name: "), /*#__PURE__*/_react.default.createElement("span", null, co.Name)), /*#__PURE__*/_react.default.createElement("div", {
      className: "fdic__Address"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "fdic__result-label"
    }, "Main Location: "), /*#__PURE__*/_react.default.createElement("span", null, co.City, ", ", co.StateProvince, " ", co.Country)), /*#__PURE__*/_react.default.createElement("div", {
      className: "fdic__description"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "fdic__result-label"
    }, "FDIC/ABA Number: "), /*#__PURE__*/_react.default.createElement("span", null, co.FDIC, "/", co.abacompanyid)), /*#__PURE__*/_react.default.createElement("div", {
      className: "fdic__description"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "fdic__result-label"
    }, "Member: "), /*#__PURE__*/_react.default.createElement("span", null, co.IsABAMember)));
  };
  var errorDisplay = function errorDisplay(em) {
    if (R.isNil(em)) return false;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("fdic__error", {
        "is-visible": em
      })
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "fdic__error-msg"
    }, em));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "fdic__lookup"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fdic__banner"
  }, /*#__PURE__*/_react.default.createElement("form", {
    className: "fdic__form container--narrow",
    onSubmit: function onSubmit(e) {
      handleSubmit(e);
    }
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "fdic_lookup",
    className: "fdic__label"
  }, "Enter an FDIC number to look up member institutions."), /*#__PURE__*/_react.default.createElement("div", {
    className: "fdic__input-group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "fdic_lookup",
    className: "fdic__input",
    type: "text",
    ref: inputEl,
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "fdic__submit",
    type: "submit",
    disabled: isLoading ? "disabled" : false
  }, submitText()), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)("error", {
      "is-hidden": !hasError
    }),
    "aria-hidden": !hasError,
    "aria-live": hasError ? "assertive" : "off"
  }, "Please enter an FDIC number")))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("container-fluid", "fdic__results", "container--padding-large", {
      "is-hidden": R.isNil(company) && R.isNil(errorMessage)
    }),
    ref: resEl,
    "aria-live": "polite",
    role: "region"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fdic__result-item container container--narrow"
  }, companyDisplay(company), errorDisplay(errorMessage))));
};
Lookup.propTypes = propTypes;
var _default = exports.default = Lookup;

},{"./mockData.js":49,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react"}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireDefault(require("react"));
var _FDICLookup = require("./FDICLookup.jsx");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var initFDICLookup = function initFDICLookup() {
  document.querySelectorAll(".js-fdiclookup-mount").forEach(function (mount) {
    if (mount) {
      _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_FDICLookup.Lookup, {
        url: mount.getAttribute("data-url")
      }), mount);
    }
  });
};
var _default = exports.default = initFDICLookup;

},{"./FDICLookup.jsx":47,"react":"react","react-dom":"react-dom"}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var mockData = [{
  "Name": "Company Name",
  "AddressLineOne": "212 Elm Street, Somerville, MA, 02144",
  "FDIC": 1234
}];
var _default = exports.default = mockData;

},{}],50:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _useSearchValues2 = _interopRequireDefault(require("../../../../common/useSearchValues.js"));
var _usePrevious = _interopRequireDefault(require("../../../../common/usePrevious.js"));
var _Sponsors = _interopRequireDefault(require("../Sponsors.jsx"));
var _SearchField = _interopRequireDefault(require("../SearchField/SearchField.jsx"));
var _SortField = _interopRequireDefault(require("../SortField/SortField.jsx"));
var _ResultItem = _interopRequireDefault(require("../../../ResultItem/ResultItem.jsx"));
var _ListingContainer = _interopRequireDefault(require("../Listing/ListingContainer.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _fuse = _interopRequireDefault(require("fuse.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  queryStringState: (0, _propTypes.shape)({
    r: _propTypes.string,
    q: _propTypes.string
  }),
  setQueryStringState: _propTypes.func,
  fetchUrl: _propTypes.string,
  sponsors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    link: _propTypes.string,
    imageSrc: _propTypes.string,
    imageAlt: _propTypes.string
  }))
};
var App = function App(props) {
  var queryStringState = props.queryStringState,
    setQueryStringState = props.setQueryStringState,
    fetchUrl = props.fetchUrl,
    sponsors = props.sponsors;
  var _useSearchValues = (0, _useSearchValues2.default)(),
    searchValues = _useSearchValues.searchValues;
  var event = new CustomEvent("newResults");
  var resultsRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    defaultsResults = _useState2[0],
    setDefaultsResults = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    results = _useState4[0],
    setResults = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    sortedResults = _useState6[0],
    setSortedResults = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    resultCount = _useState8[0],
    setResultCount = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isLoading = _useState0[0],
    setIsLoading = _useState0[1];
  var previousResults = (0, _usePrevious.default)(results);
  var previousQuery = (0, _usePrevious.default)(queryStringState.q);
  var previousSort = (0, _usePrevious.default)(queryStringState.sort);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var fuseOpts = {
    includeScore: false,
    includeMatches: true,
    threshold: 0,
    keys: ["city", "state", "bank", "contact_info.name", "contact_info.phone", "contact_info.email"]
  };
  var fuse = (0, _react.useRef)(new _fuse.default([], fuseOpts));
  var toResults = function toResults() {
    document.dispatchEvent(event);
  };
  var handleChange = function handleChange(change, e) {
    //if sort === previous sort dont update
    if (change.sort === previousSort) return false;
    setQueryStringState(change);
    toResults();
  };
  var scrollToResults = function scrollToResults() {
    setTimeout(function () {
      resultsRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
      resultsRef.current.focus({
        preventScroll: true
      });
    }, 1000);
  };
  var groupResults = function groupResults() {
    var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";
    var sortBy = R.ifElse(function () {
      return sort.toLowerCase() === "asc";
    }, function () {
      return R.sort(R.ascend(R.prop("state")));
    }, function () {
      return R.sort(R.descend(R.prop("state")));
    });
    return R.compose(R.unnest, R.map(function (i) {
      return R.drop(1, i);
    }), R.toPairs, R.mapObjIndexed(function (items, state) {
      return {
        state: state,
        data: _toConsumableArray(R.uniq(items))
      };
    }), R.groupBy(R.prop("state")), sortBy(sort))(results);
  };
  var statusText = "Showing ".concat(resultCount, " result").concat(
  // eslint-disable-next-line no-constant-condition
  999 > 1 || 999 <= 0 ? "s" : "", "  ").concat(searchValues.q !== "" ? "for" : "", " ").concat(searchValues.q);
  (0, _react.useEffect)(function () {
    //event listener to focus on and scroll to new results
    document.addEventListener("newResults", scrollToResults, false);
    setIsLoading(true);
    fetch(fetchUrl).then(function (response) {
      return response.json();
    }).then(function (data) {
      setDefaultsResults(data.results);
      fuse.current.setCollection(data.results);
      setResultCount(data.results.length);
      setIsLoading(false);
      updateResults(previousSort, queryStringState.sort, previousQuery, queryStringState.q, data.results);
    });
    return function () {
      document.removeEventListener("newResults", scrollToResults, false);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var updateResults = (0, _react.useCallback)(function (prevSort, sort, prevQuery, query, res) {
    if (sort !== prevSort) {
      setSortedResults(groupResults(results, queryStringState.sort));
    }
    if (prevQuery !== query) {
      if (queryStringState.q !== "") {
        //query changed and is not blank
        var fuseResults = R.map(function (i) {
          return i.item;
        })(fuse.current.search(queryStringState.q));
        setResultCount(R.uniq(fuseResults).length);
        setResults(fuseResults);
        setSortedResults(groupResults(fuseResults, sort));
      } else {
        //query Changed and is blank
        setResultCount(R.uniq(res).length);
        setResults(res);
        setSortedResults(groupResults(res, sort));
      }
    }
  });
  (0, _react.useEffect)(function () {
    updateResults(previousSort, queryStringState.sort, previousQuery, queryStringState.q, defaultsResults);
  }, [defaultsResults, fuseOpts, previousQuery, previousResults, previousSort, queryStringState.q, queryStringState.sort, results, updateResults]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "listing"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--fluid  aba-container--light-gray aba-container--padding-b-lg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container__col"
  }, sponsors && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "National Sponsors"), /*#__PURE__*/_react.default.createElement(_Sponsors.default, {
    sponsors: sponsors
  })), /*#__PURE__*/_react.default.createElement("h2", null, "All Participating Banks"), /*#__PURE__*/_react.default.createElement(_SearchField.default, {
    handleChange: handleChange,
    queryStringState: queryStringState,
    defaultValue: searchValues.q,
    labelText: "Search by State, City, or Bank Name",
    results: defaultsResults
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "results aba-container aba-container--100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container__col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "results__header"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "status",
    role: "status"
  }, statusText), /*#__PURE__*/_react.default.createElement(_SortField.default, {
    handleChange: handleChange,
    queryStringState: queryStringState,
    defaultValue: queryStringState.sort
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "results__list",
    ref: resultsRef,
    "aria-label": "Results",
    tabIndex: "-1"
  }, /*#__PURE__*/_react.default.createElement(_ListingContainer.default, {
    isLoading: isLoading
  }, !isLoading && sortedResults.map(function (r, k) {
    return /*#__PURE__*/_react.default.createElement(_ResultItem.default, {
      result: r,
      key: "".concat(r.state, "_").concat(k)
    });
  }), !isLoading && sortedResults.length < 1 && /*#__PURE__*/_react.default.createElement("h2", null, "No results were found for your search"))))));
};
App.propTypes = propTypes;
var _default = exports.default = App;

},{"../../../../common/usePrevious.js":5,"../../../../common/useSearchValues.js":6,"../../../ResultItem/ResultItem.jsx":79,"../Listing/ListingContainer.jsx":53,"../SearchField/SearchField.jsx":54,"../SortField/SortField.jsx":55,"../Sponsors.jsx":56,"fuse.js":"fuse.js","prop-types":"prop-types","ramda":"ramda","react":"react"}],51:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("prop-types");
var _App = _interopRequireDefault(require("./App.jsx"));
var _QueryStringContext = require("../../../QueryStringContext/QueryStringContext.jsx");
var _AppContext = require("./AppContext.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {};
var queryStringStore = (0, _QueryStringContext.createStore)({
  q: "",
  sort: "asc"
});
var AppContainer = function AppContainer(props) {
  var fetchUrl = props.fetchUrl,
    sponsors = props.sponsors,
    showContact = props.showContact;
  //set context with data response

  var initialState = {
    showContact: showContact
  };
  var _useState = (0, _react.useState)(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    appContext = _useState2[0],
    setAppContext = _useState2[1];
  return /*#__PURE__*/_react.default.createElement(_QueryStringContext.QueryStringProvider, {
    store: queryStringStore
  }, /*#__PURE__*/_react.default.createElement(_QueryStringContext.QueryStringConsumer, null, function (context) {
    return /*#__PURE__*/_react.default.createElement(_AppContext.AppContext.Provider, {
      value: {
        state: appContext,
        actions: setAppContext
      }
    }, /*#__PURE__*/_react.default.createElement(_App.default, {
      setQueryStringState: context.setQueryStringState,
      queryStringState: context.queryStringState,
      fetchUrl: fetchUrl,
      sponsors: sponsors
    }));
  }));
};
AppContainer.propTypes = propTypes;
var _default = exports.default = AppContainer;

},{"../../../QueryStringContext/QueryStringContext.jsx":77,"./App.jsx":50,"./AppContext.js":52,"prop-types":"prop-types","react":"react"}],52:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFinEdListingContext = exports.AppContext = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AppContext = exports.AppContext = /*#__PURE__*/_react.default.createContext();
var useFinEdListingContext = exports.useFinEdListingContext = function useFinEdListingContext() {
  return (0, _react.useContext)(AppContext);
};

},{"react":"react"}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _excluded = ["isLoading", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  isLoading: _propTypes.bool,
  children: _propTypes.node
};
var ListingContainer = function ListingContainer(props) {
  var isLoading = props.isLoading,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("section", otherProps, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("fin-ed-listing__loader", {
      "is-loading": isLoading
    }),
    "aria-hidden": !isLoading
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "circle-loader fin-ed-listing__loader-svg",
    viewBox: "0 0 100 100",
    "aria-label": "Loading",
    focusable: "true",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Loading"), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45"
  }))), children);
};
ListingContainer.propTypes = propTypes;
var _default = exports.default = ListingContainer;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],54:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _downshift = _interopRequireDefault(require("downshift"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  handleChange: _propTypes.func.isRequired,
  defaultValue: _propTypes.string,
  labelText: _propTypes.string.isRequired,
  results: _propTypes.array.isRequired,
  statusText: _propTypes.string
};
var SearchField = function SearchField(props) {
  var handleChange = props.handleChange,
    defaultValue = props.defaultValue,
    labelText = props.labelText,
    results = props.results;
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    itemCount = _useState4[0],
    setItemCount = _useState4[1];
  var input = (0, _react.useRef)(null);
  var submitBtn = (0, _react.useRef)(null);
  var downshift = (0, _react.useRef)(null);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    handleChange({
      q: inputValue
    });
  };
  var clearInput = function clearInput(e) {
    e.preventDefault();
    setInputValue("");
    input.current.focus();
    downshift.current.reset({
      inputValue: ""
    });
  };
  var parseResults = function parseResults(results) {
    return R.compose(R.uniq, R.flatten(), R.map(
    //just pass the bank and state
    function (i) {
      return [{
        type: "bank",
        value: i.bank
      }, {
        type: "state",
        value: i.state
      }, {
        type: "city",
        value: i.city
      }];
    }))(results);
  };
  var typeAheadResults = (0, _react.useMemo)(function () {
    return parseResults(results);
  }, [results]);
  (0, _react.useEffect)(function () {
    setItemCount(typeAheadResults.filter(function (i) {
      return !inputValue || i.value.toLowerCase().includes(inputValue.toLowerCase());
    }).length);
  }, [inputValue, typeAheadResults]);
  return /*#__PURE__*/_react.default.createElement("form", {
    role: "search",
    "aria-label": "FinEd Participant Listing",
    className: "aba-form fined__form",
    onSubmit: function onSubmit(e) {
      return handleSubmit(e);
    }
    //key added to rerender component when keyword is manually entered after using typeahead
    ,
    key: defaultValue
  }, /*#__PURE__*/_react.default.createElement(_downshift.default, {
    ref: downshift,
    onStateChange: function onStateChange(_ref) {
      var inputValue = _ref.inputValue,
        type = _ref.type,
        isOpen = _ref.isOpen;
      return setInputValue(inputValue === undefined ? "" : inputValue);
    },
    onChange: function onChange(c) {
      submitBtn.current.focus();
    },
    initialInputValue: defaultValue,
    itemToString: function itemToString(item) {
      return item ? item.value : inputValue;
    }
  }, function (_ref2) {
    var getInputProps = _ref2.getInputProps,
      getItemProps = _ref2.getItemProps,
      getLabelProps = _ref2.getLabelProps,
      isOpen = _ref2.isOpen,
      inputValue = _ref2.inputValue,
      highlightedIndex = _ref2.highlightedIndex,
      selectedItem = _ref2.selectedItem;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "fined__form-content"
    }, /*#__PURE__*/_react.default.createElement("label", _extends({
      className: "fined__form-label"
    }, getLabelProps(), {
      htmlFor: "query"
    }), labelText), /*#__PURE__*/_react.default.createElement("div", {
      className: "aba-input__typeahead-container"
    }, /*#__PURE__*/_react.default.createElement("input", _extends({
      ref: input
    }, getInputProps(), {
      className: (0, _classnames.default)("fined__form-input", "aba-input", "form-control", {
        "is-open": isOpen && itemCount > 0
      }),
      id: "query",
      name: "query",
      type: "search"
    })), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: (0, _classnames.default)("aba-btn", "aba-btn--clear", {
        "is-hidden": !inputValue
      }),
      onClick: function onClick(e) {
        return clearInput(e);
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      id: "abasearchfieldclear",
      className: "visuallyhidden"
    }, "Clear search field"), /*#__PURE__*/_react.default.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 17 17",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      focusable: "false",
      "aria-labelledby": "abasearchfieldclear"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M2.4896 2.4896C5.809-.83 11.191-.83 14.5104 2.4896c3.3195 3.3194 3.3195 8.7014 0 12.0208-3.3194 3.3195-8.7014 3.3195-12.0208 0C-.83 11.191-.83 5.809 2.4896 2.4896zM5.318 3.9038L3.9038 5.318 7.0858 8.5l-3.182 3.182 1.4142 1.4142L8.5 9.9142l3.182 3.182 1.4142-1.4142L9.9142 8.5l3.182-3.182-1.4142-1.4142L8.5 7.0858l-3.182-3.182z",
      fillRule: "evenodd",
      fill: "currentColor"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("aba-input__typeahead", {
        "is-visible": isOpen && itemCount > 0
      }),
      "aria-hidden": !isOpen && itemCount > 0
    }, typeAheadResults.filter(function (i) {
      return !inputValue || i.value.toLowerCase().includes(inputValue.toLowerCase());
    }).map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        className: (0, _classnames.default)("aba-input__typeahead-opt"),
        key: index
      }, getItemProps({
        key: "".concat(item.value, "_").concat(item.type),
        index: index,
        item: item,
        style: {
          backgroundColor: highlightedIndex === index ? "#f3f3f3" : "white",
          fontWeight: selectedItem === item ? "bold" : "normal"
        }
      })), item.value);
    }))), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      "aria-label": "submit",
      className: "btn btn-primary fined__form-submit",
      ref: submitBtn
    }, "Search"));
  }));
};
SearchField.propTypes = propTypes;
var _default = exports.default = SearchField;

},{"classnames":"classnames","downshift":"downshift","prop-types":"prop-types","ramda":"ramda","react":"react"}],55:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var propTypes = {
  handleChange: _propTypes.func.isRequired,
  defaultValue: _propTypes.string
};
var SortField = function SortField(props) {
  var handleChange = props.handleChange,
    defaultValue = props.defaultValue;
  var select = (0, _react.useRef)();
  return /*#__PURE__*/_react.default.createElement("form", {
    className: "aba-form aba__fined-sort"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "fined-sort"
  }, "Sort by "), /*#__PURE__*/_react.default.createElement("select", {
    defaultValue: defaultValue,
    ref: select,
    className: "form-control",
    onChange: function onChange(e) {
      return handleChange({
        sort: select.current.value
      }, e);
    },
    onBlur: function onBlur(e) {
      return handleChange({
        sort: select.current.value
      }, e);
    },
    onKeyUp: function onKeyUp(e) {
      return handleChange({
        sort: select.current.value
      }, e);
    },
    id: "fined-sort"
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: "asc"
  }, "A-Z"), /*#__PURE__*/_react.default.createElement("option", {
    value: "desc"
  }, "Z-A")));
};
SortField.propTypes = propTypes;
var _default = exports.default = SortField;

},{"prop-types":"prop-types","react":"react"}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import usBankImg from "../../../../img/banks/usbank.jpg";
// import bbtImg from "../../../../img/banks/bbt.jpg";
// import jpMorganImg from "../../../../img/banks/jpmorgan.jpg";
// import tdBankImg from "../../../../img/banks/tdbank.jpg";
// import wellsFargoImg from "../../../../img/banks/wellsfargo.jpg";

var propTypes = {
  sponsors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    link: _propTypes.string,
    imageSrc: _propTypes.string,
    imageAlt: _propTypes.string
  }))
};
var Sponsors = function Sponsors(props) {
  var sponsors = props.sponsors;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container sponsors"
  }, sponsors.map(function (sponsor, idx) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: idx,
      className: "aba-container__col"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: sponsor.link,
      className: "sponsors__card",
      target: "__blank"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: sponsor.imageSrc,
      alt: sponsor.imageAlt
    })));
  }));
};
Sponsors.propTypes = propTypes;
var _default = exports.default = Sponsors;

},{"prop-types":"prop-types","react":"react"}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireDefault(require("react"));
var _AppContainer = _interopRequireDefault(require("./components/App/AppContainer.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var initFinEdListing = function initFinEdListing() {
  document.querySelectorAll(".js-fin-ed-listing-mount").forEach(function (mount) {
    if (mount) {
      _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_AppContainer.default, {
        fetchUrl: mount.dataset.url,
        sponsors: mount.dataset.sponsors ? JSON.parse(mount.dataset.sponsors) : null,
        showContact: mount.dataset.showcontact === "true"
      }), mount);
    }
  });
};
var _default = exports.default = initFinEdListing;

},{"./components/App/AppContainer.jsx":51,"react":"react","react-dom":"react-dom"}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _excluded = ["label", "as"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  disabled: _propTypes.bool,
  label: _propTypes.string,
  as: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.object])
};
var defaultProps = {
  as: "input"
};
var Checkbox = function Checkbox(props) {
  var label = props.label,
    Component = props.as,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: "aba-form__field checkbox"
  }, /*#__PURE__*/_react.default.createElement(Component, _extends({
    type: "checkbox"
  }, rest)), /*#__PURE__*/_react.default.createElement("span", {
    className: "checkbox__custom"
  }), label);
};
Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
var _default = exports.default = Checkbox;

},{"prop-types":"prop-types","react":"react"}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var propTypes = {
  legend: _propTypes.string,
  children: _propTypes.node,
  className: _propTypes.string
};
var CheckboxGroup = function CheckboxGroup(props) {
  var legend = props.legend,
    className = props.className,
    children = props.children;
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    className: (0, _classnames.default)("checkbox-group", className)
  }, /*#__PURE__*/_react.default.createElement("legend", {
    dangerouslySetInnerHTML: {
      __html: legend
    }
  }), children);
};
CheckboxGroup.propTypes = propTypes;
var _default = exports.default = CheckboxGroup;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var propTypes = {
  errorMessage: _propTypes.string
};
var ErrorMessage = function ErrorMessage(props) {
  var errorMessage = props.errorMessage;
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "alert",
    className: (0, _classnames.default)("error-message", {
      "is-active": errorMessage
    }),
    "data-error": errorMessage,
    "aria-label": "Error Message.",
    tabIndex: "-1"
  }, errorMessage);
};
ErrorMessage.propTypes = propTypes;
var _default = exports.default = ErrorMessage;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _formik = require("formik");
var _CheckboxGroup = _interopRequireDefault(require("../../Form/Checkbox/CheckboxGroup.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["label", "type", "fieldType", "name", "description", "isValidating", "children", "Component", "formik", "characterLimit"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  label: _propTypes.string,
  type: _propTypes.string,
  fieldType: _propTypes.string,
  name: _propTypes.string,
  description: _propTypes.string,
  isValidating: _propTypes.bool,
  children: _propTypes.node,
  Component: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.object]),
  formik: _propTypes.object
};
var defaultProps = {
  type: "input",
  Component: _formik.Field
};
var FormField = function FormField(props) {
  var label = props.label,
    type = props.type,
    fieldType = props.fieldType,
    name = props.name,
    description = props.description,
    isValidating = props.isValidating,
    children = props.children,
    Component = props.Component,
    formik = props.formik,
    characterLimit = props.characterLimit,
    rest = _objectWithoutProperties(props, _excluded);
  var errors = formik.errors,
    touched = formik.touched,
    values = formik.values;
  var hasError = function hasError(key) {
    return isValidating && errors[key] || touched[key] && errors[key];
  };
  var displayError = function displayError(key) {
    return hasError(key) ? errors[key] : null;
  };
  var errorMessage = /*#__PURE__*/_react.default.createElement("p", {
    id: "".concat(name, "-error"),
    className: "aba-form__error-message",
    "aria-atomic": "true",
    "aria-hidden": hasError(name) ? false : true
  }, displayError(name));
  var characterLimitMessage = null;
  if (characterLimit) {
    var currLen = values[name] ? values[name].length : 0;
    var rem = characterLimit - currLen >= 0 ? characterLimit - currLen : 0;
    characterLimitMessage = /*#__PURE__*/_react.default.createElement("p", null, "You have " + rem + " characters remaining.");
    touched[name] = true;
  }
  var renderField = function renderField(type) {
    switch (type) {
      case "radiogroup":
        return /*#__PURE__*/_react.default.createElement("fieldset", {
          className: (0, _classnames.default)("aba-form__field aba-form__radio-group", {
            "aba-form__field--invalid": hasError(name)
          })
        }, (label || description) && /*#__PURE__*/_react.default.createElement("legend", null, /*#__PURE__*/_react.default.createElement("strong", null, label), /*#__PURE__*/_react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: description
          }
        })), children, errorMessage);
      case "checkboxgroup":
        return /*#__PURE__*/_react.default.createElement(_CheckboxGroup.default, {
          className: (0, _classnames.default)("aba-form__field", {
            "aba-form__field--invalid": hasError(name)
          }),
          legend: "<strong>".concat(label, "</strong>")
        }, children, errorMessage);
      default:
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)("aba-form__field", {
            "aba-form__field--invalid": hasError(name)
          })
        }, label && /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: name
        }, label), description && /*#__PURE__*/_react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: description
          }
        }), /*#__PURE__*/_react.default.createElement(Component, _extends({
          id: name,
          name: name,
          as: type,
          type: fieldType,
          className: "form-control",
          "aria-invalid": hasError(name) ? "true" : null,
          "aria-describedby": hasError(name) ? "".concat(name, "-error") : null,
          children: children
        }, rest)), characterLimit && !hasError(name) && characterLimitMessage, errorMessage);
    }
  };
  return renderField(type);
};
FormField.propTypes = propTypes;
FormField.defaultProps = defaultProps;
var _default = exports.default = (0, _formik.connect)(FormField);

},{"../../Form/Checkbox/CheckboxGroup.jsx":59,"classnames":"classnames","formik":"formik","prop-types":"prop-types","react":"react"}],62:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _formik = require("formik");
var _useGoogleMaps = _interopRequireDefault(require("./useGoogleMaps.js"));
var _excluded = ["id", "value", "onUpdate", "onUpdateLongitude", "onUpdateLatitude", "apiKey"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  value: _propTypes.string,
  onUpdate: _propTypes.func
};
window.componentForm = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country: "short_name",
  postal_code: "short_name"
};
var GoogleMapsSearch = function GoogleMapsSearch(props) {
  var id = props.id,
    _props$value = props.value,
    value = _props$value === void 0 ? "" : _props$value,
    onUpdate = props.onUpdate,
    onUpdateLongitude = props.onUpdateLongitude,
    onUpdateLatitude = props.onUpdateLatitude,
    apiKey = props.apiKey,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = (0, _react.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    stateValue = _useState2[0],
    setValue = _useState2[1];
  var status = (0, _useGoogleMaps.default)({
    key: apiKey,
    callback: "initAutocomplete",
    libraries: "places",
    v: "3",
    sensor: "false"
  });
  window.initAutocomplete = function () {
    // Create the autocomplete object, restricting the search to geographical
    // location types.
    window.autocomplete = new google.maps.places.Autocomplete(document.getElementById(id), {
      types: ["geocode"]
    });

    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    autocomplete.addListener("place_changed", fillInAddress);
    google.maps.event.addDomListener(document.getElementById(id), "keydown", function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    });
  };
  var handleChange = function handleChange(value) {
    setValue(value);
    onUpdate(value);
    if (onUpdateLongitude) onUpdateLongitude(null);
    if (onUpdateLatitude) onUpdateLatitude(null);
  };
  var fillInAddress = function fillInAddress() {
    // Get the place details from the autocomplete object.
    var place = window.autocomplete.getPlace();
    var street_number = "",
      address = "",
      city = "",
      state = "",
      zip = "",
      country = "";
    var long = place.geometry.location.lng();
    var lat = place.geometry.location.lat();
    if (onUpdateLongitude) onUpdateLongitude(long);
    if (onUpdateLatitude) onUpdateLatitude(lat);
    var input = document.getElementById(id);
    input.value = "";

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (componentForm[addressType]) {
        var val = place.address_components[i][componentForm[addressType]];
        switch (addressType) {
          case "street_number":
            street_number = val;
            break;
          case "route":
            address = val;
            break;
          case "locality":
            city = val;
            break;
          case "administrative_area_level_1":
            state = val;
            break;
          case "postal_code":
            zip = val;
            break;
          case "country":
            country = val;
            break;
          default:
        }
        var newValue = city === "" ? "Statewide, " + state : "".concat(city, ", ").concat(state === "" || state.length > 2 ? country : state);
        setValue(newValue);
        onUpdate(newValue);
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    id: id
  }, rest, {
    type: "text",
    value: stateValue,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    }
  }));
};
GoogleMapsSearch.propTypes = propTypes;
var _default = exports.default = GoogleMapsSearch;

},{"./useGoogleMaps.js":63,"formik":"formik","prop-types":"prop-types","react":"react"}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useGoogleMaps = function useGoogleMaps(opts) {
  // Keep track of script status ("idle", "loading", "ready", "error")
  var _useState = (0, _react.useState)(opts ? "loading" : "idle"),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  (0, _react.useEffect)(function () {
    // Allow falsy src value if waiting on other data needed for
    // constructing the script URL passed to this hook.
    if (!opts) {
      setStatus("idle");
      return;
    }
    var queryParams = Object.keys(opts).map(function (key) {
      return key + "=" + opts[key];
    }).join("&");
    var src = "//maps.googleapis.com/maps/api/js?".concat(queryParams);

    // Fetch existing script element by src
    // It may have been added by another intance of this hook
    var script = document.querySelector("script[src=\"".concat(src, "\"]"));
    if (!script) {
      // Create script
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.setAttribute("data-status", "loading");
      // Add script to document body
      document.body.appendChild(script);

      // Store status in attribute on script
      // This can be read by other instances of this hook
      var setAttributeFromEvent = function setAttributeFromEvent(event) {
        script.setAttribute("data-status", event.type === "load" ? "ready" : "error");
      };
      script.addEventListener("load", setAttributeFromEvent);
      script.addEventListener("error", setAttributeFromEvent);
    } else {
      // Grab existing script status from attribute and set to state.
      setStatus(script.getAttribute("data-status"));
      var callback = window[opts.callback];
      callback();
    }

    // Script event handler to update status in state
    // Note: Even if the script already exists we still need to add
    // event handlers to update the state for *this* hook instance.
    var setStateFromEvent = function setStateFromEvent(event) {
      setStatus(event.type === "load" ? "ready" : "error");
    };

    // Add event listeners
    script.addEventListener("load", setStateFromEvent);
    script.addEventListener("error", setStateFromEvent);

    // Remove event listeners on cleanup
    return function () {
      if (script) {
        script.removeEventListener("load", setStateFromEvent);
        script.removeEventListener("error", setStateFromEvent);
      }
    };
  }, [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  return status;
};
var _default = exports.default = useGoogleMaps;

},{"react":"react"}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  function handleEnterSpacebarKeypress(event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      (0, _jquery.default)(this).click();
      if (event.keyCode === 32) {
        event.preventDefault();
      }
    }
  }

  /* #################### ESC KEY PRESS #################### */
  (0, _jquery.default)(document).on("keyup", function (e) {
    if (e.code === "Escape") {
      (0, _jquery.default)("body").removeClass("main-nav--open header__search--open utility-nav__account--open search-filters--open filter-modal-open video-modal-open");
      (0, _jquery.default)(".main-nav__list > li").removeClass("main-nav__dropdown--open");
      (0, _jquery.default)(".main-nav__list > li").children("span").attr("aria-expanded", false);
      (0, _jquery.default)(".utility-nav__account-trigger svg").attr("aria-expanded", false);
      setHamburgerButtonClosed();
      (0, _jquery.default)(".main-nav__sub-nav > li").removeClass("tert-nav--open");
      (0, _jquery.default)("body").removeClass("tert-nav--open");
      (0, _jquery.default)(".modal").removeClass("modal--open modal--speaker--open");
      (0, _jquery.default)(".video-modal").removeClass("video-modal--open");
    }
  });

  /* #################### SHADE #################### */
  (0, _jquery.default)(".shade").on("click", function () {
    (0, _jquery.default)("body").removeClass("main-nav--open header__search--open utility-nav__account--open search-filters--open filter-modal-open video-modal-open");
    (0, _jquery.default)(".main-nav__list > li").removeClass("main-nav__dropdown--open");
    (0, _jquery.default)(".main-nav__list > li").children("span").attr("aria-expanded", false);
    (0, _jquery.default)(".utility-nav__account-trigger svg").attr("aria-expanded", false);
    setHamburgerButtonClosed();
    (0, _jquery.default)(".main-nav__sub-nav > li").removeClass("tert-nav--open");
    (0, _jquery.default)("body").removeClass("tert-nav--open");
    (0, _jquery.default)(".video-modal").removeClass("video-modal--open");
  });

  /* #################### HEADER #################### */
  /* ########## POSITIONING ########## */
  function headerPositioning() {
    var heroHeight = (0, _jquery.default)(".hero").innerHeight();
    var halfScrollAmount = (0, _jquery.default)(window).innerHeight() / 2 - (0, _jquery.default)("header").innerHeight() / 2;
    var scrollAmount = (0, _jquery.default)(window).scrollTop();
    if (window.innerWidth >= 1080) {
      (0, _jquery.default)("header").css({
        position: "fixed",
        top: "0"
      });
      if ((0, _jquery.default)("body").hasClass("body--home")) {
        (0, _jquery.default)(window).on("scroll", function (event) {
          scrollAmount = (0, _jquery.default)(window).scrollTop();
          // dropdown positioning when scrolled to midpoint
          if (scrollAmount >= halfScrollAmount) {
            (0, _jquery.default)("body").addClass("scrolled-half-window-height");
          } else {
            (0, _jquery.default)("body").removeClass("scrolled-half-window-height");
          }
          // stickky header when scrolled to top
          if (scrollAmount >= heroHeight) {
            (0, _jquery.default)("body").addClass("header-position-top");
          } else {
            (0, _jquery.default)("body").removeClass("header-position-top");
          }
        });
      } else {
        (0, _jquery.default)(window).on("scroll", function (event) {
          (0, _jquery.default)("header").css({
            position: "fixed",
            top: "0"
          });
        });
      }
    } else {
      var prevScrollAmount = 0;
      (0, _jquery.default)(window).on("scroll", function (event) {
        scrollAmount = (0, _jquery.default)(window).scrollTop();
        if ((0, _jquery.default)("body").hasClass("main-nav--open")) {
          (0, _jquery.default)("header").css({
            position: "fixed",
            top: "0"
          });
        } else {
          if (scrollAmount > prevScrollAmount) {
            // down
            if (scrollAmount >= 65) {
              (0, _jquery.default)("header").css({
                position: "fixed",
                top: "-65px"
              });
            } else {
              (0, _jquery.default)("header").css({
                position: "absolute",
                top: "0"
              });
            }
          } else {
            // up
            (0, _jquery.default)("header").css({
              position: "fixed",
              top: "0"
            });
          }
        }
        prevScrollAmount = scrollAmount;
      });
    }
  }
  (0, _jquery.default)(window).on("load resize", function (e) {
    var onLoadWidth = (0, _jquery.default)(window).width();
    headerPositioning(onLoadWidth);
  });

  /* ########## STRIP HOME HEADER IF TOO LARGE FOR SCREEN ########## */
  function stripHomeHeader() {
    (0, _jquery.default)(".main-nav__dropdown").css("max-height", "999999999px");
    var windowHeight = (0, _jquery.default)(window).innerHeight();
    var tallestNavDropdown = -1;
    var headerHeight = (0, _jquery.default)("header").innerHeight();
    (0, _jquery.default)(".main-nav__dropdown").each(function () {
      tallestNavDropdown = tallestNavDropdown > (0, _jquery.default)(this).innerHeight() ? tallestNavDropdown : (0, _jquery.default)(this).innerHeight();
    });
    (0, _jquery.default)(".main-nav__dropdown").css("max-height", "0");
    tallestNavDropdown = tallestNavDropdown + headerHeight;
    if (tallestNavDropdown >= windowHeight) {
      (0, _jquery.default)("body.with-homepage-header").removeClass("body--home");
      (0, _jquery.default)(".main-nav__dropdown").css("overflow-y", "scroll");
    } else {
      (0, _jquery.default)("body.with-homepage-header").addClass("body--home");
      (0, _jquery.default)(".main-nav__dropdown").css("overflow-y", "visible");
    }
  }
  (0, _jquery.default)(window).on("resize", function () {
    stripHomeHeader();
  });
  (0, _jquery.default)(document).on("ready", function () {
    setTimeout(stripHomeHeader, 50);
  });

  /* ########## SEARCH OPEN/CLOSE ########## */
  (0, _jquery.default)(".utility-nav__search svg").on("click", function () {
    (0, _jquery.default)(".main-nav__list > li").removeClass("main-nav__dropdown--open");
    (0, _jquery.default)(".main-nav__list > li").children("span").attr("aria-expanded", false);
    (0, _jquery.default)(".utility-nav__hamburger svg").attr("aria-expanded", false);
    setHamburgerButtonClosed();
    (0, _jquery.default)(".main-nav__sub-nav > li").removeClass("tert-nav--open");
    (0, _jquery.default)("body").removeClass("tert-nav--open");
    (0, _jquery.default)("body").removeClass("main-nav--open utility-nav__account--open");
    (0, _jquery.default)("body").toggleClass("header__search--open");
    if ((0, _jquery.default)("body").hasClass("header__search--open")) {
      (0, _jquery.default)(".utility-nav__search .visuallyhidden").html("Search is activated.");
      (0, _jquery.default)(".CoveoSearchbox input").focus();
    } else {
      (0, _jquery.default)(".utility-nav__search .visuallyhidden").html("");
    }
    (0, _jquery.default)(".utility-nav__account-trigger svg").attr("aria-expanded", false);
  });
  (0, _jquery.default)(".utility-nav__search svg").on("keydown", handleEnterSpacebarKeypress);
  (0, _jquery.default)(".header__search__close").on("click", function () {
    (0, _jquery.default)("body").toggleClass("header__search--open");
  });

  /* ########## SEARCH PREDICTIVE RESULTS ########## */
  (0, _jquery.default)("#header-search").on("keyup", function () {
    if ((0, _jquery.default)(this).val().length >= 1) {
      (0, _jquery.default)(this).parent().addClass("header__search__predictive--open");
    } else {
      (0, _jquery.default)(this).parent().removeClass("header__search__predictive--open");
    }
  });

  /* ########## SEARCH CLEAR ########## */
  (0, _jquery.default)(".header__search__cancel").on("click", function () {
    (0, _jquery.default)("#header-search").val("");
    (0, _jquery.default)("#header-search").parent().removeClass("header__search__predictive--open");
  });

  /* ########## HAMBURGER ########## */
  (0, _jquery.default)(".utility-nav__hamburger svg").on("click", function () {
    if ((0, _jquery.default)(this).hasClass("utility-nav__hamburger__close")) {
      setHamburgerButtonClosed();
    } else if ((0, _jquery.default)(this).hasClass("utility-nav__hamburger__hamburger")) {
      toggleNavigationTabbable(true);
      (0, _jquery.default)(".utility-nav__hamburger svg").attr("aria-expanded", true);
      (0, _jquery.default)(".utility-nav__hamburger__close").removeClass("visuallyhidden");
      (0, _jquery.default)(".utility-nav__hamburger__close").attr("tabindex", 0);
      (0, _jquery.default)(".utility-nav__hamburger__hamburger").addClass("visuallyhidden");
      (0, _jquery.default)(".utility-nav__hamburger__hamburger").attr("tabindex", -1);
    }
    (0, _jquery.default)("body").removeClass("header__search--open");
    (0, _jquery.default)(".main-nav__list > li").removeClass("main-nav__dropdown--open");
    (0, _jquery.default)(".main-nav__list > li").children("span").attr("aria-expanded", false);
    (0, _jquery.default)(".utility-nav__account-trigger svg").attr("aria-expanded", false);
    (0, _jquery.default)(".main-nav__sub-nav > li").removeClass("tert-nav--open");
    (0, _jquery.default)("body").removeClass("tert-nav--open");
    (0, _jquery.default)("body").toggleClass("main-nav--open");
    if ((0, _jquery.default)(this).hasClass("utility-nav__hamburger__close")) {
      (0, _jquery.default)(".utility-nav__hamburger__hamburger").focus();
    } else if ((0, _jquery.default)(this).hasClass("utility-nav__hamburger__hamburger")) {
      (0, _jquery.default)(".utility-nav__hamburger__close").focus();
    }
  });
  (0, _jquery.default)(".utility-nav__hamburger svg").on("keydown", handleEnterSpacebarKeypress);
  function setHamburgerButtonClosed() {
    (0, _jquery.default)(".utility-nav__hamburger__close").addClass("visuallyhidden");
    (0, _jquery.default)(".utility-nav__hamburger__close").attr("tabindex", -1);
    (0, _jquery.default)(".utility-nav__hamburger__hamburger").removeClass("visuallyhidden");
    (0, _jquery.default)(".utility-nav__hamburger__hamburger").attr("tabindex", 0);
    toggleNavigationTabbable(false);
    (0, _jquery.default)(".utility-nav__hamburger svg").attr("aria-expanded", false);
  }

  /* ########## ACCOUNT ########## */
  (0, _jquery.default)(".utility-nav__account-trigger").on("click", function () {
    (0, _jquery.default)("body").removeClass("main-nav--open header__search--open");
    (0, _jquery.default)(".main-nav__list > li").removeClass("main-nav__dropdown--open");
    (0, _jquery.default)(".main-nav__list > li").children("span").attr("aria-expanded", false);
    (0, _jquery.default)("body").toggleClass("utility-nav__account--open");
    (0, _jquery.default)(".utility-nav__account-trigger svg").attr("aria-expanded", (0, _jquery.default)(".utility-nav__account-trigger svg").attr("aria-expanded") === "false" ? true : false);
  });
  (0, _jquery.default)(".utility-nav__account-trigger svg").on("keydown", handleEnterSpacebarKeypress);

  /* ########## MAIN NAV WIDTH ########## */
  function mainNavWidth() {
    if (window.innerWidth >= 1180) {
      var utilityNavWidth = (0, _jquery.default)(".utility-nav").innerWidth();
      var alteredUtilityNavWidth = utilityNavWidth + 4;
      (0, _jquery.default)(".main-nav").css("width", "calc(100% - " + alteredUtilityNavWidth + "px)");
    } else {
      (0, _jquery.default)(".main-nav").css("width", "100%");
    }
  }
  (0, _jquery.default)(window).on("load resize", function (e) {
    var onLoadWidth = (0, _jquery.default)(window).width();
    mainNavWidth(onLoadWidth);
  });

  /* ########## MAIN NAV INTERACTIVITY ########## */
  (0, _jquery.default)(".main-nav__list > li > span").on("click", function () {
    if ((0, _jquery.default)(this).parent().hasClass("main-nav__dropdown--open")) {
      if (window.innerWidth >= 1180) {
        (0, _jquery.default)("body").removeClass("main-nav--open");
      }
      (0, _jquery.default)(".main-nav__list > li").removeClass("main-nav__dropdown--open");
      (0, _jquery.default)(".main-nav__list > li").children("span").attr("aria-expanded", false);
    } else {
      (0, _jquery.default)("body").removeClass("header__search--open utility-nav__account--open");
      if (window.innerWidth >= 1180) {
        (0, _jquery.default)("body").addClass("main-nav--open");
      }
      (0, _jquery.default)(".main-nav__list > li").removeClass("main-nav__dropdown--open");
      (0, _jquery.default)(".main-nav__list > li").children("span").attr("aria-expanded", false);
      (0, _jquery.default)(this).parent().addClass("main-nav__dropdown--open");
      (0, _jquery.default)(this).parent().children("span").attr("aria-expanded", true);
    }
  });
  (0, _jquery.default)(".main-nav__list > li > span").on("keydown", handleEnterSpacebarKeypress);
  (0, _jquery.default)('.main-nav__list button, .main-nav__list a, .main-nav__list input, .main-nav__list select, .main-nav__list textarea, .main-nav__list [tabindex]:not([tabindex="-1"]), .login-link').on("keydown", function (event) {
    if (event.code === "Tab") {
      var openSubNav = (0, _jquery.default)(".main-nav__dropdown--open");
      var tabbables = openSubNav.find(":tabbable");
      var i = tabbables.index(event.target);
      if (!event.shiftKey && i === tabbables.length - 1) {
        //Open next menu
        openSubNav.removeClass("main-nav__dropdown--open");
        openSubNav.children("span").attr("aria-expanded", false);
        var nextNav = openSubNav.next(".main-nav__list > li");
        nextNav.addClass("main-nav__dropdown--open");
        nextNav.children("span").attr("aria-expanded", true);
      } else if (event.shiftKey && i === 0) {
        //open previous menu
        var prevNav = openSubNav.prev(".main-nav__list > li");
        openSubNav.removeClass("main-nav__dropdown--open");
        openSubNav.children("span").attr("aria-expanded", false);
        prevNav.addClass("main-nav__dropdown--open");
        prevNav.children("span").attr("aria-expanded", true);
      }

      //Small viewports - go back to hamburger menu button if tabbing backward from first tabbable in nav
      tabbables = (0, _jquery.default)(".main-nav :tabbable");
      i = tabbables.index(event.target);
      if (event.shiftKey && i === 0) {
        if ((0, _jquery.default)(".utility-nav__hamburger__close").is(":visible")) {
          (0, _jquery.default)(".utility-nav__hamburger__close").focus();
          event.preventDefault();
        }
      }

      //Small viewports - handle tabbing order within tertiary menu
      if ((0, _jquery.default)(".utility-nav__hamburger__close").is(":visible")) {
        var tertMenu = (0, _jquery.default)(event.target).closest(".main-nav__tert-nav");
        if (tertMenu.length) {
          tabbables = tertMenu.find(":tabbable");
          i = tabbables.index(event.target);
          if (!event.shiftKey && i === tabbables.length - 1) {
            tertMenu.prev(".tert-nav__wrapper__close-tert").focus();
            event.preventDefault();
          }
        }
        if ((0, _jquery.default)(this).hasClass("tert-nav__wrapper__close-tert") && event.shiftKey) {
          tertMenu = (0, _jquery.default)(this).next(".main-nav__tert-nav");
          tertMenu.find(":tabbable").last().focus();
          event.preventDefault();
        }
      }
    }
  });
  (0, _jquery.default)(window).on("load resize", function (e) {
    if ((0, _jquery.default)(".utility-nav__hamburger").is(":visible")) {
      toggleNavigationTabbable((0, _jquery.default)("body").hasClass("main-nav--open"));
    } else {
      toggleNavigationTabbable(true);
    }
  });
  (0, _jquery.default)(document).on("ready", function () {
    if ((0, _jquery.default)(".utility-nav__hamburger").is(":visible")) {
      toggleNavigationTabbable((0, _jquery.default)("body").hasClass("main-nav--open"));
    }
  });
  function toggleNavigationTabbable(enable) {
    var val = enable ? 0 : -1;
    var selector = enable ? (0, _jquery.default)('[TabIndex="-1"]') : (0, _jquery.default)(".main-nav :tabbable");
    selector.attr("tabindex", val);
  }
  (0, _jquery.default)(".utility-nav__hamburger__close").on("keydown", function (event) {
    if (!event.shiftKey && event.code === "Tab") {
      var nav = (0, _jquery.default)(".main-nav");
      nav.find(":tabbable").first().focus();
      event.preventDefault();
    }
  });
  function visible(element) {
    return _jquery.default.expr.filters.visible(element) && !(0, _jquery.default)(element).parents().addBack().filter(function () {
      return _jquery.default.css(this, "visibility") === "hidden";
    }).length;
  }
  function _focusable(element, isTabIndexNotNaN) {
    var map,
      mapName,
      img,
      nodeName = element.nodeName.toLowerCase();
    if (nodeName === "area") {
      map = element.parentNode;
      mapName = map.name;
      if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") {
        return false;
      }
      img = (0, _jquery.default)("img[usemap=#" + mapName + "]")[0];
      return !!img && visible(img);
    }
    return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled : nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
    // the element and all of its ancestors must be visible
    visible(element);
  }
  _jquery.default.extend(_jquery.default.expr[":"], {
    data: _jquery.default.expr.createPseudo ? _jquery.default.expr.createPseudo(function (dataName) {
      return function (elem) {
        return !!_jquery.default.data(elem, dataName);
      };
    }) // support: jQuery <1.8
    : function (elem, i, match) {
      return !!_jquery.default.data(elem, match[3]);
    },
    focusable: function focusable(element) {
      return _focusable(element, !isNaN(_jquery.default.attr(element, "tabindex")));
    },
    tabbable: function tabbable(element) {
      var tabIndex = _jquery.default.attr(element, "tabindex"),
        isTabIndexNaN = isNaN(tabIndex);
      return (isTabIndexNaN || tabIndex >= 0) && _focusable(element, !isTabIndexNaN);
    }
  });

  /* ########## MAIN NAV DROPDOWN HEIGHT MATCH ########## */
  function dropdownHeightMatch() {
    if (window.innerWidth >= 1180) {
      (0, _jquery.default)(".main-nav__dropdown").each(function () {
        (0, _jquery.default)(this).find(".main-nav__sub-nav").css("height", "auto");
        (0, _jquery.default)(this).find(".main-nav__desktop-sidebar").css("height", "auto");
        var subNavHeight = (0, _jquery.default)(this).find(".main-nav__sub-nav").innerHeight();
        var sidebarHeight = (0, _jquery.default)(this).find(".main-nav__desktop-sidebar").innerHeight();
        if (sidebarHeight >= subNavHeight) {
          (0, _jquery.default)(this).find(".main-nav__sub-nav").css("height", sidebarHeight);
        } else {
          (0, _jquery.default)(this).find(".main-nav__desktop-sidebar").css("height", "100%");
        }
      });
    } else {
      (0, _jquery.default)(".main-nav__sub-nav").css("height", "auto");
    }
  }
  (0, _jquery.default)(window).on("load resize", function (e) {
    var onLoadWidth = (0, _jquery.default)(window).width();
    dropdownHeightMatch(onLoadWidth);
  });

  /* ########## TERTIARY NAV INTERACTIVITY ########## */
  (0, _jquery.default)(".main-nav__sub-nav__tert-trigger").on("click", function () {
    (0, _jquery.default)(this).parent().addClass("tert-nav--open");
    (0, _jquery.default)("body").addClass("tert-nav--open");
  });
  (0, _jquery.default)(".tert-nav__wrapper__close-tert").on("click", function () {
    (0, _jquery.default)(this).parent().parent().removeClass("tert-nav--open");
    (0, _jquery.default)("body").removeClass("tert-nav--open");
  });
  (0, _jquery.default)(".main-nav__sub-nav__tert-trigger, .tert-nav__wrapper__close-tert").on("keydown", handleEnterSpacebarKeypress);

  /* ########## Close Search A11Y ########## */
  (0, _jquery.default)(".searchCloseDesktop").keyup(function (event) {
    //Enter key code
    if (event.keyCode === 13 || event.keyCode === 32) {
      (0, _jquery.default)("body").toggleClass("header__search--open");
    }
  });
  (0, _jquery.default)(document).ready(function () {
    var $logo150thElement = (0, _jquery.default)('.col-auto.header__logo-150th');
    var $containerElement = (0, _jquery.default)('.header__container');
    if ($logo150thElement.length === 0 && $containerElement.length > 0) {
      $containerElement.removeClass('header__container');
    }
  });
};

},{"jquery":"jquery"}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = require("../../common/analytics");
var initCartConfirmation = function initCartConfirmation() {
  document.querySelectorAll(".js-cart-confirmation").forEach(function (el) {
    var result = JSON.parse(el.dataset.products);
    (0, _analytics.addToCartComplete)(result.Products[0]);
  });
};
var _default = exports.default = initCartConfirmation;

},{"../../common/analytics":2}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var initInterstitialCart = function initInterstitialCart() {
  document.querySelectorAll(".js-add-to-cart").forEach(function (link) {
    var prodId = link.getAttribute("data-prod-id");
    var prodLoid = link.getAttribute("data-prod-loid");
    var prodEventKey = link.getAttribute("data-prod-eventkey");
    var url = link.getAttribute("data-url");
    var linkTextEl = link.querySelector("span");
    var isLMS = link.getAttribute("data-isLms");
    var errorElement = link.previousElementSibling;
    link.addEventListener("click", function (e) {
      e.preventDefault();
      errorElement.classList.remove("is-active");

      //do fetch of api
      //if success change to added add active class
      var payload = {
        productId: prodId,
        isLMS: isLMS,
        productLoid: prodLoid !== null && prodLoid !== void 0 ? prodLoid : "",
        eventPrimaryKey: prodEventKey !== null && prodEventKey !== void 0 ? prodEventKey : ""
      };
      link.classList.add("is-loading");
      linkTextEl.innerHTML = "<svg \n        class=\"flashing-loader\" viewBox=\"0 0 50 100\" aria-label=\"Loading\" focusable=\"false\" role=\"img\" \n   xmlns=\"http://www.w3.org/2000/svg\">\n           <circle cx=\"-47\" cy=\"50\" r=\"28\" fill=\"currentColor\"/>\n           <circle cx=\"26\" cy=\"50\" r=\"28\" fill=\"currentColor\"/>\n           <circle cx=\"97\" cy=\"50\" r=\"28\" fill=\"currentColor\"/>\n          </svg>";
      //how do we want to handle error messages
      // window.location = data.result.redirectUrl;
      //
      fetch("".concat(url), {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.Success) {
          window.location = data.Result.redirectUrl;
        } else {
          link.classList.remove("is-loading");
          link.classList.add("is-active");
          linkTextEl.innerHTML = "ADD PRODUCT";
          if (data.Errors) {
            if (errorElement.classList.contains("js-add-to-cart-error")) {
              errorElement.innerHTML = data.Errors.ErrorMessage;
              errorElement.tabIndex = -1;
              setTimeout(function () {
                errorElement.focus();
              }, 400);
            } else {
              alert(data.Errors.ErrorMessage);
            }
          } else {
            if (errorElement.classList.contains("js-add-to-cart-error")) {
              errorElement.innerHTML = "<p>Error: Could not add to cart. Please try again later.</p>";
              setTimeout(function () {
                errorElement.focus();
              }, 400);
            } else {
              alert("Error: Could not add to cart. Please try again later.");
            }
          }
          errorElement.classList.add("is-active");
        }
      }).catch(function (err) {
        console.error("err", err);
        link.classList.remove("is-loading");
        errorElement.classList.add("is-active");
        linkTextEl.innerHTML = "ADD PRODUCT";
        errorElement.innerHTML = "Error: Could not add to cart. Please try again later.";
        errorElement.tabIndex = -1;
        setTimeout(function () {
          errorElement.focus();
        }, 400);
      });
    });
  });
};
var _default = exports.default = initInterstitialCart;

},{}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### MODAL #################### */
  (0, _jquery.default)(".modal-open-trigger").click(function () {
    var modalTriggered = (0, _jquery.default)(this).attr("data-modal-trigger");
    (0, _jquery.default)(".modal").each(function () {
      if ((0, _jquery.default)(this).attr("data-modal") === modalTriggered) {
        (0, _jquery.default)(this).addClass("modal--open");
      } else {
        (0, _jquery.default)(this).removeClass("modal--open modal--speaker--open");
      }
    });
  });
  (0, _jquery.default)(".modal__shade, .modal__content__close, .call-to-action--modal, .close-registration-modal").click(function () {
    (0, _jquery.default)(".modal").removeClass("modal--open modal--speaker--open");
  });

  /* #################### FILTER MODAL OPEN/CLOSE #################### */
  (0, _jquery.default)(".filter-with-modal-open").click(function () {
    (0, _jquery.default)("body").addClass("filter-modal-open");
  });
  (0, _jquery.default)(".filter-with-modal__close, .filter-with-modal .btn").click(function () {
    (0, _jquery.default)("body").removeClass("filter-modal-open");
  });

  /* #################### VIDEO MODAL #################### */
  (0, _jquery.default)(".vid-modal-open-trigger").click(function () {
    if ((0, _jquery.default)("body").hasClass(".video-modal--open")) {
      (0, _jquery.default)("body").removeClass("video-modal-open");
    } else {
      (0, _jquery.default)("body").addClass("video-modal-open");
    }
    var vidModalTriggered = (0, _jquery.default)(this).attr("data-vid-modal-trigger");
    (0, _jquery.default)(".video-modal").each(function () {
      if ((0, _jquery.default)(this).attr("data-vid-modal") === vidModalTriggered) {
        (0, _jquery.default)(this).addClass("video-modal--open");
      } else {
        (0, _jquery.default)(this).removeClass("video-modal--open");
      }
    });
  });
  (0, _jquery.default)(".video-modal__close").click(function () {
    (0, _jquery.default)(".video-modal").removeClass("video-modal--open");
    (0, _jquery.default)("body").removeClass("video-modal-open");
  });
  (0, _jquery.default)(".video-modal").click(function (e) {
    if (e.target !== this) return;
    (0, _jquery.default)("video-modal").removeClass("video-modal--open");
    (0, _jquery.default)("body").removeClass("video-modal-open");
  });
  (0, _jquery.default)(".video-modal .container-fluid").click(function (e) {
    if (e.target !== this) return;
    (0, _jquery.default)("video-modal").removeClass("video-modal--open");
    (0, _jquery.default)("body").removeClass("video-modal-open");
  });
  (0, _jquery.default)(".video-modal .container-fluid .row").click(function (e) {
    if (e.target !== this) return;
    (0, _jquery.default)("video-modal").removeClass("video-modal--open");
    (0, _jquery.default)("body").removeClass("video-modal-open");
  });
  (0, _jquery.default)(".video-modal .container-fluid .row .col-12").click(function (e) {
    if (e.target !== this) return;
    (0, _jquery.default)("video-modal").removeClass("video-modal--open");
    (0, _jquery.default)("body").removeClass("video-modal-open");
  });

  /* ########## TRANSCRIPT OPEN/CLOSE ########## */
  (0, _jquery.default)(".video-modal__transcript-trigger").click(function (e) {
    (0, _jquery.default)(this).parent().parent().parent().parent().toggleClass("video-modal__transcript-wrapper--open");
  });
};

},{"jquery":"jquery"}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _paymentFormValidator = _interopRequireDefault(require("./paymentFormValidator.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  document.querySelectorAll(".js-payment-form").forEach(function (el) {
    // get attributes from data-validate
    var _JSON$parse = JSON.parse(JSON.stringify(el.dataset.validate)),
      donationAmountValidation = _JSON$parse.donationAmountValidation,
      otherDonationAmountValidation = _JSON$parse.otherDonationAmountValidation,
      donationTypeValidation = _JSON$parse.donationTypeValidation,
      firstNameValidation = _JSON$parse.firstNameValidation,
      lastNameValidation = _JSON$parse.lastNameValidation,
      emailValidation = _JSON$parse.emailValidation,
      phoneValidation = _JSON$parse.phoneValidation,
      addressValidation = _JSON$parse.addressValidation,
      cityValidation = _JSON$parse.cityValidation,
      stateValidation = _JSON$parse.stateValidation,
      zipValidation = _JSON$parse.zipValidation;
    var paymentValidator = (0, _paymentFormValidator.default)();
    paymentValidator.init(donationAmountValidation, otherDonationAmountValidation, donationTypeValidation, firstNameValidation, lastNameValidation, emailValidation, phoneValidation, addressValidation, cityValidation, stateValidation, zipValidation);
  });
};

},{"./paymentFormValidator.js":69}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
require("jquery-validation");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  var clearSelectedTab = function clearSelectedTab() {
    (0, _jquery.default)(".tabs__selection .tabs__selection__selected").each(function (i, e) {
      (0, _jquery.default)(e).removeClass("tabs__selection__selected");
    });
    window.scrollTo(0, 0);
  };
  (0, _jquery.default)('#nonce-form [name="stateProvince"]').change(function (e) {
    (0, _jquery.default)("#nonce-form [name='state']").val((0, _jquery.default)(this).val());
  });
  (0, _jquery.default)("#nonce-form input, #nonce-form select").change(function (e) {
    var validator = (0, _jquery.default)("#nonce-form").validate();
    var elemName = (0, _jquery.default)(e.target).attr("name");
    if (validator.element((0, _jquery.default)(e.target))) {
      (0, _jquery.default)('#nonce-form [name="' + elemName + '"]').removeClass("is-invalid");
    } else {
      (0, _jquery.default)('#nonce-form [name="' + elemName + '"]').addClass("is-invalid");
    }
  });
  (0, _jquery.default)("#step1Next").click(function () {
    if (!(0, _jquery.default)("#nonce-form").valid()) {
      return false;
    }
    (0, _jquery.default)(".step-1").hide();
    (0, _jquery.default)(".step-2").show();
    clearSelectedTab();
    (0, _jquery.default)(".tabs__selection .step2Tab").addClass("tabs__selection__selected");
  });
  (0, _jquery.default)("#step2Next").click(function () {
    if (!(0, _jquery.default)("#nonce-form").valid()) {
      return false;
    }
    (0, _jquery.default)('#nonce-form input[name="state"]').val((0, _jquery.default)('#nonce-form select[name="stateProvince"]').val());
    (0, _jquery.default)(".step-2").hide();
    (0, _jquery.default)(".step-3").show();
    clearSelectedTab();
    (0, _jquery.default)(".tabs__selection .step3Tab").addClass("tabs__selection__selected");
  });
  (0, _jquery.default)("#step2Back").click(function () {
    (0, _jquery.default)(".step-1").show();
    (0, _jquery.default)(".step-2").hide();
    clearSelectedTab();
    (0, _jquery.default)(".tabs__selection .step1Tab").addClass("tabs__selection__selected");
  });
  (0, _jquery.default)("#step3Back").click(function () {
    (0, _jquery.default)(".step-2").show();
    (0, _jquery.default)(".step-3").hide();
    clearSelectedTab();
    (0, _jquery.default)(".tabs__selection .step2Tab").addClass("tabs__selection__selected");
  });
  if (window.location.href.toLowerCase().indexOf("error=payment") > 0) {
    (0, _jquery.default)(".step-1").hide();
    (0, _jquery.default)(".step-2").hide();
    (0, _jquery.default)(".step-3").show();
    clearSelectedTab();
    (0, _jquery.default)(".tabs__selection .step3Tab").addClass("tabs__selection__selected");
  }
  var init = function init(donationAmtMsg, otherDonationMsg, donationTypeMsg, firstNameMsg, lastNameMsg, emailMsg, phoneMsg, addressMsg, cityMsg, stateMsg, zipMsg) {
    (0, _jquery.default)("#nonce-form").validate({
      // Specify validation rules
      debug: true,
      rules: {
        donationAmount: "required",
        otherDonationAmount: {
          required: {
            depends: function depends(element) {
              return (0, _jquery.default)("#other").is(":checked");
            }
          },
          number: true
        },
        donationType: "required",
        firstName: "required",
        lastName: "required",
        email: {
          required: true,
          email: true
        },
        phone: "required",
        addressOne: "required",
        city: "required",
        zip: {
          required: true,
          minlength: 5,
          maxlength: 5,
          digits: true
        },
        stateProvince: "required"
      },
      // Specify validation error messages
      messages: {
        donationAmount: donationAmtMsg,
        otherDonationAmount: otherDonationMsg,
        donationType: donationTypeMsg,
        firstName: firstNameMsg,
        lastName: lastNameMsg,
        email: emailMsg,
        phone: phoneMsg,
        addressOne: addressMsg,
        city: cityMsg,
        zip: zipMsg,
        stateProvince: stateMsg
      },
      invalidHandler: function invalidHandler(event, validator) {
        // 'this' refers to the form

        (0, _jquery.default)("#nonce-form input, #nonce-form select").removeClass("is-invalid");
        _jquery.default.each(validator.errorList, function (i, e) {
          var elemName = (0, _jquery.default)(e.element).attr("name");
          (0, _jquery.default)('#nonce-form [name="' + elemName + '"]').addClass("is-invalid");
        });
      }
    });
  };
  (0, _jquery.default)("#email").on("keypress", function () {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.value);
    if (!re) {
      (0, _jquery.default)("#emailFormatError").css("display", "block");
    } else {
      (0, _jquery.default)("#emailFormatError").hide();
    }
  });
  return {
    init: init
  };
};

},{"jquery":"jquery","jquery-validation":"jquery-validation"}],70:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = require("../../common/analytics.js");
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var initPricingComponent = function initPricingComponent() {
  document.querySelectorAll(".js-pricing-component").forEach(function (component) {
    var dropdown = component.querySelector(".js-pricing-component-dropdown");
    var itemList = component.querySelector(".js-pricing-items");
    var itemData = JSON.parse(itemList.dataset.products);
    var items = _toConsumableArray(itemList.querySelectorAll(".js-pricing-item"));
    if (dropdown) {
      var selectedOption = dropdown.querySelector('option:first-child');
      //Hack for browser cache selecting the previous selected item.
      if (selectedOption) {
        dropdown.value = selectedOption.value;
        setTimeout(function () {
          dropdown.value = selectedOption.value;
        }, 0);
      }
      var _currentItem = component.querySelector(".".concat(dropdown.value));
      _currentItem.classList.add("is-active");
      dropdown.addEventListener("change", function (e) {
        //change component content
        items.forEach(function (item) {
          if (item.classList.contains(e.target.value)) {
            var _selectedItem = R.find(R.propEq("SitecoreItemName", item.id), itemData);
            item.classList.add("is-active");
            (0, _analytics.viewProductDetails)(_selectedItem);
          } else {
            item.classList.remove("is-active");
          }
        });
      });
    } else {
      if (items.length === 1) {
        items[0].classList.add("is-active");
      }
    }
    var currentItem = component.querySelector(".is-active");
    var selectedItem = R.find(R.propEq("SitecoreItemName", currentItem.id), itemData);
    (0, _analytics.viewProductDetails)(selectedItem);
    // Data layer push
    var atcButton = component.querySelectorAll(".sidebar-component__button");
    _toConsumableArray(atcButton).forEach(function (button) {
      button.addEventListener("click", function (e) {
        var currentItem = component.querySelector(".is-active");
        var selectedItem = R.find(R.propEq("SitecoreItemName", currentItem.id), itemData);
        (0, _analytics.addToCartInit)(selectedItem);
      });
    });
    var errorEl = component.querySelector(".js-add-to-cart-error");
    console.log(selectedItem);
    if (errorEl && errorEl.dataset.error) {
      errorEl.tabIndex = -1;
      setTimeout(function () {
        errorEl.innerHTML = errorEl.dataset.error;
        errorEl.focus();
      }, 400);
    }
  });
};
var _default = exports.default = initPricingComponent;

},{"../../common/analytics.js":2,"ramda":"ramda"}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### Flex Wrap Reverse on Mobile #################### */
  var updateFlexWrap = function updateFlexWrap() {
    (0, _jquery.default)("section.article").each(function () {
      var $section = (0, _jquery.default)(this);
      var $row = $section.find(".container-fluid > .row").first();
      var $pricingComponent = $section.find(".sidebar-component--pricing");
      if ($row.length && $pricingComponent.length) {
        if (window.innerWidth <= 1024) {
          $row.addClass("flex-wrap-reverse");
        } else {
          $row.removeClass("flex-wrap-reverse");
        }
      }
    });
  };

  // Run function
  updateFlexWrap();

  // Update specified article section on window resize
  (0, _jquery.default)(window).on("resize", updateFlexWrap);
};

},{"jquery":"jquery"}],72:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _Listing = _interopRequireDefault(require("./components/Listing.jsx"));
var _ListingContainer = _interopRequireDefault(require("./components/ListingContainer.jsx"));
var _mockData = _interopRequireWildcard(require("./mockData.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  dictionary: (0, _propTypes.shape)({
    loginUrl: _propTypes.string,
    loginCta: _propTypes.string,
    errorMessage: _propTypes.string
  }),
  productId: _propTypes.string,
  productLoid: _propTypes.string,
  productEventKey: _propTypes.string
};
var ProfileListing = function ProfileListing(props) {
  var _props$dictionary = props.dictionary,
    loginUrl = _props$dictionary.loginUrl,
    loginCta = _props$dictionary.loginCta,
    errorMessage = _props$dictionary.errorMessage;
  var productId = props.productId,
    productLoid = props.productLoid,
    productEventKey = props.productEventKey;
  var url = "/api/sitecore/AbaAccount/GetLMSProfile?productId=".concat(productId, "&productLoid=").concat(productLoid);

  // Development use only
  // const url = `http://echoapi.velir.com/?json=${JSON.stringify(mockData)}`;
  // const errorurl = `http://echoapi.velir.com/?json=${JSON.stringify(error)}`;

  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFetching = _useState6[0],
    setIsFetching = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    createdResult = _useState8[0],
    setCreatedResult = _useState8[1];
  var listingRef = (0, _react.useRef)(null);
  var controller = new AbortController();
  var signal = controller.signal;
  (0, _react.useEffect)(function () {
    fetch(url, {
      credentials: "same-origin",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.Result) {
        setResult(data.Result);
      } else {
        setResult(null);
      }
      setIsLoading(false);
      return data;
    }).catch(function (err) {
      return console.log("err", err);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var createProfile = function createProfile(index) {
    listingRef.current.querySelectorAll(".listing-item")[index].classList.add("is-loading");
    if (isFetching) {
      controller.abort();
    } else {
      setIsFetching(true);
      fetch("/api/sitecore/AbaAccount/CreateLMSProfile", {
        method: "POST",
        signal: signal
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        setIsFetching(false);
        if (data.Success) {
          var list = listingRef.current.querySelectorAll(".listing-item");
          list[index].classList.remove("is-loading");
          list[index].classList.add("is-successful");
          setCreatedResult([_objectSpread(_objectSpread({}, data.Result.Profiles[0]), {}, {
            title: "New Profile",
            className: "new-item"
          })]);
          //add success class to create profile item.
        } else {
          var _list = listingRef.current.querySelectorAll(".listing-item");
          //add success class to create profile item.
          _list[index].classList.remove("is-loading");
          _list[index].classList.add("is-error");
        }
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ListingContainer.default, {
    isLoading: isLoading,
    className: "profile-listing"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "profile-listing__wrapper",
    ref: listingRef
  }, result && result.Profiles && [].concat(_toConsumableArray(result.Profiles), _toConsumableArray(createdResult)).length > 0 && [].concat(_toConsumableArray(result.Profiles), _toConsumableArray(createdResult)).map(function (i, k) {
    return /*#__PURE__*/_react.default.createElement(_Listing.default, {
      item: _objectSpread(_objectSpread({}, i), {}, {
        productId: productId || null,
        productLoid: productLoid || null,
        profilePrice: result.profilePrice || null,
        regularPrice: result.regularPrice || null,
        savings: result.savings || null,
        productEventKey: productEventKey || null
      }),
      key: k,
      index: k,
      className: i.className,
      username: i.Username,
      errorMessage: /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: errorMessage
        }
      })
    });
  }), result === null && /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-padding-m"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: " aba-container aba-container--100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container__col"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Something went wrong, please try again later."))))), result && result.CanCreateNewProfile === true && /*#__PURE__*/_react.default.createElement(_Listing.default, {
    index: [].concat(_toConsumableArray(result.Profiles), _toConsumableArray(createdResult)).length,
    item: {
      createNewProfile: true
    },
    onCreateProfile: createProfile,
    username: result.Username,
    errorMessage: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: errorMessage
      }
    })
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--100 profile-listing__link-container"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "profile-listing__login-link",
    href: loginUrl
  }, loginCta)));
};
ProfileListing.propTypes = propTypes;
var _default = exports.default = ProfileListing;

},{"./components/Listing.jsx":73,"./components/ListingContainer.jsx":74,"./mockData.js":76,"prop-types":"prop-types","react":"react"}],73:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _mockData = require("../mockData.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  item: (0, _propTypes.shape)({
    title: _propTypes.string,
    email: _propTypes.string,
    domain: _propTypes.string,
    profilePrice: _propTypes.number,
    savings: _propTypes.number,
    regularPrice: _propTypes.number,
    profileId: _propTypes.string,
    IsProductAvailable: _propTypes.bool,
    description: _propTypes.string,
    createNew: _propTypes.bool,
    btnText: _propTypes.string,
    className: _propTypes.string
  }),
  onCreateProfile: _propTypes.func,
  className: _propTypes.string,
  index: _propTypes.number,
  username: _propTypes.string,
  errorMessage: _propTypes.node
};
var Listing = function Listing(props) {
  var item = props.item,
    onCreateProfile = props.onCreateProfile,
    className = props.className,
    index = props.index,
    username = props.username,
    errorMessage = props.errorMessage;
  var DomainName = item.DomainName,
    IsProductAvailable = item.IsProductAvailable,
    createNewProfile = item.createNewProfile;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetching = _useState2[0],
    setIsFetching = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNewProfile = _useState4[0],
    setIsNewProfile = _useState4[1];
  var _useState5 = (0, _react.useState)(IsProductAvailable ? "Use This Profile" : "Not Available"),
    _useState6 = _slicedToArray(_useState5, 2),
    buttonText = _useState6[0],
    setButtonText = _useState6[1];
  var listItem = (0, _react.useRef)(null);
  var controller = new AbortController();
  var signal = controller.signal;
  var url = "/api/sitecore/AbaAccount/SelectLMSProfile";

  // Development use only
  // const url = `http://echoapi.velir.com/?json=${JSON.stringify(
  //   selectionDataError,
  // )}`;

  var handleSelection = function handleSelection(item, isFetching) {
    if (isFetching) {
      controller.abort();
    } else {
      setIsFetching(true);
      fetch(url, {
        method: "POST",
        body: JSON.stringify(item),
        headers: {
          "Content-Type": "application/json"
        },
        signal: signal
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.Success) {
          if (data.Result.MakePurchase) {
            var payload = {
              productId: item.productId,
              isLMS: "1",
              productLoid: item.productLoid,
              eventPrimaryKey: item.productEventKey
            };
            fetch("/api/sitecore/Product/AddProductToCart", {
              method: "POST",
              body: JSON.stringify(payload),
              headers: {
                "Content-Type": "application/json"
              }
              // signal,
            }).then(function (response) {
              return response.json();
            }).then(function (data) {
              setIsFetching(false);
              if (data.Success) {
                window.location = data.Result.redirectUrl;
              } else {
                listItem.current.classList.add("is-error");
              }
            });
          } else {
            listItem.current.classList.add("is-error");
            setIsFetching(false);
          }
        } else {
          listItem.current.classList.add("is-error");
          setIsFetching(false);
        }
      });
    }
  };
  var handleNewProfile = function handleNewProfile(isNewProfile, index) {
    if (!isNewProfile) {
      //show check messaging
      setIsNewProfile(true);
      setButtonText("Yes, Create New Profile");
    } else {
      //after check execute createProfile
      onCreateProfile(index);
    }
  };
  var BtnTxt = function BtnTxt(isFetching) {
    return isFetching ? /*#__PURE__*/_react.default.createElement("svg", {
      className: "flashing-loader",
      viewBox: "0 0 50 100",
      "aria-label": "Loading",
      focusable: "false",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      cx: "-47",
      cy: "50",
      r: "28",
      fill: "currentColor"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      cx: "26",
      cy: "50",
      r: "28",
      fill: "currentColor"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      cx: "97",
      cy: "50",
      r: "28",
      fill: "currentColor"
    })) : /*#__PURE__*/_react.default.createElement("span", null, buttonText);
  };
  (0, _react.useEffect)(function () {
    if (className) {
      setTimeout(function () {
        //scroll to this item if it has new-item class
        listItem.current.querySelector("button").focus({
          preventScroll: true
        });
        listItem.current.scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      }, 1000);
    }
  }, [className]);
  (0, _react.useEffect)(function () {
    if (createNewProfile) {
      setButtonText("create New Profile");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "listing-item ".concat(className ? className : ""),
    "aria-live": "polite"
    // aria-label={`Profile ${index + 1}`}
    ,
    ref: listItem
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--100 list-item__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container aba-container--30-30-30 list-item__main"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container__col"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "listing-item__title"
  }, "Profile ", index + 1), createNewProfile !== true && /*#__PURE__*/_react.default.createElement("p", {
    className: "listing-item__description"
  }, username && /*#__PURE__*/_react.default.createElement("span", null, "Username: ", username), username && DomainName && /*#__PURE__*/_react.default.createElement("br", null), DomainName && /*#__PURE__*/_react.default.createElement("span", null, "Domain: ", DomainName)), createNewProfile === true && username && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "listing-item__description"
  }, /*#__PURE__*/_react.default.createElement("span", null, isNewProfile === false ? "Don't see your profile? Create a new one with \"".concat(username, "\"") : "You\u2019re about to create a new personal profile with \"".concat(username, "\""))), isNewProfile === true && /*#__PURE__*/_react.default.createElement("p", {
    className: "listing-item__detail-text listing-item__detail-text--red"
  }, "Are you sure?"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container__col list-item__btn-container"
  }, /*#__PURE__*/_react.default.createElement("button", _extends({
    className: (0, _classnames.default)("btn", {
      "btn-primary": IsProductAvailable,
      "btn-not-available": !IsProductAvailable && !createNewProfile,
      "is-loading": isFetching,
      "btn-secondary": createNewProfile
    }),
    onClick: function onClick() {
      onCreateProfile ? handleNewProfile(isNewProfile, index) : handleSelection(item || null, isFetching);
    }
  }, !createNewProfile && {
    "aria-label": "Use Profile ".concat(index + 1)
  }, {
    "aria-disabled": !IsProductAvailable && !createNewProfile,
    disabled: !IsProductAvailable && !createNewProfile
  }), /*#__PURE__*/_react.default.createElement("span", null, BtnTxt(isFetching)))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "aba-container list-item__action"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__loading"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__loading-content"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Creating profile... Your new profile will appear in a moment.")), /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__loading-icon"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "circle-loader profile-listing__loader-svg",
    viewBox: "0 0 100 100",
    "aria-label": "Loading",
    focusable: "true",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Loading"), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__successful"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__success-content icon-success"
  }, "Profile created. You can now use your new profile.")), /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__error",
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "list-item__error-content icon-error"
  }, errorMessage))));
};
Listing.propTypes = propTypes;
var _default = exports.default = Listing;

},{"../mockData.js":76,"classnames":"classnames","prop-types":"prop-types","react":"react"}],74:[function(require,module,exports){
arguments[4][44][0].apply(exports,arguments)
},{"classnames":"classnames","dup":44,"prop-types":"prop-types","react":"react"}],75:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireDefault(require("react"));
var _ProfileListing = _interopRequireDefault(require("./ProfileListing.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var initProfileListing = function initProfileListing() {
  document.querySelectorAll(".js-profile-listing-mount").forEach(function (mount) {
    if (mount) {
      _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_ProfileListing.default, {
        dictionary: JSON.parse(mount.dataset.dictionary),
        productId: mount.dataset.pid,
        productLoid: mount.dataset.ploid,
        productEventKey: mount.dataset.peventkey
      }), mount);
    }
  });
};
var _default = exports.default = initProfileListing;

},{"./ProfileListing.jsx":72,"react":"react","react-dom":"react-dom"}],76:[function(require,module,exports){
arguments[4][46][0].apply(exports,arguments)
},{"dup":46}],77:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryStringProvider = exports.QueryStringContext = exports.QueryStringConsumer = void 0;
exports.createStore = createStore;
var _react = _interopRequireWildcard(require("react"));
var _queryString = _interopRequireDefault(require("query-string"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * QueryString store.
 * v3.0.0
 * exports createStore, QueryStringContext, QueryStringProvider, QueryStringConsumer
 *
 * The url is the source of truth, so the state is not stored in this store.
 * Instead, use getStateFromUrl() whenever we need the state.
 * The store is mostly to keep track of the listeners, since there is no way to
 * detect a history.pushState in javascript. Using the store allows multiple
 * QueryStringProviders to stay in sync.
 *
 * Usage for Context provider:
 *   import { createStore, QueryStringProvider } from "./QueryStringContext.jsx";
 *
 *   const queryStringStore = createStore(defaultState);
 *
 *   <QueryStringProvider store={queryStringStore}>
 *     <App />
 *   </QueryStringProvider>
 *
 *
 * Usage for Context Consumer:
 *  import { useContext } from "react";
 *  import { QueryStringContext } from "./QueryStringContext.jsx";
 *
 *  const { queryStringState, setQueryStringState } = useContext(QueryStringContext);
 *
 * or
 *
 *  import { QueryStringConsumer } from "./QueryStringContext.jsx";
 *
 *  <QueryStringConsumer>
 *    ({ queryStringState, setQueryStringState }) => { ... }
 *  </QueryStringConsumer>
 *
 */

function createStore(defaultState) {
  var listeners = [];
  function alertListeners() {
    listeners.forEach(function (l) {
      return l();
    });
  }

  // the url contains only state that is different from the defaults
  function getStateFromUrl() {
    return _objectSpread(_objectSpread({}, defaultState), _queryString.default.parse(window.location.search));
  }
  function getUrl(state) {
    // don't include any default values in the url
    var query = Object.keys(state).filter(function (key) {
      return state[key] !== defaultState[key];
    }).reduce(function (obj, key) {
      return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, state[key]));
    }, {});
    return window.location.origin + window.location.pathname + "?" + _queryString.default.stringify(query);
  }

  // public function that the consumers will call
  function setQueryStringState(newState) {
    // merge the new state in with the current state
    var state = _objectSpread(_objectSpread({}, getStateFromUrl()), newState);

    // add a new entry to the browser history
    history.pushState(null, null, getUrl(state));
    alertListeners();
  }

  // popstate listener
  function handleUrlChange() {
    // replaceState to update the url to have all the default values
    // from the defaultState
    history.replaceState(null, null, getUrl(getStateFromUrl()));
    alertListeners();
  }

  // subscribe to query string changes
  function subscribe(callback) {
    listeners.push(callback);

    // only listen to popstate if we have listners
    if (listeners.length > 0) {
      // when the user navigates the history via back/forward
      window.addEventListener("popstate", handleUrlChange);
    }
    return function unsubscribe() {
      listeners = listeners.filter(function (l) {
        return l === callback;
      });
      if (listeners.length === 0) {
        // if we don't have any listners, remove popstate event listener
        window.removeEventListener("popstate", handleUrlChange);
      }
    };
  }
  return {
    getState: getStateFromUrl,
    setState: setQueryStringState,
    subscribe: subscribe
  };
}
var QueryStringContext = exports.QueryStringContext = /*#__PURE__*/_react.default.createContext();
var QueryStringProvider = exports.QueryStringProvider = function QueryStringProvider(props) {
  var children = props.children,
    store = props.store;
  var getProviderValue = (0, _react.useCallback)(function () {
    return {
      queryStringState: store.getState(),
      setQueryStringState: store.setState
    };
  }, [store]);
  var _useState = (0, _react.useState)(getProviderValue()),
    _useState2 = _slicedToArray(_useState, 2),
    providerValue = _useState2[0],
    setProviderValue = _useState2[1];
  (0, _react.useEffect)(function () {
    // store.subscribe returns an unsubscribe function
    return store.subscribe(function () {
      setProviderValue(getProviderValue());
    });
  }, [getProviderValue, store]);
  return /*#__PURE__*/_react.default.createElement(QueryStringContext.Provider, {
    value: providerValue
  }, children);
};
QueryStringProvider.propTypes = {
  children: _propTypes.node,
  store: (0, _propTypes.shape)({
    getState: _propTypes.func.isRequired,
    setState: _propTypes.func.isRequired,
    subscribe: _propTypes.func.isRequired
  }).isRequired
};
var QueryStringConsumer = exports.QueryStringConsumer = QueryStringContext.Consumer;

},{"prop-types":"prop-types","query-string":"query-string","react":"react"}],78:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### RELATED CONTENT TILES HEIGHT #################### */
  function relatedContentTilesHeight() {
    if (window.innerWidth >= 768) {
      (0, _jquery.default)(".related-content-tiles__tile__content").css("height", "auto");
      var tallestRelatedTileContent = -1;
      (0, _jquery.default)(".related-content-tiles__tile__content").each(function () {
        tallestRelatedTileContent = tallestRelatedTileContent > (0, _jquery.default)(this).innerHeight() ? tallestRelatedTileContent : (0, _jquery.default)(this).innerHeight();
      });
      (0, _jquery.default)(".related-content-tiles__tile__content").css("height", tallestRelatedTileContent);
    } else {
      (0, _jquery.default)(".related-content-tiles__tile__content").css("height", "auto");
    }
  }
  (0, _jquery.default)(window).on("load resize", function (e) {
    var onLoadWidth = (0, _jquery.default)(window).width();
    relatedContentTilesHeight(onLoadWidth);
  });
};

},{"jquery":"jquery"}],79:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _Table = _interopRequireDefault(require("../Table/Table.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  result: _propTypes.object
};
var ResultItem = function ResultItem(props) {
  var result = props.result;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("results__item", {
      "is-open": isOpen
    })
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "results__accordion-button",
    "aria-expanded": isOpen,
    "aria-controls": "results-item-".concat(result.id, "-panel"),
    onClick: function onClick(e) {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "results__title",
    id: "results-".concat(result.id, "-title")
  }, result.state), /*#__PURE__*/_react.default.createElement("i", {
    className: "results__accordion-icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    role: "region",
    id: "results-item-".concat(result.id, "-panel"),
    "aria-labelledby": "result-".concat(result.id, "-title"),
    className: "results__accordion-panel"
  }, /*#__PURE__*/_react.default.createElement(_Table.default, {
    tableData: _toConsumableArray(result.data)
  })));
};
ResultItem.propTypes = propTypes;
var _default = exports.default = ResultItem;

},{"../Table/Table.jsx":86,"classnames":"classnames","prop-types":"prop-types","react":"react"}],80:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### SEARCH GROUP #################### */
  /* ########## VALUE ENTERED ########## */
  (0, _jquery.default)(".search-group input").keyup(function () {
    if ((0, _jquery.default)(this).val().length >= 1) {
      (0, _jquery.default)(this).parent().addClass("search-group--value-entered");
    } else {
      (0, _jquery.default)(this).parent().removeClass("search-group--value-entered");
    }
  });

  /* ########## CLEAR ########## */
  (0, _jquery.default)(".search-group__cancel").click(function () {
    (0, _jquery.default)(".search-group input").val("");
    (0, _jquery.default)(".search-group").removeClass("search-group--value-entered");
  });
  (0, _jquery.default)(".search-group__cancel-default").hover(function () {
    (0, _jquery.default)(".search-group__cancel-hover").toggleClass("search-group__cancel-hover--visible");
  });
};

},{"jquery":"jquery"}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### SEARCH FILTERS TOGGLE #################### */
  (0, _jquery.default)(".search-filters-trigger").click(function () {
    (0, _jquery.default)("body").addClass("search-filters--open");
  });
  (0, _jquery.default)(".search-filters__close, .search-filters__apply").click(function () {
    (0, _jquery.default)("body").removeClass("search-filters--open");
  });
  function JumpToFilters() {
    document.getElementById("filters-jump").scrollIntoView();
  }

  // Expose function globally
  window.JumpToFilters = JumpToFilters;
};

},{"jquery":"jquery"}],82:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### SIGN IN - WHAT'S NEW #################### */
  (0, _jquery.default)(".sign-in__wrapper__header__whats-new").click(function () {
    (0, _jquery.default)(".sign-in__wrapper").addClass("sign-in__wrapper--whats-new-open");
  });
  (0, _jquery.default)(".sign-in__whats-new__back, .sign-in__whats-new__close").click(function () {
    (0, _jquery.default)(".sign-in__wrapper").removeClass("sign-in__wrapper--whats-new-open");
  });

  /* #################### Forgot Password Toggle #################### */
  (0, _jquery.default)("#hideshowpass").keyup(function (event) {
    //Enter key code
    if (event.keyCode === 13) {
      (0, _jquery.default)(this).click();
    }
  });

  /* #################### Forgot Password Toggle #################### */
  (0, _jquery.default)(".hideshowpass").keyup(function (event) {
    //Enter key code
    if (event.keyCode === 13) {
      (0, _jquery.default)(this).click();
    }
  });
};

},{"jquery":"jquery"}],83:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
require("slick-carousel");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  (0, _jquery.default)(".media__slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    accessibility: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }]
  });
  (0, _jquery.default)(".feature-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    accessibility: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }]
  });
  (0, _jquery.default)(".testimonial-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    accessibility: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true
      }
    }]
  });
  (0, _jquery.default)(".event-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    accessibility: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }]
  });
};

},{"jquery":"jquery","slick-carousel":"slick-carousel"}],84:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### TALLEST SPONSOR EXHIBITOR ITEM #################### */
  function tallestSponsorItem() {
    if (window.innerWidth >= 768) {
      (0, _jquery.default)(".sponsor").each(function () {
        var highestBox = 0;
        (0, _jquery.default)(".sponsor-exhibitor-item__image img", this).each(function () {
          if ((0, _jquery.default)(this).height() > highestBox) {
            highestBox = (0, _jquery.default)(this).height();
          }
        });
        (0, _jquery.default)(".sponsor-exhibitor-item__image", this).height(highestBox);
        (0, _jquery.default)(".sponsor-exhibitor-item__image").css("opacity", "1");
      });
    } else {
      (0, _jquery.default)(".sponsor-exhibitor-item__image").css("height", "auto");
      (0, _jquery.default)(".sponsor-exhibitor-item__image").css("opacity", "1");
    }
  }
  (0, _jquery.default)(window).on("load resize", function () {
    tallestSponsorItem();
  });
  (0, _jquery.default)(document).on('click', '.tabs__selection li', function () {
    tallestSponsorItem();
  });
};

},{"jquery":"jquery"}],85:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _excluded = ["icon", "text"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  icon: _propTypes.string
};
var Svg = function Svg(props) {
  var icon = props.icon,
    text = props.text,
    otherProps = _objectWithoutProperties(props, _excluded);
  switch (icon) {
    case "lock":
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        "aria-hidden": "true",
        focusable: "false",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512"
      }, otherProps), text && /*#__PURE__*/_react.default.createElement("title", null, text), /*#__PURE__*/_react.default.createElement("path", {
        fill: "currentColor",
        d: "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
      }));
    case "phone":
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20"
      }, otherProps), text && /*#__PURE__*/_react.default.createElement("title", null, text), /*#__PURE__*/_react.default.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.28447 7.4347l1.26483-.60532c.54993-.27515.7699-.88048.60492-1.43078L5.50444.83113C5.39445.44592 5.0645.17077 4.62455.0607 3.19475-.1594 2.0399.2258 1.10502 1.10628c-.7699.71538-1.15484 1.6509-1.09985 2.69646.43994 7.374 8.85382 15.73852 16.16785 16.17876 1.04486.11006 1.97973-.27515 2.74963-1.04556.87989-.93551 1.26483-2.09114.98987-3.57694-.055-.38521-.32996-.71539-.7699-.88048l-4.56439-1.59586c-.54993-.22012-1.15485.05503-1.4298.60533l-.54994 1.21065C9.24394 13.488 6.5493 10.7365 5.28447 7.43471z"
      }));
    case "email":
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 23 16"
      }, otherProps), text && /*#__PURE__*/_react.default.createElement("title", null, text), /*#__PURE__*/_react.default.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.1312 16l6.8752-6.8752c.3512.3128.7448.5744 1.1728.7736.5264.244 1.0968.3912 1.676.4328.692.0496 1.3928-.052 2.0416-.2968.552-.2088 1.0568-.5192 1.4968-.9088L21.2688 16H1.1312zm5.7376-8L0 14.8688V1.1312L6.8688 8zM22.4 1.1552v13.7136l-6.8536-6.8536C17.86 5.7576 20.128 3.4544 22.4 1.1552zM21.2688 0l-7.804 7.804c-.3056.3016-.6624.5432-1.06.7048-.8032.3256-1.7264.3096-2.5168-.0456-.3296-.148-.628-.3528-.8912-.5992-.1192-.1152-.2392-.2304-.3584-.3456-.0096-.0128-.0192-.0256-.0304-.0376-.0432-.0512-.0928-.0968-.148-.1352C5.9712 4.9336 3.536 2.4664 1.1008 0h20.168z"
      }));
    default:
      return false;
  }
};
Svg.propTypes = propTypes;
var _default = exports.default = Svg;

},{"prop-types":"prop-types","react":"react"}],86:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _AppContext = require("../FinEdListing/components/App/AppContext.js");
var _Svg = _interopRequireDefault(require("../Svg/Svg.jsx"));
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var propTypes = {
  tableData: _propTypes.array
};
var defaultProps = {
  tableData: []
};
var Table = function Table(props) {
  var tableData = props.tableData;
  var _useFinEdListingConte = (0, _AppContext.useFinEdListingContext)(),
    showContact = _useFinEdListingConte.state.showContact;

  //check for no data
  if (tableData.length < 1) return false;
  //put keys in array

  var renderValue = function renderValue(d) {
    if (_typeof(d) === "object") {
      return /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, d.name && d.name), d.phone && /*#__PURE__*/_react.default.createElement("a", {
        href: "tel:".concat(d.phone),
        "aria-label": "Phone"
      }, /*#__PURE__*/_react.default.createElement(_Svg.default, {
        focusable: "false",
        role: "img",
        icon: "phone",
        text: "Phone",
        width: "16",
        height: "16",
        "aria-label": "Phone icon"
      })), " ", d.email && /*#__PURE__*/_react.default.createElement("a", {
        href: "mailTo:".concat(d.email),
        "aria-label": "Email"
      }, /*#__PURE__*/_react.default.createElement(_Svg.default, {
        focusable: "false",
        role: "img",
        icon: "email",
        text: "Email",
        width: "23",
        height: "16",
        "aria-label": "Email icon"
      })));
    }
    return /*#__PURE__*/_react.default.createElement("p", null, d);
  };
  var sortedData = R.compose(R.sortBy(R.prop("city")), R.map(function (obj) {
    return R.compose(R.reduce(function (res, key) {
      return res[key] = obj[key], res;
    }, {}), function (arr) {
      return arr.sort();
    }, R.filter(function (key) {
      return !showContact ? key === "contact_info" ? false : true : true;
    }), R.filter(function (key) {
      return key !== "state";
    }), R.keys)(obj);
  }))(tableData);
  var keys = Object.keys(sortedData[0]).map(function (i) {
    return i.replace("_", " ");
  });
  return /*#__PURE__*/_react.default.createElement("table", {
    className: "aba-table aba-table--alt-mobile"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: "aba-table__row"
  }, keys.map(function (heading, k) {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: "heading_".concat(k),
      scope: "col",
      className: "aba-table__cell aba-table__cell--heading mobile-hidden"
    }, heading);
  })), sortedData.map(function (data, k) {
    //put values in array
    var values = Object.values(sortedData[k]);
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: "level-1-".concat(k),
      className: "aba-table__row"
    }, values.map(function (d, k) {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: "level-2-".concat(k),
        className: "aba-table__cell"
      }, /*#__PURE__*/_react.default.createElement("div", {
        role: "rowheader",
        className: "aba-table__label desktop-hidden aba-table__cell aba-table__cell--heading"
      }, keys[k]), /*#__PURE__*/_react.default.createElement("div", {
        role: "gridcell"
      }, renderValue(d)));
    }));
  })));
};
Table.defaultProps = defaultProps;
Table.propTypes = propTypes;
var _default = exports.default = Table;

},{"../FinEdListing/components/App/AppContext.js":52,"../Svg/Svg.jsx":85,"prop-types":"prop-types","ramda":"ramda","react":"react"}],87:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  /* #################### TABS #################### */
  (0, _jquery.default)(".tabs .tabs__selection li").attr("tabindex", "0").attr("role", "tab").attr("aria-selected", "false");

  // first aria-selected attribute default as true
  var $firstTab = (0, _jquery.default)(".tabs .tabs__selection li").first();
  $firstTab.addClass("tabs__selection__selected").attr("aria-selected", "true");
  var firstTabContentId = $firstTab.attr("data-tabSelection");
  $firstTab.closest(".tabs").find(".tabs__content").each(function () {
    if ((0, _jquery.default)(this).attr("data-tabContent") === firstTabContentId) {
      (0, _jquery.default)(this).addClass("tabs__content--selected");
      (0, _jquery.default)(this).removeAttr("hidden");
    } else {
      (0, _jquery.default)(this).removeClass("tabs__content--selected");
      (0, _jquery.default)(this).attr("hidden", false);
    }
  });
  (0, _jquery.default)(".tabs .tabs__selection li").click(function () {
    var tabClicked = (0, _jquery.default)(this).attr("data-tabSelection");
    (0, _jquery.default)(this).closest(".tabs").find(".tabs__selection li").removeClass("tabs__selection__selected").attr("aria-selected", "false");
    (0, _jquery.default)(this).addClass("tabs__selection__selected").attr("aria-selected", "true");
    (0, _jquery.default)(this).closest(".tabs").find(".tabs__content").each(function () {
      if ((0, _jquery.default)(this).attr("data-tabContent") === tabClicked) {
        (0, _jquery.default)(this).addClass("tabs__content--selected");
        (0, _jquery.default)(this).removeAttr("hidden");
      } else {
        (0, _jquery.default)(this).removeClass("tabs__content--selected");
        (0, _jquery.default)(this).attr("hidden", false);
      }
    });
  });
  (0, _jquery.default)(".tabs .tabs__content__mobile-trigger").click(function () {
    (0, _jquery.default)(this).parent().toggleClass("tabs__content--accordion-open");
  });

  // Keyboard accessibility for tabs tabbing and click event
  (0, _jquery.default)(".tabs .tabs__selection li").keydown(function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault(); // Prevent default space key behavior
      (0, _jquery.default)(this).click(); // Trigger the click event to switch tabs
    }
  });

  // Arrow key navigation between tabs
  (0, _jquery.default)(".tabs .tabs__selection").keydown(function (e) {
    var $focusedTab = (0, _jquery.default)(document.activeElement);
    if (!$focusedTab.is("li")) return;
    var $newTab;
    if (e.key === "ArrowRight") {
      $newTab = $focusedTab.next("li");
      if (!$newTab.length) {
        $newTab = (0, _jquery.default)(".tabs .tabs__selection li").first();
      }
    } else if (e.key === "ArrowLeft") {
      $newTab = $focusedTab.prev("li");
      if (!$newTab.length) {
        $newTab = (0, _jquery.default)(".tabs .tabs__selection li").last();
      }
    }
    if ($newTab && $newTab.length) {
      $newTab.focus();
    }
  });
};

},{"jquery":"jquery"}],88:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _initFDICLookup = _interopRequireDefault(require("./components/FDICLookup/initFDICLookup.js"));
var _initInterstitialCart = _interopRequireDefault(require("./components/InterstitialCart/initInterstitialCart.js"));
var _initCartConfirmation = _interopRequireDefault(require("./components/InterstitialCart/initCartConfirmation.js"));
var _initPricingComponent = _interopRequireDefault(require("./components/PricingComponent/initPricingComponent.js"));
var _initCartButtonCount = _interopRequireDefault(require("./components/CartButtonCount/initCartButtonCount.js"));
var _initProfileListing = _interopRequireDefault(require("./components/ProfileListing/initProfileListing.js"));
var _initFinEdListing = _interopRequireDefault(require("./components/FinEdListing/initFinEdListing.js"));
var _initCommunityOrganizerForm = _interopRequireDefault(require("./components/CommunityOrganizerForm/initCommunityOrganizerForm.js"));
var _initBankerRegistrationForm = _interopRequireDefault(require("./components/BankerRegistrationForm/initBankerRegistrationForm.js"));
var _initBankerPairingForm = _interopRequireDefault(require("./components/BankerPairingForm/initBankerPairingForm.js"));
var _initProfileListing2 = _interopRequireDefault(require("./components/DirectProfileListing/initProfileListing.js"));
var _initGlobalHeader = _interopRequireDefault(require("./components/GlobalHeader/initGlobalHeader.js"));
var _initModal = _interopRequireDefault(require("./components/Modal/initModal.js"));
var _initSearchGroup = _interopRequireDefault(require("./components/SearchGroup/initSearchGroup.js"));
var _initBackToTop = _interopRequireDefault(require("./components/BackToTop/initBackToTop.js"));
var _initAccordion = _interopRequireDefault(require("./components/Accordion/initAccordion.js"));
var _initRelatedContent = _interopRequireDefault(require("./components/RelatedContent/initRelatedContent.js"));
var _initSponsors = _interopRequireDefault(require("./components/Sponsors/initSponsors.js"));
var _initSignIn = _interopRequireDefault(require("./components/SignIn/initSignIn.js"));
var _initSearchFilters = _interopRequireDefault(require("./components/Search/initSearchFilters.js"));
var _initButtonClicks = _interopRequireDefault(require("./components/Button/initButtonClicks.js"));
var _initTabs = _interopRequireDefault(require("./components/Tabs/initTabs.js"));
var _initSlickSlider = _interopRequireDefault(require("./components/Slider/initSlickSlider.js"));
var _initPaymentValidation = _interopRequireDefault(require("./components/PaymentForm/initPaymentValidation.js"));
var _initProductPages = _interopRequireDefault(require("./components/ProductPages/initProductPages.js"));
var _rdaScripts = _interopRequireDefault(require("./rda-scripts.js"));
var _abaCommon = _interopRequireDefault(require("./aba-common.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// This is required to make Storybook run JS when patterns are choosen
document.addEventListener("DOMContentLoaded", function () {
  (0, _initCartButtonCount.default)();
  (0, _initFDICLookup.default)();
  (0, _initInterstitialCart.default)();
  (0, _initCartConfirmation.default)();
  (0, _initPricingComponent.default)();
  (0, _initFinEdListing.default)();
  (0, _initProfileListing.default)();
  (0, _initCommunityOrganizerForm.default)();
  (0, _initBankerRegistrationForm.default)();
  (0, _initBankerPairingForm.default)();
  (0, _initProfileListing2.default)();
  (0, _initGlobalHeader.default)();
  (0, _initModal.default)();
  (0, _initSearchGroup.default)();
  (0, _initBackToTop.default)();
  (0, _initAccordion.default)();
  (0, _initRelatedContent.default)();
  (0, _initSponsors.default)();
  (0, _initSignIn.default)();
  (0, _initSearchFilters.default)();
  (0, _initButtonClicks.default)();
  (0, _initTabs.default)();
  (0, _initSlickSlider.default)();
  (0, _initPaymentValidation.default)();
  (0, _initProductPages.default)();
  (0, _rdaScripts.default)();
  (0, _abaCommon.default)();

  // only dynamically import AblePlayer if video/audio is found on the page
  var mediaElms = document.querySelectorAll("video, audio");
  var _iterator = _createForOfIteratorHelper(mediaElms),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var elm = _step.value;
      if (elm.hasAttribute("data-able-player")) {
        _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var _yield$import, initAblePlayer;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _context.n = 1;
                return Promise.resolve().then(function () {
                  return _interopRequireWildcard(require("./third-party/ableplayer/ableplayer-aba.min.js"));
                });
              case 1:
                _yield$import = _context.v;
                initAblePlayer = _yield$import.default;
                initAblePlayer();
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }))();
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
});

},{"./aba-common.js":1,"./components/Accordion/initAccordion.js":7,"./components/BackToTop/initBackToTop.js":8,"./components/BankerPairingForm/initBankerPairingForm.js":15,"./components/BankerRegistrationForm/initBankerRegistrationForm.js":27,"./components/Button/initButtonClicks.js":29,"./components/CartButtonCount/initCartButtonCount.js":30,"./components/CommunityOrganizerForm/initCommunityOrganizerForm.js":39,"./components/DirectProfileListing/initProfileListing.js":45,"./components/FDICLookup/initFDICLookup.js":48,"./components/FinEdListing/initFinEdListing.js":57,"./components/GlobalHeader/initGlobalHeader.js":64,"./components/InterstitialCart/initCartConfirmation.js":65,"./components/InterstitialCart/initInterstitialCart.js":66,"./components/Modal/initModal.js":67,"./components/PaymentForm/initPaymentValidation.js":68,"./components/PricingComponent/initPricingComponent.js":70,"./components/ProductPages/initProductPages.js":71,"./components/ProfileListing/initProfileListing.js":75,"./components/RelatedContent/initRelatedContent.js":78,"./components/Search/initSearchFilters.js":81,"./components/SearchGroup/initSearchGroup.js":80,"./components/SignIn/initSignIn.js":82,"./components/Slider/initSlickSlider.js":83,"./components/Sponsors/initSponsors.js":84,"./components/Tabs/initTabs.js":87,"./rda-scripts.js":89,"./third-party/ableplayer/ableplayer-aba.min.js":90}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _hasValue = require("./common/hasValue.js");
var _getQSValue = require("./common/getQSValue.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default() {
  var registerUrl;
  var loginUrl;
  document.querySelectorAll(".js-url-mount").forEach(function (mount) {
    if (mount) {
      registerUrl = mount.dataset.registerurl;
      loginUrl = mount.dataset.loginurl;
    }
  });
  var isPageEditor = function isPageEditor() {
    return !!(Sitecore && Sitecore.PageModes && Sitecore.PageModes.PageEditor);
  };

  // 1/24/2019|DFR: pause the video if you click outside the video element, or on the X button.
  (0, _jquery.default)(".video-modal").click(function (e) {
    switch ((0, _jquery.default)(e.target).attr("class")) {
      case "video-modal":
      case "video-modal__close":
        var parentContainer = (0, _jquery.default)(this).closest("div.video-modal");
        handleVideoModalClose(parentContainer);
        break;
    }
  });

  // handle esc pressed to close video modal
  (0, _jquery.default)(document).keyup(function (e) {
    if (e.keyCode === 27) {
      // TODO: the complicated code should be replaced with the below line but this needs to happen BEFORE avendi code removes the 'video-modal--open' class
      // var activeVideoModal = $('.video-modal--open');
      var activeVideoModal = (0, _jquery.default)(".video-modal").has('.able-button-handler-play[aria-label*="Pause"]');
      if (activeVideoModal.length > 0) {
        handleVideoModalClose(activeVideoModal);
      }
    }
  });
  // handle click outside of video
  (0, _jquery.default)(".shade").click(function () {
    // TODO: the complicated code should be replaced with the below line but this needs to happen BEFORE avendi code removes the 'video-modal--open' class
    // var activeVideoModal = $('.video-modal--open');
    var activeVideoModal = (0, _jquery.default)(".video-modal").has('.able-button-handler-play[aria-label*="Pause"]');
    if (activeVideoModal.length > 0) {
      handleVideoModalClose(activeVideoModal);
    }
  });

  // 7/26/2019|bugfix:7294|Bob: new handler since youtube video cannot be accessed within iframe because of different domains
  // targetModal is the jQuery object of the current div.video-modal element
  function handleVideoModalClose(targetModal) {
    var ablePlayButton = targetModal.find(".able-button-handler-play");
    // if video is playing trigger the play/pause button of the able player
    if (ablePlayButton.attr("aria-label").toLowerCase() === "pause") {
      ablePlayButton.trigger("click");
    }
  }
  (0, _jquery.default)(".login-link").click(function (e) {
    e.preventDefault();
    window.location = loginUrl + generateReturnUrl();
  });
  (0, _jquery.default)(".register-link").click(function (e) {
    e.preventDefault();
    window.location = registerUrl + generateReturnUrl();
  });
  function generateReturnUrl() {
    var returnUrl = (0, _getQSValue.getQSValue)("returnUrl");
    if (!(0, _hasValue.hasValue)(returnUrl)) {
      if (window.location.pathname.indexOf(loginUrl) <= -1 && window.location.pathname.indexOf(registerUrl) <= -1) {
        returnUrl = window.location.pathname + window.location.search + window.location.hash;
      }
    }
    return (0, _hasValue.hasValue)(returnUrl) ? "?returnUrl=" + encodeURIComponent(returnUrl) : "";
  }

  //Handle Login Behavior
  //$("#mobileLogin").on('click', function (event) {
  //    submitParentForm(event, this);
  //});
  //$("#desktopLogin").on('click', function (event) {
  //    submitParentForm(event, this);
  //});

  //Handle Logout Behavior
  (0, _jquery.default)("#mobileLogout").on("click", function (event) {
    submitParentForm(event, this);
  });
  (0, _jquery.default)("#desktopLogout").on("click", function (event) {
    submitParentForm(event, this);
  });

  //Helper Functions
  function submitParentForm(event, link) {
    event.preventDefault();
    link.parentNode.submit();
  }

  /* Banking Topics A-Z jump tags */
  (0, _jquery.default)(document).ready(function () {
    (0, _jquery.default)("a.scrollLink").click(function (event) {
      event.preventDefault();
      var t = (0, _jquery.default)(this).attr("href");
      var offset = (0, _jquery.default)(t).offset();
      var scrollto = offset.top - 80; // minus fixed header height
      (0, _jquery.default)("html, body").animate({
        scrollTop: scrollto
      }, 500);
    });
  });
  (0, _jquery.default)(".speaker-modal__trigger").click(function (event) {
    var speakerName = event.target.innerText;
    _jquery.default.get("/api/Sitecore/SpeakerModal/Index?speaker-name=" + speakerName, function (data) {
      (0, _jquery.default)("#speaker-modal-container").html(data);
      (0, _jquery.default)("#speaker-modal-container").addClass("modal--speaker--open");
    });
  });

  // Speaker modal delegated event handler
  (0, _jquery.default)("#speaker-modal-container").on("click", ".modal__shade, .modal__content__close", function (event) {
    event.preventDefault();
    (0, _jquery.default)("#speaker-modal-container").removeClass("modal--speaker--open");
  });
};

},{"./common/getQSValue.js":3,"./common/hasValue.js":4,"jquery":"jquery"}],90:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ablePlayer;
var _jquery = _interopRequireDefault(require("jquery"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ablePlayer() {
  var $, isoLangs;
  $ = _jquery.default, $(document).ready(function () {
    $("video, audio").each(function (t, e) {
      void 0 !== $(e).data("able-player") && new AblePlayer($(this), $(e));
    });
  }), window.onYouTubeIframeAPIReady = function () {
    AblePlayer.youtubeIframeAPIReady = !0, $("body").trigger("youtubeIframeAPIReady", []);
  }, $(window).keydown(function (t) {
    1 === AblePlayer.nextIndex && AblePlayer.lastCreated.onPlayerKeyPress(t);
  }), window.AblePlayer = function (t) {
    if (AblePlayer.lastCreated = this, this.media = t, 0 !== $(t).length) {
      if (void 0 !== $(t).attr("autoplay") ? this.autoplay = !0 : this.autoplay = !1, void 0 !== $(t).attr("loop") ? this.loop = !0 : this.loop = !1, void 0 !== $(t).attr("playsinline") ? this.playsInline = "1" : this.playsInline = "0", void 0 !== $(t).data("start-time") && $.isNumeric($(t).data("start-time")) ? this.startTime = $(t).data("start-time") : this.startTime = 0, void 0 !== $(t).data("debug") && !1 !== $(t).data("debug") ? this.debug = !0 : this.debug = !1, void 0 !== $(t).data("root-path") ? this.rootPath = $(t).data("root-path").replace(/\/?$/, "/") : this.rootPath = "/assets/project/americasbanks/js/third-party/", this.defaultVolume = 7, void 0 !== $(t).data("volume") && "" !== $(t).data("volume")) {
        var e = $(t).data("volume");
        e >= 0 && e <= 10 && (this.defaultVolume = e);
      }
      if (this.volume = this.defaultVolume, void 0 !== $(t).data("use-chapters-button") && !1 === $(t).data("use-chapters-button") ? this.useChaptersButton = !1 : this.useChaptersButton = !0, void 0 !== $(t).data("use-descriptions-button") && !1 === $(t).data("use-descriptions-button") ? this.useDescriptionsButton = !1 : this.useDescriptionsButton = !0, void 0 !== $(t).data("heading-level") && "" !== $(t).data("heading-level")) {
        var i = $(t).data("heading-level");
        /^[0-6]*$/.test(i) && (this.playerHeadingLevel = i);
      }
      if (this.transcriptType = null, void 0 !== $(t).data("transcript-src") ? (this.transcriptSrc = $(t).data("transcript-src"), this.transcriptSrcHasRequiredParts() ? this.transcriptType = "manual" : this.transcriptType = null) : $(t).find('track[kind="captions"], track[kind="subtitles"]').length > 0 && (void 0 !== $(t).data("transcript-div") && "" !== $(t).data("transcript-div") ? (this.transcriptDivLocation = $(t).data("transcript-div"), this.transcriptType = "external") : void 0 !== $(t).data("include-transcript") ? !1 !== $(t).data("include-transcript") && (this.transcriptType = "popup") : this.transcriptType = "popup"), void 0 !== $(t).data("lyrics-mode") && !1 !== $(t).data("lyrics-mode") ? this.lyricsMode = !0 : this.lyricsMode = !1, void 0 !== $(t).data("transcript-title") && "" !== $(t).data("transcript-title") && (this.transcriptTitle = $(t).data("transcript-title")), "overlay" === $(t).data("captions-position") ? this.defaultCaptionsPosition = "overlay" : this.defaultCaptionsPosition = "below", void 0 !== $(t).data("chapters-div") && "" !== $(t).data("chapters-div") && (this.chaptersDivLocation = $(t).data("chapters-div")), void 0 !== $(t).data("chapters-title") && (this.chaptersTitle = $(t).data("chapters-title")), void 0 !== $(t).data("chapters-default") && "" !== $(t).data("chapters-default") ? this.defaultChapter = $(t).data("chapters-default") : this.defaultChapter = null, "chapter" === $(t).data("prevnext-unit") || "chapters" === $(t).data("prevnext-unit") ? this.prevNextUnit = "chapter" : "playlist" === $(t).data("prevnext-unit") ? this.prevNextUnit = "playlist" : this.prevNextUnit = !1, "arrows" === $(t).data("speed-icons") ? this.speedIcons = "arrows" : this.speedIcons = "animals", "chapter" === $(t).data("seekbar-scope") || "chapters" === $(t).data("seekbar-scope") ? this.seekbarScope = "chapter" : this.seekbarScope = "video", void 0 !== $(t).data("youtube-id") && "" !== $(t).data("youtube-id") && (this.youTubeId = $(t).data("youtube-id")), void 0 !== $(t).data("youtube-desc-id") && "" !== $(t).data("youtube-desc-id") && (this.youTubeDescId = $(t).data("youtube-desc-id")), void 0 !== $(t).data("youtube-nocookie") && $(t).data("youtube-nocookie") ? this.youTubeNoCookie = !0 : this.youTubeNoCookie = !1, this.iconType = "font", this.forceIconType = !1, void 0 !== $(t).data("icon-type") && "" !== $(t).data("icon-type")) {
        var s = $(t).data("icon-type");
        "font" !== s && "image" != s && "svg" != s || (this.iconType = s, this.forceIconType = !0);
      }
      if (void 0 !== $(t).data("allow-fullscreen") && !1 === $(t).data("allow-fullscreen") ? this.allowFullScreen = !1 : this.allowFullScreen = !0, this.defaultSeekInterval = 10, this.useFixedSeekInterval = !1, void 0 !== $(t).data("seek-interval") && "" !== $(t).data("seek-interval")) {
        var a = $(t).data("seek-interval");
        /^[1-9][0-9]*$/.test(a) && (this.seekInterval = a, this.useFixedSeekInterval = !0);
      }
      if (void 0 !== $(t).data("show-now-playing") && !1 === $(t).data("show-now-playing") ? this.showNowPlaying = !1 : this.showNowPlaying = !0, void 0 !== $(t).data("use-ttml") ? (this.useTtml = !0, this.convert = require("xml-js")) : this.useTtml = !1, this.fallback = null, this.fallbackPath = null, this.fallbackJwKey = null, this.testFallback = !1, void 0 !== $(t).data("fallback") && "" !== $(t).data("fallback")) {
        var n = $(t).data("fallback");
        "jw" === n && (this.fallback = n);
      }
      if ("jw" === this.fallback) {
        if (void 0 !== $(t).data("fallback-path") && !1 !== $(t).data("fallback-path")) {
          this.fallbackPath = $(t).data("fallback-path");
          var r = $(t).data("fallback-path"),
            o = "jwplayer.js";
          r.endsWith(o) && (r = r.slice(0, r.length - 11)), this.fallbackPath = r;
        } else this.fallbackPath = this.rootPath + "thirdparty/";
        void 0 !== $(t).data("fallback-jwkey") && (this.fallbackJwKey = $(t).data("fallback-jwkey")), void 0 !== $(t).data("test-fallback") && !1 !== $(t).data("test-fallback") && (this.testFallback = !0);
      }
      if (this.lang = "en", void 0 !== $(t).data("lang") && "" !== $(t).data("lang")) {
        var l = $(t).data("lang");
        2 == l.length && (this.lang = l);
      }
      void 0 !== $(t).data("force-lang") && !1 !== $(t).data("force-lang") ? this.forceLang = !0 : this.forceLang = !1, void 0 !== $(t).data("meta-type") && "" !== $(t).data("meta-type") && (this.metaType = $(t).data("meta-type")), void 0 !== $(t).data("meta-div") && "" !== $(t).data("meta-div") && (this.metaDiv = $(t).data("meta-div")), void 0 !== $(t).data("search") && "" !== $(t).data("search") && (void 0 !== $(t).data("search-div") && "" !== $(t).data("search-div") && (this.searchString = $(t).data("search"), this.searchDiv = $(t).data("search-div")), void 0 !== $(t).data("search-lang") && "" !== $(t).data("search-lang") ? this.searchLang = $(t).data("search-lang") : this.searchLang = null, void 0 !== $(t).data("search-div") && "" !== $(t).data("search-div") && (this.searchString = $(t).data("search"), this.searchDiv = $(t).data("search-div"))), void 0 !== $(t).data("hide-controls") && !1 !== $(t).data("hide-controls") ? this.hideControls = !0 : this.hideControls = !1, this.setDefaults(), this.ableIndex = AblePlayer.nextIndex, AblePlayer.nextIndex += 1, this.title = $(t).attr("title"), this.tt = {};
      var h = this;
      $.when(this.getTranslationText()).then(function () {
        h.countProperties(h.tt) > 50 ? h.setup() : h.provideFallback();
      });
    } else this.provideFallback();
  }, AblePlayer.nextIndex = 0, AblePlayer.prototype.setup = function () {
    var t = this;
    this.reinitialize().then(function () {
      t.player ? t.setupInstance().then(function () {
        t.recreatePlayer();
      }) : t.provideFallback();
    });
  }, AblePlayer.getActiveDOMElement = function () {
    for (var t = document.activeElement; t.shadowRoot && t.shadowRoot.activeElement;) t = t.shadowRoot.activeElement;
    return t;
  }, AblePlayer.localGetElementById = function (t, e) {
    return t.getRootNode ? $(t.getRootNode().querySelector("#" + e)) : $(document.getElementById(e));
  }, AblePlayer.youtubeIframeAPIReady = !1, AblePlayer.loadingYoutubeIframeAPI = !1, function (t) {
    AblePlayer.prototype.setDefaults = function () {
      this.playing = !1, this.clickedPlay = !1, this.getUserAgent(), this.setIconColor(), this.setButtonImages();
    }, AblePlayer.prototype.getRootPath = function () {
      var t, e, i, s, a, n;
      for (t = document.getElementsByTagName("script"), e = 0; e < t.length; e++) if (-1 !== (i = t[e].src).substr(i.lastIndexOf("/")).indexOf("ableplayer")) {
        s = i.split("?")[0];
        break;
      }
      return n = (a = s.split("/").slice(0, -1).join("/")).lastIndexOf("/"), a.substring(0, n) + "/";
    }, AblePlayer.prototype.setIconColor = function () {
      var e, i, s, a, n;
      for (e = ["controller", "toolbar"], i = 0; i < e.length; i++) "controller" == e[i] ? s = t("<div>", {
        class: "able-controller"
      }).hide() : "toolbar" === e[i] && (s = t("<div>", {
        class: "able-window-toolbar"
      }).hide()), t("body").append(s), n = .2126 * (a = s.css("background-color").replace(/[^\d,]/g, "").split(","))[0] + .7152 * a[1] + .0722 * a[2] < 125 ? "white" : "black", "controller" === e[i] ? this.iconColor = n : "toolbar" === e[i] && (this.toolbarIconColor = n), s.remove();
    }, AblePlayer.prototype.setButtonImages = function () {
      this.imgPath = this.rootPath + "button-icons/" + this.iconColor + "/", this.playButtonImg = this.imgPath + "play.png", this.pauseButtonImg = this.imgPath + "pause.png", this.restartButtonImg = this.imgPath + "restart.png", this.rewindButtonImg = this.imgPath + "rewind.png", this.forwardButtonImg = this.imgPath + "forward.png", this.previousButtonImg = this.imgPath + "previous.png", this.nextButtonImg = this.imgPath + "next.png", "arrows" === this.speedIcons ? (this.fasterButtonImg = this.imgPath + "slower.png", this.slowerButtonImg = this.imgPath + "faster.png") : "animals" === this.speedIcons && (this.fasterButtonImg = this.imgPath + "rabbit.png", this.slowerButtonImg = this.imgPath + "turtle.png"), this.captionsButtonImg = this.imgPath + "captions.png", this.chaptersButtonImg = this.imgPath + "chapters.png", this.signButtonImg = this.imgPath + "sign.png", this.transcriptButtonImg = this.imgPath + "transcript.png", this.descriptionsButtonImg = this.imgPath + "descriptions.png", this.fullscreenExpandButtonImg = this.imgPath + "fullscreen-expand.png", this.fullscreenCollapseButtonImg = this.imgPath + "fullscreen-collapse.png", this.prefsButtonImg = this.imgPath + "preferences.png", this.helpButtonImg = this.imgPath + "help.png";
    }, AblePlayer.prototype.getSvgData = function (t) {
      var e = Array();
      switch (t) {
        case "play":
          e[0] = "0 0 16 20", e[1] = "M0 18.393v-16.429q0-0.29 0.184-0.402t0.441 0.033l14.821 8.237q0.257 0.145 0.257 0.346t-0.257 0.346l-14.821 8.237q-0.257 0.145-0.441 0.033t-0.184-0.402z";
          break;
        case "pause":
          e[0] = "0 0 20 20", e[1] = "M0 18.036v-15.714q0-0.29 0.212-0.502t0.502-0.212h5.714q0.29 0 0.502 0.212t0.212 0.502v15.714q0 0.29-0.212 0.502t-0.502 0.212h-5.714q-0.29 0-0.502-0.212t-0.212-0.502zM10 18.036v-15.714q0-0.29 0.212-0.502t0.502-0.212h5.714q0.29 0 0.502 0.212t0.212 0.502v15.714q0 0.29-0.212 0.502t-0.502 0.212h-5.714q-0.29 0-0.502-0.212t-0.212-0.502z";
          break;
        case "stop":
          e[0] = "0 0 20 20", e[1] = "M0 18.036v-15.714q0-0.29 0.212-0.502t0.502-0.212h15.714q0.29 0 0.502 0.212t0.212 0.502v15.714q0 0.29-0.212 0.502t-0.502 0.212h-15.714q-0.29 0-0.502-0.212t-0.212-0.502z";
          break;
        case "restart":
          e[0] = "0 0 20 20", e[1] = "M18 8h-6l2.243-2.243c-1.133-1.133-2.64-1.757-4.243-1.757s-3.109 0.624-4.243 1.757c-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.133 1.133 2.64 1.757 4.243 1.757s3.109-0.624 4.243-1.757c0.095-0.095 0.185-0.192 0.273-0.292l1.505 1.317c-1.466 1.674-3.62 2.732-6.020 2.732-4.418 0-8-3.582-8-8s3.582-8 8-8c2.209 0 4.209 0.896 5.656 2.344l2.344-2.344v6z";
          break;
        case "rewind":
          e[0] = "0 0 20 20", e[1] = "M11.25 3.125v6.25l6.25-6.25v13.75l-6.25-6.25v6.25l-6.875-6.875z";
          break;
        case "forward":
          e[0] = "0 0 20 20", e[1] = "M10 16.875v-6.25l-6.25 6.25v-13.75l6.25 6.25v-6.25l6.875 6.875z";
          break;
        case "previous":
          e[0] = "0 0 20 20", e[1] = "M5 17.5v-15h2.5v6.875l6.25-6.25v13.75l-6.25-6.25v6.875z";
          break;
        case "next":
          e[0] = "0 0 20 20", e[1] = "M15 2.5v15h-2.5v-6.875l-6.25 6.25v-13.75l6.25 6.25v-6.875z";
          break;
        case "slower":
          e[0] = "0 0 20 20", e[1] = "M0 7.321q0-0.29 0.212-0.502t0.502-0.212h10q0.29 0 0.502 0.212t0.212 0.502-0.212 0.502l-5 5q-0.212 0.212-0.502 0.212t-0.502-0.212l-5-5q-0.212-0.212-0.212-0.502z";
          break;
        case "faster":
          e[0] = "0 0 11 20", e[1] = "M0 12.411q0-0.29 0.212-0.502l5-5q0.212-0.212 0.502-0.212t0.502 0.212l5 5q0.212 0.212 0.212 0.502t-0.212 0.502-0.502 0.212h-10q-0.29 0-0.502-0.212t-0.212-0.502z";
          break;
        case "turtle":
          e[0] = "0 0 20 20", e[1] = "M17.212 3.846c-0.281-0.014-0.549 0.025-0.817 0.144-1.218 0.542-1.662 2.708-2.163 3.942-1.207 2.972-7.090 4.619-11.755 5.216-0.887 0.114-1.749 0.74-2.428 1.466 0.82-0.284 2.126-0.297 2.74 0.144 0.007 0.488-0.376 1.062-0.625 1.37-0.404 0.5-0.398 0.793 0.12 0.793 0.473 0 0.752 0.007 1.635 0 0.393-0.003 0.618-0.16 1.49-1.49 3.592 0.718 5.986-0.264 5.986-0.264s0.407 1.755 1.418 1.755h1.49c0.633 0 0.667-0.331 0.625-0.433-0.448-1.082-0.68-1.873-0.769-2.5-0.263-1.857 0.657-3.836 2.524-5.457 0.585 0.986 2.253 0.845 2.909-0.096s0.446-2.268-0.192-3.221c-0.49-0.732-1.345-1.327-2.188-1.37zM8.221 4.663c-0.722-0.016-1.536 0.111-2.5 0.409-4.211 1.302-4.177 4.951-3.51 5.745 0 0-0.955 0.479-0.409 1.274 0.448 0.652 3.139 0.191 5.409-0.529s4.226-1.793 5.312-2.692c0.948-0.785 0.551-2.106-0.505-1.947-0.494-0.98-1.632-2.212-3.798-2.26zM18.846 5.962c0.325 0 0.577 0.252 0.577 0.577s-0.252 0.577-0.577 0.577c-0.325 0-0.577-0.252-0.577-0.577s0.252-0.577 0.577-0.577z";
          break;
        case "rabbit":
          e[0] = "0 0 20 20", e[1] = "M10.817 0c-2.248 0-1.586 0.525-1.154 0.505 1.551-0.072 5.199 0.044 6.851 2.428 0 0-1.022-2.933-5.697-2.933zM10.529 0.769c-2.572 0-2.837 0.51-2.837 1.106 0 0.545 1.526 0.836 2.524 0.697 2.778-0.386 4.231-0.12 5.264 0.865-1.010 0.779-0.75 1.401-1.274 1.851-1.093 0.941-2.643-0.673-4.976-0.673-2.496 0-4.712 1.92-4.712 4.76-0.157-0.537-0.769-0.913-1.442-0.913-0.974 0-1.514 0.637-1.514 1.49 0 0.769 1.13 1.791 2.861 0.938 0.499 1.208 2.265 1.364 2.452 1.418 0.538 0.154 1.875 0.098 1.875 0.865 0 0.794-1.034 1.094-1.034 1.707 0 1.070 1.758 0.873 2.284 1.034 1.683 0.517 2.103 1.214 2.788 2.212 0.771 1.122 2.572 1.408 2.572 0.625 0-3.185-4.413-4.126-4.399-4.135 0.608-0.382 2.139-1.397 2.139-3.534 0-1.295-0.703-2.256-1.755-2.861 1.256 0.094 2.572 1.205 2.572 2.74 0 1.877-0.653 2.823-0.769 2.957 1.975-1.158 3.193-3.91 3.029-6.37 0.61 0.401 1.27 0.577 1.971 0.625 0.751 0.052 1.475-0.225 1.635-0.529 0.38-0.723 0.162-2.321-0.12-2.837-0.763-1.392-2.236-1.73-3.606-1.683-1.202-1.671-3.812-2.356-5.529-2.356zM1.37 3.077l-0.553 1.538h3.726c0.521-0.576 1.541-1.207 2.284-1.538h-5.457zM18.846 5.192c0.325 0 0.577 0.252 0.577 0.577s-0.252 0.577-0.577 0.577c-0.325 0-0.577-0.252-0.577-0.577s0.252-0.577 0.577-0.577zM0.553 5.385l-0.553 1.538h3.197c0.26-0.824 0.586-1.328 0.769-1.538h-3.413z";
          break;
        case "ellipsis":
          e[0] = "0 0 20 20", e[1] = "M10.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2zM3.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.986 2.199-2.2s-0.984-2.2-2.199-2.2zM17.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2z";
          break;
        case "pipe":
          e[0] = "0 0 20 20", e[1] = "M10.15 0.179h0.623c0.069 0 0.127 0.114 0.127 0.253v19.494c0 0.139-0.057 0.253-0.127 0.253h-1.247c-0.069 0-0.126-0.114-0.126-0.253v-19.494c0-0.139 0.057-0.253 0.126-0.253h0.623z";
          break;
        case "captions":
          e[0] = "0 0 20 20", e[1] = "M0.033 3.624h19.933v12.956h-19.933v-12.956zM18.098 10.045c-0.025-2.264-0.124-3.251-0.743-3.948-0.112-0.151-0.322-0.236-0.496-0.344-0.606-0.386-3.465-0.526-6.782-0.526s-6.313 0.14-6.907 0.526c-0.185 0.108-0.396 0.193-0.519 0.344-0.607 0.697-0.693 1.684-0.731 3.948 0.037 2.265 0.124 3.252 0.731 3.949 0.124 0.161 0.335 0.236 0.519 0.344 0.594 0.396 3.59 0.526 6.907 0.547 3.317-0.022 6.176-0.151 6.782-0.547 0.174-0.108 0.384-0.183 0.496-0.344 0.619-0.697 0.717-1.684 0.743-3.949v0 0zM9.689 9.281c-0.168-1.77-1.253-2.813-3.196-2.813-1.773 0-3.168 1.387-3.168 3.617 0 2.239 1.271 3.636 3.372 3.636 1.676 0 2.851-1.071 3.035-2.852h-2.003c-0.079 0.661-0.397 1.168-1.068 1.168-1.059 0-1.253-0.91-1.253-1.876 0-1.33 0.442-2.010 1.174-2.010 0.653 0 1.068 0.412 1.13 1.129h1.977zM16.607 9.281c-0.167-1.77-1.252-2.813-3.194-2.813-1.773 0-3.168 1.387-3.168 3.617 0 2.239 1.271 3.636 3.372 3.636 1.676 0 2.851-1.071 3.035-2.852h-2.003c-0.079 0.661-0.397 1.168-1.068 1.168-1.059 0-1.253-0.91-1.253-1.876 0-1.33 0.441-2.010 1.174-2.010 0.653 0 1.068 0.412 1.13 1.129h1.976z";
          break;
        case "descriptions":
          e[0] = "0 0 20 20", e[1] = "M17.623 3.57h-1.555c1.754 1.736 2.763 4.106 2.763 6.572 0 2.191-0.788 4.286-2.189 5.943h1.484c1.247-1.704 1.945-3.792 1.945-5.943-0-2.418-0.886-4.754-2.447-6.572v0zM14.449 3.57h-1.55c1.749 1.736 2.757 4.106 2.757 6.572 0 2.191-0.788 4.286-2.187 5.943h1.476c1.258-1.704 1.951-3.792 1.951-5.943-0-2.418-0.884-4.754-2.447-6.572v0zM11.269 3.57h-1.542c1.752 1.736 2.752 4.106 2.752 6.572 0 2.191-0.791 4.286-2.181 5.943h1.473c1.258-1.704 1.945-3.792 1.945-5.943 0-2.418-0.876-4.754-2.447-6.572v0zM10.24 9.857c0 3.459-2.826 6.265-6.303 6.265v0.011h-3.867v-12.555h3.896c3.477 0 6.274 2.806 6.274 6.279v0zM6.944 9.857c0-1.842-1.492-3.338-3.349-3.338h-0.876v6.686h0.876c1.858 0 3.349-1.498 3.349-3.348v0z";
          break;
        case "sign":
          e[0] = "0 0 20 20", e[1] = "M10.954 10.307c0.378 0.302 0.569 1.202 0.564 1.193 0.697 0.221 1.136 0.682 1.136 0.682 1.070-0.596 1.094-0.326 1.558-0.682 0.383-0.263 0.366-0.344 0.567-1.048 0.187-0.572-0.476-0.518-1.021-1.558-0.95 0.358-1.463 0.196-1.784 0.167-0.145-0.020-0.12 0.562-1.021 1.247zM14.409 17.196c-0.133 0.182-0.196 0.218-0.363 0.454-0.28 0.361 0.076 0.906 0.253 0.82 0.206-0.076 0.341-0.488 0.567-0.623 0.115-0.061 0.422-0.513 0.709-0.82 0.211-0.238 0.363-0.344 0.564-0.594 0.341-0.422 0.412-0.744 0.709-1.193 0.184-0.236 0.312-0.307 0.481-0.594 0.886-1.679 0.628-2.432 1.475-3.629 0.26-0.353 0.552-0.442 0.964-0.653 0.383-2.793-0.888-4.356-0.879-4.361-1.067 0.623-1.644 0.879-2.751 0.82-0.417-0.005-0.636-0.182-1.048-0.145-0.385 0.015-0.582 0.159-0.964 0.29-0.589 0.182-0.91 0.344-1.529 0.535-0.393 0.11-0.643 0.115-1.050 0.255-0.348 0.147-0.182 0.029-0.427 0.312-0.317 0.348-0.238 0.623-0.535 1.222-0.371 0.785-0.326 0.891-0.115 0.987-0.14 0.402-0.174 0.672-0.14 1.107 0.039 0.331-0.101 0.562 0.255 0.825 0.483 0.361 1.499 1.205 1.757 1.217 0.39-0.012 1.521 0.029 2.096-0.368 0.13-0.081 0.167-0.162 0.056 0.145-0.022 0.037-1.433 1.136-1.585 1.131-1.794 0.056-1.193 0.157-1.303 0.115-0.091 0-0.955-1.055-1.477-0.682-0.196 0.12-0.287 0.236-0.363 0.452 0.066 0.137 0.383 0.358 0.675 0.54 0.422 0.27 0.461 0.552 0.881 0.653 0.513 0.115 1.060 0.039 1.387 0.081 0.125 0.034 1.256-0.297 1.961-0.675 0.65-0.336-0.898 0.648-1.276 1.131-1.141 0.358-0.82 0.373-1.362 0.483-0.503 0.115-0.479 0.086-0.822 0.196-0.356 0.086-0.648 0.572-0.312 0.825 0.201 0.167 0.827-0.066 1.445-0.086 0.275-0.005 1.391-0.518 1.644-0.653 0.633-0.339 1.099-0.81 1.472-1.077 0.518-0.361-0.584 0.991-1.050 1.558zM8.855 9.799c-0.378-0.312-0.569-1.212-0.564-1.217-0.697-0.206-1.136-0.667-1.136-0.653-1.070 0.582-1.099 0.312-1.558 0.653-0.388 0.277-0.366 0.363-0.567 1.045-0.187 0.594 0.471 0.535 1.021 1.561 0.95-0.344 1.463-0.182 1.784-0.142 0.145 0.010 0.12-0.572 1.021-1.247zM5.4 2.911c0.133-0.191 0.196-0.228 0.368-0.454 0.27-0.371-0.081-0.915-0.253-0.849-0.211 0.096-0.346 0.508-0.599 0.653-0.093 0.052-0.4 0.503-0.682 0.82-0.211 0.228-0.363 0.334-0.564 0.599-0.346 0.407-0.412 0.729-0.709 1.161-0.184 0.258-0.317 0.324-0.481 0.621-0.886 1.669-0.631 2.422-1.475 3.6-0.26 0.38-0.552 0.461-0.964 0.682-0.383 2.788 0.883 4.346 0.879 4.336 1.068-0.609 1.639-0.861 2.751-0.825 0.417 0.025 0.636 0.201 1.048 0.174 0.385-0.025 0.582-0.169 0.964-0.285 0.589-0.196 0.91-0.358 1.499-0.54 0.422-0.12 0.672-0.125 1.080-0.285 0.348-0.128 0.182-0.010 0.427-0.282 0.312-0.358 0.238-0.633 0.508-1.217 0.398-0.8 0.353-0.906 0.142-0.991 0.135-0.412 0.174-0.677 0.14-1.107-0.044-0.336 0.101-0.572-0.255-0.82-0.483-0.375-1.499-1.22-1.752-1.222-0.395 0.002-1.526-0.039-2.101 0.339-0.13 0.101-0.167 0.182-0.056-0.11 0.022-0.052 1.433-1.148 1.585-1.163 1.794-0.039 1.193-0.14 1.303-0.088 0.091-0.007 0.955 1.045 1.477 0.682 0.191-0.13 0.287-0.245 0.368-0.452-0.071-0.147-0.388-0.368-0.68-0.537-0.422-0.282-0.464-0.564-0.881-0.655-0.513-0.125-1.065-0.049-1.387-0.11-0.125-0.015-1.256 0.317-1.956 0.68-0.66 0.351 0.893-0.631 1.276-1.136 1.136-0.339 0.81-0.353 1.36-0.479 0.501-0.101 0.476-0.071 0.82-0.172 0.351-0.096 0.648-0.577 0.312-0.849-0.206-0.152-0.827 0.081-1.44 0.086-0.28 0.020-1.396 0.533-1.649 0.677-0.633 0.329-1.099 0.8-1.472 1.048-0.523 0.38 0.584-0.967 1.050-1.529z";
          break;
        case "mute":
          e[0] = "0 0 20 20", e[1] = "M7.839 1.536c0.501-0.501 0.911-0.331 0.911 0.378v16.172c0 0.709-0.41 0.879-0.911 0.378l-4.714-4.713h-3.125v-7.5h3.125l4.714-4.714zM18.75 12.093v1.657h-1.657l-2.093-2.093-2.093 2.093h-1.657v-1.657l2.093-2.093-2.093-2.093v-1.657h1.657l2.093 2.093 2.093-2.093h1.657v1.657l-2.093 2.093z";
          break;
        case "volume-mute":
          e[0] = "0 0 20 20", e[1] = "M10.723 14.473c-0.24 0-0.48-0.092-0.663-0.275-0.366-0.366-0.366-0.96 0-1.326 1.584-1.584 1.584-4.161 0-5.745-0.366-0.366-0.366-0.96 0-1.326s0.96-0.366 1.326 0c2.315 2.315 2.315 6.082 0 8.397-0.183 0.183-0.423 0.275-0.663 0.275zM7.839 1.536c0.501-0.501 0.911-0.331 0.911 0.378v16.172c0 0.709-0.41 0.879-0.911 0.378l-4.714-4.713h-3.125v-7.5h3.125l4.714-4.714z";
          break;
        case "volume-medium":
          e[0] = "0 0 20 20", e[1] = "M14.053 16.241c-0.24 0-0.48-0.092-0.663-0.275-0.366-0.366-0.366-0.96 0-1.326 2.559-2.559 2.559-6.722 0-9.281-0.366-0.366-0.366-0.96 0-1.326s0.96-0.366 1.326 0c1.594 1.594 2.471 3.712 2.471 5.966s-0.878 4.373-2.471 5.966c-0.183 0.183-0.423 0.275-0.663 0.275zM10.723 14.473c-0.24 0-0.48-0.092-0.663-0.275-0.366-0.366-0.366-0.96 0-1.326 1.584-1.584 1.584-4.161 0-5.745-0.366-0.366-0.366-0.96 0-1.326s0.96-0.366 1.326 0c2.315 2.315 2.315 6.082 0 8.397-0.183 0.183-0.423 0.275-0.663 0.275zM7.839 1.536c0.501-0.501 0.911-0.331 0.911 0.378v16.172c0 0.709-0.41 0.879-0.911 0.378l-4.714-4.713h-3.125v-7.5h3.125l4.714-4.714z";
          break;
        case "volume-loud":
          e[0] = "0 0 21 20", e[1] = "M17.384 18.009c-0.24 0-0.48-0.092-0.663-0.275-0.366-0.366-0.366-0.96 0-1.326 1.712-1.712 2.654-3.988 2.654-6.408s-0.943-4.696-2.654-6.408c-0.366-0.366-0.366-0.96 0-1.326s0.96-0.366 1.326 0c2.066 2.066 3.204 4.813 3.204 7.734s-1.138 5.668-3.204 7.734c-0.183 0.183-0.423 0.275-0.663 0.275zM14.053 16.241c-0.24 0-0.48-0.092-0.663-0.275-0.366-0.366-0.366-0.96 0-1.326 2.559-2.559 2.559-6.722 0-9.281-0.366-0.366-0.366-0.96 0-1.326s0.96-0.366 1.326 0c1.594 1.594 2.471 3.712 2.471 5.966s-0.878 4.373-2.471 5.966c-0.183 0.183-0.423 0.275-0.663 0.275zM10.723 14.473c-0.24 0-0.48-0.092-0.663-0.275-0.366-0.366-0.366-0.96 0-1.326 1.584-1.584 1.584-4.161 0-5.745-0.366-0.366-0.366-0.96 0-1.326s0.96-0.366 1.326 0c2.315 2.315 2.315 6.082 0 8.397-0.183 0.183-0.423 0.275-0.663 0.275zM7.839 1.536c0.501-0.501 0.911-0.331 0.911 0.378v16.172c0 0.709-0.41 0.879-0.911 0.378l-4.714-4.713h-3.125v-7.5h3.125l4.714-4.714z";
          break;
        case "chapters":
          e[0] = "0 0 20 20", e[1] = "M5 2.5v17.5l6.25-6.25 6.25 6.25v-17.5zM15 0h-12.5v17.5l1.25-1.25v-15h11.25z";
          break;
        case "transcript":
          e[0] = "0 0 20 20", e[1] = "M0 19.107v-17.857q0-0.446 0.313-0.759t0.759-0.313h8.929v6.071q0 0.446 0.313 0.759t0.759 0.313h6.071v11.786q0 0.446-0.313 0.759t-0.759 0.312h-15q-0.446 0-0.759-0.313t-0.313-0.759zM4.286 15.536q0 0.156 0.1 0.257t0.257 0.1h7.857q0.156 0 0.257-0.1t0.1-0.257v-0.714q0-0.156-0.1-0.257t-0.257-0.1h-7.857q-0.156 0-0.257 0.1t-0.1 0.257v0.714zM4.286 12.679q0 0.156 0.1 0.257t0.257 0.1h7.857q0.156 0 0.257-0.1t0.1-0.257v-0.714q0-0.156-0.1-0.257t-0.257-0.1h-7.857q-0.156 0-0.257 0.1t-0.1 0.257v0.714zM4.286 9.821q0 0.156 0.1 0.257t0.257 0.1h7.857q0.156 0 0.257-0.1t0.1-0.257v-0.714q0-0.156-0.1-0.257t-0.257-0.1h-7.857q-0.156 0-0.257 0.1t-0.1 0.257v0.714zM11.429 5.893v-5.268q0.246 0.156 0.402 0.313l4.554 4.554q0.156 0.156 0.313 0.402h-5.268z";
          break;
        case "preferences":
          e[0] = "0 0 20 20", e[1] = "M18.238 11.919c-1.049-1.817-0.418-4.147 1.409-5.205l-1.965-3.404c-0.562 0.329-1.214 0.518-1.911 0.518-2.1 0-3.803-1.714-3.803-3.828h-3.931c0.005 0.653-0.158 1.314-0.507 1.919-1.049 1.818-3.382 2.436-5.212 1.382l-1.965 3.404c0.566 0.322 1.056 0.793 1.404 1.396 1.048 1.815 0.42 4.139-1.401 5.2l1.965 3.404c0.56-0.326 1.209-0.513 1.902-0.513 2.094 0 3.792 1.703 3.803 3.808h3.931c-0.002-0.646 0.162-1.3 0.507-1.899 1.048-1.815 3.375-2.433 5.203-1.387l1.965-3.404c-0.562-0.322-1.049-0.791-1.395-1.391zM10 14.049c-2.236 0-4.050-1.813-4.050-4.049s1.813-4.049 4.050-4.049 4.049 1.813 4.049 4.049c-0 2.237-1.813 4.049-4.049 4.049z";
          break;
        case "close":
          e[0] = "0 0 16 20", e[1] = "M1.228 14.933q0-0.446 0.312-0.759l3.281-3.281-3.281-3.281q-0.313-0.313-0.313-0.759t0.313-0.759l1.518-1.518q0.313-0.313 0.759-0.313t0.759 0.313l3.281 3.281 3.281-3.281q0.313-0.313 0.759-0.313t0.759 0.313l1.518 1.518q0.313 0.313 0.313 0.759t-0.313 0.759l-3.281 3.281 3.281 3.281q0.313 0.313 0.313 0.759t-0.313 0.759l-1.518 1.518q-0.313 0.313-0.759 0.313t-0.759-0.313l-3.281-3.281-3.281 3.281q-0.313 0.313-0.759 0.313t-0.759-0.313l-1.518-1.518q-0.313-0.313-0.313-0.759z";
          break;
        case "fullscreen-expand":
          e[0] = "0 0 20 20", e[1] = "M0 18.036v-5q0-0.29 0.212-0.502t0.502-0.212 0.502 0.212l1.607 1.607 3.705-3.705q0.112-0.112 0.257-0.112t0.257 0.112l1.272 1.272q0.112 0.112 0.112 0.257t-0.112 0.257l-3.705 3.705 1.607 1.607q0.212 0.212 0.212 0.502t-0.212 0.502-0.502 0.212h-5q-0.29 0-0.502-0.212t-0.212-0.502zM8.717 8.393q0-0.145 0.112-0.257l3.705-3.705-1.607-1.607q-0.212-0.212-0.212-0.502t0.212-0.502 0.502-0.212h5q0.29 0 0.502 0.212t0.212 0.502v5q0 0.29-0.212 0.502t-0.502 0.212-0.502-0.212l-1.607-1.607-3.705 3.705q-0.112 0.112-0.257 0.112t-0.257-0.112l-1.272-1.272q-0.112-0.112-0.112-0.257z";
          break;
        case "fullscreen-collapse":
          e[0] = "0 0 20 20", e[1] = "M0.145 16.964q0-0.145 0.112-0.257l3.705-3.705-1.607-1.607q-0.212-0.212-0.212-0.502t0.212-0.502 0.502-0.212h5q0.29 0 0.502 0.212t0.212 0.502v5q0 0.29-0.212 0.502t-0.502 0.212-0.502-0.212l-1.607-1.607-3.705 3.705q-0.112 0.112-0.257 0.112t-0.257-0.112l-1.272-1.272q-0.112-0.112-0.112-0.257zM8.571 9.464v-5q0-0.29 0.212-0.502t0.502-0.212 0.502 0.212l1.607 1.607 3.705-3.705q0.112-0.112 0.257-0.112t0.257 0.112l1.272 1.272q0.112 0.112 0.112 0.257t-0.112 0.257l-3.705 3.705 1.607 1.607q0.212 0.212 0.212 0.502t-0.212 0.502-0.502 0.212h-5q-0.29 0-0.502-0.212t-0.212-0.502z";
          break;
        case "help":
          e[0] = "0 0 11 20", e[1] = "M0.577 6.317q-0.028-0.167 0.061-0.313 1.786-2.969 5.179-2.969 0.893 0 1.797 0.346t1.629 0.926 1.183 1.423 0.458 1.769q0 0.603-0.173 1.127t-0.391 0.854-0.614 0.664-0.642 0.485-0.681 0.396q-0.458 0.257-0.765 0.725t-0.307 0.748q0 0.19-0.134 0.363t-0.313 0.173h-2.679q-0.167 0-0.285-0.206t-0.117-0.419v-0.502q0-0.926 0.725-1.747t1.596-1.211q0.658-0.301 0.938-0.625t0.279-0.848q0-0.469-0.519-0.826t-1.2-0.357q-0.725 0-1.205 0.324-0.391 0.279-1.194 1.283-0.145 0.179-0.346 0.179-0.134 0-0.279-0.089l-1.83-1.395q-0.145-0.112-0.173-0.279zM3.786 16.875v-2.679q0-0.179 0.134-0.313t0.313-0.134h2.679q0.179 0 0.313 0.134t0.134 0.313v2.679q0 0.179-0.134 0.313t-0.313 0.134h-2.679q-0.179 0-0.313-0.134t-0.134-0.313z";
      }
      return e;
    }, AblePlayer.prototype.reinitialize = function () {
      var e, i;
      if (i = (e = new t.Deferred()).promise(), this, window.console || (this.debug = !1), this.startedPlaying = !1, this.autoScrollTranscript = !0, this.$media = t(this.media).first(), this.media = this.$media[0], this.$media.is("audio")) this.mediaType = "audio";else {
        if (!this.$media.is("video")) return this.provideFallback(), e.fail(), i;
        this.mediaType = "video";
      }
      return this.$sources = this.$media.find("source"), this.player = this.getPlayer(), this.player || this.provideFallback(), this.setIconType(), this.setDimensions(), e.resolve(), i;
    }, AblePlayer.prototype.setDimensions = function () {
      this.$media.attr("width") && this.$media.attr("height") ? (this.playerMaxWidth = parseInt(this.$media.attr("width"), 10), this.playerMaxHeight = parseInt(this.$media.attr("height"), 10)) : this.$media.attr("width") ? this.playerMaxWidth = parseInt(this.$media.attr("width"), 10) : (this.playerMaxWidth = this.$media.parent().width(), this.playerMaxHeight = this.getMatchingHeight(this.playerMaxWidth)), this.$media.css({
        width: "100%",
        height: "auto"
      });
    }, AblePlayer.prototype.getMatchingHeight = function (e) {
      var i, s, a, n, r;
      return i = [3840, 2560, 1920, 1280, 854, 640, 426], s = [2160, 1440, 1080, 720, 480, 360, 240], a = null, n = null, t.each(i, function (t) {
        (null == a || Math.abs(this - e) < Math.abs(a - e)) && (a = this, n = t);
      }), r = s[n], this.aspectRatio = a / r, Math.round(e / this.aspectRatio);
    }, AblePlayer.prototype.setIconType = function () {
      var e, i, s;
      if (this.forceIconType) return !1;
      document.createElementNS && document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect ? this.iconType = "svg" : (window.getComputedStyle ? (t("span.icon-play").length ? i = t("span.icon-play") : (e = t("<span>", {
        class: "icon-play able-clipped"
      }), t("body").append(e), i = e), void 0 !== (s = window.getComputedStyle(i.get(0), null).getPropertyValue("font-family")) && -1 !== s.indexOf("able") ? this.iconType = "font" : this.iconType = "image") : this.iconType = "image", this.debug && console.log("Using " + this.iconType + "s for player controls"), void 0 !== e && e.remove());
    }, AblePlayer.prototype.setupInstance = function () {
      var e = new t.Deferred(),
        i = e.promise();
      return this.$media.attr("id") ? this.mediaId = this.$media.attr("id") : (this.mediaId = "ableMediaId_" + this.ableIndex, this.$media.attr("id", this.mediaId)), this.setupInstancePlaylist(), e.resolve(), i;
    }, AblePlayer.prototype.setupInstancePlaylist = function () {
      var e = this;
      if (this.hasPlaylist = !1, t(".able-playlist").each(function () {
        if (t(this).data("player") === e.mediaId) {
          e.hasPlaylist = !0, e.$playlist = t(this).find("li"), t(this).find("li").attr("tabindex", "0"), e.playlistIndex = 0;
          var i = t(this).data("embedded");
          e.playlistEmbed = void 0 !== i && !1 !== i;
        }
      }), this.hasPlaylist && this.loop && this.media.removeAttribute("loop"), this.hasPlaylist && this.playlistEmbed) {
        var i = this.$playlist.parent();
        this.$playlistDom = i.clone(), i.remove();
      }
    }, AblePlayer.prototype.recreatePlayer = function () {
      var t, e, i;
      t = this, this.player ? (this.loadCurrentPreferences(), this.injectPlayerCode(), this.initSignLanguage(), this.setupTracks().then(function () {
        t.setupAltCaptions().then(function () {
          "external" !== t.transcriptType && "popup" !== t.transcriptType || t.captions.length <= 1 && t.$transcriptLanguageSelect.parent().remove(), t.initDescription(), t.initDefaultCaption(), t.initPlayer().then(function () {
            for (t.initializing = !1, t.setMediaAttributes(), e = t.getPreferencesGroups(), i = 0; i < e.length; i++) t.injectPrefsForm(e[i]);
            t.setupPopups(), t.updateCaption(), t.updateTranscript(), t.injectVTS(), t.chaptersDivLocation && t.populateChaptersDiv(), t.showSearchResults();
          }, function () {
            t.provideFallback();
          });
        });
      })) : console.log("Can't create player; no appropriate player type detected.");
    }, AblePlayer.prototype.initPlayer = function () {
      var e,
        i = this;
      "html5" === this.player ? e = this.initHtml5Player() : "jw" === this.player ? e = this.initJwPlayer() : "youtube" === this.player && (e = this.initYouTubePlayer());
      var s = new t.Deferred(),
        a = s.promise();
      return e.done(function () {
        !1 === i.useFixedSeekInterval && i.setSeekInterval(), i.addControls(), i.addEventListeners(), i.Volume && i.setMute(!1), i.setFullscreen(!1), i.setVolume(i.defaultVolume), i.refreshControls(), "html5" === i.player && (i.isIOS() || i.startTime > 0 || i.autoplay) && i.$media[0].load(), s.resolve();
      }).fail(function () {
        s.reject();
      }), a;
    }, AblePlayer.prototype.setSeekInterval = function () {
      var t;
      this.seekInterval = this.defaultSeekInterval, void 0 === (t = this.useChapterTimes ? this.chapterDuration : this.getDuration()) || t < 1 ? this.seekIntervalCalculated = !1 : (this.seekInterval = t <= 20 ? 5 : t <= 30 ? 6 : t <= 40 ? 8 : t <= 100 ? 10 : t / 10, this.seekIntervalCalculated = !0);
    }, AblePlayer.prototype.initDefaultCaption = function () {
      var t, e;
      if ((t = this.usingYouTubeCaptions ? this.ytCaptions : this.captions).length > 0) {
        for (e = 0; e < t.length; e++) !0 === t[e].def && (this.captionLang = t[e].language, this.selectedCaptions = t[e]);
        if (void 0 === this.captionLang) for (e = 0; e < t.length; e++) t[e].language === this.lang && (this.captionLang = t[e].language, this.selectedCaptions = t[e]);
        void 0 === this.captionLang && (this.captionLang = t[0].language, this.selectedCaptions = t[0]), void 0 !== this.captionLang && (this.$transcriptLanguageSelect && this.$transcriptLanguageSelect.find("option[lang=" + this.captionLang + "]").prop("selected", !0), this.syncTrackLanguages("init", this.captionLang));
      }
    }, AblePlayer.prototype.initHtml5Player = function () {
      var e = new t.Deferred(),
        i = e.promise();
      return e.resolve(), i;
    }, AblePlayer.prototype.initJwPlayer = function () {
      var e = this,
        i = new t.Deferred(),
        s = i.promise();
      return t.ajax({
        async: !1,
        url: this.fallbackPath + "jwplayer.js",
        dataType: "script",
        success: function success(s, a, n) {
          e.fallbackJwKey && t("head").append('<script type="text/javascript">jwplayer.key="' + e.fallbackJwKey + '";<\/script>'), e.jwId = e.mediaId + "_fallback", e.$mediaContainer.attr("id", e.jwId), "audio" === e.mediaType ? 0 : e.playerHeight;
          var r = [];
          t.each(e.$sources, function (e, i) {
            r.push({
              file: t(i).attr("src")
            });
          });
          var o = e.fallbackPath + "jwplayer.flash.swf",
            l = e.fallbackPath + "jwplayer.html5.js";
          "video" === e.mediaType ? e.jwPlayer = jwplayer(e.jwId).setup({
            playlist: [{
              image: e.$media.attr("poster"),
              sources: r
            }],
            flashplayer: o,
            html5player: l,
            controls: !1,
            volume: 100 * e.defaultVolume,
            width: "100%",
            fallback: !1,
            primary: "flash",
            wmode: "transparent"
          }) : e.jwPlayer = jwplayer(e.jwId).setup({
            playlist: [{
              sources: r
            }],
            flashplayer: o,
            html5player: l,
            controls: !1,
            volume: 100 * this.defaultVolume,
            height: 0,
            width: "100%",
            fallback: !1,
            primary: "flash"
          }), e.$media.remove(), i.resolve();
        },
        error: function error(t, e, s) {
          i.reject();
        }
      }), s;
    }, AblePlayer.prototype.setMediaAttributes = function () {
      this.$media.attr("tabindex", -1);
      var t = this.$media.get(0).textTracks;
      if (t) for (var e = 0; e < t.length;) t[e].mode = "disabled", e += 1;
    }, AblePlayer.prototype.getPlayer = function () {
      return this.youTubeId ? "video" !== this.mediaType ? null : "youtube" : this.testFallback || (this.isUserAgent("msie 7") || this.isUserAgent("msie 8") || this.isUserAgent("msie 9")) && "video" === this.mediaType || this.isIOS() && (this.isIOS(4) || this.isIOS(5) || this.isIOS(6)) ? "jw" === this.fallback && this.jwCanPlay() ? "jw" : null : this.media.canPlayType ? "html5" : null;
    }, AblePlayer.prototype.jwCanPlay = function () {
      var e, i, s;
      if (this.$sources.length > 0) for (e = 0; e < this.$sources.length; e++) if (i = this.$sources[e].getAttribute("type"), "video" === this.mediaType && "video/mp4" === i || "audio" === this.mediaType && "audio/mpeg" === i) return !0;
      if (t(".able-playlist") && (s = t(".able-playlist").eq(0).find("li").eq(0), "audio" === this.mediaType)) {
        if (s.attr("data-mp3")) return !0;
        if ("video" === this.mediaType && s.attr("data-mp4")) return !0;
      }
      return !1;
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.setCookie = function (t) {
      _jsCookie.default.set("Able-Player", t, {
        expires: 90
      });
    }, AblePlayer.prototype.getCookie = function () {
      var t,
        e = {
          preferences: {},
          sign: {},
          transcript: {}
        };
      try {
        t = JSON.parse(_jsCookie.default.get("Able-Player"));
      } catch (i) {
        t = e;
      }
      return t || e;
    }, AblePlayer.prototype.updateCookie = function (t) {
      var e, i, s, a, n, r;
      if (e = this.getCookie(), "transcript" === t || "sign" === t) "transcript" === t ? (s = (i = this.$transcriptArea).position(), void 0 === e.transcript && (e.transcript = {}), e.transcript.position = i.css("position"), e.transcript.zindex = i.css("z-index"), e.transcript.top = s.top, e.transcript.left = s.left, e.transcript.width = i.width(), e.transcript.height = i.height()) : "sign" === t && (s = (i = this.$signWindow).position(), void 0 === e.sign && (e.sign = {}), e.sign.position = i.css("position"), e.sign.zindex = i.css("z-index"), e.sign.top = s.top, e.sign.left = s.left, e.sign.width = i.width(), e.sign.height = i.height());else for (a = this.getAvailablePreferences(), n = 0; n < a.length; n++) (r = a[n].name) == t && (e.preferences[r] = this[r]);
      this.setCookie(e);
    }, AblePlayer.prototype.getPreferencesGroups = function () {
      if ("video" === this.mediaType) return ["captions", "descriptions", "keyboard", "transcript"];
      if ("audio" === this.mediaType) {
        var t = [];
        return t.push("keyboard"), this.lyricsMode && t.push("transcript"), t;
      }
    }, AblePlayer.prototype.getAvailablePreferences = function () {
      var t = [];
      return t.push({
        name: "prefAltKey",
        label: this.tt.prefAltKey,
        group: "keyboard",
        default: 1
      }), t.push({
        name: "prefCtrlKey",
        label: this.tt.prefCtrlKey,
        group: "keyboard",
        default: 1
      }), t.push({
        name: "prefShiftKey",
        label: this.tt.prefShiftKey,
        group: "keyboard",
        default: 0
      }), t.push({
        name: "prefTranscript",
        label: null,
        group: "transcript",
        default: 0
      }), t.push({
        name: "prefHighlight",
        label: this.tt.prefHighlight,
        group: "transcript",
        default: 1
      }), t.push({
        name: "prefAutoScrollTranscript",
        label: null,
        group: "transcript",
        default: 1
      }), t.push({
        name: "prefTabbable",
        label: this.tt.prefTabbable,
        group: "transcript",
        default: 0
      }), "video" === this.mediaType && (t.push({
        name: "prefCaptions",
        label: null,
        group: "captions",
        default: 1
      }), t.push({
        name: "prefCaptionsPosition",
        label: this.tt.prefCaptionsPosition,
        group: "captions",
        default: this.defaultCaptionsPosition
      }), t.push({
        name: "prefCaptionsFont",
        label: this.tt.prefCaptionsFont,
        group: "captions",
        default: this.tt.sans
      }), t.push({
        name: "prefCaptionsSize",
        label: this.tt.prefCaptionsSize,
        group: "captions",
        default: "100%"
      }), t.push({
        name: "prefCaptionsColor",
        label: this.tt.prefCaptionsColor,
        group: "captions",
        default: "white"
      }), t.push({
        name: "prefCaptionsBGColor",
        label: this.tt.prefCaptionsBGColor,
        group: "captions",
        default: "black"
      }), t.push({
        name: "prefCaptionsOpacity",
        label: this.tt.prefCaptionsOpacity,
        group: "captions",
        default: "100%"
      }), t.push({
        name: "prefDesc",
        label: null,
        group: "descriptions",
        default: 0
      }), t.push({
        name: "prefDescFormat",
        label: this.tt.prefDescFormat,
        group: "descriptions",
        default: "video"
      }), t.push({
        name: "prefDescPause",
        label: this.tt.prefDescPause,
        group: "descriptions",
        default: 0
      }), t.push({
        name: "prefVisibleDesc",
        label: this.tt.prefVisibleDesc,
        group: "descriptions",
        default: 1
      }), t.push({
        name: "prefSign",
        label: null,
        group: null,
        default: 0
      })), t;
    }, AblePlayer.prototype.loadCurrentPreferences = function () {
      for (var t = this.getAvailablePreferences(), e = this.getCookie(), i = 0; i < t.length; i++) {
        var s = t[i].name,
          a = t[i].default;
        void 0 !== e.preferences[s] ? this[s] = e.preferences[s] : (e.preferences[s] = a, this[s] = a);
      }
      this.setCookie(e);
    }, AblePlayer.prototype.injectPrefsForm = function (e) {
      var i, s, a, n, r, o, l, h, p, c, d, u, f, g, v, m, b, y, w, P, k, C, $, T, A, x, D, S, M, B, I, N, F, O, z, j, L, W, H, V, R, q, E, K, Y, X, U, G, _;
      s = this, i = this.getAvailablePreferences();
      var Q = "able-prefs-form-" + e;
      if ((a = t("<div>", {
        class: "able-prefs-form "
      })).addClass(Q), "captions" == e) n = this.tt.prefTitleCaptions, r = this.tt.prefIntroCaptions, J = t("<p>", {
        text: r
      }), a.append(J);else if ("descriptions" == e) {
        n = this.tt.prefTitleDescriptions;
        var J = t("<p>", {
            text: this.tt.prefIntroDescription1
          }),
          Z = t("<ul>"),
          tt = t("<li>", {
            text: this.tt.prefDescFormatOption1
          }),
          et = t("<li>", {
            text: this.tt.prefDescFormatOption2
          });
        Z.append(tt, et), this.hasOpenDesc && this.hasClosedDesc ? (V = this.tt.prefIntroDescription2 + " ", V += "<strong>" + this.tt.prefDescFormatOption1b + "</strong>", V += " <em>" + this.tt.and + "</em> <strong>" + this.tt.prefDescFormatOption2b + "</strong>.") : this.hasOpenDesc ? (V = this.tt.prefIntroDescription2, V += " <strong>" + this.tt.prefDescFormatOption1b + "</strong>.") : this.hasClosedDesc ? (V = this.tt.prefIntroDescription2, V += " <strong>" + this.tt.prefDescFormatOption2b + "</strong>.") : V = this.tt.prefIntroDescriptionNone, o = t("<p>", {
          html: V
        }), l = this.tt.prefIntroDescription3, (this.hasOpenDesc || this.hasClosedDesc) && (l += " " + this.tt.prefIntroDescription4), h = t("<p>", {
          text: l
        }), a.append(J, Z, o, h);
      } else "keyboard" == e ? (n = this.tt.prefTitleKeyboard, r = this.tt.prefIntroKeyboard1, r += " " + this.tt.prefIntroKeyboard2, r += " " + this.tt.prefIntroKeyboard3, J = t("<p>", {
        text: r
      }), a.append(J)) : "transcript" == e && (n = this.tt.prefTitleTranscript, r = this.tt.prefIntroTranscript, J = t("<p>", {
        text: r
      }), a.append(J));
      for ("descriptions" === e ? (g = t("<fieldset>"), u = "able-prefs-" + e + "1", f = this.mediaId + "-prefs-" + e + "1", g.addClass(u).attr("id", f), v = t("<legend>" + this.tt.prefDescFormat + "</legend>"), g.append(v), m = t("<fieldset>"), u = "able-prefs-" + e + "2", f = this.mediaId + "-prefs-" + e + "2", m.addClass(u).attr("id", f), b = t("<legend>" + this.tt.prefHeadingTextDescription + "</legend>"), m.append(b)) : (d = t("<fieldset>"), u = "able-prefs-" + e, f = this.mediaId + "-prefs-" + e, d.addClass(u).attr("id", f), "keyboard" === e && (y = t("<legend>" + this.tt.prefHeadingKeyboard1 + "</legend>"), d.append(y))), p = 0; p < i.length; p++) if (i[p].group == e && i[p].label) {
        if (k = "able-" + (w = i[p].name), C = this.mediaId + "_" + w, "prefDescFormat" !== w && (P = t("<div>").addClass(k)), "prefDescFormat" == w) A = t("<div>"), x = C + "_1", S = t("<label>").attr("for", x).text(this.capitalizeFirstLetter(this.tt.prefDescFormatOption1)), D = t("<input>", {
          type: "radio",
          name: w,
          id: x,
          value: "video"
        }), "video" === this.prefDescFormat && D.prop("checked", !0), A.append(D, S), M = t("<div>"), B = C + "_2", N = t("<label>").attr("for", B).text(this.capitalizeFirstLetter(this.tt.prefDescFormatOption2)), I = t("<input>", {
          type: "radio",
          name: w,
          id: B,
          value: "text"
        }), "text" === this.prefDescFormat && I.prop("checked", !0), M.append(I, N);else if ("captions" === e) {
          for ($ = t('<label for="' + C + '"> ' + i[p].label + "</label>"), T = t("<select>", {
            name: w,
            id: C
          }), "prefCaptions" !== w && "prefCaptionsStyle" !== w && T.change(function () {
            L = t(this).attr("name"), s.stylizeCaptions(s.$sampleCapsDiv, L);
          }), F = this.getCaptionsOptions(w), c = 0; c < F.length; c++) "prefCaptionsPosition" === w ? "overlay" === (z = F[c]) ? j = this.tt.captionsPositionOverlay : "below" === z && (z = F[c], j = this.tt.captionsPositionBelow) : "prefCaptionsColor" === w || "prefCaptionsBGColor" === w ? (z = F[c][0], j = F[c][1]) : "prefCaptionsOpacity" === w ? (z = F[c], j = F[c], "0%" === z ? j += " (" + this.tt.transparent + ")" : "100%" === z && (j += " (" + this.tt.solid + ")")) : (z = F[c], j = F[c]), O = t("<option>", {
            value: z,
            text: j
          }), this[w] === z && O.prop("selected", !0), T.append(O);
          P.append($, T);
        } else $ = t('<label for="' + C + '"> ' + i[p].label + "</label>"), T = t("<input>", {
          type: "checkbox",
          name: w,
          id: C,
          value: "true"
        }), 1 === this[w] && T.prop("checked", !0), "keyboard" === e && T.change(function () {
          "prefAltKey" === (L = t(this).attr("name")) ? (W = ".able-modkey-alt", H = s.tt.prefAltKey + " + ") : "prefCtrlKey" === L ? (W = ".able-modkey-ctrl", H = s.tt.prefCtrlKey + " + ") : "prefShiftKey" === L && (W = ".able-modkey-shift", H = s.tt.prefShiftKey + " + "), t(this).is(":checked") ? t(W).text(H) : t(W).text("");
        }), P.append(T, $);
        "descriptions" === e ? "prefDescFormat" === w ? g.append(A, M) : m.append(P) : d.append(P);
      }
      if ("descriptions" === e ? a.append(g, m) : a.append(d), "captions" === e) "video" === this.mediaType && (this.$sampleCapsDiv = t("<div>", {
        class: "able-captions-sample"
      }).text(this.tt.sampleCaptionText), a.append(this.$sampleCapsDiv), this.stylizeCaptions(this.$sampleCapsDiv));else if ("keyboard" === e) {
        for (R = t("<h2>", {
          text: this.tt.prefHeadingKeyboard2
        }), q = t("<ul>"), E = [], K = [], p = 0; p < this.controls.length; p++) "play" === this.controls[p] ? (E.push(this.tt.play + "/" + this.tt.pause), K.push("p</span> <em>" + this.tt.or + '</em> <span class="able-help-modifiers"> ' + this.tt.spacebar)) : "restart" === this.controls[p] ? (E.push(this.tt.restart), K.push("s")) : "rewind" === this.controls[p] ? (E.push(this.tt.rewind), K.push("r")) : "forward" === this.controls[p] ? (E.push(this.tt.forward), K.push("f")) : "volume" === this.controls[p] ? (E.push(this.tt.volume), K.push("v</span> <em>" + this.tt.or + '</em> <span class="able-modkey">1-9'), E.push(this.tt.mute + "/" + this.tt.unmute), K.push("m")) : "captions" === this.controls[p] ? (this.captions.length > 1 ? E.push(this.tt.captions) : this.captionsOn ? E.push(this.tt.hideCaptions) : E.push(this.tt.showCaptions), K.push("c")) : "descriptions" === this.controls[p] ? (this.descOn ? E.push(this.tt.turnOffDescriptions) : E.push(this.tt.turnOnDescriptions), K.push("d")) : "prefs" === this.controls[p] ? (E.push(this.tt.preferences), K.push("e")) : "help" === this.controls[p] && (E.push(this.tt.help), K.push("h"));
        for (p = 0; p < K.length; p++) Y = '<span class="able-modkey-alt">', 1 === this.prefAltKey && (Y += this.tt.prefAltKey + " + "), Y += "</span>", Y += '<span class="able-modkey-ctrl">', 1 === this.prefCtrlKey && (Y += this.tt.prefCtrlKey + " + "), Y += "</span>", Y += '<span class="able-modkey-shift">', 1 === this.prefShiftKey && (Y += this.tt.prefShiftKey + " + "), Y += "</span>", Y += '<span class="able-modkey">' + K[p] + "</span>", Y += " = " + E[p], X = t("<li>", {
          html: Y
        }), q.append(X);
        Y = '<span class="able-modkey">' + this.tt.escapeKey + "</span>", Y += " = " + this.tt.escapeKeyFunction, X = t("<li>", {
          html: Y
        }), q.append(X), a.append(R, q);
      }
      t("body").append(a), U = new AccessibleDialog(a, this.$prefsButton, "dialog", n, J, s.tt.closeButtonLabel, "32em"), a.append("<hr>"), G = t('<button class="modal-button">' + this.tt.save + "</button>"), _ = t('<button class="modal-button">' + this.tt.cancel + "</button>"), G.click(function () {
        U.hide(), s.savePrefsFromForm();
      }), _.click(function () {
        U.hide(), s.resetPrefsForm();
      }), a.append(G), a.append(_), "captions" === e ? this.captionPrefsDialog = U : "descriptions" === e ? this.descPrefsDialog = U : "keyboard" === e ? this.keyboardPrefsDialog = U : "transcript" === e && (this.transcriptPrefsDialog = U), t("div.able-prefs-form button.modalCloseButton").click(function () {
        s.resetPrefsForm();
      }), t("div.able-prefs-form").keydown(function (t) {
        27 === t.which && s.resetPrefsForm();
      });
    }, AblePlayer.prototype.resetPrefsForm = function () {
      var e, i, s, a;
      for (this, e = this.getCookie(), i = this.getAvailablePreferences(), s = 0; s < i.length; s++) "prefDescFormat" === (a = i[s].name) ? "text" === this[a] ? t('input[value="text"]').prop("checked", !0) : t('input[value="video"]').prop("checked", !0) : -1 !== a.indexOf("Captions") && "prefCaptions" !== a ? t('select[name="' + a + '"]').val(e.preferences[a]) : 1 === this[a] ? t('input[name="' + a + '"]').prop("checked", !0) : t('input[name="' + a + '"]').prop("checked", !1);
      this.stylizeCaptions(this.$sampleCapsDiv);
    }, AblePlayer.prototype.savePrefsFromForm = function () {
      var e, i, s, a, n;
      e = 0, i = 0, s = !1;
      for (var r = this.getCookie(), o = this.getAvailablePreferences(), l = 0; l < o.length; l++) if (o[l].label) {
        var h = o[l].name;
        "prefDescFormat" == h ? (this.prefDescFormat = t('input[name="' + h + '"]:checked').val(), this.prefDescFormat !== r.preferences.prefDescFormat && (r.preferences.prefDescFormat = this.prefDescFormat, e++)) : -1 !== h.indexOf("Captions") && "prefCaptions" !== h ? (n = t('select[name="' + h + '"]').val(), r.preferences[h] !== n && (r.preferences[h] = n, this[h] = n, e++, i++), "prefCaptionsSize" === h && (s = !0, a = n)) : t('input[name="' + h + '"]').is(":checked") ? (r.preferences[h] = 1, 1 === this[h] || (this[h] = 1, e++)) : (r.preferences[h] = 0, 1 === this[h] && (this[h] = 0, e++));
      }
      e > 0 ? (this.setCookie(r), this.showAlert(this.tt.prefSuccess)) : this.showAlert(this.tt.prefNoChange), "youtube" === this.player && void 0 !== this.usingYouTubeCaptions && this.usingYouTubeCaptions && s && this.youTubePlayer.setOption(this.ytCaptionModule, "fontSize", this.translatePrefs("size", a, "youtube")), this.updatePrefs(), i > 0 && (this.stylizeCaptions(this.$captionsDiv), void 0 !== this.$descDiv && this.stylizeCaptions(this.$descDiv));
    }, AblePlayer.prototype.updatePrefs = function () {
      var e;
      e = 1 === this.prefAltKey ? "Alt + " : "", 1 === this.prefCtrlKey && (e += "Control + "), 1 === this.prefShiftKey && (e += "Shift + "), t(".able-help-modifiers").text(e), 1 === this.prefTabbable ? t(".able-transcript span.able-transcript-seekpoint").attr("tabindex", "0") : t(".able-transcript span.able-transcript-seekpoint").removeAttr("tabindex"), 0 === this.prefHighlight && t(".able-transcript span").removeClass("able-highlight"), this.updateCaption(), this.refreshingDesc = !0, this.initDescription();
    }, AblePlayer.prototype.usingModifierKeys = function (t) {
      return !(1 === this.prefAltKey && !t.altKey) && !(1 === this.prefCtrlKey && !t.ctrlKey) && !(1 === this.prefShiftKey && !t.shiftKey);
    };
  }(_jquery.default), function (t) {
    function e(t, e) {
      for (var s = [], a = 0; a < e.length; a++) s.push(i(t, e[a]));
      return s;
    }
    function i(t, e) {
      var i = e(t);
      if (null !== t.error) throw t.error;
      return i;
    }
    function s(t, e) {
      for (var i = 0; i < e.length; i++) "\n" === e[i] ? (t.column = 1, t.line += 1) : t.column += 1;
    }
    function a(t, e) {
      var i = t.text.substring(0, e);
      return s(t, i), t.text = t.text.substring(e), i;
    }
    function n(t, e) {
      var i,
        a = t.text.indexOf("\n");
      return -1 === a ? (s(t, i = t.text), t.text = "") : (i = t.text.substring(0, a), s(t, i + "\n"), t.text = t.text.substring(a + 1)), i;
    }
    function r(t) {
      var e = t.text.indexOf("\n");
      return -1 === e ? t.text : t.text.substring(0, e);
    }
    function o(t) {
      e(t, [b, y]);
      var i = t.text[0];
      " " === i || "\t" === i || "\n" === i ? e(t, [C, l, T, d]) : t.error = "WEBVTT signature not followed by whitespace.";
    }
    function l(t) {
      for (;;) {
        var e = r(t);
        if (-1 !== e.indexOf("--\x3e")) return;
        if (0 === e.length) return;
        var s = i(t, p);
        t.metadata[s[0]] = s[1], i(t, C);
      }
    }
    function h(t) {
      var e = [],
        i = t.indexOf(" ");
      i >= 0 && e.push(i);
      var s = t.indexOf("\t");
      s >= 0 && e.push(s);
      var a = t.indexOf("\n");
      return a >= 0 && e.push(a), Math.min.apply(null, e);
    }
    function p(t) {
      var e = t.text.indexOf("\n"),
        i = a(t, e),
        s = i.indexOf(":");
      return -1 === s ? void (t.error = "Missing colon.") : [i.substring(0, s), i.substring(s + 1)];
    }
    function c(t) {
      var e = a(t, h(t.text)),
        i = e.indexOf(":");
      return -1 === i ? void (t.error = "Missing colon.") : [e.substring(0, i), e.substring(i + 1)];
    }
    function d(s) {
      for (;;) {
        var a = r(s);
        if (0 !== a.indexOf("NOTE") || 4 !== a.length && " " !== a[4] && "\t" !== a[4]) {
          if (0 === t.trim(a).length && s.text.length > 0) i(s, $);else {
            if (!(t.trim(a).length > 0)) return;
            i(s, u);
          }
        } else e(s, [m, $]);
      }
    }
    function u(t) {
      var s,
        o,
        l = r(t);
      if (-1 === l.indexOf("--\x3e") && (s = n(t), -1 === (l = r(t)).indexOf("--\x3e"))) return o = "Invalid WebVTT file: " + t.src + "\n", o += "Line: " + t.line + ", ", o += "Column: " + t.column + "\n", o += "Expected cue timing for cueId '" + s + "' but found: " + l + "\n", void (console.warn ? console.warn(o) : console.log && console.log(o));
      var h = e(t, [A, k, w, k, A]),
        p = h[0],
        c = h[4];
      if (p >= c) t.error = "Start time is not sooner than end time.";else {
        i(t, P);
        var d = i(t, f);
        a(t, 1);
        var u = i(t, g);
        void 0 === s && (s = t.cues.length + 1), t.cues.push({
          id: s,
          start: p,
          end: c,
          settings: d,
          components: u
        });
      }
    }
    function f(t) {
      for (var e = {}; t.text.length > 0 && "\n" !== t.text[0];) {
        var s = i(t, c);
        e[s[0]] = s[1], i(t, P);
      }
      return e;
    }
    function g(e) {
      for (var s = {
          type: "internal",
          tagName: "",
          value: "",
          classes: [],
          annotation: "",
          parent: null,
          children: [],
          language: ""
        }, n = s, o = []; e.text.length > 0;) {
        var l = r(e);
        if (-1 !== l.indexOf("--\x3e") || /^\s*$/.test(l)) break;
        if (e.text.length >= 2 && "\n" === e.text[0] && "\n" === e.text[1]) {
          a(e, 2);
          break;
        }
        var h = v(e);
        if ("string" === h.type) n.children.push(h);else if ("startTag" === h.type) h.type = h.tagName, h.parent = n, -1 !== t.inArray(h.tagName, ["i", "b", "u", "ruby"]) || "rt" === h.tagName && "ruby" === n.tagName ? (o.length > 0 && (n.language = o[o.length - 1]), n.children.push(h), n = h) : "c" === h.tagName || "v" === h.tagName ? (h.value = h.annotation, o.length > 0 && (n.language = o[o.length - 1]), n.children.push(h), n = h) : "lang" === h.tagName && (o.push(h.annotation), o.length > 0 && (n.language = o[o.length - 1]), n.children.push(h), n = h);else if ("endTag" === h.type) h.tagName === n.type && -1 !== t.inArray(h.tagName, ["c", "i", "b", "u", "ruby", "rt", "v"]) ? n = n.parent : "lang" === h.tagName && "lang" === n.type ? (n = n.parent, o.pop()) : "ruby" === h.tagName && "rt" === n.type && (n = n.parent.parent);else if ("timestampTag" === h.type) {
          var p = {
            text: h.value,
            error: null,
            metadata: {},
            cues: [],
            line: 1,
            column: 1
          };
          try {
            var c = i(p, A);
            0 === p.text.length && (h.value = c, n.push(h));
          } catch (t) {}
        }
      }
      return s;
    }
    function v(e) {
      for (var i = "data", s = [], n = "", r = {
          type: "",
          tagName: "",
          value: "",
          classes: [],
          annotation: "",
          children: []
        };;) {
        var o;
        if (o = e.text.length >= 2 && "\n" === e.text[0] && "\n" === e.text[1] ? "" : e.text.length > 0 ? e.text[0] : "", "data" === i) {
          if ("&" === o) n = "&", i = "escape";else if ("<" === o) {
            if (0 !== s.length) return r.type = "string", r.value = s.join(""), r;
            i = "tag";
          } else {
            if ("" === o) return {
              type: "string",
              value: s.join("")
            };
            s.push(o);
          }
        } else if ("escape" === i) {
          if ("&" === o) s.push(n), n = "&";else if (o.match(/[0-9a-z]/)) n += o;else if (";" === o) "&amp" === n ? s.push("&") : "&lt" === n ? s.push("<") : "&gt" === n ? s.push(">") : "&lrm" === n ? s.push("‎") : "&rlm" === n ? s.push("‏") : "&nbsp" === n ? s.push(" ") : (s.push(n), s.push(";")), i = "data";else {
            if ("<" === o || "" === o) return s.push(n), r.type = "string", r.value = s.join(""), r;
            if ("\t" === o || "\n" === o || "\f" === o || " " === o) return s.push(n), r.type = "string", r.value = s.join(""), r;
            s.push(n), i = "data";
          }
        } else if ("tag" === i) {
          if ("\t" === o || "\n" === o || "\f" === o || " " === o) i = "startTagAnnotation";else if ("." === o) i = "startTagClass";else if ("/" === o) i = "endTag";else if (o.match("[0-9]")) i = "timestampTag", s.push(o);else {
            if (">" === o) {
              a(e, 1);
              break;
            }
            if ("" === o) return r.tagName = "", r.type = "startTag", r;
            s.push(o), i = "startTag";
          }
        } else if ("startTag" === i) {
          if ("\t" === o || "\f" === o || " " === o) i = "startTagAnnotation";else if ("\n" === o) n = o, i = "startTagAnnotation";else if ("." === o) i = "startTagClass";else {
            if (">" === o) return a(e, 1), r.tagName = s.join(""), r.type = "startTag", r;
            if ("" === o) return r.tagName = s.join(""), r.type = "startTag", r;
            s.push(o);
          }
        } else if ("startTagClass" === i) {
          if ("\t" === o || "\f" === o || " " === o) r.classes.push(n), n = "", i = "startTagAnnotation";else if ("\n" === o) r.classes.push(n), n = o, i = "startTagAnnotation";else if ("." === o) r.classes.push(n), n = "";else {
            if (">" === o) return a(e, 1), r.classes.push(n), r.type = "startTag", r.tagName = s.join(""), r;
            if ("" === o) return r.classes.push(n), r.type = "startTag", r.tagName = s.join(""), r;
            n += "c";
          }
        } else if ("startTagAnnotation" === i) {
          if (">" === o) return a(e, 1), n = t.trim(n).replace(/ +/, " "), r.type = "startTag", r.tagName = s.join(""), r.annotation = n, r;
          if ("" === o) return n = t.trim(n).replace(/ +/, " "), r.type = "startTag", r.tagName = s.join(""), r.annotation = n, r;
          n += o;
        } else if ("endTag" === i) {
          if (">" === o) return a(e, 1), r.type = "endTag", r.tagName = s.join(""), r;
          if ("" === o) return r.type = "endTag", r.tagName = s.join(""), r;
          s.push(o);
        } else {
          if ("timestampTag" !== i) throw "Unknown tokenState " + i;
          if (">" === o) return a(e, 1), r.type = "timestampTag", r.name = s.join(""), r;
          if ("" === o) return r.type = "timestampTag", r.name = s.join(""), r;
          s.push(o);
        }
        a(e, 1);
      }
    }
    function m(e) {
      if (-1 === n(e).indexOf("--\x3e")) for (;;) {
        var i = r(e);
        if (0 === t.trim(i).length) return;
        if (-1 !== i.indexOf("--\x3e")) return void (e.error = "Invalid syntax: --\x3e in comment.");
        n(e);
      } else e.error = "Invalid syntax: --\x3e in NOTE line.";
    }
    function b(t) {
      "\uFEFF" === t.text[0] && a(t, 1);
    }
    function y(t) {
      "WEBVTT" === t.text.substring(0, 6) ? a(t, 6) : t.error = "Invalid signature.";
    }
    function w(t) {
      t.text.length < 3 || "--\x3e" !== t.text.substring(0, 3) ? t.error = "Missing --\x3e" : a(t, 3);
    }
    function P(t) {
      for (; "\t" === t.text[0] || " " === t.text[0];) a(t, 1);
    }
    function k(t) {
      for (var e = 0; "\t" === t.text[0] || " " === t.text[0];) a(t, 1), e += 1;
      0 === e && (t.error = "Missing space.");
    }
    function C(t) {
      var e = t.text.indexOf("\n");
      -1 === e ? t.error = "Missing EOL." : a(t, e + 1);
    }
    function $(e) {
      for (; e.text.length > 0;) {
        var i = r(e);
        if (0 !== t.trim(i).length) break;
        n(e);
      }
    }
    function T(e) {
      for (var i = 0; e.text.length > 0;) {
        var s = r(e);
        if (0 !== t.trim(s).length) break;
        n(e), i += 1;
      }
      0 === i && (e.error = "Missing empty line.");
    }
    function A(t) {
      var e = h(t.text);
      if (-1 !== e) {
        var i = a(t, e),
          s = /((\d\d):)?((\d\d):)(\d\d).(\d\d\d)|(\d+).(\d\d\d)/.exec(i);
        if (s) {
          var n = 0,
            r = s[2],
            o = s[4];
          if (o) {
            if (parseInt(o, 10) > 59) return void (t.error = "Invalid minute range");
            r && (n += 3600 * parseInt(r, 10)), n += 60 * parseInt(o, 10);
            var l = s[5];
            if (parseInt(l, 10) > 59) return void (t.error = "Invalid second range");
            n += parseInt(l, 10), n += parseInt(s[6], 10) / 1e3;
          } else n += parseInt(s[7], 10), n += parseInt(s[8], 10) / 1e3;
          return n;
        }
        t.error = "Unable to parse timestamp";
      } else t.error("Missing timing.");
    }
    AblePlayer.prototype.parseWebVTT = function (t, e) {
      var s = {
        src: t,
        text: e = e.replace(/(\r\n|\n|\r)/g, "\n"),
        error: null,
        metadata: {},
        cues: [],
        line: 1,
        column: 1
      };
      try {
        i(s, o);
      } catch (t) {
        var a = "Invalid WebVTT file: " + s.src + "\n";
        a += "Line: " + s.line + ", ", a += "Column: " + s.column + "\n", a += t, console.warn ? console.warn(a) : console.log && console.log(a);
      }
      return s;
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.injectPlayerCode = function () {
      var e;
      this.$mediaContainer = this.$media.wrap('<div class="able-media-container"></div>').parent(), this.$ableDiv = this.$mediaContainer.wrap('<div class="able"></div>').parent(), this.$ableWrapper = this.$ableDiv.wrap('<div class="able-wrapper"></div>').parent(), this.$ableWrapper.css({
        "max-width": this.playerMaxWidth + "px"
      }), this.injectOffscreenHeading(), "video" === this.mediaType && ("image" != this.iconType && "youtube" !== this.player && this.injectBigPlayButton(), e = t("<div>", {
        class: "able-vidcap-container"
      }), this.$vidcapContainer = this.$mediaContainer.wrap(e).parent()), this.injectPlayerControlArea(), this.injectTextDescriptionArea(), this.transcriptType && ("popup" === this.transcriptType || "external" === this.transcriptType ? this.injectTranscriptArea() : "manual" === this.transcriptType && this.setupManualTranscript(), this.addTranscriptAreaEvents()), this.injectAlert(), this.injectPlaylist();
    }, AblePlayer.prototype.injectOffscreenHeading = function () {
      var e;
      "0" == this.playerHeadingLevel || (void 0 === this.playerHeadingLevel && (this.playerHeadingLevel = this.getNextHeadingLevel(this.$ableDiv)), e = "h" + this.playerHeadingLevel.toString(), this.$headingDiv = t("<" + e + ">"), this.$ableDiv.prepend(this.$headingDiv), this.$headingDiv.addClass("able-offscreen"), this.$headingDiv.text(this.tt.playerHeading));
    }, AblePlayer.prototype.injectBigPlayButton = function () {
      this.$bigPlayButton = t("<button>", {
        class: "able-big-play-button icon-play",
        "aria-hidden": !0,
        tabindex: -1
      });
      var e = this;
      this.$bigPlayButton.click(function () {
        e.handlePlay();
      }), this.$mediaContainer.append(this.$bigPlayButton);
    }, AblePlayer.prototype.injectPlayerControlArea = function () {
      this.$playerDiv = t("<div>", {
        class: "able-player",
        role: "region",
        "aria-label": this.mediaType + " player"
      }), this.$playerDiv.addClass("able-" + this.mediaType), this.$nowPlayingDiv = t("<div>", {
        class: "able-now-playing",
        "aria-live": "assertive",
        "aria-atomic": "true"
      }), this.$controllerDiv = t("<div>", {
        class: "able-controller"
      }), this.$controllerDiv.addClass("able-" + this.iconColor + "-controls"), this.$statusBarDiv = t("<div>", {
        class: "able-status-bar"
      }), this.$timer = t("<span>", {
        class: "able-timer"
      }), this.$elapsedTimeContainer = t("<span>", {
        class: "able-elapsedTime",
        text: "0:00"
      }), this.$durationContainer = t("<span>", {
        class: "able-duration"
      }), this.$timer.append(this.$elapsedTimeContainer).append(this.$durationContainer), this.$speed = t("<span>", {
        class: "able-speed",
        "aria-live": "assertive"
      }).text(this.tt.speed + ": 1x"), this.$status = t("<span>", {
        class: "able-status",
        "aria-live": "polite"
      }), this.$statusBarDiv.append(this.$timer, this.$speed, this.$status), this.$playerDiv.append(this.$nowPlayingDiv, this.$controllerDiv, this.$statusBarDiv), this.$ableDiv.append(this.$playerDiv);
    }, AblePlayer.prototype.injectTextDescriptionArea = function () {
      this.$descDiv = t("<div>", {
        class: "able-descriptions",
        "aria-live": "assertive",
        "aria-atomic": "true"
      }), this.$descDiv.hide(), this.$ableDiv.append(this.$descDiv);
    }, AblePlayer.prototype.getDefaultWidth = function (t) {
      return "transcript" === t ? 450 : "sign" === t ? 400 : void 0;
    }, AblePlayer.prototype.positionDraggableWindow = function (e, i) {
      var s, a, n, r;
      s = this.getCookie(), "transcript" === e ? (n = this.$transcriptArea, void 0 !== s.transcript && (a = s.transcript)) : "sign" === e && (n = this.$signWindow, void 0 !== s.transcript && (a = s.sign)), void 0 === a || t.isEmptyObject(a) ? (r = this.getOptimumPosition(e, i), void 0 === i && (i = this.getDefaultWidth(e)), n.css({
        position: r[0],
        width: i,
        "z-index": r[3]
      }), "absolute" === r[0] && n.css({
        top: r[1] + "px",
        left: r[2] + "px"
      })) : (n.css({
        position: a.position,
        width: a.width,
        "z-index": a.zindex
      }), "absolute" === a.position && n.css({
        top: a.top,
        left: a.left
      }), this.updateZIndex(e));
    }, AblePlayer.prototype.getOptimumPosition = function (e, i) {
      var s, a, n, r, o, l;
      return void 0 === i && (i = this.getDefaultWidth(e)), 5, s = [], a = this.$ableDiv.width(), this.$ableDiv.height(), (n = this.$ableDiv.offset()).top, r = n.left, o = t(window).width(), l = 0, "transcript" === e ? void 0 !== this.$signWindow && this.$signWindow.is(":visible") && (l = this.$signWindow.width() + 5) : "sign" === e && void 0 !== this.$transcriptArea && this.$transcriptArea.is(":visible") && (l = this.$transcriptArea.width() + 5), i < o - (r + a + 5 + l) ? (s[0] = "absolute", s[1] = 0, s[2] = a + l + 5) : i + 5 < r ? (s[0] = "absolute", s[1] = 0, s[2] = r - i - 5) : s[0] = "relative", s;
    }, AblePlayer.prototype.injectPoster = function (e, i) {
      var s, a, n;
      "youtube" === i ? void 0 !== this.ytWidth ? (a = this.ytWidth, n = this.ytHeight) : void 0 !== this.playerMaxWidth ? (a = this.playerMaxWidth, n = this.playerMaxHeight) : void 0 !== this.playerWidth && (a = this.playerWidth, n = this.playerHeight) : "fallback" === i && (a = "100%", n = "auto"), this.$media.attr("poster") && (s = this.$media.attr("poster"), this.$posterImg = t("<img>", {
        class: "able-poster",
        src: s,
        alt: "",
        role: "presentation",
        width: a,
        height: n
      }), e.append(this.$posterImg));
    }, AblePlayer.prototype.injectAlert = function () {
      var e;
      this.$alertBox = t('<div role="alert"></div>'), this.$alertBox.addClass("able-alert"), this.$alertBox.hide(), this.$alertBox.appendTo(this.$ableDiv), e = "audio" == this.mediaType ? -10 : Math.round(10 * this.$mediaContainer.offset().top) / 10, this.$alertBox.css({
        top: e + "px"
      }), this.$srAlertBox = t('<div role="alert"></div>'), this.$srAlertBox.addClass("able-screenreader-alert"), this.$srAlertBox.appendTo(this.$ableDiv);
    }, AblePlayer.prototype.injectPlaylist = function () {
      if (!0 === this.playlistEmbed) {
        var t = this.$playlistDom.clone();
        t.insertBefore(this.$statusBarDiv), this.$playlist = t.find("li");
      }
      this.hasPlaylist && 0 === this.$sources.length && (this.initializing = !0, this.swapSource(0), this.$sources = this.$media.find("source"));
    }, AblePlayer.prototype.createPopup = function (e, i) {
      var s, a, n, r, o, l, h, p, c, d, u, f, g;
      if (s = this, a = t("<ul>", {
        id: this.mediaId + "-" + e + "-menu",
        class: "able-popup",
        role: "menu"
      }).hide(), "captions" === e && a.addClass("able-popup-captions"), "prefs" === e) for (n = this.getPreferencesGroups(), r = 0; r < n.length; r++) o = t("<li></li>", {
        role: "menuitem",
        tabindex: "-1"
      }), "captions" === (l = n[r]) ? o.text(this.tt.prefMenuCaptions) : "descriptions" === l ? o.text(this.tt.prefMenuDescriptions) : "keyboard" === l ? o.text(this.tt.prefMenuKeyboard) : "transcript" === l && o.text(this.tt.prefMenuTranscript), o.on("click", function () {
        d = t(this).text(), s.setFullscreen(!1), d === s.tt.prefMenuCaptions ? s.captionPrefsDialog.show() : d === s.tt.prefMenuDescriptions ? s.descPrefsDialog.show() : d === s.tt.prefMenuKeyboard ? s.keyboardPrefsDialog.show() : d === s.tt.prefMenuTranscript && s.transcriptPrefsDialog.show(), s.closePopups();
      }), a.append(o);else if ("captions" === e || "chapters" === e) {
        for (h = !1, r = 0; r < i.length; r++) p = i[r], o = t("<li></li>", {
          role: "menuitemradio",
          tabindex: "-1",
          lang: p.language
        }), p.def ? (o.attr("aria-checked", "true"), h = !0) : o.attr("aria-checked", "false"), "captions" == e || "ytCaptions" == e ? (o.text(p.label), o.on("click", this.getCaptionClickFunction(p))) : "chapters" == e && (o.text(this.flattenCueForCaption(p) + " - " + this.formatSecondsAsColonTime(p.start)), o.on("click", this.getChapterClickFunction(p.start))), a.append(o);
        "captions" !== e && "ytcaptions" !== e || (o = t("<li></li>", {
          role: "menuitemradio",
          tabindex: "-1"
        }).text(this.tt.captionsOff), 0 === this.prefCaptions && (o.attr("aria-checked", "true"), h = !0), o.on("click", this.getCaptionOffFunction()), a.append(o));
      } else if ("transcript-window" === e || "sign-window" === e) for ((c = []).push({
        name: "move",
        label: this.tt.windowMove
      }), c.push({
        name: "resize",
        label: this.tt.windowResize
      }), c.push({
        name: "close",
        label: this.tt.windowClose
      }), r = 0; r < c.length; r++) (o = t("<li></li>", {
        role: "menuitem",
        tabindex: "-1",
        "data-choice": c[r].name
      })).text(c[r].label), o.on("click mousedown", function (i) {
        if (i.stopPropagation(), 0 !== i.button) return !1;
        s.windowMenuClickRegistered || s.finishingDrag || (s.windowMenuClickRegistered = !0, s.handleMenuChoice(e.substr(0, e.indexOf("-")), t(this).attr("data-choice"), i));
      }), a.append(o);
      return "captions" !== e && "ytcaptions" !== e || h ? "chapters" === e && (a.find('li:contains("' + this.defaultChapter + '")') ? a.find('li:contains("' + this.defaultChapter + '")').attr("aria-checked", "true").addClass("able-focus") : a.find("li").first().attr("aria-checked", "true").addClass("able-focus")) : a.find("li[lang=" + this.captionLang + "]") ? a.find("li[lang=" + this.captionLang + "]").attr("aria-checked", "true") : a.find("li").last().attr("aria-checked", "true"), a.on("keydown", function (e) {
        t(this).attr("id").split("-")[1], (u = t(this).find("li:focus")).is(":first-child") ? (f = t(this).find("li").last(), g = u.next()) : u.is(":last-child") ? (f = u.prev(), g = t(this).find("li").first()) : (f = u.prev(), g = u.next()), 9 === e.which ? e.shiftKey ? (u.removeClass("able-focus"), f.focus().addClass("able-focus")) : (u.removeClass("able-focus"), g.focus().addClass("able-focus")) : 40 === e.which || 39 === e.which ? (u.removeClass("able-focus"), g.focus().addClass("able-focus")) : 38 == e.which || 37 === e.which ? (u.removeClass("able-focus"), f.focus().addClass("able-focus")) : 32 === e.which || 13 === e.which ? u.click() : 27 === e.which && (u.removeClass("able-focus"), s.closePopups()), e.preventDefault();
      }), this.$controllerDiv.append(a), a;
    }, AblePlayer.prototype.closePopups = function () {
      this.chaptersPopup && this.chaptersPopup.is(":visible") && (this.chaptersPopup.hide(), this.$chaptersButton.attr("aria-expanded", "false").focus()), this.captionsPopup && this.captionsPopup.is(":visible") && (this.captionsPopup.hide(), this.$ccButton.attr("aria-expanded", "false").focus()), this.prefsPopup && this.prefsPopup.is(":visible") && (this.prefsPopup.hide(), this.prefsPopup.find("li").removeClass("able-focus").attr("tabindex", "-1"), this.$prefsButton.attr("aria-expanded", "false").focus()), this.$volumeSlider && this.$volumeSlider.is(":visible") && (this.$volumeSlider.hide().attr("aria-hidden", "true"), this.$volumeAlert.text(this.tt.volumeSliderClosed), this.$volumeButton.attr("aria-expanded", "false").focus()), this.$transcriptPopup && this.$transcriptPopup.is(":visible") && (this.$transcriptPopup.hide(), this.$transcriptPopup.find("li").removeClass("able-focus").attr("tabindex", "-1"), this.$transcriptPopupButton.attr("aria-expanded", "false").focus()), this.$signPopup && this.$signPopup.is(":visible") && (this.$signPopup.hide(), this.$signPopup.find("li").removeClass("able-focus").attr("tabindex", "-1"), this.$signPopupButton.attr("aria-expanded", "false").focus());
    }, AblePlayer.prototype.setupPopups = function (t) {
      var e, i;
      if (e = [], void 0 === t && e.push("prefs"), "captions" !== t && void 0 !== t || (void 0 !== this.ytCaptions ? this.ytCaptions.length && e.push("ytCaptions") : this.captions.length > 0 && e.push("captions")), "chapters" !== t && void 0 !== t || this.chapters.length > 0 && this.useChaptersButton && e.push("chapters"), "transcript-window" === t && "popup" === this.transcriptType && e.push("transcript-window"), "sign-window" === t && this.hasSignLanguage && e.push("sign-window"), e.length > 0) {
        this;
        for (var s = 0; s < e.length; s++) {
          var a = e[s];
          if (!1, "prefs" == a) this.prefsPopup = this.createPopup("prefs");else if ("captions" == a) void 0 === this.captionsPopup && (this.captionsPopup = this.createPopup("captions", this.captions));else if ("chapters" == a) i = this.selectedChapters ? this.selectedChapters.cues : this.chapters.length >= 1 ? this.chapters[0].cues : [], void 0 === this.chaptersPopup && (this.chaptersPopup = this.createPopup("chapters", i));else if ("ytCaptions" == a) void 0 === this.captionsPopup && (this.captionsPopup = this.createPopup("captions", this.ytCaptions));else {
            if ("transcript-window" == a) return this.createPopup("transcript-window");
            if ("sign-window" == a) return this.createPopup("sign-window");
          }
        }
      }
    }, AblePlayer.prototype.provideFallback = function () {
      var e, i, s, a, n, r, o, l, h, p;
      if (r = !1, e = t("<div>", {
        class: "able-fallback",
        role: "alert"
      }), i = void 0 !== this.playerMaxWidth ? this.playerMaxWidth + "px" : this.$media.attr("width") ? parseInt(this.$media.attr("width"), 10) + "px" : "100%", e.css("max-width", i), s = this.$media.clone(), t("source, track", s).remove(), (a = s.html().trim()).length ? e.html(a) : (n = this.tt.fallbackError1 + " " + this.tt[this.mediaType] + ". ", n += this.tt.fallbackError2 + ":", a = t("<p>").text(n), e.html(a), r = !0), r) {
        for (p = t("<ul>"), o = this.getSupportingBrowsers(), l = 0; l < o.length; l++) (h = t("<li>")).text(o[l].name + " " + o[l].minVersion + " " + this.tt.orHigher), p.append(h);
        e.append(p);
      }
      this.injectPoster(e, "fallback"), void 0 !== this.$ableWrapper ? (this.$ableWrapper.before(e), this.$ableWrapper.remove()) : void 0 !== this.$media ? (this.$media.before(e), this.$media.remove()) : t("body").prepend(e);
    }, AblePlayer.prototype.getSupportingBrowsers = function () {
      var t = [];
      return t[0] = {
        name: "Chrome",
        minVersion: "31"
      }, t[1] = {
        name: "Firefox",
        minVersion: "34"
      }, t[2] = {
        name: "Internet Explorer",
        minVersion: "10"
      }, t[3] = {
        name: "Opera",
        minVersion: "26"
      }, t[4] = {
        name: "Safari for Mac OS X",
        minVersion: "7.1"
      }, t[5] = {
        name: "Safari for iOS",
        minVersion: "7.1"
      }, t[6] = {
        name: "Android Browser",
        minVersion: "4.1"
      }, t[7] = {
        name: "Chrome for Android",
        minVersion: "40"
      }, t;
    }, AblePlayer.prototype.calculateControlLayout = function () {
      var t = {
        ul: ["play", "restart", "rewind", "forward"],
        ur: ["seek"],
        bl: [],
        br: []
      };
      this.browserSupportsVolume() ? (this.volumeButton = "volume-" + this.getVolumeName(this.volume), t.ur.push("volume")) : this.volume = !1;
      var e = [],
        i = [];
      return this.isPlaybackRateSupported() && (e.push("slower"), e.push("faster")), "video" === this.mediaType && (this.hasCaptions && e.push("captions"), this.hasSignLanguage && e.push("sign"), (this.hasOpenDesc || this.hasClosedDesc) && this.useDescriptionsButton && e.push("descriptions")), "popup" === this.transcriptType && e.push("transcript"), "video" === this.mediaType && this.hasChapters && this.useChaptersButton && e.push("chapters"), t.br.push("preferences"), "video" === this.mediaType && this.allowFullScreen && "jw" !== this.player && t.br.push("fullscreen"), e.length > 0 && i.length > 0 ? (t.bl = e, t.bl.push("pipe"), t.bl = t.bl.concat(i)) : t.bl = e.concat(i), t;
    }, AblePlayer.prototype.addControls = function () {
      var e, i, s, a, n, r, o, l, h, p, c, d, u, f, g, v, m, b, y, w, P, k, C;
      for (e = this, 100, i = this.calculateControlLayout(), s = {
        0: "ul",
        1: "ur",
        2: "bl",
        3: "br"
      }, u = this.mediaId + "-tooltip", this.$tooltipDiv = t("<div>", {
        id: u,
        class: "able-tooltip"
      }).hide(), this.$controllerDiv.append(this.$tooltipDiv), a = 0; a <= 3; a++) {
        for (r = i[s[a]], o = t("<div>", a % 2 == 0 ? {
          class: "able-left-controls"
        } : {
          class: "able-right-controls"
        }), this.$controllerDiv.append(o), n = 0; n < r.length; n++) {
          if ("seek" === (f = r[n])) l = t('<div class="able-seekbar"></div>'), h = this.mediaType + " " + this.tt.seekbarLabel, o.append(l), 0 == (p = this.getDuration()) && (p = 100), this.seekBar = new AccessibleSlider(this.mediaType, l, "horizontal", 100, 0, p, this.seekInterval, h, "seekbar", !0, "visible");else if ("pipe" === f) c = t("<span>", {
            tabindex: "-1",
            "aria-hidden": "true"
          }), "font" === this.iconType ? c.addClass("icon-pipe") : (d = t("<img>", {
            src: this.rootPath + "button-icons/" + this.iconColor + "/pipe.png",
            alt: "",
            role: "presentation"
          }), c.append(d)), o.append(c);else {
            if (v = "volume" === f ? this.rootPath + "button-icons/" + this.iconColor + "/" + this.volumeButton + ".png" : "fullscreen" === f ? this.rootPath + "button-icons/" + this.iconColor + "/fullscreen-expand.png" : "slower" === f ? "animals" === this.speedIcons ? this.rootPath + "button-icons/" + this.iconColor + "/turtle.png" : this.rootPath + "button-icons/" + this.iconColor + "/slower.png" : "faster" === f ? "animals" === this.speedIcons ? this.rootPath + "button-icons/" + this.iconColor + "/rabbit.png" : this.rootPath + "button-icons/" + this.iconColor + "/faster.png" : this.rootPath + "button-icons/" + this.iconColor + "/" + f + ".png", m = this.getButtonTitle(f), b = t("<button>", {
              type: "button",
              tabindex: "0",
              "aria-label": m,
              class: "able-button-handler-" + f
            }), "volume" !== f && "preferences" !== f || ("preferences" == f ? C = this.mediaId + "-prefs-menu" : "volume" === f && (C = this.mediaId + "-volume-slider"), b.attr({
              "aria-controls": C,
              "aria-expanded": "false"
            })), "font" === this.iconType) y = "volume" === f ? "icon-" + this.volumeButton : "slower" === f ? "animals" === this.speedIcons ? "icon-turtle" : "icon-slower" : "faster" === f ? "animals" === this.speedIcons ? "icon-rabbit" : "icon-faster" : "icon-" + f, w = t("<span>", {
              class: y,
              "aria-hidden": "true"
            }), b.append(w);else if ("svg" === this.iconType) {
              var $;
              $ = "volume" === f ? this.getSvgData(this.volumeButton) : "fullscreen" === f ? this.getSvgData("fullscreen-expand") : "slower" === f ? "animals" === this.speedIcons ? this.getSvgData("turtle") : this.getSvgData("slower") : "faster" === f ? "animals" === this.speedIcons ? this.getSvgData("rabbit") : this.getSvgData("faster") : this.getSvgData(f), w = t("<svg>", {
                focusable: "false",
                "aria-hidden": "true",
                viewBox: $[0]
              }), P = t("<path>", {
                d: $[1]
              }), w.append(P), b.html(w), b.html(b.html());
            } else g = t("<img>", {
              src: v,
              alt: "",
              role: "presentation"
            }), b.append(g);
            var T = t("<span>", {
              class: "able-clipped"
            }).text(m);
            b.append(T), b.on("mouseenter focus", function (i) {
              var s = t(this).attr("aria-label"),
                a = t(this).position(),
                n = t(this).height(),
                r = (t(this).width(), a.top - n - 15),
                o = !0;
              if (t(this).closest("div").hasClass("able-right-controls")) {
                if (t(this).closest("div").find("button:last").get(0) == t(this).get(0)) {
                  o = !1;
                  var l = {
                    left: "",
                    right: 0 + "px",
                    top: r + "px"
                  };
                }
              } else if (t(this).is(":first-child")) {
                o = !1;
                l = {
                  left: a.left + "px",
                  right: "",
                  top: r + "px"
                };
              }
              if (o) {
                var h = AblePlayer.localGetElementById(b[0], u).text(s).width();
                l = {
                  left: a.left - h / 2 + "px",
                  right: "",
                  top: r + "px"
                };
              }
              var p = AblePlayer.localGetElementById(b[0], u).text(s).css(l);
              e.showTooltip(p), t(this).on("mouseleave blur", function () {
                AblePlayer.localGetElementById(b[0], u).text("").hide();
              });
            }), "captions" === f ? this.prefCaptions && 1 === this.prefCaptions || (k = this.captions.length > 1 ? this.tt.captions : this.tt.showCaptions, b.addClass("buttonOff").attr("title", k)) : "descriptions" === f && (this.prefDesc && 1 === this.prefDesc || b.addClass("buttonOff").attr("title", this.tt.turnOnDescriptions)), o.append(b), "play" === f ? this.$playpauseButton = b : "captions" === f ? this.$ccButton = b : "sign" === f ? (this.$signButton = b, this.$signWindow.is(":visible") || this.$signButton.addClass("buttonOff")) : "descriptions" === f ? this.$descButton = b : "mute" === f ? this.$muteButton = b : "transcript" === f ? (this.$transcriptButton = b, this.$transcriptDiv.is(":visible") || this.$transcriptButton.addClass("buttonOff").attr("title", this.tt.showTranscript)) : "fullscreen" === f ? this.$fullscreenButton = b : "chapters" === f ? this.$chaptersButton = b : "preferences" === f ? this.$prefsButton = b : "volume" === f && (this.$volumeButton = b);
          }
          "volume" === f && this.addVolumeSlider(o);
        }
        a % 2 == 1 && this.$controllerDiv.append('<div style="clear:both;"></div>');
      }
      for (var A in "video" === this.mediaType && (void 0 !== this.$captionsDiv && this.stylizeCaptions(this.$captionsDiv), void 0 !== this.$descDiv && this.stylizeCaptions(this.$descDiv)), this.controls = [], i) i.hasOwnProperty(A) && (this.controls = this.controls.concat(i[A]));
      this.refreshControls();
    }, AblePlayer.prototype.useSvg = function () {
      // @copyright Copyright (c) 2016 IcoMoon.io
      // @license   Licensed under MIT license
      var t,
        e,
        i = Object.create(null),
        s = function s() {
          clearTimeout(e), e = setTimeout(t, 100);
        },
        a = function a() {},
        n = "http://www.w3.org/1999/xlink";
      t = function t() {
        var t,
          e,
          r,
          o,
          l,
          h,
          p,
          c,
          d,
          u = 0;
        if (window.XMLHttpRequest && (l = void 0 !== (l = new XMLHttpRequest()).withCredentials ? XMLHttpRequest : XDomainRequest || void 0), void 0 !== l) {
          for (a(), c = document.getElementsByTagName("use"), o = 0; o < c.length; o += 1) {
            try {
              e = c[o].getBoundingClientRect();
            } catch (t) {
              e = !1;
            }
            t = (p = c[o].getAttributeNS(n, "href").split("#"))[0], r = p[1], h = e && 0 === e.left && 0 === e.right && 0 === e.top && 0 === e.bottom, e && 0 === e.width && 0 === e.height && !h ? t.length && (!0 !== (d = i[t]) && setTimeout(g({
              useEl: c[o],
              base: t,
              hash: r
            }), 0), void 0 === d && (d = new l(), i[t] = d, d.onload = v(d), d.onerror = m(d), d.ontimeout = m(d), d.open("GET", t), d.send(), u += 1)) : h || (void 0 === i[t] ? i[t] = !0 : i[t].onload && (i[t].abort(), i[t].onload = void 0, i[t] = !0));
          }
          c = "", u += 1, f();
        }
        function f() {
          var t;
          0 === (u -= 1) && (window.addEventListener("resize", s, !1), window.addEventListener("orientationchange", s, !1), window.MutationObserver ? ((t = new MutationObserver(s)).observe(document.documentElement, {
            childList: !0,
            subtree: !0,
            attributes: !0
          }), a = function a() {
            try {
              t.disconnect(), window.removeEventListener("resize", s, !1), window.removeEventListener("orientationchange", s, !1);
            } catch (t) {}
          }) : (document.documentElement.addEventListener("DOMSubtreeModified", s, !1), a = function a() {
            document.documentElement.removeEventListener("DOMSubtreeModified", s, !1), window.removeEventListener("resize", s, !1), window.removeEventListener("orientationchange", s, !1);
          }));
        }
        function g(t) {
          return function () {
            !0 !== i[t.base] && t.useEl.setAttributeNS(n, "xlink:href", "#" + t.hash);
          };
        }
        function v(t) {
          return function () {
            var e,
              i = document.body,
              s = document.createElement("x");
            t.onload = null, s.innerHTML = t.responseText, (e = s.getElementsByTagName("svg")[0]) && (e.setAttribute("aria-hidden", "true"), e.style.position = "absolute", e.style.width = 0, e.style.height = 0, e.style.overflow = "hidden", i.insertBefore(e, i.firstChild)), f();
          };
        }
        function m(t) {
          return function () {
            t.onerror = null, t.ontimeout = null, f();
          };
        }
      };
    }, AblePlayer.prototype.swapSource = function (e) {
      var i, s, a, n, r, o, l, h, p;
      for (this.$media.find("source").remove(), s = (i = this.$playlist.eq(e)).html(), i.attr("lang") && (a = i.attr("lang")), n = [], r = 0, "audio" === this.mediaType ? (i.attr("data-mp3") && (o = i.attr("data-mp3"), n[r] = new Array("audio/mpeg", o), r++), i.attr("data-webm") && (n[r] = new Array("audio/webm", i.attr("data-webm")), r++), i.attr("data-webma") && (n[r] = new Array("audio/webm", i.attr("data-webma")), r++), i.attr("data-ogg") && (n[r] = new Array("audio/ogg", i.attr("data-ogg")), r++), i.attr("data-oga") && (n[r] = new Array("audio/ogg", i.attr("data-oga")), r++), i.attr("data-wav") && (n[r] = new Array("audio/wav", i.attr("data-wav")), r++)) : "video" === this.mediaType && (i.attr("data-mp4") && (o = i.attr("data-mp4"), n[r] = new Array("video/mp4", o), r++), i.attr("data-webm") && (n[r] = new Array("video/webm", i.attr("data-webm")), r++), i.attr("data-webmv") && (n[r] = new Array("video/webm", i.attr("data-webmv")), r++), i.attr("data-ogg") && (n[r] = new Array("video/ogg", i.attr("data-ogg")), r++), i.attr("data-ogv") && (n[r] = new Array("video/ogg", i.attr("data-ogv")), r++)), l = 0; l < n.length; l++) h = t("<source>", {
        type: n[l][0],
        src: n[l][1]
      }), this.$media.append(h);
      this.$playlist.removeClass("able-current"), i.addClass("able-current"), !0 === this.showNowPlaying && (p = t("<span>"), void 0 !== a && p.attr("lang", a), p.html("<span>Selected track:</span>" + s), this.$nowPlayingDiv.html(p)), this.initializing ? this.swappingSrc = !1 : (this.swappingSrc = !0, "html5" === this.player ? this.media.load() : "jw" === this.player ? this.jwPlayer.load({
        file: o
      }) : this.player);
    }, AblePlayer.prototype.getButtonTitle = function (t) {
      return "playpause" === t || "play" === t ? this.tt.play : "pause" === t ? this.tt.pause : "restart" === t ? this.tt.restart : "rewind" === t ? this.tt.rewind : "forward" === t ? this.tt.forward : "captions" === t ? (this.usingYouTubeCaptions ? this.ytCaptions.length : this.captions.length) > 1 ? this.tt.captions : this.captionsOn ? this.tt.hideCaptions : this.tt.showCaptions : "descriptions" === t ? this.descOn ? this.tt.turnOffDescriptions : this.tt.turnOnDescriptions : "transcript" === t ? this.$transcriptDiv.is(":visible") ? this.tt.hideTranscript : this.tt.showTranscript : "chapters" === t ? this.tt.chapters : "sign" === t ? this.tt.sign : "volume" === t ? this.tt.volume : "faster" === t ? this.tt.faster : "slower" === t ? this.tt.slower : "preferences" === t ? this.tt.preferences : "help" !== t ? (this.debug && console.log("Found an untranslated label: " + t), t.charAt(0).toUpperCase() + t.slice(1)) : void 0;
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.setupTracks = function () {
      var e = this,
        i = new t.Deferred(),
        s = i.promise();
      this.$tracks = this.$media.find("track"), this.captions = [], this.captionLabels = [], this.descriptions = [], this.chapters = [], this.meta = [], t("#able-vts").length ? (this.vtsTracks = [], this.hasVts = !0) : this.hasVts = !1;
      for (var a = [], n = 0; n < this.$tracks.length; n++) {
        var r = this.$tracks[n],
          o = r.getAttribute("kind"),
          l = r.getAttribute("src");
        r.getAttribute("default");
        if (l) {
          var h = this.loadTextObject(l);
          a.push(h), h.then(function (t, i, s, a) {
            s = t.getAttribute("srclang") || e.lang, a = t.getAttribute("label") || e.getLanguageName(s);
            return function (n, r) {
              var o = r;
              e.useTtml && (n.endsWith(".xml") || r.startsWith("<?xml")) && (o = e.ttml2webvtt(r)), e.hasVts && e.setupVtsTracks(i, s, a, n, o);
              var l = e.parseWebVTT(n, o).cues;
              "captions" === i || "subtitles" === i ? e.setupCaptions(t, l, s, a) : "descriptions" === i ? e.setupDescriptions(t, l, s) : "chapters" === i ? e.setupChapters(t, l, s) : "metadata" === i && e.setupMetadata(t, l);
            };
          }(r, o));
        }
      }
      return t.when.apply(t, a).then(function () {
        i.resolve();
      }), s;
    }, AblePlayer.prototype.setupCaptions = function (e, i, s, a) {
      if (this.hasCaptions = !0, "string" == typeof e.getAttribute("default")) {
        var n = !0;
        e.removeAttribute("default");
      } else n = !1;
      if ("video" === this.mediaType && (this.$captionsDiv || (this.$captionsDiv = t("<div>", {
        class: "able-captions"
      }), this.$captionsWrapper = t("<div>", {
        class: "able-captions-wrapper",
        "aria-hidden": "true"
      }).hide(), "below" === this.prefCaptionsPosition ? this.$captionsWrapper.addClass("able-captions-below") : this.$captionsWrapper.addClass("able-captions-overlay"), this.$captionsWrapper.append(this.$captionsDiv), this.$vidcapContainer.append(this.$captionsWrapper))), this.currentCaption = -1, 1 === this.prefCaptions ? this.captionsOn = !0 : this.captionsOn = !1, "external" === this.transcriptType || "popup" === this.transcriptType) {
        this.$unknownTranscriptOption && (this.$unknownTranscriptOption.remove(), this.$unknownTranscriptOption = null);
        var r = t("<option></option>", {
          value: s,
          lang: s
        }).text(a);
      }
      if ("external" === this.transcriptType || "popup" === this.transcriptType) var o = this.$transcriptLanguageSelect.find("option");
      if (0 === this.captions.length) this.captions.push({
        cues: i,
        language: s,
        label: a,
        def: n
      }), "external" !== this.transcriptType && "popup" !== this.transcriptType || (n && r.prop("selected", !0), this.$transcriptLanguageSelect.append(r)), this.captionLabels.push(a);else {
        for (var l = !1, h = 0; h < this.captions.length; h++) {
          this.captionLabels[h];
          if (a.toLowerCase() < this.captionLabels[h].toLowerCase()) {
            this.captions.splice(h, 0, {
              cues: i,
              language: s,
              label: a,
              def: n
            }), "external" !== this.transcriptType && "popup" !== this.transcriptType || (n && r.prop("selected", !0), r.insertBefore(o.eq(h))), this.captionLabels.splice(h, 0, a), l = !0;
            break;
          }
        }
        l || (this.captions.push({
          cues: i,
          language: s,
          label: a,
          def: n
        }), "external" !== this.transcriptType && "popup" !== this.transcriptType || (n && r.prop("selected", !0), this.$transcriptLanguageSelect.append(r)), this.captionLabels.push(a));
      }
      "external" !== this.transcriptType && "popup" !== this.transcriptType || this.$transcriptLanguageSelect.find("option").length > 1 && this.$transcriptLanguageSelect.prop("disabled", !1);
    }, AblePlayer.prototype.setupDescriptions = function (t, e, i) {
      this.hasClosedDesc = !0, this.currentDescription = -1, this.descriptions.push({
        cues: e,
        language: i
      });
    }, AblePlayer.prototype.setupChapters = function (t, e, i) {
      this.hasChapters = !0, this.chapters.push({
        cues: e,
        language: i
      });
    }, AblePlayer.prototype.setupMetadata = function (e, i) {
      "text" === this.metaType ? this.metaDiv && t("#" + this.metaDiv) && (this.$metaDiv = t("#" + this.metaDiv), this.hasMeta = !0, this.meta = i) : "selector" === this.metaType && (this.hasMeta = !0, this.visibleSelectors = [], this.meta = i);
    }, AblePlayer.prototype.loadTextObject = function (e) {
      var i = new t.Deferred(),
        s = i.promise(),
        a = this,
        n = t("<div>", {
          style: "display:none"
        });
      return n.load(e, function (t, s, r) {
        "error" === s ? (a.debug && console.log("error reading file " + e + ": " + s), i.fail()) : i.resolve(e, t), n.remove();
      }), s;
    }, AblePlayer.prototype.setupAltCaptions = function () {
      var e = new t.Deferred(),
        i = e.promise();
      return 0 === this.captions.length && "youtube" === this.player && "undefined" != typeof youTubeDataAPIKey ? this.setupYouTubeCaptions().done(function () {
        e.resolve();
      }) : e.resolve(), i;
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.initYouTubePlayer = function () {
      var e, i, s, a;
      return e = this, s = (i = new t.Deferred()).promise(), a = this.youTubeDescId && this.prefDesc ? this.youTubeDescId : this.youTubeId, this.activeYouTubeId = a, AblePlayer.youtubeIframeAPIReady ? this.finalizeYoutubeInit().then(function () {
        i.resolve();
      }) : (AblePlayer.loadingYoutubeIframeAPI || t.getScript("https://www.youtube.com/iframe_api").fail(function () {
        i.fail();
      }), t("body").on("youtubeIframeAPIReady", function () {
        e.finalizeYoutubeInit().then(function () {
          i.resolve();
        });
      })), s;
    }, AblePlayer.prototype.finalizeYoutubeInit = function () {
      var e, i, s, a, n, r;
      return i = (e = new t.Deferred()).promise(), s = this, a = this.mediaId + "_youtube", this.$mediaContainer.prepend(t("<div>").attr("id", a)), this.youTubeCaptionsReady = !1, s.captions.length ? (n = 0, this.usingYouTubeCaptions = !1) : n = this.captionsOn ? 1 : 0, (r = this.getYouTubeDimensions(this.activeYouTubeId, a)) ? (this.ytWidth = r[0], this.ytHeight = r[1], this.aspectRatio = s.ytWidth / s.ytHeight) : (this.ytWidth = null, this.ytHeight = null), this.youTubePlayer = new YT.Player(a, {
        videoId: this.activeYouTubeId,
        host: this.youTubeNoCookie ? "https://www.youtube-nocookie.com" : "https://www.youtube.com",
        width: this.ytWidth,
        height: this.ytHeight,
        playerVars: {
          autoplay: 0,
          enablejsapi: 1,
          disableKb: 1,
          playsinline: this.playsInline,
          start: this.startTime,
          controls: 0,
          cc_load_policy: n,
          hl: this.lang,
          modestbranding: 1,
          rel: 0,
          html5: 1,
          iv_load_policy: 3
        },
        events: {
          onReady: function onReady() {
            s.swappingSrc && (s.swappingSrc = !1, s.playing && s.playMedia()), void 0 === s.aspectRatio && s.resizeYouTubePlayer(s.activeYouTubeId, a), e.resolve();
          },
          onError: function onError(t) {
            e.fail();
          },
          onStateChange: function onStateChange(t) {
            var e = s.getPlayerState(t.data);
            "playing" === e ? (s.playing = !0, s.startedPlaying = !0) : s.playing = !1, s.stoppingYouTube && "paused" === e && (void 0 !== s.$posterImg && s.$posterImg.show(), s.stoppingYouTube = !1, s.seeking = !1, s.playing = !1);
          },
          onPlaybackQualityChange: function onPlaybackQualityChange() {},
          onApiChange: function onApiChange(t) {
            s.initYouTubeCaptionModule();
          }
        }
      }), s.injectPoster(s.$mediaContainer, "youtube"), s.$media.remove(), i;
    }, AblePlayer.prototype.getYouTubeDimensions = function (e, i) {
      var s, a, n, r;
      return s = [], void 0 !== this.playerMaxWidth ? (s[0] = this.playerMaxWidth, void 0 !== this.playerMaxHeight && (s[1] = this.playerMaxHeight), s) : void 0 !== t("#" + i) && (n = (a = t("#" + i)).width(), r = a.height(), n > 0 && r > 0) && (s[0] = n, s[1] = r, s);
    }, AblePlayer.prototype.resizeYouTubePlayer = function (t, e) {
      var i, s, a;
      void 0 !== this.aspectRatio ? this.restoringAfterFullScreen ? (this.youTubePlayer && this.youTubePlayer.setSize(this.ytWidth, this.ytHeight), this.restoringAfterFullScreen = !1) : (s = this.$ableWrapper.parent().width(), a = Math.round(s / this.aspectRatio), this.$ableWrapper.css({
        "max-width": s + "px",
        width: ""
      }), this.youTubePlayer.setSize(s, a), this.isFullscreen() ? this.youTubePlayer.setSize(s, a) : this.youTubePlayer.setSize(this.ytWidth, this.ytHeight)) : (i = this.getYouTubeDimensions(t, e)) && (s = i[0], a = i[1], s > 0 && a > 0 && (this.aspectRatio = s / a, this.ytWidth = s, this.ytHeight = a, s !== this.$ableWrapper.width() && (s = this.$ableWrapper.width(), a = Math.round(s / this.aspectRatio), this.youTubePlayer && this.youTubePlayer.setSize(s, a))));
    }, AblePlayer.prototype.setupYouTubeCaptions = function () {
      var e,
        i,
        s = new t.Deferred(),
        a = s.promise();
      return e = this, this.ytCaptions = [], i = this.youTubeDescId && this.prefDesc ? this.youTubeDescId : this.youTubeId, t.doWhen({
        when: function when() {
          return googleApiReady;
        },
        interval: 100,
        attempts: 1e3
      }).done(function () {
        e.getYouTubeCaptionData(i).done(function () {
          s.resolve();
        });
      }).fail(function () {
        console.log("Unable to initialize Google API. YouTube captions are currently unavailable.");
      }), a;
    }, AblePlayer.prototype.getYouTubeCaptionData = function (e) {
      var i,
        s,
        a,
        n,
        r,
        o,
        l,
        h = new t.Deferred(),
        p = h.promise();
      return i = this, gapi.client.setApiKey(youTubeDataAPIKey), gapi.client.load("youtube", "v3").then(function () {
        gapi.client.youtube.captions.list({
          part: "id, snippet",
          videoId: e
        }).then(function (t) {
          if (t.result.items.length) {
            for (i.hasCaptions = !0, i.usingYouTubeCaptions = !0, 1 === i.prefCaptions ? i.captionsOn = !0 : i.captionsOn = !1, s = 0; s < t.result.items.length; s++) t.result.items[s].id, n = t.result.items[s].snippet.name, a = t.result.items[s].snippet.language, r = t.result.items[s].snippet.trackKind, o = t.result.items[s].snippet.isDraft, "ASR" === r || o || ("" === n && (n = i.getLanguageName(a)), l = a === i.lang, i.ytCaptions.push({
              language: a,
              label: n,
              def: l
            }));
            i.setupPopups("captions"), h.resolve();
          } else i.hasCaptions = !1, i.usingYouTubeCaptions = !1, h.resolve();
        }, function (t) {
          console.log("Error: " + t.result.error.message);
        });
      }), p;
    }, AblePlayer.prototype.initYouTubeCaptionModule = function () {
      var t;
      if ((t = this.youTubePlayer.getOptions()).length) {
        for (var e = 0; e < t.length; e++) {
          if ("cc" == t[e]) {
            this.ytCaptionModule = "cc", this.hasCaptions || (this.hasCaptions = !0, this.usingYouTubeCaptions = !0);
            break;
          }
          if ("captions" == t[e]) {
            this.ytCaptionModule = "captions", this.hasCaptions || (this.hasCaptions = !0, this.usingYouTubeCaptions = !0);
            break;
          }
        }
        void 0 !== this.ytCaptionModule && (this.usingYouTubeCaptions ? (this.youTubePlayer.setOption(this.ytCaptionModule, "track", {
          languageCode: this.captionLang
        }), this.youTubePlayer.setOption(this.ytCaptionModule, "fontSize", this.translatePrefs("size", this.prefCaptionsSize, "youtube"))) : this.youTubePlayer.unloadModule(this.ytCaptionModule));
      } else this.hasCaptions = !1, this.usingYouTubeCaptions = !1;
      this.refreshControls();
    };
  }(_jquery.default), function (t) {
    window.AccessibleSlider = function (e, i, s, a, n, r, o, l, h, p, c) {
      var d;
      d = this, this.position = 0, this.tracking = !1, this.trackDevice = null, this.keyTrackPosition = 0, this.lastTrackPosition = 0, this.nextStep = 1, this.inertiaCount = 0, this.bodyDiv = t(i), p && (this.loadedDiv = t("<div></div>"), this.playedDiv = t("<div></div>")), this.seekHead = t("<div>", {
        orientation: s,
        class: "able-" + h + "-head"
      }), "visible" === c ? this.seekHead.attr("tabindex", "0") : this.seekHead.attr("tabindex", "-1"), this.seekHead.attr({
        role: "slider",
        "aria-label": l,
        "aria-valuemin": n,
        "aria-valuemax": r
      }), this.timeTooltip = t("<div>"), this.bodyDiv.append(this.timeTooltip), this.timeTooltip.attr("role", "tooltip"), this.timeTooltip.addClass("able-tooltip"), this.timeTooltip.hide(), this.bodyDiv.append(this.loadedDiv), this.bodyDiv.append(this.playedDiv), this.bodyDiv.append(this.seekHead), this.bodyDiv.wrap("<div></div>"), this.wrapperDiv = this.bodyDiv.parent(), "horizontal" === s ? (this.wrapperDiv.width(a), this.loadedDiv.width(0)) : (this.wrapperDiv.height(a), this.loadedDiv.height(0)), this.wrapperDiv.addClass("able-" + h + "-wrapper"), p && (this.loadedDiv.addClass("able-" + h + "-loaded"), this.playedDiv.width(0), this.playedDiv.addClass("able-" + h + "-played"), this.setDuration(r)), this.seekHead.hover(function (t) {
        d.overHead = !0, d.refreshTooltip();
      }, function (t) {
        d.overHead = !1, !d.overBody && d.tracking && "mouse" === d.trackDevice && d.stopTracking(d.pageXToPosition(t.pageX)), d.refreshTooltip();
      }), this.seekHead.mousemove(function (t) {
        d.tracking && "mouse" === d.trackDevice && d.trackHeadAtPageX(t.pageX);
      }), this.seekHead.focus(function (t) {
        d.overHead = !0, d.refreshTooltip();
      }), this.seekHead.blur(function (t) {
        d.overHead = !1, d.refreshTooltip();
      }), this.bodyDiv.hover(function () {
        d.overBody = !0, d.refreshTooltip();
      }, function (t) {
        d.overBody = !1, d.overBodyMousePos = null, d.refreshTooltip(), !d.overHead && d.tracking && "mouse" === d.trackDevice && d.stopTracking(d.pageXToPosition(t.pageX));
      }), this.bodyDiv.mousemove(function (t) {
        d.overBodyMousePos = {
          x: t.pageX,
          y: t.pageY
        }, d.tracking && "mouse" === d.trackDevice && d.trackHeadAtPageX(t.pageX), d.refreshTooltip();
      }), this.bodyDiv.mousedown(function (t) {
        d.startTracking("mouse", d.pageXToPosition(t.pageX)), d.trackHeadAtPageX(t.pageX), d.seekHead.is(":focus") || d.seekHead.focus(), t.preventDefault();
      }), this.seekHead.mousedown(function (t) {
        d.startTracking("mouse", d.pageXToPosition(d.seekHead.offset() + d.seekHead.width() / 2)), d.bodyDiv.is(":focus") || d.bodyDiv.focus(), t.preventDefault();
      }), this.bodyDiv.mouseup(function (t) {
        d.tracking && "mouse" === d.trackDevice && d.stopTracking(d.pageXToPosition(t.pageX));
      }), this.seekHead.mouseup(function (t) {
        d.tracking && "mouse" === d.trackDevice && d.stopTracking(d.pageXToPosition(t.pageX));
      }), this.bodyDiv.keydown(function (t) {
        if (36 === t.which) d.trackImmediatelyTo(0);else if (35 === t.which) d.trackImmediatelyTo(d.duration);else if (37 === t.which || 40 === t.which) d.arrowKeyDown(-1);else if (39 === t.which || 38 === t.which) d.arrowKeyDown(1);else if (33 === t.which && o > 0) d.arrowKeyDown(o);else {
          if (!(34 === t.which && o > 0)) return;
          d.arrowKeyDown(-o);
        }
        t.preventDefault();
      }), this.bodyDiv.keyup(function (t) {
        t.which >= 33 && t.which <= 40 && (d.tracking && "keyboard" === d.trackDevice && d.stopTracking(d.keyTrackPosition), t.preventDefault());
      });
    }, AccessibleSlider.prototype.arrowKeyDown = function (t) {
      this.tracking && "keyboard" === this.trackDevice ? (this.keyTrackPosition = this.boundPos(this.keyTrackPosition + this.nextStep * t), this.inertiaCount += 1, 20 === this.inertiaCount && (this.inertiaCount = 0, this.nextStep *= 2), this.trackHeadAtPosition(this.keyTrackPosition)) : (this.nextStep = 1, this.inertiaCount = 0, this.keyTrackPosition = this.boundPos(this.position + this.nextStep * t), this.startTracking("keyboard", this.keyTrackPosition), this.trackHeadAtPosition(this.keyTrackPosition));
    }, AccessibleSlider.prototype.pageXToPosition = function (t) {
      var e = t - this.bodyDiv.offset().left,
        i = this.duration * (e / this.bodyDiv.width());
      return this.boundPos(i);
    }, AccessibleSlider.prototype.boundPos = function (t) {
      return Math.max(0, Math.min(t, this.duration));
    }, AccessibleSlider.prototype.setDuration = function (t) {
      t !== this.duration && (this.duration = t, this.resetHeadLocation(), this.seekHead.attr("aria-valuemax", t));
    }, AccessibleSlider.prototype.setWidth = function (t) {
      this.wrapperDiv.width(t), this.resizeDivs(), this.resetHeadLocation();
    }, AccessibleSlider.prototype.getWidth = function () {
      return this.wrapperDiv.width();
    }, AccessibleSlider.prototype.resizeDivs = function () {
      this.playedDiv.width(this.bodyDiv.width() * (this.position / this.duration)), this.loadedDiv.width(this.bodyDiv.width() * this.buffered);
    }, AccessibleSlider.prototype.resetHeadLocation = function () {
      var t = this.position / this.duration,
        e = this.bodyDiv.width() * t;
      this.seekHead.css("left", e - this.seekHead.width() / 2), this.tracking && this.stopTracking(this.position);
    }, AccessibleSlider.prototype.setPosition = function (t, e) {
      this.position = t, this.resetHeadLocation(), this.refreshTooltip(), this.resizeDivs(), this.updateAriaValues(t, e);
    }, AccessibleSlider.prototype.setBuffered = function (t) {
      this.buffered = t, this.redrawDivs;
    }, AccessibleSlider.prototype.startTracking = function (t, e) {
      this.tracking || (this.trackDevice = t, this.tracking = !0, this.bodyDiv.trigger("startTracking", [e]));
    }, AccessibleSlider.prototype.stopTracking = function (t) {
      this.trackDevice = null, this.tracking = !1, this.bodyDiv.trigger("stopTracking", [t]), this.setPosition(t, !0);
    }, AccessibleSlider.prototype.trackHeadAtPageX = function (t) {
      var e = this.pageXToPosition(t),
        i = t - this.bodyDiv.offset().left - this.seekHead.width() / 2;
      i = Math.max(0, Math.min(i, this.bodyDiv.width() - this.seekHead.width())), this.lastTrackPosition = e, this.seekHead.css("left", i), this.reportTrackAtPosition(e);
    }, AccessibleSlider.prototype.trackHeadAtPosition = function (t) {
      var e = t / this.duration,
        i = this.bodyDiv.width() * e;
      this.lastTrackPosition = t, this.seekHead.css("left", i - this.seekHead.width() / 2), this.reportTrackAtPosition(t);
    }, AccessibleSlider.prototype.reportTrackAtPosition = function (t) {
      this.bodyDiv.trigger("tracking", [t]), this.updateAriaValues(t, !0);
    }, AccessibleSlider.prototype.updateAriaValues = function (e, i) {
      var s,
        a = Math.floor(e / 3600),
        n = Math.floor(e % 3600 / 60),
        r = Math.floor(e % 60),
        o = 1 === n ? "minute" : "minutes",
        l = 1 === r ? "second" : "seconds";
      s = a > 0 ? a + " " + (1 === a ? "hour" : "hours") + ", " + n + " " + o + ", " + r + " " + l : n > 0 ? n + " " + o + ", " + r + " " + l : r + " " + l, this.liveAriaRegion || (this.liveAriaRegion = t("<span>", {
        class: "able-offscreen",
        "aria-live": "polite"
      }), this.wrapperDiv.append(this.liveAriaRegion)), i && this.liveAriaRegion.text() !== s && this.liveAriaRegion.text(s), this.seekHead.attr("aria-valuetext", s), this.seekHead.attr("aria-valuenow", Math.floor(e).toString());
    }, AccessibleSlider.prototype.trackImmediatelyTo = function (t) {
      this.startTracking("keyboard", t), this.trackHeadAtPosition(t), this.keyTrackPosition = t;
    }, AccessibleSlider.prototype.refreshTooltip = function () {
      this.overHead ? (this.timeTooltip.show(), this.tracking ? this.timeTooltip.text(this.positionToStr(this.lastTrackPosition)) : this.timeTooltip.text(this.positionToStr(this.position)), this.setTooltipPosition(this.seekHead.position().left + this.seekHead.width() / 2)) : this.overBody && this.overBodyMousePos ? (this.timeTooltip.show(), this.timeTooltip.text(this.positionToStr(this.pageXToPosition(this.overBodyMousePos.x))), this.setTooltipPosition(this.overBodyMousePos.x - this.bodyDiv.offset().left)) : this.timeTooltip.hide();
    }, AccessibleSlider.prototype.setTooltipPosition = function (t) {
      this.timeTooltip.css({
        left: t - this.timeTooltip.width() / 2 - 10,
        bottom: this.seekHead.height() + 10
      });
    }, AccessibleSlider.prototype.positionToStr = function (t) {
      var e = Math.floor(t / 3600),
        i = Math.floor(t / 60) % 60,
        s = Math.floor(t % 60);
      return s < 10 && (s = "0" + s), e > 0 ? (i < 10 && (i = "0" + i), e + ":" + i + ":" + s) : i + ":" + s;
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.addVolumeSlider = function (e) {
      var i, s, a, n, r;
      i = this, s = this.mediaId + "-volume-slider", a = this.mediaId + "-volume-help", this.volumeTrackHeight = 50, this.volumeHeadHeight = 7, this.volumeTickHeight = this.volumeTrackHeight / 10, this.$volumeSlider = t("<div>", {
        id: s,
        class: "able-volume-slider",
        "aria-hidden": "true"
      }).hide(), this.$volumeSliderTooltip = t("<div>", {
        class: "able-tooltip",
        role: "tooltip"
      }).hide(), this.$volumeSliderTrack = t("<div>", {
        class: "able-volume-track"
      }), this.$volumeSliderTrackOn = t("<div>", {
        class: "able-volume-track able-volume-track-on"
      }), this.$volumeSliderHead = t("<div>", {
        class: "able-volume-head",
        role: "slider",
        "aria-orientation": "vertical",
        "aria-label": this.tt.volumeUpDown,
        "aria-valuemin": 0,
        "aria-valuemax": 10,
        "aria-valuenow": this.volume,
        tabindex: -1
      }), this.$volumeSliderTrack.append(this.$volumeSliderTrackOn, this.$volumeSliderHead), this.$volumeAlert = t("<div>", {
        class: "able-offscreen",
        "aria-live": "assertive",
        "aria-atomic": "true"
      }), r = parseInt(i.volume) / 10 * 100, this.$volumeHelp = t("<div>", {
        id: a,
        class: "able-volume-help"
      }).text(r + "%, " + this.tt.volumeHelp), this.$volumeButton.attr({
        "aria-describedby": a
      }), this.$volumeSlider.append(this.$volumeSliderTooltip, this.$volumeSliderTrack, this.$volumeAlert, this.$volumeHelp), e.append(this.$volumeSlider), this.refreshVolumeSlider(this.volume), this.$volumeSliderHead.on("mousedown", function (e) {
        e.preventDefault(), i.draggingVolume = !0, i.volumeHeadPositionTop = t(this).offset().top;
      }), this.$mediaContainer.on("mouseover", function (t) {
        "youtube" == i.player && (i.draggingVolume = !1);
      }), t(document).on("mouseup", function (t) {
        i.draggingVolume = !1;
      }), t(document).on("mousemove", function (t) {
        i.draggingVolume && (t.pageX, n = t.pageY, i.moveVolumeHead(n));
      }), this.$volumeSliderHead.on("keydown", function (t) {
        if (37 === t.which || 40 === t.which) i.handleVolume("down");else if (39 === t.which || 38 === t.which) i.handleVolume("up");else {
          if (27 !== t.which && 13 !== t.which) return;
          i.$volumeSlider.is(":visible") ? i.hideVolumePopup() : i.showVolumePopup();
        }
        t.preventDefault();
      });
    }, AblePlayer.prototype.refreshVolumeSlider = function (t) {
      var e, i, s, a, n;
      i = (e = t / 10 * 100) + "%", s = t * this.volumeTickHeight, n = (a = this.volumeTrackHeight - s) - this.volumeHeadHeight, this.$volumeSliderTrackOn.css({
        height: s + "px",
        top: a + "px"
      }), this.$volumeSliderHead.attr({
        "aria-valuenow": t,
        "aria-valuetext": i
      }), this.$volumeSliderHead.css({
        top: n + "px"
      }), this.$volumeAlert.text(e + "%");
    }, AblePlayer.prototype.refreshVolumeButton = function (t) {
      var e, i, s, a, n;
      e = this.getVolumeName(t), i = t / 10 * 100, s = this.tt.volume + " " + i + "%", "font" === this.iconType ? (a = "icon-volume-" + e, this.$volumeButton.find("span").first().removeClass().addClass(a), this.$volumeButton.find("span.able-clipped").text(s)) : (n = this.imgPath + "volume-" + e + ".png", this.$volumeButton.find("img").attr("src", n));
    }, AblePlayer.prototype.moveVolumeHead = function (t) {
      var e,
        i,
        s,
        a = this.volumeHeadPositionTop - t;
      if (Math.abs(a) > this.volumeTickHeight) {
        if ("up" == (e = a > 0 ? "up" : "down") && 10 == this.volume) return;
        if ("down" == e && 0 == this.volume) return;
        i = Math.round(Math.abs(a) / this.volumeTickHeight), "up" == e ? (s = this.volume + i) > 10 && (s = 10) : (s = this.volume - i) < 0 && (s = 0), this.setVolume(s), this.refreshVolumeSlider(s), this.refreshVolumeButton(s), this.volumeHeadPositionTop = t;
      }
    }, AblePlayer.prototype.handleVolume = function (t) {
      var e;
      void 0 !== t ? (t >= 49 && t <= 57 ? e = t - 48 : (e = this.getVolume(), "up" === t && e < 10 ? e += 1 : "down" === t && e > 0 && (e -= 1)), this.isMuted() && e > 0 ? this.setMute(!1) : 0 === e ? this.setMute(!0) : (this.setVolume(e), this.refreshVolumeSlider(e), this.refreshVolumeButton(e))) : this.$volumeSlider.is(":visible") ? this.hideVolumePopup() : this.showVolumePopup();
    }, AblePlayer.prototype.handleMute = function () {
      this.isMuted() ? this.setMute(!1) : this.setMute(!0);
    }, AblePlayer.prototype.showVolumePopup = function () {
      this.closePopups(), this.$tooltipDiv.hide(), this.$volumeSlider.show().attr("aria-hidden", "false"), this.$volumeButton.attr("aria-expanded", "true"), this.$volumeSliderHead.attr("tabindex", "0").focus();
    }, AblePlayer.prototype.hideVolumePopup = function () {
      this.$volumeSlider.hide().attr("aria-hidden", "true"), this.$volumeSliderHead.attr("tabindex", "-1"), this.$volumeButton.attr("aria-expanded", "false").focus();
    }, AblePlayer.prototype.isMuted = function () {
      return "html5" === this.player ? this.media.muted : "jw" === this.player && this.jwPlayer ? this.jwPlayer.getMute() : "youtube" === this.player ? this.youTubePlayer.isMuted() : void 0;
    }, AblePlayer.prototype.setMute = function (t) {
      t ? (this.lastVolume = this.volume, this.volume = 0) : void 0 !== this.lastVolume && (this.volume = this.lastVolume), "html5" === this.player ? this.media.muted = t : "jw" === this.player && this.jwPlayer ? this.jwPlayer.setMute(t) : "youtube" === this.player && (t ? this.youTubePlayer.mute() : this.youTubePlayer.unMute()), this.refreshVolumeSlider(this.volume), this.refreshVolumeButton(this.volume);
    }, AblePlayer.prototype.setVolume = function (t) {
      "html5" === this.player ? (this.media.volume = t / 10, this.hasSignLanguage && this.signVideo && (this.signVideo.volume = 0)) : "jw" === this.player && this.jwPlayer ? this.jwPlayer.setVolume(10 * t) : "youtube" === this.player && (this.youTubePlayer.setVolume(10 * t), this.volume = t), this.lastVolume = t;
    }, AblePlayer.prototype.getVolume = function (t) {
      return "html5" === this.player ? 10 * this.media.volume : "jw" === this.player && this.jwPlayer ? this.jwPlayer.getVolume() / 10 : "youtube" === this.player ? this.youTubePlayer.getVolume() / 10 : void 0;
    }, AblePlayer.prototype.getVolumeName = function (t) {
      return 0 == t ? "mute" : 10 == t ? "loud" : t < 5 ? "soft" : "medium";
    };
  }(_jquery.default), function (t) {
    var e = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
    window.AccessibleDialog = function (i, s, a, n, r, o, l, h, p) {
      this.title = n, this.closeButtonLabel = o, this.focusedElementBeforeModal = s, this.escapeHook = p, this.baseId = t(i).attr("id") || Math.floor(1e9 * Math.random()).toString();
      var c = this,
        d = i;
      if (this.modal = d, d.css({
        width: l || "50%",
        top: h ? "0" : "5%"
      }), d.addClass("able-modal-dialog"), !h) {
        var u = t("<button>", {
          class: "modalCloseButton",
          title: c.closeButtonLabel,
          "aria-label": c.closeButtonLabel
        }).text("X");
        u.keydown(function (t) {
          32 === t.which && c.hide();
        }).click(function () {
          c.hide();
        });
        var f = t("<h1></h1>");
        f.attr("id", "modalTitle-" + this.baseId), f.css("text-align", "center"), f.text(n), r.attr("id", "modalDesc-" + this.baseId), d.attr({
          "aria-labelledby": "modalTitle-" + this.baseId,
          "aria-describedby": "modalDesc-" + this.baseId
        }), d.prepend(f), d.prepend(u);
      }
      d.attr({
        "aria-hidden": "true",
        role: a
      }), d.keydown(function (i) {
        if (27 === i.which) c.escapeHook ? c.escapeHook(i, this) : (c.hide(), i.preventDefault());else if (9 === i.which) {
          var s = d.find("*").filter(e).filter(":visible");
          if (0 === s.length) return;
          var a = t(":focus"),
            n = s.index(a);
          i.shiftKey ? 0 === n && (s.get(s.length - 1).focus(), i.preventDefault()) : n === s.length - 1 && (s.get(0).focus(), i.preventDefault());
        }
        i.stopPropagation();
      }), t("body > *").not(".able-modal-overlay").not(".able-modal-dialog").attr("aria-hidden", "false");
    }, AccessibleDialog.prototype.show = function () {
      if (!this.overlay) {
        var i = t("<div></div>").attr({
          class: "able-modal-overlay",
          tabindex: "-1"
        });
        this.overlay = i, t("body").append(i), i.on("mousedown.accessibleModal", function (t) {
          t.preventDefault();
        });
      }
      t("body > *").not(".able-modal-overlay").not(".able-modal-dialog").attr("aria-hidden", "true"), this.overlay.css("display", "block"), this.modal.css("display", "block"), this.modal.attr({
        "aria-hidden": "false",
        tabindex: "-1"
      }), 0 === this.modal.find("*").filter(e).filter(":visible").length && this.focusedElementBeforeModal.blur();
      var s = this;
      setTimeout(function () {
        s.modal.focus();
      }, 300);
    }, AccessibleDialog.prototype.hide = function () {
      this.overlay && this.overlay.css("display", "none"), this.modal.css("display", "none"), this.modal.attr("aria-hidden", "true"), t("body > *").not(".able-modal-overlay").not(".able-modal-dialog").attr("aria-hidden", "false"), this.focusedElementBeforeModal.focus();
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.getNextHeadingLevel = function (e) {
      var i, s, a, n;
      return e.parents().each(function () {
        if (i = t(this).children(":header"), s = i.length) return a = i.eq(s - 1).prop("tagName"), !1;
      }), void 0 === a ? n = 1 : (n = parseInt(a[1]), (n += 1) > 6 && (n = 6)), n;
    }, AblePlayer.prototype.countProperties = function (t) {
      var e, i;
      for (i in e = 0, t) t.hasOwnProperty(i) && ++e;
      return e;
    }, AblePlayer.prototype.formatSecondsAsColonTime = function (t, e) {
      var i, s, a, n, r, o, l;
      if (e) if (2 === (n = t.toString().split(".")).length) {
        if ((r = n[1]).length < 3) for (o = 3 - r.length, l = 1; l <= o; l++) r += "0";
      } else r = "000";
      return i = Math.floor(t / 3600), s = Math.floor(t / 60) % 60, (a = Math.floor(t % 60)) < 10 && (a = "0" + a), i > 0 ? (s < 10 && (s = "0" + s), e ? i + ":" + s + ":" + a + "." + r : i + ":" + s + ":" + a) : e ? (i < 1 ? i = "00" : i < 10 && (i = "0" + i), s < 1 ? s = "00" : s < 10 && (s = "0" + s), i + ":" + s + ":" + a + "." + r) : s + ":" + a;
    }, AblePlayer.prototype.getSecondsFromColonTime = function (t) {
      var e;
      return 3 === (e = t.split(":")).length ? 3600 * parseInt(e[0]) + 60 * parseInt(e[1]) + parseFloat(e[2]) : 2 === e.length ? 60 * parseInt(e[0]) + parseFloat(e[1]) : 1 === e.length ? parseFloat(e[0]) : void 0;
    }, AblePlayer.prototype.capitalizeFirstLetter = function (t) {
      return t.charAt(0).toUpperCase() + t.slice(1);
    };
  }(_jquery.default), AblePlayer.prototype.initDescription = function () {
    this.refreshingDesc || (this.descFile = this.$sources.first().attr("data-desc-src"), void 0 !== this.descFile || this.youTubeDescId ? this.hasOpenDesc = !0 : this.hasOpenDesc = !1), this.prefDesc ? this.hasOpenDesc && this.hasClosedDesc ? (this.useDescFormat = this.prefDescFormat, this.descOn = !0) : this.hasOpenDesc ? (this.useDescFormat = "video", this.descOn = !0) : this.hasClosedDesc && (this.useDescFormat = "text", this.descOn = !0) : this.refreshingDesc ? (this.prevDescFormat = this.useDescFormat, this.useDescFormat = !1, this.descOn = !1) : this.useDescFormat = !1, this.descOn ? "video" === this.useDescFormat ? (this.usingAudioDescription() || this.swapDescription(), this.$descDiv.hide(), this.$descDiv.removeClass("able-clipped")) : "text" === this.useDescFormat && (this.$descDiv.show(), this.prefVisibleDesc ? this.$descDiv.removeClass("able-clipped") : this.$descDiv.addClass("able-clipped"), this.swappingSrc || this.showDescription(this.getElapsed())) : "video" === this.prevDescFormat ? this.usingAudioDescription() && this.swapDescription() : "text" === this.prevDescFormat && (this.$descDiv.hide(), this.$descDiv.removeClass("able-clipped")), this.refreshingDesc = !1;
  }, AblePlayer.prototype.usingAudioDescription = function () {
    return "youtube" === this.player ? this.activeYouTubeId === this.youTubeDescId : this.$sources.first().attr("data-desc-src") === this.$sources.first().attr("src");
  }, AblePlayer.prototype.swapDescription = function () {
    var t, e, i, s, a, n, r;
    if (t = this, this.swapTime = this.getElapsed(), this.descOn ? this.showAlert(this.tt.alertDescribedVersion) : this.showAlert(this.tt.alertNonDescribedVersion), "html5" === this.player) {
      if (this.usingAudioDescription()) {
        for (e = 0; e < this.$sources.length; e++) i = this.$sources[e].getAttribute("data-orig-src"), a = this.$sources[e].getAttribute("type"), i && this.$sources[e].setAttribute("src", i), "video/mp4" === a && (n = e);
        this.swappingSrc = !0;
      } else {
        for (e = 0; e < this.$sources.length; e++) i = this.$sources[e].getAttribute("src"), s = this.$sources[e].getAttribute("data-desc-src"), a = this.$sources[e].getAttribute("type"), s && (this.$sources[e].setAttribute("src", s), this.$sources[e].setAttribute("data-orig-src", i)), "video/mp4" === a && (n = e);
        this.swappingSrc = !0;
      }
      "html5" === this.player ? this.media.load() : "youtube" === this.player || "jw" === this.player && this.jwPlayer && (r = this.$sources[n].getAttribute("src"), this.jwPlayer.load({
        file: r
      }));
    } else "youtube" === this.player && (this.usingAudioDescription() ? (this.activeYouTubeId = this.youTubeId, this.showAlert(this.tt.alertNonDescribedVersion)) : (this.activeYouTubeId = this.youTubeDescId, this.showAlert(this.tt.alertDescribedVersion)), void 0 !== this.youTubePlayer && this.setupAltCaptions().then(function () {
      t.playing ? t.youTubePlayer.loadVideoById(t.activeYouTubeId, t.swapTime) : t.youTubePlayer.cueVideoById(t.activeYouTubeId, t.swapTime);
    }));
  }, AblePlayer.prototype.showDescription = function (t) {
    if (!this.swappingSrc) {
      var e,
        i,
        s,
        _a = function a(t) {
          var e = [];
          if ("string" === t.type) e.push(t.value);else for (var i = 0; i < t.children.length; i++) e.push(_a(t.children[i]));
          return e.join("");
        };
      for (s = this.selectedDescriptions ? this.selectedDescriptions.cues : this.descriptions.length >= 1 ? this.descriptions[0].cues : [], e = 0; e < s.length; e++) if (s[e].start <= t && s[e].end > t) {
        i = e;
        break;
      }
      void 0 !== i ? this.currentDescription !== i && (this.$status.removeAttr("aria-live"), this.$descDiv.html(_a(s[i].components)), this.prefDescPause && this.pauseMedia(), this.currentDescription = i) : (this.$descDiv.html(""), this.currentDescription = -1, this.$status.attr("aria-live", "polite"));
    }
  }, AblePlayer.prototype.getUserAgent = function () {
    this.userAgent = {}, this.userAgent.browser = {}, /Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent) ? (this.userAgent.browser.name = "Firefox", this.userAgent.browser.version = RegExp.$1) : /MSIE (\d+\.\d+);/.test(navigator.userAgent) || /Trident.*rv[ :]*(\d+\.\d+)/.test(navigator.userAgent) ? (this.userAgent.browser.name = "Internet Explorer", this.userAgent.browser.version = RegExp.$1) : /Edge[\/\s](\d+\.\d+)/.test(navigator.userAgent) ? (this.userAgent.browser.name = "Edge", this.userAgent.browser.version = RegExp.$1) : /OPR\/(\d+\.\d+)/i.test(navigator.userAgent) ? (this.userAgent.browser.name = "Opera", this.userAgent.browser.version = RegExp.$1) : /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) ? (this.userAgent.browser.name = "Chrome", /Chrome[\/\s](\d+\.\d+)/.test(navigator.userAgent) && (this.userAgent.browser.version = RegExp.$1)) : /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor) ? (this.userAgent.browser.name = "Safari", /Version[\/\s](\d+\.\d+)/.test(navigator.userAgent) && (this.userAgent.browser.version = RegExp.$1)) : (this.userAgent.browser.name = "Unknown", this.userAgent.browser.version = "Unknown"), -1 != window.navigator.userAgent.indexOf("Windows NT 6.2") ? this.userAgent.os = "Windows 8" : -1 != window.navigator.userAgent.indexOf("Windows NT 6.1") ? this.userAgent.os = "Windows 7" : -1 != window.navigator.userAgent.indexOf("Windows NT 6.0") ? this.userAgent.os = "Windows Vista" : -1 != window.navigator.userAgent.indexOf("Windows NT 5.1") ? this.userAgent.os = "Windows XP" : -1 != window.navigator.userAgent.indexOf("Windows NT 5.0") ? this.userAgent.os = "Windows 2000" : -1 != window.navigator.userAgent.indexOf("Mac") ? this.userAgent.os = "Mac/iOS" : -1 != window.navigator.userAgent.indexOf("X11") ? this.userAgent.os = "UNIX" : -1 != window.navigator.userAgent.indexOf("Linux") && (this.userAgent.os = "Linux"), this.debug && (console.log("User agent:" + navigator.userAgent), console.log("Vendor: " + navigator.vendor), console.log("Browser: " + this.userAgent.browser.name), console.log("Version: " + this.userAgent.browser.version), console.log("OS: " + this.userAgent.os));
  }, AblePlayer.prototype.isUserAgent = function (t) {
    var e = navigator.userAgent.toLowerCase();
    return this.debug && console.log("User agent: " + e), -1 !== e.indexOf(t.toLowerCase());
  }, AblePlayer.prototype.isIOS = function (t) {
    var e;
    return e = navigator.userAgent.toLowerCase(), !!/ipad|iphone|ipod/.exec(e) && (void 0 === t || -1 !== e.indexOf("os " + t));
  }, AblePlayer.prototype.browserSupportsVolume = function () {
    var t, e;
    return t = navigator.userAgent.toLowerCase(), !(e = /ipad|iphone|ipod|android|blackberry|windows ce|windows phone|webos|playbook/.exec(t)) || !("android" !== e[0] || !/firefox/.test(t));
  }, AblePlayer.prototype.nativeFullscreenSupported = function () {
    return "jw" !== this.player && (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
  }, function (t) {
    AblePlayer.prototype.seekTo = function (t) {
      var e;
      (this.seekFromTime = this.media.currentTime, this.seekToTime = t, this.seeking = !0, this.liveUpdatePending = !0, "html5" === this.player) ? (this.startTime = t, (e = this.media.seekable).length > 0 && this.startTime >= e.start(0) && this.startTime <= e.end(0) && (this.media.currentTime = this.startTime, this.hasSignLanguage && this.signVideo && (this.signVideo.currentTime = this.startTime))) : "jw" === this.player && this.jwPlayer ? (this.jwSeekPause = !0, this.jwPlayer.seek(t)) : "youtube" === this.player && (this.youTubePlayer.seekTo(t, !0), t > 0 && void 0 !== this.$posterImg && this.$posterImg.hide());
      this.refreshControls();
    }, AblePlayer.prototype.getDuration = function () {
      var t;
      return "html5" === this.player ? t = this.media.duration : "jw" === this.player && this.jwPlayer ? t = this.jwPlayer.getDuration() : "youtube" === this.player && this.youTubePlayer && (t = this.youTubePlayer.getDuration()), void 0 === t || isNaN(t) || -1 === t ? 0 : t;
    }, AblePlayer.prototype.getElapsed = function () {
      var t;
      if ("html5" === this.player) t = this.media.currentTime;else if ("jw" === this.player && this.jwPlayer) {
        if ("IDLE" === this.jwPlayer.getState()) return 0;
        t = this.jwPlayer.getPosition();
      } else "youtube" === this.player && this.youTubePlayer && (t = this.youTubePlayer.getCurrentTime());
      return void 0 === t || isNaN(t) || -1 === t ? 0 : t;
    }, AblePlayer.prototype.getPlayerState = function () {
      if (!this.swappingSrc) {
        if ("html5" === this.player) return this.media.paused ? 0 === this.getElapsed() ? "stopped" : this.media.ended ? "ended" : "paused" : 4 !== this.media.readyState ? "buffering" : "playing";
        if ("jw" === this.player && this.jwPlayer) {
          if ("PAUSED" === this.jwPlayer.getState() || "IDLE" === this.jwPlayer.getState() || void 0 === this.jwPlayer.getState()) return 0 === this.getElapsed() ? "stopped" : this.getElapsed() === this.getDuration() ? "ended" : "paused";
          if ("BUFFERING" === this.jwPlayer.getState()) return "buffering";
          if ("PLAYING" === this.jwPlayer.getState()) return "playing";
        } else if ("youtube" === this.player && this.youTubePlayer) {
          var t = this.youTubePlayer.getPlayerState();
          if (-1 === t || 5 === t) return "stopped";
          if (0 === t) return "ended";
          if (1 === t) return "playing";
          if (2 === t) return "paused";
          if (3 === t) return "buffering";
        }
      }
    }, AblePlayer.prototype.isPlaybackRateSupported = function () {
      return "html5" === this.player ? !!this.media.playbackRate : ("jw" !== this.player || !this.jwPlayer) && ("youtube" === this.player ? this.youTubePlayer.getAvailablePlaybackRates().length > 1 : void 0);
    }, AblePlayer.prototype.setPlaybackRate = function (t) {
      t = Math.max(.5, t), "html5" === this.player ? this.media.playbackRate = t : "youtube" === this.player && this.youTubePlayer.setPlaybackRate(t), this.hasSignLanguage && this.signVideo && (this.signVideo.playbackRate = t), this.$speed.text(this.tt.speed + ": " + t.toFixed(2).toString() + "x");
    }, AblePlayer.prototype.getPlaybackRate = function () {
      return "html5" === this.player ? this.media.playbackRate : "jw" === this.player && this.jwPlayer ? 1 : "youtube" === this.player ? this.youTubePlayer.getPlaybackRate() : void 0;
    }, AblePlayer.prototype.isPaused = function () {
      var t = this.getPlayerState();
      return "paused" === t || "stopped" === t || "ended" === t;
    }, AblePlayer.prototype.pauseMedia = function () {
      "html5" === this.player ? (this.media.pause(!0), this.hasSignLanguage && this.signVideo && this.signVideo.pause(!0)) : "jw" === this.player && this.jwPlayer ? this.jwPlayer.pause(!0) : "youtube" === this.player && this.youTubePlayer.pauseVideo();
    }, AblePlayer.prototype.playMedia = function () {
      var t = this;
      "html5" === this.player ? (this.media.play(!0), this.hasSignLanguage && this.signVideo && this.signVideo.play(!0)) : "jw" === this.player && this.jwPlayer ? this.jwPlayer.play(!0) : "youtube" === this.player && (this.youTubePlayer.playVideo(), void 0 !== this.$posterImg && this.$posterImg.hide(), this.stoppingYouTube = !1), this.startedPlaying = !0, this.hideControls && (this.hidingControls = !0, this.hideControlsTimeout = window.setTimeout(function () {
        t.fadeControls("out"), t.controlsHidden = !0, t.hidingControls = !1;
      }, 2e3));
    }, AblePlayer.prototype.fadeControls = function (t) {
      "out" == t ? (this.$controllerDiv.addClass("able-offscreen"), this.$statusBarDiv.addClass("able-offscreen"), this.playerBackground = this.$playerDiv.css("background-color"), this.$playerDiv.css("background-color", "black")) : "in" == t && (this.$controllerDiv.removeClass("able-offscreen"), this.$statusBarDiv.removeClass("able-offscreen"), void 0 !== this.playerBackground ? this.$playerDiv.css("background-color", this.playerBackground) : this.$playerDiv.css("background-color", ""));
    }, AblePlayer.prototype.refreshControls = function () {
      var e, i, s, a, n, r, o, l, h, p, c, d, u, f, g, v, m;
      e = this, this.swappingSrc || (i = this.getDuration(), s = this.getElapsed(), this.useChapterTimes && (this.chapterDuration = this.getChapterDuration(), this.chapterElapsed = this.getChapterElapsed()), !1 === this.useFixedSeekInterval && !1 === this.seekIntervalCalculated && i > 0 && this.setSeekInterval(), this.seekBar && (this.useChapterTimes ? (a = this.selectedChapters.cues.length - 1, this.selectedChapters.cues[a] == this.currentChapter && this.currentChapter.end !== i ? this.seekBar.setDuration(i - this.currentChapter.start) : this.seekBar.setDuration(this.chapterDuration)) : this.seekBar.setDuration(i), this.seekBar.tracking || (r = this.liveUpdatePending || this.seekBar.seekHead.is(t(document.activeElement)), this.liveUpdatePending = !1, this.useChapterTimes ? this.seekBar.setPosition(this.chapterElapsed, r) : this.seekBar.setPosition(s, r)), n = this.seekBar.tracking ? this.seekBar.lastTrackPosition : this.useChapterTimes ? this.chapterElapsed : s), this.useChapterTimes ? this.$durationContainer.text(" / " + this.formatSecondsAsColonTime(this.chapterDuration)) : this.$durationContainer.text(" / " + this.formatSecondsAsColonTime(i)), this.$elapsedTimeContainer.text(this.formatSecondsAsColonTime(n)), o = {
        stopped: this.tt.statusStopped,
        paused: this.tt.statusPaused,
        playing: this.tt.statusPlaying,
        buffering: this.tt.statusBuffering,
        ended: this.tt.statusEnd
      }, this.stoppingYouTube ? (this.$status.text() !== this.tt.statusStopped && this.$status.text(this.tt.statusStopped), this.$playpauseButton.find("span").first().hasClass("icon-pause") && ("font" === this.iconType ? (this.$playpauseButton.find("span").first().removeClass("icon-pause").addClass("icon-play"), this.$playpauseButton.find("span.able-clipped").text(this.tt.play)) : "svg" === this.iconType ? (m = this.getSvgData("play"), this.$playpauseButton.find("svg").attr("viewBox", m[0]), this.$playpauseButton.find("path").attr("d", m[1])) : this.$playpauseButton.find("img").attr("src", this.playButtonImg))) : void 0 !== this.$status && void 0 !== this.seekBar && (this.$status.text() === o[this.getPlayerState()] || this.seekBar.tracking ? (this.statusDebounceStart = null, clearTimeout(this.statusTimeout), this.statusTimeout = null) : (l = new Date().getTime(), this.statusDebounceStart ? l - this.statusDebounceStart > 250 && (this.$status.text(o[this.getPlayerState()]), this.statusDebounceStart = null, clearTimeout(this.statusTimeout), this.statusTimeout = null) : (this.statusDebounceStart = l, this.statusTimeout = setTimeout(function () {
        e.refreshControls();
      }, 300))), this.seekBar.tracking || this.stoppingYouTube || (this.isPaused() ? (this.$playpauseButton.attr("aria-label", this.tt.play), "font" === this.iconType ? (this.$playpauseButton.find("span").first().removeClass("icon-pause").addClass("icon-play"), this.$playpauseButton.find("span.able-clipped").text(this.tt.play)) : "svg" === this.iconType ? (m = this.getSvgData("play"), this.$playpauseButton.find("svg").attr("viewBox", m[0]), this.$playpauseButton.find("path").attr("d", m[1])) : this.$playpauseButton.find("img").attr("src", this.playButtonImg)) : (this.$playpauseButton.attr("aria-label", this.tt.pause), "font" === this.iconType ? (this.$playpauseButton.find("span").first().removeClass("icon-play").addClass("icon-pause"), this.$playpauseButton.find("span.able-clipped").text(this.tt.pause)) : "svg" === this.iconType ? (m = this.getSvgData("pause"), this.$playpauseButton.find("svg").attr("viewBox", m[0]), this.$playpauseButton.find("path").attr("d", m[1])) : this.$playpauseButton.find("img").attr("src", this.pauseButtonImg)))), this.seekBar && (h = 0, 40, c = (p = this.seekBar.wrapperDiv.parent().prev("div.able-left-controls")).next("div.able-right-controls"), p.children().each(function () {
        "BUTTON" == t(this).prop("tagName") && (h += t(this).width());
      }), c.children().each(function () {
        "BUTTON" == t(this).prop("tagName") && (h += t(this).width());
      }), d = this.isFullscreen() ? t(window).width() - h - 40 : this.$ableWrapper.width() - h - 40, Math.abs(d - this.seekBar.getWidth()) > 5 && this.seekBar.setWidth(d)), this.isFullscreen() || (300, v = this.$statusBarDiv.height(), this.$statusBarDiv.find("span.able-speed").height() > v + 5 ? (this.$statusBarDiv.find("span.able-speed").hide(), this.hidingSpeed = !0) : (this.hidingSpeed && (this.$statusBarDiv.find("span.able-speed").show(), this.hidingSpeed = !1), this.$statusBarDiv.width() < 300 ? (this.$statusBarDiv.find("span.able-speed").hide(), this.hidingSpeed = !0) : this.hidingSpeed && (this.$statusBarDiv.find("span.able-speed").show(), this.hidingSpeed = !1))), this.$descButton && (this.descOn ? (this.$descButton.removeClass("buttonOff").attr("aria-label", this.tt.turnOffDescriptions), this.$descButton.find("span.able-clipped").text(this.tt.turnOffDescriptions)) : (this.$descButton.addClass("buttonOff").attr("aria-label", this.tt.turnOnDescriptions), this.$descButton.find("span.able-clipped").text(this.tt.turnOnDescriptions))), this.$ccButton && (u = this.usingYouTubeCaptions ? this.ytCaptions.length : this.captions.length, this.captionsOn ? (this.$ccButton.removeClass("buttonOff"), 1 === u && (this.$ccButton.attr("aria-label", this.tt.hideCaptions), this.$ccButton.find("span.able-clipped").text(this.tt.hideCaptions))) : (this.$ccButton.addClass("buttonOff"), 1 === u && (this.$ccButton.attr("aria-label", this.tt.showCaptions), this.$ccButton.find("span.able-clipped").text(this.tt.showCaptions))), u > 1 && (this.$ccButton.attr({
        "aria-label": this.tt.captions,
        "aria-haspopup": "true",
        "aria-controls": this.mediaId + "-captions-menu",
        "aria-expanded": "false"
      }), this.$ccButton.find("span.able-clipped").text(this.tt.captions))), this.$chaptersButton && this.$chaptersButton.attr({
        "aria-label": this.tt.chapters,
        "aria-haspopup": "true",
        "aria-controls": this.mediaId + "-chapters-menu",
        "aria-expanded": "false"
      }), this.$fullscreenButton && (this.isFullscreen() ? (this.$fullscreenButton.attr("aria-label", this.tt.exitFullScreen), "font" === this.iconType ? (this.$fullscreenButton.find("span").first().removeClass("icon-fullscreen-expand").addClass("icon-fullscreen-collapse"), this.$fullscreenButton.find("span.able-clipped").text(this.tt.exitFullScreen)) : "svg" === this.iconType ? (m = this.getSvgData("fullscreen-collapse"), this.$fullscreenButton.find("svg").attr("viewBox", m[0]), this.$fullscreenButton.find("path").attr("d", m[1])) : this.$fullscreenButton.find("img").attr("src", this.fullscreenCollapseButtonImg)) : (this.$fullscreenButton.attr("aria-label", this.tt.enterFullScreen), "font" === this.iconType ? (this.$fullscreenButton.find("span").first().removeClass("icon-fullscreen-collapse").addClass("icon-fullscreen-expand"), this.$fullscreenButton.find("span.able-clipped").text(this.tt.enterFullScreen)) : "svg" === this.iconType ? (m = this.getSvgData("fullscreen-expand"), this.$fullscreenButton.find("svg").attr("viewBox", m[0]), this.$fullscreenButton.find("path").attr("d", m[1])) : this.$fullscreenButton.find("img").attr("src", this.fullscreenExpandButtonImg))), void 0 !== this.$bigPlayButton && (this.isPaused() && !this.seekBar.tracking ? (this.hideBigPlayButton || this.$bigPlayButton.show(), this.isFullscreen() ? (this.$bigPlayButton.width(t(window).width()), this.$bigPlayButton.height(t(window).height())) : (this.$bigPlayButton.width(this.$mediaContainer.width()), this.$bigPlayButton.height(this.$mediaContainer.height()))) : this.$bigPlayButton.hide()), this.transcriptType && (1 === this.prefAutoScrollTranscript ? (this.autoScrollTranscript = !0, this.$autoScrollTranscriptCheckbox.prop("checked", !0)) : (this.autoScrollTranscript = !1, this.$autoScrollTranscriptCheckbox.prop("checked", !1)), this.autoScrollTranscript && this.currentHighlight && (g = Math.floor(t(".able-transcript").scrollTop() + t(this.currentHighlight).position().top - t(".able-transcript").height() / 2 + t(this.currentHighlight).height() / 2)) !== Math.floor(t(".able-transcript").scrollTop()) && (this.scrollingTranscript = !0, t(".able-transcript").scrollTop(g))), "html5" === this.player ? this.media.buffered.length > 0 && (f = this.media.buffered.end(0), this.useChapterTimes ? (f > this.chapterDuration && (f = this.chapterDuration), this.seekBar && this.seekBar.setBuffered(f / this.chapterDuration)) : this.seekBar && this.seekBar.setBuffered(f / i)) : "jw" === this.player && this.jwPlayer ? this.seekBar && this.seekBar.setBuffered(this.jwPlayer.getBuffer() / 100) : "youtube" === this.player && this.seekBar && this.seekBar.setBuffered(this.youTubePlayer.getVideoLoadedFraction()));
    }, AblePlayer.prototype.getHiddenWidth = function (t) {
      var e = t.clone().appendTo("body"),
        i = e.outerWidth();
      return e.remove(), i;
    }, AblePlayer.prototype.handlePlay = function (t) {
      this.isPaused() ? this.playMedia() : this.pauseMedia(), this.refreshControls();
    }, AblePlayer.prototype.handleRestart = function () {
      this.seekTo(0), this.refreshControls();
    }, AblePlayer.prototype.handleRewind = function () {
      var t;
      t = this.getElapsed() - this.seekInterval, this.useChapterTimes ? t < this.currentChapter.start && (t = this.currentChapter.start) : t < 0 && (t = 0), this.seekTo(t);
    }, AblePlayer.prototype.handleFastForward = function () {
      var t, e, i, s;
      t = this.getElapsed(), e = this.getDuration(), s = this.chapters.length - 1, i = t + this.seekInterval, this.useChapterTimes ? this.chapters[s] == this.currentChapter ? (i > e || i > this.currentChapter.end || e % i < this.seekInterval) && (i = Math.min(e, this.currentChapter.end)) : i > this.currentChapter.end && (i = this.currentChapter.end) : i > e && (i = e), this.seekTo(i);
    }, AblePlayer.prototype.handleRateIncrease = function () {
      this.changeRate(1);
    }, AblePlayer.prototype.handleRateDecrease = function () {
      this.changeRate(-1);
    }, AblePlayer.prototype.changeRate = function (t) {
      if ("html5" === this.player) this.setPlaybackRate(this.getPlaybackRate() + .25 * t);else if ("youtube" === this.player) {
        var e = this.youTubePlayer.getAvailablePlaybackRates(),
          i = this.getPlaybackRate(),
          s = e.indexOf(i);
        -1 === s ? console.log("ERROR: Youtube returning unknown playback rate " + i.toString()) : (s += t) < e.length && s >= 0 && this.setPlaybackRate(e[s]);
      }
    }, AblePlayer.prototype.handleCaptionToggle = function () {
      var t;
      if (this.hidingPopup) return this.hidingPopup = !1, !1;
      if (1 === (t = this.captions.length ? this.captions : this.ytCaptions.length ? this.ytCaptions : []).length) {
        if (!0 === this.captionsOn) this.captionsOn = !1, this.prefCaptions = 0, this.updateCookie("prefCaptions"), this.usingYouTubeCaptions ? this.youTubePlayer.unloadModule(this.ytCaptionModule) : this.$captionsWrapper.hide();else {
          this.captionsOn = !0, this.prefCaptions = 1, this.updateCookie("prefCaptions"), this.usingYouTubeCaptions ? void 0 !== this.ytCaptionModule && this.youTubePlayer.loadModule(this.ytCaptionModule) : this.$captionsWrapper.show();
          for (var e = 0; e < t.length; e++) !0 === t[e].def && (this.selectedCaptions = t[e]);
          this.selectedCaptions = this.captions[0], this.descriptions.length >= 0 && (this.selectedDescriptions = this.descriptions[0]);
        }
        this.refreshControls();
      } else this.captionsPopup && this.captionsPopup.is(":visible") ? (this.captionsPopup.hide(), this.hidingPopup = !1, this.$ccButton.attr("aria-expanded", "false").focus()) : (this.closePopups(), this.captionsPopup && (this.captionsPopup.show(), this.$ccButton.attr("aria-expanded", "true"), this.captionsPopup.css("top", this.$ccButton.position().top - this.captionsPopup.outerHeight()), this.captionsPopup.css("left", this.$ccButton.position().left), this.captionsPopup.find("li").removeClass("able-focus"), this.captionsPopup.find("li").first().focus().addClass("able-focus")));
    }, AblePlayer.prototype.handleChapters = function () {
      if (this.hidingPopup) return this.hidingPopup = !1, !1;
      this.chaptersPopup.is(":visible") ? (this.chaptersPopup.hide(), this.hidingPopup = !1, this.$chaptersButton.attr("aria-expanded", "false").focus()) : (this.closePopups(), this.chaptersPopup.show(), this.$chaptersButton.attr("aria-expanded", "true"), this.chaptersPopup.css("top", this.$chaptersButton.position().top - this.chaptersPopup.outerHeight()), this.chaptersPopup.css("left", this.$chaptersButton.position().left), this.chaptersPopup.find("li").removeClass("able-focus"), this.chaptersPopup.find('li[aria-checked="true"]').length ? this.chaptersPopup.find('li[aria-checked="true"]').focus().addClass("able-focus") : this.chaptersPopup.find("li").first().addClass("able-focus").attr("aria-checked", "true").focus());
    }, AblePlayer.prototype.handleDescriptionToggle = function () {
      this.descOn = !this.descOn, this.prefDesc = +this.descOn, this.updateCookie("prefDesc"), this.refreshingDesc = !0, this.initDescription(), this.refreshControls();
    }, AblePlayer.prototype.handlePrefsClick = function (t) {
      var e, i;
      if (this.hidingPopup) return this.hidingPopup = !1, !1;
      this.prefsPopup.is(":visible") ? (this.prefsPopup.hide(), this.hidingPopup = !1, this.$prefsButton.attr("aria-expanded", "false").focus(), this.prefsPopup.find("li").removeClass("able-focus").attr("tabindex", "-1")) : (this.closePopups(), this.prefsPopup.show(), this.$prefsButton.attr("aria-expanded", "true"), e = this.$prefsButton.position(), i = this.$ableDiv.width() - 5 - this.prefsPopup.width(), this.prefsPopup.css("top", e.top - this.prefsPopup.outerHeight()), this.prefsPopup.css("left", i), this.prefsPopup.find("li").removeClass("able-focus").attr("tabindex", "0"), this.prefsPopup.find("li").first().focus().addClass("able-focus"));
    }, AblePlayer.prototype.handleHelpClick = function () {
      this.setFullscreen(!1), this.helpDialog.show();
    }, AblePlayer.prototype.handleTranscriptToggle = function () {
      this.$transcriptDiv.is(":visible") ? (this.$transcriptArea.hide(), this.$transcriptButton.addClass("buttonOff").attr("aria-label", this.tt.showTranscript), this.$transcriptButton.find("span.able-clipped").text(this.tt.showTranscript), this.prefTranscript = 0, this.$transcriptButton.focus().addClass("able-focus")) : (this.positionDraggableWindow("transcript"), this.$transcriptArea.show(), this.$transcriptButton.removeClass("buttonOff").attr("aria-label", this.tt.hideTranscript), this.$transcriptButton.find("span.able-clipped").text(this.tt.hideTranscript), this.prefTranscript = 1), this.updateCookie("prefTranscript");
    }, AblePlayer.prototype.handleSignToggle = function () {
      this.$signWindow.is(":visible") ? (this.$signWindow.hide(), this.$signButton.addClass("buttonOff").attr("aria-label", this.tt.showSign), this.$signButton.find("span.able-clipped").text(this.tt.showSign), this.prefSign = 0, this.$signButton.focus().addClass("able-focus")) : (this.positionDraggableWindow("sign"), this.$signWindow.show(), this.$signButton.removeClass("buttonOff").attr("aria-label", this.tt.hideSign), this.$signButton.find("span.able-clipped").text(this.tt.hideSign), this.prefSign = 1), this.updateCookie("prefSign");
    }, AblePlayer.prototype.isFullscreen = function () {
      return this.nativeFullscreenSupported() ? !!(document.fullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement || document.mozFullScreenElement || document.msFullscreenElement) : !!this.modalFullscreenActive;
    }, AblePlayer.prototype.setFullscreen = function (e) {
      if (this.isFullscreen() != e) {
        var i = this,
          s = this.$ableWrapper,
          a = s[0];
        if (this.nativeFullscreenSupported()) e ? (this.preFullScreenWidth = this.$ableWrapper.width(), this.preFullScreenHeight = this.$ableWrapper.height(), a.requestFullscreen ? a.requestFullscreen() : a.webkitRequestFullscreen ? a.webkitRequestFullscreen() : a.mozRequestFullScreen ? a.mozRequestFullScreen() : a.msRequestFullscreen && a.msRequestFullscreen()) : document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.webkitCancelFullScreen ? document.webkitCancelFullScreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen && document.msExitFullscreen(), t(document).on("webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange", function () {
          i.isFullscreen() || (i.restoringAfterFullScreen = !0, i.resizePlayer(i.preFullScreenWidth, i.preFullScreenHeight));
        });else {
          if (!this.fullscreenDialog) {
            var n = t("<div>"),
              r = t("<p>", {
                class: "able-screenreader-alert"
              }).text(this.tt.fullscreen);
            n.append(r), this.fullscreenDialog = new AccessibleDialog(n, this.$fullscreenButton, "dialog", "Fullscreen video player", r, this.tt.exitFullScreen, "100%", !0, function () {
              i.handleFullscreenToggle();
            }), t("body").append(n);
          }
          var o = this.isPaused();
          if (e) {
            this.modalFullscreenActive = !0, this.fullscreenDialog.show(), this.$modalFullscreenPlaceholder = t('<div class="placeholder">'), this.$modalFullscreenPlaceholder.insertAfter(s), s.appendTo(this.fullscreenDialog.modal), s === this.$ableColumnLeft && s.width("100%");
            var l = t(window).height() - this.$playerDiv.height();
            this.$descDiv.is(":hidden") || (l -= this.$descDiv.height()), this.resizePlayer(t(window).width(), l);
          } else this.modalFullscreenActive = !1, s === this.$ableColumnLeft && s.width("50%"), s.insertAfter(this.$modalFullscreenPlaceholder), this.$modalFullscreenPlaceholder.remove(), this.fullscreenDialog.hide(), this.resizePlayer(this.$ableWrapper.width(), this.$ableWrapper.height());
          !o && this.isPaused() && this.playMedia();
        }
        this.refreshControls();
      }
    }, AblePlayer.prototype.handleFullscreenToggle = function () {
      var t = this.isPaused();
      this.setFullscreen(!this.isFullscreen()), t ? this.pauseMedia() : t || this.playMedia();
    }, AblePlayer.prototype.handleTranscriptLockToggle = function (t) {
      this.autoScrollTranscript = t, this.prefAutoScrollTranscript = +t, this.updateCookie("prefAutoScrollTranscript"), this.refreshControls();
    }, AblePlayer.prototype.showTooltip = function (t) {
      t.is(":animated") ? t.stop(!0, !0).show().delay(4e3).fadeOut(1e3) : t.stop().show().delay(4e3).fadeOut(1e3);
    }, AblePlayer.prototype.showAlert = function (t, e) {
      var i, s, a, n;
      "transcript" === e ? (i = this.$transcriptAlert, s = this.$transcriptArea) : "sign" === e ? (i = this.$signAlert, s = this.$signWindow) : i = "screenreader" === e ? this.$srAlertBox : this.$alertBox, i.show(), i.text(t), "transcript" == e || "sign" === e ? (a = s.width() > i.width() ? s.width() / 2 - i.width() / 2 : 10, "sign" === e ? n = s.height() / 3 * 2 : "transcript" === e && (n = this.$transcriptToolbar.height() + 30), i.css({
        top: n + "px",
        left: a + "px"
      })) : "screenreader" !== e && i.css({
        left: this.$playerDiv.width() / 2 - i.width() / 2
      }), "screenreader" !== e && setTimeout(function () {
        i.fadeOut(300);
      }, 3e3);
    }, AblePlayer.prototype.showedAlert = function (t) {
      return "transcript" === t ? !!this.showedTranscriptAlert : "sign" === t && !!this.showedSignAlert;
    }, AblePlayer.prototype.resizePlayer = function (t, e) {
      var i, s, a;
      this.isFullscreen() ? (void 0 !== this.$vidcapContainer && (this.$ableWrapper.css({
        width: t + "px",
        "max-width": ""
      }), this.$vidcapContainer.css({
        height: e + "px",
        width: t
      }), this.$media.css({
        height: e + "px",
        width: t
      })), void 0 !== this.$transcriptArea && this.retrieveOffscreenWindow("transcript", t, e), void 0 !== this.$signWindow && this.retrieveOffscreenWindow("sign", t, e)) : this.restoringAfterFullScreen && (t = this.preFullScreenWidth, e = this.preFullScreenHeight, this.restoringAfterFullScreen = !1, this.$ableWrapper.css({
        "max-width": t + "px",
        width: ""
      }), void 0 !== this.$vidcapContainer && this.$vidcapContainer.css({
        height: "",
        width: ""
      }), this.$media.css({
        width: "100%",
        height: "auto"
      })), "youtube" === this.player && this.youTubePlayer ? this.youTubePlayer.setSize(t, e) : "jw" === this.player && this.jwPlayer && ("audio" === this.mediaType ? this.jwPlayer.resize(t, 0) : this.jwPlayer.resize(t, undefined)), void 0 !== this.$captionsDiv && (400, 1e3, i = parseInt(this.prefCaptionsSize, 10), a = (s = t > 1e3 ? 1.5 * i : t < 400 ? i / 1.5 : i) + 25, this.$captionsDiv.css("font-size", s + "%"), this.$captionsWrapper.css("line-height", a + "%")), this.refreshControls();
    }, AblePlayer.prototype.retrieveOffscreenWindow = function (t, e, i) {
      var s, a, n, r, o, l, h, p;
      "transcript" == t ? s = this.$transcriptArea : "sign" == t && (s = this.$signWindow), l = s.width(), p = s.height(), n = (a = s.position()).top, o = (r = a.left) + l, h = n + p, n < 0 && (n = 10, s.css("top", n)), r < 0 && (r = 10, s.css("left", r)), o > e && (r = e - 20 - l, s.css("left", r)), h > i && (n = i - 10 - p, s.css("top", n));
    }, AblePlayer.prototype.getHighestZIndex = function () {
      var e, i;
      return e = 0, t("body *").not(".able-modal-dialog,.able-modal-dialog *,.able-modal-overlay,.able-modal-overlay *,.able-sign-window,.able-transcript-area").each(function () {
        i = t(this).css("z-index"), Number.isInteger(+i) && parseInt(i) > e && (e = parseInt(i));
      }), e;
    }, AblePlayer.prototype.updateZIndex = function (t) {
      var e, i, s, a, n, r;
      if (e = 8e3, i = 7e3, this.getHighestZIndex(), void 0 === this.$transcriptArea || void 0 === this.$signWindow) return void 0 !== this.$transcriptArea ? (s = parseInt(this.$transcriptArea.css("z-index"))) > i && this.$transcriptArea.css("z-index", i) : void 0 !== this.$signWindow && (a = parseInt(this.$signWindow.css("z-index"))) > e && this.$signWindow.css("z-index", e), !1;
      if ((s = parseInt(this.$transcriptArea.css("z-index"))) === (a = parseInt(this.$signWindow.css("z-index")))) n = e, r = i;else if (s > a) {
        if ("transcript" === t) return !1;
        n = s, r = a;
      } else {
        if ("sign" === t) return !1;
        n = a, r = s;
      }
      "transcript" === t ? (this.$transcriptArea.css("z-index", n), this.$signWindow.css("z-index", r)) : "sign" === t && (this.$signWindow.css("z-index", n), this.$transcriptArea.css("z-index", r));
    }, AblePlayer.prototype.syncTrackLanguages = function (t, e) {
      var i, s, a, n, r;
      for (i = 0; i < this.captions.length; i++) this.captions[i].language === e && (s = this.captions[i]);
      for (i = 0; i < this.chapters.length; i++) this.chapters[i].language === e && (n = this.chapters[i]);
      for (i = 0; i < this.descriptions.length; i++) this.descriptions[i].language === e && (a = this.descriptions[i]);
      for (i = 0; i < this.meta.length; i++) this.meta[i].language === e && (r = this.meta[i]);
      this.transcriptLang = e, "init" === t || "captions" === t ? (this.captionLang = e, this.selectedCaptions = s, this.selectedChapters = n, this.selectedDescriptions = a, this.selectedMeta = r, this.transcriptCaptions = s, this.transcriptChapters = n, this.transcriptDescriptions = a, this.updateChaptersList()) : "transcript" === t && (this.transcriptCaptions = s, this.transcriptChapters = n, this.transcriptDescriptions = a), this.updateTranscript();
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.updateCaption = function (t) {
      this.usingYouTubeCaptions || void 0 === this.$captionsWrapper || (this.captionsOn ? (this.$captionsWrapper.show(), this.showCaptions(t || this.getElapsed())) : this.$captionsWrapper && (this.$captionsWrapper.hide(), this.prefCaptions = 0));
    }, AblePlayer.prototype.updateCaptionsMenu = function (t) {
      this.captionsPopup.find("li").attr("aria-checked", "false"), void 0 === t ? this.captionsPopup.find("li").last().attr("aria-checked", "true") : this.captionsPopup.find("li[lang=" + t + "]").attr("aria-checked", "true");
    }, AblePlayer.prototype.getCaptionClickFunction = function (t) {
      var e = this;
      return function () {
        e.selectedCaptions = t, e.captionLang = t.language, e.currentCaption = -1, e.usingYouTubeCaptions ? e.captionsOn ? void 0 !== e.ytCaptionModule && e.youTubePlayer.setOption(e.ytCaptionModule, "track", {
          languageCode: e.captionLang
        }) : (e.resettingYouTubeCaptions = !0, e.youTubePlayer.loadModule(e.ytCaptionModule)) : (e.syncTrackLanguages("captions", e.captionLang), this.swappingSrc || (e.updateCaption(), e.showDescription(e.getElapsed()))), e.captionsOn = !0, e.hidingPopup = !0, e.captionsPopup.hide(), setTimeout(function () {
          e.hidingPopup = !1;
        }, 100), e.updateCaptionsMenu(e.captionLang), e.$ccButton.focus(), e.prefCaptions = 1, e.updateCookie("prefCaptions"), e.refreshControls();
      };
    }, AblePlayer.prototype.getCaptionOffFunction = function () {
      var t = this;
      return function () {
        "youtube" == t.player && t.youTubePlayer.unloadModule(t.ytCaptionModule), t.captionsOn = !1, t.currentCaption = -1, t.hidingPopup = !0, t.captionsPopup.hide(), setTimeout(function () {
          t.hidingPopup = !1;
        }, 100), t.updateCaptionsMenu(), t.$ccButton.focus(), t.prefCaptions = 0, t.updateCookie("prefCaptions"), this.swappingSrc || (t.refreshControls(), t.updateCaption());
      };
    }, AblePlayer.prototype.showCaptions = function (t) {
      var e, i, s, a;
      for (a = this.selectedCaptions ? this.selectedCaptions.cues : this.captions.length >= 1 ? this.captions[0].cues : [], e = 0; e < a.length; e++) if (a[e].start <= t && a[e].end > t) {
        i = e;
        break;
      }
      void 0 !== i ? this.currentCaption !== i && (s = this.flattenCueForCaption(a[i]).replace("\n", "<br>"), this.$captionsDiv.html(s), this.currentCaption = i, 0 === s.length ? this.$captionsDiv.css("display", "none") : this.$captionsDiv.css("display", "inline-block")) : (this.$captionsDiv.html(""), this.currentCaption = -1);
    }, AblePlayer.prototype.flattenCueForCaption = function (t) {
      var e = [],
        _i = function i(t) {
          var e,
            s = [];
          if ("string" === t.type) s.push(t.value);else if ("v" === t.type) for (s.push("(" + t.value + ")"), e = 0; e < t.children.length; e++) s.push(_i(t.children[e]));else if ("i" === t.type) {
            for (s.push("<em>"), e = 0; e < t.children.length; e++) s.push(_i(t.children[e]));
            s.push("</em>");
          } else if ("b" === t.type) {
            for (s.push("<strong>"), e = 0; e < t.children.length; e++) s.push(_i(t.children[e]));
            s.push("</strong>");
          } else for (e = 0; e < t.children.length; e++) s.push(_i(t.children[e]));
          return s.join("");
        };
      if (void 0 !== t.components) for (var s = 0; s < t.components.children.length; s++) e.push(_i(t.components.children[s]));
      return e.join("");
    }, AblePlayer.prototype.getCaptionsOptions = function (t) {
      var e = [];
      switch (t) {
        case "prefCaptionsFont":
          e[0] = this.tt.serif, e[1] = this.tt.sans, e[3] = this.tt.cursive, e[4] = this.tt.fantasy, e[2] = this.tt.monospace;
          break;
        case "prefCaptionsColor":
        case "prefCaptionsBGColor":
          e[0] = ["white", this.tt.white], e[1] = ["yellow", this.tt.yellow], e[2] = ["green", this.tt.green], e[3] = ["cyan", this.tt.cyan], e[4] = ["blue", this.tt.blue], e[5] = ["magenta", this.tt.magenta], e[6] = ["red", this.tt.red], e[7] = ["black", this.tt.black];
          break;
        case "prefCaptionsSize":
          e[0] = "75%", e[1] = "100%", e[2] = "125%", e[3] = "150%", e[4] = "200%";
          break;
        case "prefCaptionsOpacity":
          e[0] = "0%", e[1] = "25%", e[2] = "50%", e[3] = "75%", e[4] = "100%";
          break;
        case "prefCaptionsStyle":
          e[0] = this.tt.captionsStylePopOn, e[1] = this.tt.captionsStyleRollUp;
          break;
        case "prefCaptionsPosition":
          e[0] = "overlay", e[1] = "below";
      }
      return e;
    }, AblePlayer.prototype.translatePrefs = function (t, e, i) {
      if ("youtube" == i && "size" === t) switch (e) {
        case "75%":
          return -1;
        case "100%":
          return 0;
        case "125%":
          return 1;
        case "150%":
          return 2;
        case "200%":
          return 3;
      }
      return !1;
    }, AblePlayer.prototype.stylizeCaptions = function (e, i) {
      var s, a, n, r;
      void 0 !== e && ("prefCaptionsPosition" == i ? this.positionCaptions() : void 0 !== i ? ("prefCaptionsFont" === i ? s = "font-family" : "prefCaptionsSize" === i ? s = "font-size" : "prefCaptionsColor" === i ? s = "color" : "prefCaptionsBGColor" === i ? s = "background-color" : "prefCaptionsOpacity" === i && (s = "opacity"), a = "prefCaptionsOpacity" === i ? parseFloat(t("#" + this.mediaId + "_" + i).val()) / 100 : t("#" + this.mediaId + "_" + i).val(), e.css(s, a)) : (n = parseFloat(this.prefCaptionsOpacity) / 100, e.css({
        "font-family": this.prefCaptionsFont,
        "font-size": this.prefCaptionsSize,
        color: this.prefCaptionsColor,
        "background-color": this.prefCaptionsBGColor,
        opacity: n
      }), e === this.$captionsDiv && void 0 !== this.$captionsWrapper && (r = parseInt(this.prefCaptionsSize, 10) + 25, this.$captionsWrapper.css("line-height", r + "%")), "below" === this.prefCaptionsPosition ? void 0 !== this.$captionsWrapper && this.$captionsWrapper.css({
        "background-color": this.prefCaptionsBGColor,
        opacity: "1"
      }) : "overlay" === this.prefCaptionsPosition && void 0 !== this.$captionsWrapper && this.$captionsWrapper.css({
        "background-color": "transparent",
        opacity: ""
      }), this.positionCaptions()));
    }, AblePlayer.prototype.positionCaptions = function (t) {
      void 0 === t && (t = this.prefCaptionsPosition), void 0 !== this.$captionsWrapper && ("below" == t ? (this.$captionsWrapper.removeClass("able-captions-overlay").addClass("able-captions-below"), this.$captionsWrapper.css({
        "background-color": this.prefCaptionsBGColor,
        opacity: "1"
      })) : (this.$captionsWrapper.removeClass("able-captions-below").addClass("able-captions-overlay"), this.$captionsWrapper.css({
        "background-color": "transparent",
        opacity: ""
      })));
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.populateChaptersDiv = function () {
      var e, i, s;
      t("#" + this.chaptersDivLocation) && (this.$chaptersDiv = t("#" + this.chaptersDivLocation), this.$chaptersDiv.addClass("able-chapters-div"), this.chaptersTitle && (e = "h" + this.getNextHeadingLevel(this.$chaptersDiv).toString(), i = this.mediaId + "-chapters-heading", s = t("<" + e + ">", {
        class: "able-chapters-heading",
        id: i
      }).text(this.chaptersTitle), this.$chaptersDiv.append(s)), this.$chaptersNav = t("<nav>"), this.chaptersTitle ? this.$chaptersNav.attr("aria-labelledby", i) : this.$chaptersNav.attr("aria-label", this.tt.chapters), this.$chaptersDiv.append(this.$chaptersNav), this.updateChaptersList());
    }, AblePlayer.prototype.updateChaptersList = function () {
      var e, i, s, a, n, r, o, l, h, p;
      if (e = this, !this.$chaptersNav) return !1;
      if (void 0 === this.useChapterTimes && ("chapter" === this.seekbarScope && this.selectedChapters.cues.length ? this.useChapterTimes = !0 : this.useChapterTimes = !1), (i = this.useChapterTimes ? this.selectedChapters.cues : this.chapters.length >= 1 ? this.chapters[0].cues : []).length > 0) {
        for (p = t("<ul>"), s = 0; s < i.length; s++) a = s, n = t("<li></li>"), l = function l(i) {
          return function () {
            e.seekTrigger = "chapter", h = t(this).closest("li"), p = t(this).closest("ul").find("li"), p.index(h), p.removeClass("able-current-chapter").attr("aria-selected", ""), h.addClass("able-current-chapter").attr("aria-selected", "true"), e.updateChapter(i), e.seekTo(i);
          };
        }, (r = t("<button>", {
          type: "button",
          val: a
        }).text(this.flattenCueForCaption(i[a]))).on("click", l(i[a].start)), r.on("focus", function () {
          t(this).closest("ul").find("li").removeClass("able-focus"), t(this).closest("li").addClass("able-focus");
        }), n.on("hover", function () {
          t(this).closest("ul").find("li").removeClass("able-focus"), t(this).addClass("able-focus");
        }), n.on("mouseleave", function () {
          t(this).removeClass("able-focus");
        }), r.on("blur", function () {
          t(this).closest("li").removeClass("able-focus");
        }), n.append(r), p.append(n), this.defaultChapter === i[a].id && (r.attr("aria-selected", "true").parent("li").addClass("able-current-chapter"), this.currentChapter = i[a], o = !0);
        o || (this.currentChapter = i[0], p.find("button").first().attr("aria-selected", "true").parent("li").addClass("able-current-chapter")), this.$chaptersNav.html(p);
      }
      return !1;
    }, AblePlayer.prototype.seekToChapter = function (t) {
      for (var e = 0; e < this.selectedChapters.cues.length;) {
        if (this.selectedChapters.cues[e].id == t) {
          this.seekTo(this.selectedChapters.cues[e].start), this.updateChapter(this.selectedChapters.cues[e].start);
          break;
        }
        e++;
      }
    }, AblePlayer.prototype.updateChapter = function (t) {
      if (void 0 !== this.selectedChapters) {
        var e, i, s;
        for (e = this.selectedChapters.cues, i = 0; i < e.length; i++) if (e[i].start <= t && e[i].end > t) {
          s = i;
          break;
        }
        void 0 !== s && this.currentChapter !== e[s] && (this.currentChapter = e[s], this.useChapterTimes && (this.chapterDuration = this.getChapterDuration(), this.seekIntervalCalculated = !1), void 0 !== this.$chaptersDiv && (this.$chaptersDiv.find("ul").find("li").removeClass("able-current-chapter").attr("aria-selected", ""), this.$chaptersDiv.find("ul").find("li").eq(s).addClass("able-current-chapter").attr("aria-selected", "true")));
      }
    }, AblePlayer.prototype.getChapterDuration = function () {
      var t, e, i;
      return void 0 === this.currentChapter ? 0 : (t = this.getDuration(), e = this.selectedChapters.cues.length - 1, this.selectedChapters.cues[e] == this.currentChapter && this.currentChapter.end !== t ? (i = t, this.currentChapter.end = t) : i = this.currentChapter.end, i - this.currentChapter.start);
    }, AblePlayer.prototype.getChapterElapsed = function () {
      if (void 0 === this.currentChapter) return 0;
      this.getDuration();
      var t = this.getElapsed();
      return t > this.currentChapter.start ? t - this.currentChapter.start : 0;
    }, AblePlayer.prototype.convertChapterTimeToVideoTime = function (t) {
      if (void 0 !== this.currentChapter) {
        var e = this.currentChapter.start + t;
        return e > this.currentChapter.end ? this.currentChapter.end : e;
      }
      return t;
    }, AblePlayer.prototype.getChapterClickFunction = function (t) {
      var e = this;
      return function () {
        e.seekTrigger = "chapter", e.seekTo(t), e.hidingPopup = !0, e.chaptersPopup.hide(), setTimeout(function () {
          e.hidingPopup = !1;
        }, 100), e.$chaptersButton.focus();
      };
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.updateMeta = function (t) {
      this.hasMeta && ("text" === this.metaType ? (this.$metaDiv.show(), this.showMeta(t || this.getElapsed())) : this.showMeta(t || this.getElapsed()));
    }, AblePlayer.prototype.showMeta = function (e) {
      var i, s, a, n, r, o, l, h, p;
      for (i = [], n = this.meta.length >= 1 ? this.meta : [], s = 0; s < n.length; s++) if (n[s].start <= e && n[s].end > e) {
        a = s;
        break;
      }
      if (void 0 !== a) {
        if (this.currentMeta !== a) {
          if ("text" === this.metaType) this.$metaDiv.html(this.flattenCueForMeta(n[a]).replace("\n", "<br>"));else if ("selector" === this.metaType) {
            for (r = this.flattenCueForMeta(n[a]).split("\n"), o = 0; o < r.length; o++) "pause" === (l = t.trim(r[o])).toLowerCase().trim() ? (this.hideBigPlayButton = !0, this.pauseMedia()) : "focus:" == l.toLowerCase().substring(0, 6) ? (p = l.substring(6).trim(), t(p).length && t(p).focus()) : t(l).length && (void 0 === (h = parseInt(t(l).attr("data-duration"))) || isNaN(h) ? t(l).show() : t(l).show().delay(h).fadeOut(), this.visibleSelectors.push(l), i.push(l));
            if (this.visibleSelectors && this.visibleSelectors.length && this.visibleSelectors.length !== i.length) for (o = this.visibleSelectors.length - 1; o >= 0; o--) -1 == t.inArray(this.visibleSelectors[o], i) && (t(this.visibleSelectors[o]).hide(), this.visibleSelectors.splice(o, 1));
          }
          this.currentMeta = a;
        }
      } else {
        if (void 0 !== this.$metaDiv && this.$metaDiv.html(""), this.visibleSelectors && this.visibleSelectors.length) {
          for (o = 0; o < this.visibleSelectors.length; o++) t(this.visibleSelectors[o]).hide();
          this.visibleSelectors = [];
        }
        this.currentMeta = -1;
      }
    }, AblePlayer.prototype.flattenCueForMeta = function (t) {
      for (var e = [], _i2 = function i(t) {
          var e,
            s = [];
          if ("string" === t.type) s.push(t.value);else if ("v" === t.type) for (s.push("[" + t.value + "]"), e = 0; e < t.children.length; e++) s.push(_i2(t.children[e]));else for (e = 0; e < t.children.length; e++) s.push(_i2(t.children[e]));
          return s.join("");
        }, s = 0; s < t.components.children.length; s++) e.push(_i2(t.components.children[s]));
      return e.join("");
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.injectTranscriptArea = function () {
      this.$transcriptArea = t("<div>", {
        class: "able-transcript-area",
        tabindex: "-1"
      }), this.$transcriptToolbar = t("<div>", {
        class: "able-window-toolbar able-" + this.toolbarIconColor + "-controls"
      }), this.$transcriptDiv = t("<div>", {
        class: "able-transcript"
      }), this.$autoScrollTranscriptCheckbox = t('<input id="autoscroll-transcript-checkbox" type="checkbox">'), this.$transcriptToolbar.append(t('<label for="autoscroll-transcript-checkbox">' + this.tt.autoScroll + ": </label>"), this.$autoScrollTranscriptCheckbox), this.$transcriptLanguageSelect = t('<select id="transcript-language-select">'), this.$unknownTranscriptOption = t('<option val="unknown">' + this.tt.unknown + "</option>"), this.$transcriptLanguageSelect.append(this.$unknownTranscriptOption), this.$transcriptLanguageSelect.prop("disabled", !0);
      var e = t('<div class="transcript-language-select-wrapper">');
      this.$transcriptLanguageSelectContainer = e, e.append(t('<label for="transcript-language-select">' + this.tt.language + ": </label>"), this.$transcriptLanguageSelect), this.$transcriptToolbar.append(e), this.$transcriptArea.append(this.$transcriptToolbar, this.$transcriptDiv), this.transcriptDivLocation ? t("#" + this.transcriptDivLocation).append(this.$transcriptArea) : this.$ableWrapper.append(this.$transcriptArea), this.transcriptDivLocation || (this.initDragDrop("transcript"), 1 === this.prefTranscript && this.positionDraggableWindow("transcript", this.getDefaultWidth("transcript"))), this.prefTranscript || this.transcriptDivLocation || this.$transcriptArea.hide();
    }, AblePlayer.prototype.addTranscriptAreaEvents = function () {
      var t = this;
      this.$autoScrollTranscriptCheckbox.click(function () {
        t.handleTranscriptLockToggle(t.$autoScrollTranscriptCheckbox.prop("checked"));
      }), this.$transcriptDiv.on("mousewheel DOMMouseScroll click scroll", function (e) {
        t.scrollingTranscript || (t.autoScrollTranscript = !1, t.refreshControls()), t.scrollingTranscript = !1;
      }), void 0 !== this.$transcriptLanguageSelect && (this.$transcriptLanguageSelect.on("click mousedown", function (t) {
        t.stopPropagation();
      }), this.$transcriptLanguageSelect.on("change", function () {
        var e = t.$transcriptLanguageSelect.val();
        t.syncTrackLanguages("transcript", e);
      }));
    }, AblePlayer.prototype.transcriptSrcHasRequiredParts = function () {
      return !!(t("#" + this.transcriptSrc).length && (this.$transcriptArea = t("#" + this.transcriptSrc), this.$transcriptArea.find(".able-window-toolbar").length && (this.$transcriptToolbar = this.$transcriptArea.find(".able-window-toolbar").eq(0), this.$transcriptArea.find(".able-transcript").length && (this.$transcriptDiv = this.$transcriptArea.find(".able-transcript").eq(0), this.$transcriptArea.find(".able-transcript-seekpoint").length)))) && (this.$transcriptSeekpoints = this.$transcriptArea.find(".able-transcript-seekpoint"), !0);
    }, AblePlayer.prototype.setupManualTranscript = function () {
      this.$autoScrollTranscriptCheckbox = t('<input id="autoscroll-transcript-checkbox" type="checkbox">'), this.$transcriptToolbar.append(t('<label for="autoscroll-transcript-checkbox">' + this.tt.autoScroll + ": </label>"), this.$autoScrollTranscriptCheckbox);
    }, AblePlayer.prototype.updateTranscript = function () {
      if (this.transcriptType) {
        if ("external" === this.transcriptType || "popup" === this.transcriptType) {
          var e, i, s;
          if (this.transcriptLang ? i = this.transcriptCaptions.cues : this.transcriptCaptions ? (this.transcriptLang = this.transcriptCaptions.language, i = this.transcriptCaptions.cues) : this.selectedCaptions && (this.transcriptLang = this.captionLang, i = this.selectedCaptions.cues), this.transcriptChapters) e = this.transcriptChapters.cues;else if (this.chapters.length > 0) {
            if (this.transcriptLang) for (var a = 0; a < this.chapters.length; a++) this.chapters[a].language === this.transcriptLang && (e = this.chapters[a].cues);
            void 0 === e && (e = this.chapters[0].cues || []);
          }
          if (this.transcriptDescriptions) s = this.transcriptDescriptions.cues;else if (this.descriptions.length > 0) {
            if (this.transcriptLang) for (a = 0; a < this.descriptions.length; a++) this.descriptions[a].language === this.transcriptLang && (s = this.descriptions[a].cues);
            s || (s = this.descriptions[0].cues || []);
          }
          var n = this.generateTranscript(e || [], i || [], s || []);
          this.$transcriptDiv.html(n), this.$transcriptLanguageSelect && (this.$transcriptLanguageSelect.find("option:selected").prop("selected", !1), this.$transcriptLanguageSelect.find("option[lang=" + this.transcriptLang + "]").prop("selected", !0));
        }
        var r = this;
        1 === this.prefTabbable && t(".able-transcript span.able-transcript-seekpoint").attr("tabindex", "0"), this.$transcriptArea.length > 0 && this.$transcriptArea.find("span.able-transcript-seekpoint").click(function (e) {
          r.seekTrigger = "transcript";
          var i = parseFloat(t(this).attr("data-start"));
          i += .01, r.seekingFromTranscript ? r.seekingFromTranscript = !1 : (r.seekingFromTranscript = !0, r.seekTo(i));
        });
      }
    }, AblePlayer.prototype.highlightTranscript = function (e) {
      if (this.transcriptType) {
        var i,
          s,
          a = this;
        e = parseFloat(e), this.$transcriptArea.find("span.able-transcript-caption").each(function () {
          if (i = parseFloat(t(this).attr("data-start")), s = parseFloat(t(this).attr("data-end")), e >= i && e <= s) return a.$transcriptArea.find(".able-highlight").removeClass("able-highlight"), t(this).addClass("able-highlight"), !1;
        }), a.currentHighlight = t(".able-highlight"), 0 === a.currentHighlight.length && (a.currentHighlight = null);
      }
    }, AblePlayer.prototype.generateTranscript = function (e, i, s) {
      var a,
        n = this,
        r = t('<div class="able-transcript-container"></div>');
      if (r.attr("lang", this.transcriptLang), a = void 0 !== this.transcriptTitle ? this.transcriptTitle : this.lyricsMode ? this.tt.lyricsTitle : this.tt.transcriptTitle, void 0 === this.transcriptDivLocation) {
        var o = this.playerHeadingLevel,
          l = (o += 1) + 1;
        if (o <= 6) var h = "h" + o.toString();else h = "div";
        var p = t("<" + h + ">");
        p.addClass("able-transcript-heading"), o > 6 && p.attr({
          role: "heading",
          "aria-level": o
        }), p.text(a), p.attr("lang", this.lang), r.append(p);
      }
      for (var c = 0, d = 0, u = 0, f = function f(e, i) {
          if (l <= 6) var s = "h" + l.toString();else s = "div";
          var a = t("<" + s + ">", {
            class: "able-transcript-chapter-heading"
          });
          l > 6 && a.attr({
            role: "heading",
            "aria-level": l
          });
          for (var _n = function n(t) {
              var e = [];
              if ("string" === t.type) e.push(t.value);else for (var i = 0; i < t.children.length; i++) e = e.concat(_n(t.children[i]));
              return e;
            }, r = t("<span>", {
              class: "able-transcript-seekpoint"
            }), o = 0; o < i.components.children.length; o++) for (var h = _n(i.components.children[o]), p = 0; p < h.length; p++) r.append(h[p]);
          r.attr("data-start", i.start.toString()), r.attr("data-end", i.end.toString()), a.append(r), e.append(a);
        }, g = function g(e, i) {
          var s = t("<div>", {
              class: "able-transcript-desc"
            }),
            a = t("<span>", {
              class: "able-hidden"
            });
          a.attr("lang", n.lang), a.text(n.tt.prefHeadingDescription + ": "), s.append(a);
          for (var _r = function r(t) {
              var e = [];
              if ("string" === t.type) e.push(t.value);else for (var i = 0; i < t.children.length; i++) e = e.concat(_r(t.children[i]));
              return e;
            }, o = t("<span>", {
              class: "able-transcript-seekpoint"
            }), l = 0; l < i.components.children.length; l++) for (var h = _r(i.components.children[l]), p = 0; p < h.length; p++) o.append(h[p]);
          o.attr("data-start", i.start.toString()), o.attr("data-end", i.end.toString()), s.append(o), e.append(s);
        }, v = function v(e, i) {
          for (var s = t("<span>", {
              class: "able-transcript-seekpoint able-transcript-caption"
            }), _a2 = function a(e) {
              var i = [],
                _s = function s(e) {
                  var i = [];
                  if ("" === e) return i;
                  var a = e.indexOf("["),
                    n = e.indexOf("]"),
                    r = e.indexOf("("),
                    o = e.indexOf(")"),
                    l = -1 !== a && -1 !== n,
                    h = -1 !== r && -1 !== o;
                  if (h && l && a < r || l) i = i.concat(_s(e.substring(0, a))), (p = t("<span>", {
                    class: "able-unspoken"
                  })).text(e.substring(a, n + 1)), i.push(p), i = i.concat(_s(e.substring(r, o + 1)));else if (h) {
                    var p;
                    i = i.concat(_s(e.substring(0, r))), (p = t("<span>", {
                      class: "able-unspoken"
                    })).text(e.substring(a, n + 1)), i.push(p), i = i.concat(_s(e.substring(o + 1)));
                  } else i.push(e);
                  return i;
                };
              if ("string" === e.type) i = i.concat(_s(e.value));else if ("v" === e.type) {
                var n = t("<span>", {
                  class: "able-unspoken"
                });
                n.text("(" + e.value + ")"), i.push(n);
                for (var r = 0; r < e.children.length; r++) for (var o = _a2(e.children[r]), l = 0; l < o.length; l++) i.push(o[l]);
              } else if ("b" === e.type || "i" === e.type) {
                if ("b" === e.type) var h = t("<strong>");else if ("i" === e.type) h = t("<em>");
                for (r = 0; r < e.children.length; r++) for (o = _a2(e.children[r]), l = 0; l < o.length; l++) h.append(o[l]);
                "b" !== e.type && "i" != e.type || i.push(h, " ");
              } else for (r = 0; r < e.children.length; r++) i = i.concat(_a2(e.children[r]));
              return i;
            }, r = 0; r < i.components.children.length; r++) for (var o = _a2(i.components.children[r]), l = 0; l < o.length; l++) {
            var h = o[l];
            "string" == typeof h && (n.lyricsMode ? h = h.replace("\n", "<br>") + "<br>" : h += " "), s.append(h);
          }
          s.attr("data-start", i.start.toString()), s.attr("data-end", i.end.toString()), e.append(s), e.append(" \n");
        }; c < e.length || u < s.length || d < i.length;) {
        if (c < e.length && u < s.length && d < i.length) var m = Math.min(e[c].start, s[u].start, i[d].start);else if (c < e.length && u < s.length) m = Math.min(e[c].start, s[u].start);else if (c < e.length && d < i.length) m = Math.min(e[c].start, i[d].start);else if (u < s.length && d < i.length) m = Math.min(s[u].start, i[d].start);else m = null;
        null !== m ? void 0 !== e[c] && e[c].start === m ? (f(r, e[c]), c += 1) : void 0 !== s[u] && s[u].start === m ? (g(r, s[u]), u += 1) : (v(r, i[d]), d += 1) : c < e.length ? (f(r, e[c]), c += 1) : u < s.length ? (g(r, s[u]), u += 1) : d < i.length && (v(r, i[d]), d += 1);
      }
      var b = r.children(),
        y = 0;
      return b.each(function () {
        t(this).hasClass("able-transcript-caption") ? (-1 === t(this).text().indexOf("[") && -1 === t(this).text().indexOf("(") || y > 0 && (r.find(".able-block-temp").removeClass("able-block-temp").wrapAll('<div class="able-transcript-block"></div>'), y = 0), t(this).addClass("able-block-temp"), y++) : y > 0 && (r.find(".able-block-temp").removeClass("able-block-temp").wrapAll('<div class="able-transcript-block"></div>'), y = 0);
      }), r;
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.showSearchResults = function () {
      var e = this;
      if (this.searchDiv && this.searchString && t("#" + this.SearchDiv)) {
        var i = this.searchFor(this.searchString);
        if (i.length > 0) {
          var s = t("<p>", {
              class: "able-search-results-summary"
            }),
            a = "Found <strong>" + i.length + "</strong> matching items. ";
          a += "Click the time associated with any item ", a += "to play the video from that point.", s.html(a);
          for (var n = t("<ul>"), r = 0; r < i.length; r++) {
            var o = t("<li>", {}),
              l = this.secondsToTime(i[r].start),
              h = t("<span>", {
                class: "able-search-results-time",
                "data-start": i[r].start,
                title: l.title,
                tabindex: "0"
              });
            h.text(l.value), h.click(function (i) {
              var s = parseFloat(t(this).attr("data-start"));
              s += .01, e.seeking = !0, e.seekTo(s);
            });
            var p = t("<span>", {
              class: "able-search-result-text"
            });
            p.html("..." + i[r].caption + "..."), o.append(h, p), n.append(o);
          }
          t("#" + this.searchDiv).append(s, n);
        } else {
          var c = t("<p>").text("No results found.");
          t("#" + this.searchDiv).append(c);
        }
      }
    }, AblePlayer.prototype.searchFor = function (e) {
      var i, s, a, n, r, o, l;
      a = [];
      var h = e.split(" ");
      if (this.captions.length > 0) {
        for (o = 0; o < this.captions.length; o++) this.captions[o].language === this.searchLang && (i = this.searchLang, s = this.captions[o].cues);
        if (s.length > 0) for (r = 0, o = 0; o < s.length; o++) if (-1 !== t.inArray(s[o].components.children[0].type, ["string", "i", "b", "u", "v", "c"])) for (n = this.flattenCueForCaption(s[o]), l = 0; l < h.length; l++) if (-1 !== n.indexOf(h[l])) {
          a[r] = [], a[r].start = s[o].start, a[r].lang = i, a[r].caption = this.highlightSearchTerm(h, l, n), r++;
          break;
        }
      }
      return a;
    }, AblePlayer.prototype.highlightSearchTerm = function (t, e, i) {
      var s, a, n, r, o, l, h;
      for (s = e; s < t.length; s++) a = t[s], -1 !== (n = i.indexOf(a)) && ((r = a.length) > 0 ? (o = i.substring(0, n), l = '<span class="able-search-term">' + a + "</span>", h = i.substring(n + r), i = o + l + h) : (o = '<span class="able-search-term">' + a + "</span>", l = i.substring(n + r), i = o + l));
      return i;
    }, AblePlayer.prototype.secondsToTime = function (t) {
      t = Math.floor(t);
      var e = parseInt(t / 3600, 10) % 24,
        i = parseInt(t / 60, 10) % 60,
        s = t % 60,
        a = "",
        n = "";
      e > 0 && (a += e + ":"), i < 10 ? (a += "0" + i + ":", i > 0 && (n += i + " minutes ")) : (a += i + ":", n += i + " minutes "), s < 10 ? (a += "0" + s, s > 0 && (n += s + " seconds ")) : (a += s, n += s + " seconds ");
      var r = [];
      return r.value = a, r.title = n, r;
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.onMediaUpdateTime = function () {
      var t = this.getElapsed();
      this.swappingSrc && void 0 !== this.swapTime ? this.swapTime === t && this.playing && (this.playMedia(), this.swappingSrc = !1, this.swapTime = null) : this.startedPlaying && (1 === this.prefHighlight && this.highlightTranscript(t), this.updateCaption(), this.showDescription(t), this.updateChapter(t), this.updateMeta(), this.refreshControls());
    }, AblePlayer.prototype.onMediaPause = function () {
      this.controlsHidden && (this.fadeControls("in"), this.controlsHidden = !1), this.hidingControls && (window.clearTimeout(this.hideControlsTimeout), this.hidingControls = !1);
    }, AblePlayer.prototype.onMediaComplete = function () {
      this.hasPlaylist && (this.playlistIndex === this.$playlist.length - 1 ? this.loop && (this.playlistIndex = 0, this.swapSource(0)) : (this.playlistIndex++, this.swapSource(this.playlistIndex))), this.refreshControls();
    }, AblePlayer.prototype.onMediaNewSourceLoad = function () {
      if (!0 === this.swappingSrc) if (this.swapTime > 0) this.seekTo(this.swapTime);else {
        if (this.playing) if ("jw" === this.player) {
          var t = this.jwPlayer;
          setTimeout(function () {
            t.play(!0);
          }, 500);
        } else this.playMedia();
        this.swappingSrc = !1, this.refreshControls();
      }
    }, AblePlayer.prototype.onWindowResize = function () {
      var e, i;
      this.isFullscreen() ? (e = t(window).width(), i = this.isUserAgent("Firefox") || this.isUserAgent("Trident") || this.isUserAgent("Edge") ? window.innerHeight - this.$playerDiv.outerHeight() - 20 : window.outerHeight >= window.innerHeight ? window.innerHeight - this.$playerDiv.outerHeight() : window.outerHeight, this.$descDiv.is(":hidden") || (i -= this.$descDiv.height()), this.positionCaptions("overlay")) : this.restoringAfterFullScreen ? (e = this.preFullScreenWidth, i = this.preFullScreenHeight) : (e = this.$ableWrapper.width(), i = void 0 !== this.aspectRatio ? Math.round(e / this.aspectRatio) : this.$ableWrapper.height(), this.positionCaptions());
      this.resizePlayer(e, i);
    }, AblePlayer.prototype.addSeekbarListeners = function () {
      var t = this;
      this.seekBar.bodyDiv.on("startTracking", function (e) {
        t.pausedBeforeTracking = t.isPaused(), t.pauseMedia();
      }).on("tracking", function (e, i) {
        t.highlightTranscript(i), t.updateCaption(i), t.showDescription(i), t.updateChapter(t.convertChapterTimeToVideoTime(i)), t.updateMeta(i), t.refreshControls();
      }).on("stopTracking", function (e, i) {
        t.useChapterTimes ? t.seekTo(t.convertChapterTimeToVideoTime(i)) : t.seekTo(i), t.pausedBeforeTracking || setTimeout(function () {
          t.playMedia();
        }, 200);
      });
    }, AblePlayer.prototype.onClickPlayerButton = function (e) {
      var i = t(e).attr("class").split(" ")[0].substr(20);
      "play" === i ? this.handlePlay() : "restart" === i ? (this.seekTrigger = "restart", this.handleRestart()) : "rewind" === i ? (this.seekTrigger = "rewind", this.handleRewind()) : "forward" === i ? (this.seekTrigger = "forward", this.handleFastForward()) : "mute" === i ? this.handleMute() : "volume" === i ? this.handleVolume() : "faster" === i ? this.handleRateIncrease() : "slower" === i ? this.handleRateDecrease() : "captions" === i ? this.handleCaptionToggle() : "chapters" === i ? this.handleChapters() : "descriptions" === i ? this.handleDescriptionToggle() : "sign" === i ? this.handleSignToggle() : "preferences" === i ? this.handlePrefsClick() : "help" === i ? this.handleHelpClick() : "transcript" === i ? this.handleTranscriptToggle() : "fullscreen" === i && this.handleFullscreenToggle();
    }, AblePlayer.prototype.okToHandleKeyPress = function () {
      var e = AblePlayer.getActiveDOMElement();
      return "INPUT" !== t(e).prop("tagName");
    }, AblePlayer.prototype.onPlayerKeyPress = function (e) {
      if (!this.okToHandleKeyPress()) return !1;
      var i = e.which;
      if (i >= 65 && i <= 90 && (i += 32), !(t(":focus").is("[contenteditable]") || t(":focus").is("input") || t(":focus").is("textarea") || t(":focus").is("select") || e.target.hasAttribute("contenteditable") || "INPUT" === e.target.tagName || "TEXTAREA" === e.target.tagName || "SELECT" === e.target.tagName)) if (27 === i) this.closePopups();else if (32 === i) 0 === this.$ableWrapper.find(".able-controller button:focus").length && this.handlePlay();else if (112 === i) this.usingModifierKeys(e) && this.handlePlay();else if (115 === i) this.usingModifierKeys(e) && this.handleRestart();else if (109 === i) this.usingModifierKeys(e) && this.handleMute();else if (118 === i) this.usingModifierKeys(e) && this.handleVolume();else if (i >= 49 && i <= 57) this.usingModifierKeys(e) && this.handleVolume(i);else if (99 === i) this.usingModifierKeys(e) && this.handleCaptionToggle();else if (100 === i) this.usingModifierKeys(e) && this.handleDescriptionToggle();else if (102 === i) this.usingModifierKeys(e) && this.handleFastForward();else if (114 === i) this.usingModifierKeys(e) && this.handleRewind();else if (101 === i) this.usingModifierKeys(e) && this.handlePrefsClick();else if (13 === i) {
        var s = t(document.activeElement);
        ("SPAN" === s.prop("tagName") || "LI" === s.prop("tagName")) && s.click();
      }
    }, AblePlayer.prototype.addHtml5MediaListeners = function () {
      var t = this;
      this.$media.on("emptied", function () {}).on("loadedmetadata", function () {
        t.onMediaNewSourceLoad();
      }).on("canplay", function () {}).on("canplaythrough", function () {
        "restart" == t.seekTrigger || "chapter" == t.seekTrigger || "transcript" == t.seekTrigger ? t.playMedia() : t.startedPlaying ? t.hasPlaylist && (t.playlistIndex !== t.$playlist.length - 1 || t.loop) && t.playMedia() : t.startTime ? t.seeking ? (t.seeking = !1, t.autoplay && t.playMedia()) : t.seekTo(t.startTime) : t.defaultChapter && void 0 !== t.selectedChapters ? t.seekToChapter(t.defaultChapter) : t.autoplay && t.playMedia();
      }).on("playing", function () {
        t.playing = !0, t.refreshControls();
      }).on("ended", function () {
        t.playing = !1, t.onMediaComplete();
      }).on("progress", function () {
        t.refreshControls();
      }).on("waiting", function () {
        t.refreshControls();
      }).on("durationchange", function () {
        t.refreshControls();
      }).on("timeupdate", function () {
        t.onMediaUpdateTime();
      }).on("play", function () {
        t.debug && console.log("media play event");
      }).on("pause", function () {
        t.clickedPlay ? t.playing = !1 : t.hasPlaylist || (t.playing = !1), t.clickedPlay = !1, t.onMediaPause();
      }).on("ratechange", function () {}).on("volumechange", function () {
        t.volume = t.getVolume(), t.debug && console.log("media volume change to " + t.volume + " (" + t.volumeButton + ")");
      }).on("error", function () {
        if (t.debug) switch (t.media.error.code) {
          case 1:
            console.log("HTML5 Media Error: MEDIA_ERR_ABORTED");
            break;
          case 2:
            console.log("HTML5 Media Error: MEDIA_ERR_NETWORK ");
            break;
          case 3:
            console.log("HTML5 Media Error: MEDIA_ERR_DECODE ");
            break;
          case 4:
            console.log("HTML5 Media Error: MEDIA_ERR_SRC_NOT_SUPPORTED ");
        }
      });
    }, AblePlayer.prototype.addJwMediaListeners = function () {
      var e = this;
      this.jwPlayer.onTime(function () {
        e.onMediaUpdateTime();
      }).onComplete(function () {
        e.onMediaComplete();
      }).onReady(function () {
        e.debug && console.log("JW Player onReady event fired"), t("#" + e.jwId).removeAttr("tabindex"), e.$fallbackWrapper = t("#" + e.mediaId + "_fallback_wrapper"), e.fallbackDefaultWidth = e.$fallbackWrapper.width(), e.fallbackDefaultHeight = e.$fallbackWrapper.height(), e.fallbackRatio = e.fallbackDefaultWidth / e.fallbackDefaultHeight, e.startTime > 0 && !e.startedPlaying && (e.seekTo(e.startTime), e.startedPlaying = !0), e.refreshControls();
      }).onSeek(function (t) {
        e.debug && console.log("Seeking to " + t.position + "; target: " + t.offset), e.jwSeekPause && (e.jwSeekPause = !1, e.playMedia()), setTimeout(function () {
          e.refreshControls();
        }, 300);
      }).onPlay(function () {
        e.debug && console.log("JW Player onPlay event fired"), e.refreshControls();
      }).onPause(function () {
        e.onMediaPause();
      }).onBuffer(function () {
        e.debug && console.log("JW Player onBuffer event fired"), e.refreshControls();
      }).onBufferChange(function () {
        e.refreshControls();
      }).onIdle(function (t) {
        e.debug && console.log("JW Player onIdle event fired"), e.refreshControls();
      }).onMeta(function () {
        e.debug && console.log("JW Player onMeta event fired");
      }).onPlaylist(function () {
        e.debug && console.log("JW Player onPlaylist event fired"), e.onMediaNewSourceLoad();
      });
    }, AblePlayer.prototype.addEventListeners = function () {
      var e;
      if (e = this, t(window).resize(function () {
        e.onWindowResize();
      }), window.MutationObserver) {
        var i = this.$ableDiv[0];
        new MutationObserver(function (t) {
          t.forEach(function (t) {
            "attributes" === t.type && "style" === t.attributeName && e.$ableDiv.is(":visible") && e.refreshControls();
          });
        }).observe(i, {
          attributes: !0,
          childList: !0,
          characterData: !0
        });
      }
      this.addSeekbarListeners(), this.$controllerDiv.find("button").on("click", function (t) {
        t.stopPropagation(), e.onClickPlayerButton(this);
      }), t(document).on("click", function (i) {
        if (0 !== i.button) return !1;
        (t(".able-popup:visible").length || t(".able-volume-popup:visible")) && e.closePopups();
      }), this.$ableDiv.on("mousemove", function () {
        e.controlsHidden && (e.fadeControls("in"), e.controlsHidden = !1, e.hidingControls = !0, e.hideControlsTimeout = window.setTimeout(function () {
          void 0 !== e.playing && !0 === e.playing && (e.fadeControls("out"), e.controlsHidden = !0, e.hidingControls = !1);
        }, 3e3));
      }), t(document).keydown(function () {
        e.controlsHidden && (e.fadeControls("in"), e.controlsHidden = !1);
      }), this.$ableDiv.keydown(function (t) {
        AblePlayer.nextIndex > 1 && e.onPlayerKeyPress(t);
      }), this.$transcriptArea && this.$transcriptArea.keydown(function (t) {
        AblePlayer.nextIndex > 1 && e.onPlayerKeyPress(t);
      }), this.$playlist && this.$playlist.click(function () {
        e.playlistIndex = t(this).index(), e.swapSource(e.playlistIndex);
      }), this.$media.click(function () {
        e.handlePlay();
      }), "html5" === this.player ? this.addHtml5MediaListeners() : "jw" === this.player ? this.addJwMediaListeners() : "youtube" === this.player && setInterval(function () {
        e.onMediaUpdateTime();
      }, 300);
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.initDragDrop = function (e) {
      var i, s, a, n, r, o;
      i = this, "transcript" === e ? (s = this.$transcriptArea, n = "transcript-window", a = this.$transcriptToolbar) : "sign" === e && (s = this.$signWindow, n = "sign-window", a = this.$signToolbar), a.addClass("able-draggable"), r = t("<div>", {
        class: "able-resizable"
      }), o = parseInt(s.css("z-index")) + 100, r.css("z-index", o), s.append(r), a.on("mousedown", function (t) {
        return t.stopPropagation(), i.windowMenuClickRegistered || (i.windowMenuClickRegistered = !0, i.startMouseX = t.pageX, i.startMouseY = t.pageY, i.dragDevice = "mouse", i.startDrag(e, s)), !1;
      }), a.on("mouseup", function (t) {
        return t.stopPropagation(), i.dragging && "mouse" === i.dragDevice && i.endDrag(e), !1;
      }), r.on("mousedown", function (t) {
        if (t.stopPropagation(), !i.windowMenuClickRegistered) return i.windowMenuClickRegistered = !0, i.startMouseX = t.pageX, i.startMouseY = t.pageY, i.startResize(e, s), !1;
      }), r.on("mouseup", function (t) {
        return t.stopPropagation(), i.resizing && i.endResize(e), !1;
      }), s.on("click", function () {
        i.windowMenuClickRegistered || i.finishingDrag || i.updateZIndex(e), i.finishingDrag = !1;
      }), this.addWindowMenu(e, s, n);
    }, AblePlayer.prototype.addWindowMenu = function (e, i, s) {
      var a, n, r, o, l, h, p, c, d, u, f;
      a = this, this.windowMenuClickRegistered = !1, this.finishingDrag = !1, (n = t('<div role="alert"></div>')).addClass("able-alert"), n.hide(), n.appendTo(this.$activeWindow), n.css({
        top: i.offset().top
      }), f = this.mediaId + "-" + s + "-menu", r = t("<button>", {
        type: "button",
        tabindex: "0",
        "aria-label": this.tt.windowButtonLabel,
        "aria-haspopup": "true",
        "aria-controls": f,
        class: "able-button-handler-preferences"
      }), "font" === this.iconType ? (o = t("<span>", {
        class: "icon-preferences",
        "aria-hidden": "true"
      }), r.append(o)) : (l = this.rootPath + "button-icons/" + this.toolbarIconColor + "/preferences.png", h = t("<img>", {
        src: l,
        alt: "",
        role: "presentation"
      }), r.append(h)), p = t("<span>", {
        class: "able-clipped"
      }).text(this.tt.windowButtonLabel), r.append(p), c = this.mediaId + "-" + s + "-tooltip", d = t("<div>", {
        class: "able-tooltip",
        id: c
      }).hide(), r.on("mouseenter focus", function (e) {
        var i = t(this).attr("aria-label"),
          s = t(this).position(),
          n = t(this).height(),
          o = (t(this).width(), {
            left: "",
            right: "0px",
            top: s.top - n - 5 + "px"
          }),
          l = AblePlayer.localGetElementById(r[0], c).text(i).css(o);
        a.showTooltip(l), t(this).on("mouseleave blur", function () {
          AblePlayer.localGetElementById(r[0], c).text("").hide();
        });
      }), u = this.setupPopups(s), "transcript" === e ? (this.$transcriptAlert = n, this.$transcriptPopupButton = r, this.$transcriptPopup = u, this.$transcriptToolbar.append(n, r, d, u)) : "sign" === e && (this.$signAlert = n, this.$signPopupButton = r, this.$signPopup = u, this.$signToolbar.append(n, r, d, u)), r.on("click mousedown keydown", function (t) {
        t.stopPropagation(), a.windowMenuClickRegistered || a.finishingDrag || a.handleWindowButtonClick(e, t), a.finishingDrag = !1;
      }), this.addResizeDialog(e, i);
    }, AblePlayer.prototype.addResizeDialog = function (e, i) {
      var s, a, n, r, o, l, h, p, c, d, u, f, g, v, m, b, y, w, P, k, C, $, T;
      s = this, "transcript" === e ? (a = this.$transcriptPopup, n = this.$transcriptPopupButton) : "sign" === e && (a = this.$signPopup, n = this.$signPopupButton), r = this.mediaId + "-resize-" + e + "-width", o = this.mediaId + "-resize-" + e + "-height", l = i.width(), h = i.height(), p = l / h, c = t("<div></div>", {
        class: "able-resize-form"
      }), d = t("<div></div>"), u = t("<div></div>"), f = t("<input>", {
        type: "text",
        id: r,
        value: l
      }), g = t("<label>", {
        for: r
      }).text(this.tt.width), v = t("<div></div>"), m = t("<input>", {
        type: "text",
        id: o,
        value: h
      }), b = t("<label>", {
        for: o
      }).text(this.tt.height), "sign" === e && (m.prop("readonly", !0), f.on("input", function () {
        y = t(this).val(), w = Math.round(y / p, 0), m.val(w);
      })), P = t('<button class="modal-button">' + this.tt.save + "</button>"), k = t('<button class="modal-button">' + this.tt.cancel + "</button>"), P.on("click", function () {
        C = t("#" + r).val(), $ = t("#" + o).val(), C === l && $ === h || (i.css({
          width: C + "px",
          height: $ + "px"
        }), s.updateCookie(e)), T.hide(), a.hide(), n.focus();
      }), k.on("click", function () {
        T.hide(), a.hide(), n.focus();
      }), u.append(g, f), v.append(b, m), d.append(u, v), c.append(d, "<hr>", P, k), t("body").append(c), T = new AccessibleDialog(c, n, "alert", this.tt.windowResizeHeading, d, this.tt.closeButtonLabel, "20em"), "transcript" === e ? this.transcriptResizeDialog = T : "sign" === e && (this.signResizeDialog = T);
    }, AblePlayer.prototype.handleWindowButtonClick = function (e, i) {
      var s, a, n, r;
      if (s = this, "transcript" === e ? (a = this.$transcriptPopup, n = this.$transcriptPopupButton, this.$transcriptToolbar) : "sign" === e && (a = this.$signPopup, n = this.$signPopupButton, this.$signToolbar), "keydown" === i.type) {
        if (32 === i.which || 13 === i.which) this.windowMenuClickRegistered = !0;else {
          if (27 !== i.which) return !1;
          a.hide("fast", function () {
            s.windowMenuClickRegistered = !1, a.find("li").removeClass("able-focus").attr("tabindex", "-1"), n.focus();
          });
        }
      } else this.windowMenuClickRegistered = !0;
      a.is(":visible") ? (a.hide(200, "", function () {
        s.windowMenuClickRegistered = !1;
      }), a.find("li").removeClass("able-focus"), n.attr("aria-expanded", "false").focus()) : (this.updateZIndex(e), r = n.position().top + n.outerHeight(), a.css("top", r), a.show(200, "", function () {
        n.attr("aria-expanded", "true"), t(this).find("li").first().focus().addClass("able-focus"), s.windowMenuClickRegistered = !1;
      }));
    }, AblePlayer.prototype.handleMenuChoice = function (t, e, i) {
      var s, a, n, r, o;
      if (s = this, "transcript" === t ? (a = this.$transcriptArea, n = this.$transcriptPopup, r = this.$transcriptPopupButton, o = this.transcriptResizeDialog) : "sign" === t && (a = this.$signWindow, n = this.$signPopup, r = this.$signPopupButton, o = this.signResizeDialog), "keydown" === i.type) return 27 === i.which && (n.hide("fast", function () {
        s.windowMenuClickRegistered = !1, n.find("li").removeClass("able-focus").attr("tabindex", "-1"), r.focus();
      }), !1);
      n.hide("fast", function () {
        s.windowMenuClickRegistered = !1, n.find("li").removeClass("able-focus").attr("tabindex", "-1");
      }), "close" !== e && r.focus(), "move" === e ? (this.showedAlert(t) || (this.showAlert(this.tt.windowMoveAlert, t), "transcript" === t ? this.showedTranscriptAlert = !0 : "sign" === t && (this.showedSignAlert = !0)), "keydown" === i.type ? this.dragDevice = "keyboard" : this.dragDevice = "mouse", this.startDrag(t, a), n.hide().parent().focus()) : "resize" == e ? o.show() : "close" == e && ("transcript" === t ? this.handleTranscriptToggle() : "sign" === t && this.handleSignToggle());
    }, AblePlayer.prototype.startDrag = function (e, i) {
      var s, a, n, r, o;
      return s = this, this.$activeWindow = i, this.dragging = !0, "transcript" === e ? a = this.$transcriptPopup : "sign" === e && (a = this.$signPopup), this.showedAlert(e) || (this.showAlert(this.tt.windowMoveAlert, e), "transcript" === e ? this.showedTranscriptAlert = !0 : "sign" === e && (this.showedSignAlert = !0)), a.is(":visible") && a.hide(), this.updateZIndex(e), n = this.$activeWindow.position(), this.dragStartX = n.left, this.dragStartY = n.top, void 0 === this.startMouseX ? (this.dragDevice = "keyboard", this.dragKeyX = this.dragStartX, this.dragKeyY = this.dragStartY, this.startingDrag = !0) : (this.dragDevice = "mouse", this.dragOffsetX = this.startMouseX - this.dragStartX, this.dragOffsetY = this.startMouseY - this.dragStartY), this.$activeWindow.addClass("able-drag").css({
        position: "absolute",
        top: this.dragStartY + "px",
        left: this.dragStartX + "px"
      }).focus(), "mouse" === this.dragDevice ? t(document).on("mousemove", function (t) {
        s.dragging && (r = t.pageX - s.dragOffsetX, o = t.pageY - s.dragOffsetY, s.resetDraggedObject(r, o));
      }) : "keyboard" === this.dragDevice && this.$activeWindow.on("keydown", function (t) {
        s.dragging && s.dragKeys(e, t);
      }), !1;
    }, AblePlayer.prototype.dragKeys = function (t, e) {
      if (this.startingDrag) return this.startingDrag = !1, !1;
      switch (10, e.which) {
        case 37:
        case 63234:
          this.dragKeyX -= 10;
          break;
        case 38:
        case 63232:
          this.dragKeyY -= 10;
          break;
        case 39:
        case 63235:
          this.dragKeyX += 10;
          break;
        case 40:
        case 63233:
          this.dragKeyY += 10;
          break;
        case 13:
        case 27:
          return this.endDrag(t), !1;
        default:
          return !1;
      }
      return this.resetDraggedObject(this.dragKeyX, this.dragKeyY), e.preventDefault && e.preventDefault(), !1;
    }, AblePlayer.prototype.resetDraggedObject = function (t, e) {
      this.$activeWindow.css({
        left: t + "px",
        top: e + "px"
      });
    }, AblePlayer.prototype.resizeObject = function (t, e, i) {
      var s;
      this.$activeWindow.css({
        width: e + "px",
        height: i + "px"
      }), "transcript" === t && (s = i - 50, this.$transcriptDiv.css("height", s + "px"));
    }, AblePlayer.prototype.endDrag = function (e) {
      var i;
      "transcript" === e ? (this.$transcriptPopup, i = this.$transcriptPopupButton) : "sign" === e && (this.$signPopup, i = this.$signPopupButton), t(document).off("mousemove mouseup"), this.$activeWindow.off("keydown").removeClass("able-drag"), "keyboard" === this.dragDevice && i.focus(), this.dragging = !1, this.updateCookie(e), this.startMouseX = void 0, this.startMouseY = void 0, this.windowMenuClickRegistered = !1, this.finishingDrag = !0, setTimeout(function () {
        this.finishingDrag = !1;
      }, 100);
    }, AblePlayer.prototype.isCloseToCorner = function (t, e, i) {
      var s, a, n, r, o, l;
      return 10, a = (s = t.offset()).top, n = s.left, r = t.width(), o = a + t.height(), l = n + r, Math.abs(o - i) <= 10 && Math.abs(l - e) <= 10;
    }, AblePlayer.prototype.startResize = function (e, i) {
      var s, a, n, r;
      return s = this, this.$activeWindow = i, this.resizing = !0, "transcript" === e ? a = this.$transcriptPopup : "sign" === e && (a = this.$signPopup), a.is(":visible") && a.hide().parent().focus(), this.$activeWindow.position(), this.dragKeyX = this.dragStartX, this.dragKeyY = this.dragStartY, this.dragStartWidth = this.$activeWindow.width(), this.dragStartHeight = this.$activeWindow.height(), t(document).on("mousemove", function (t) {
        s.resizing && (n = s.dragStartWidth + (t.pageX - s.startMouseX), r = s.dragStartHeight + (t.pageY - s.startMouseY), s.resizeObject(e, n, r));
      }), !1;
    }, AblePlayer.prototype.endResize = function (e) {
      var i;
      "transcript" === e ? (this.$transcriptPopup, i = this.$transcriptPopupButton) : "sign" === e && (this.$signPopup, i = this.$signPopupButton), t(document).off("mousemove mouseup"), this.$activeWindow.off("keydown"), i.show().focus(), this.resizing = !1, this.$activeWindow.removeClass("able-resize"), this.updateCookie(e), this.windowMenuClickRegistered = !1, this.finishingDrag = !0, setTimeout(function () {
        this.finishingDrag = !1;
      }, 100);
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.initSignLanguage = function () {
      "html5" === this.player && (this.signFile = this.$sources.first().attr("data-sign-src"), this.signFile ? (this.debug && console.log("This video has an accompanying sign language video: " + this.signFile), this.hasSignLanguage = !0, this.injectSignPlayerCode()) : this.hasSignLanguage = !1);
    }, AblePlayer.prototype.injectSignPlayerCode = function () {
      var e, i, s, a, n;
      for (this, this.getDefaultWidth("sign"), e = this.mediaId + "-sign", this.$signVideo = t("<video>", {
        id: e,
        tabindex: "-1"
      }), this.signVideo = this.$signVideo[0], i = 0; i < this.$sources.length; i++) {
        if (s = this.$sources[i].getAttribute("data-sign-src"), a = this.$sources[i].getAttribute("type"), !s) {
          this.hasSignLanguage = !1;
          break;
        }
        n = t("<source>", {
          src: s,
          type: a
        }), this.$signVideo.append(n);
      }
      this.$signWindow = t("<div>", {
        class: "able-sign-window",
        tabindex: "-1"
      }), this.$signToolbar = t("<div>", {
        class: "able-window-toolbar able-" + this.toolbarIconColor + "-controls"
      }), this.$signWindow.append(this.$signToolbar, this.$signVideo), this.$ableWrapper.append(this.$signWindow), this.initDragDrop("sign"), 1 === this.prefSign ? this.positionDraggableWindow("sign", this.getDefaultWidth("sign")) : this.$signWindow.hide();
    };
  }(_jquery.default), isoLangs = {
    ab: {
      name: "Abkhaz",
      nativeName: "аҧсуа"
    },
    aa: {
      name: "Afar",
      nativeName: "Afaraf"
    },
    af: {
      name: "Afrikaans",
      nativeName: "Afrikaans"
    },
    ak: {
      name: "Akan",
      nativeName: "Akan"
    },
    sq: {
      name: "Albanian",
      nativeName: "Shqip"
    },
    am: {
      name: "Amharic",
      nativeName: "አማርኛ"
    },
    ar: {
      name: "Arabic",
      nativeName: "العربية"
    },
    an: {
      name: "Aragonese",
      nativeName: "Aragonés"
    },
    hy: {
      name: "Armenian",
      nativeName: "Հայերեն"
    },
    as: {
      name: "Assamese",
      nativeName: "অসমীয়া"
    },
    av: {
      name: "Avaric",
      nativeName: "авар мацӀ, магӀарул мацӀ"
    },
    ae: {
      name: "Avestan",
      nativeName: "avesta"
    },
    ay: {
      name: "Aymara",
      nativeName: "aymar aru"
    },
    az: {
      name: "Azerbaijani",
      nativeName: "azərbaycan dili"
    },
    bm: {
      name: "Bambara",
      nativeName: "bamanankan"
    },
    ba: {
      name: "Bashkir",
      nativeName: "башҡорт теле"
    },
    eu: {
      name: "Basque",
      nativeName: "euskara, euskera"
    },
    be: {
      name: "Belarusian",
      nativeName: "Беларуская"
    },
    bn: {
      name: "Bengali",
      nativeName: "বাংলা"
    },
    bh: {
      name: "Bihari",
      nativeName: "भोजपुरी"
    },
    bi: {
      name: "Bislama",
      nativeName: "Bislama"
    },
    bs: {
      name: "Bosnian",
      nativeName: "bosanski jezik"
    },
    br: {
      name: "Breton",
      nativeName: "brezhoneg"
    },
    bg: {
      name: "Bulgarian",
      nativeName: "български език"
    },
    my: {
      name: "Burmese",
      nativeName: "ဗမာစာ"
    },
    ca: {
      name: "Catalan",
      nativeName: "Català"
    },
    ch: {
      name: "Chamorro",
      nativeName: "Chamoru"
    },
    ce: {
      name: "Chechen",
      nativeName: "нохчийн мотт"
    },
    ny: {
      name: "Chichewa",
      nativeName: "chiCheŵa, chinyanja"
    },
    zh: {
      name: "Chinese",
      nativeName: "中文 (Zhōngwén), 汉语, 漢語"
    },
    "zh-tw": {
      name: "Chinese Traditional (Taiwan)",
      nativeName: "中文（台灣）"
    },
    cv: {
      name: "Chuvash",
      nativeName: "чӑваш чӗлхи"
    },
    kw: {
      name: "Cornish",
      nativeName: "Kernewek"
    },
    co: {
      name: "Corsican",
      nativeName: "corsu, lingua corsa"
    },
    cr: {
      name: "Cree",
      nativeName: "ᓀᐦᐃᔭᐍᐏᐣ"
    },
    hr: {
      name: "Croatian",
      nativeName: "hrvatski"
    },
    cs: {
      name: "Czech",
      nativeName: "česky, čeština"
    },
    da: {
      name: "Danish",
      nativeName: "dansk"
    },
    dv: {
      name: "Divehi",
      nativeName: "ދިވެހި"
    },
    nl: {
      name: "Dutch",
      nativeName: "Nederlands, Vlaams"
    },
    en: {
      name: "English",
      nativeName: "English"
    },
    eo: {
      name: "Esperanto",
      nativeName: "Esperanto"
    },
    et: {
      name: "Estonian",
      nativeName: "eesti, eesti keel"
    },
    ee: {
      name: "Ewe",
      nativeName: "Eʋegbe"
    },
    fo: {
      name: "Faroese",
      nativeName: "føroyskt"
    },
    fj: {
      name: "Fijian",
      nativeName: "vosa Vakaviti"
    },
    fi: {
      name: "Finnish",
      nativeName: "suomi, suomen kieli"
    },
    fr: {
      name: "French",
      nativeName: "français, langue française"
    },
    ff: {
      name: "Fula",
      nativeName: "Fulfulde, Pulaar, Pular"
    },
    gl: {
      name: "Galician",
      nativeName: "Galego"
    },
    ka: {
      name: "Georgian",
      nativeName: "ქართული"
    },
    de: {
      name: "German",
      nativeName: "Deutsch"
    },
    el: {
      name: "Greek",
      nativeName: "Ελληνικά"
    },
    gn: {
      name: "Guaraní",
      nativeName: "Avañeẽ"
    },
    gu: {
      name: "Gujarati",
      nativeName: "ગુજરાતી"
    },
    ht: {
      name: "Haitian",
      nativeName: "Kreyòl ayisyen"
    },
    ha: {
      name: "Hausa",
      nativeName: "Hausa, هَوُسَ"
    },
    he: {
      name: "Hebrew",
      nativeName: "עברית"
    },
    hz: {
      name: "Herero",
      nativeName: "Otjiherero"
    },
    hi: {
      name: "Hindi",
      nativeName: "हिन्दी, हिंदी"
    },
    ho: {
      name: "Hiri Motu",
      nativeName: "Hiri Motu"
    },
    hu: {
      name: "Hungarian",
      nativeName: "Magyar"
    },
    ia: {
      name: "Interlingua",
      nativeName: "Interlingua"
    },
    id: {
      name: "Indonesian",
      nativeName: "Bahasa Indonesia"
    },
    ie: {
      name: "Interlingue",
      nativeName: "Originally called Occidental; then Interlingue after WWII"
    },
    ga: {
      name: "Irish",
      nativeName: "Gaeilge"
    },
    ig: {
      name: "Igbo",
      nativeName: "Asụsụ Igbo"
    },
    ik: {
      name: "Inupiaq",
      nativeName: "Iñupiaq, Iñupiatun"
    },
    io: {
      name: "Ido",
      nativeName: "Ido"
    },
    is: {
      name: "Icelandic",
      nativeName: "Íslenska"
    },
    it: {
      name: "Italian",
      nativeName: "Italiano"
    },
    iu: {
      name: "Inuktitut",
      nativeName: "ᐃᓄᒃᑎᑐᑦ"
    },
    ja: {
      name: "Japanese",
      nativeName: "日本語 (にほんご／にっぽんご)"
    },
    jv: {
      name: "Javanese",
      nativeName: "basa Jawa"
    },
    kl: {
      name: "Kalaallisut",
      nativeName: "kalaallisut, kalaallit oqaasii"
    },
    kn: {
      name: "Kannada",
      nativeName: "ಕನ್ನಡ"
    },
    kr: {
      name: "Kanuri",
      nativeName: "Kanuri"
    },
    ks: {
      name: "Kashmiri",
      nativeName: "कश्मीरी, كشميري‎"
    },
    kk: {
      name: "Kazakh",
      nativeName: "Қазақ тілі"
    },
    km: {
      name: "Khmer",
      nativeName: "ភាសាខ្មែរ"
    },
    ki: {
      name: "Kikuyu",
      nativeName: "Gĩkũyũ"
    },
    rw: {
      name: "Kinyarwanda",
      nativeName: "Ikinyarwanda"
    },
    ky: {
      name: "Kyrgyz",
      nativeName: "кыргыз тили"
    },
    kv: {
      name: "Komi",
      nativeName: "коми кыв"
    },
    kg: {
      name: "Kongo",
      nativeName: "KiKongo"
    },
    ko: {
      name: "Korean",
      nativeName: "한국어 (韓國語), 조선말 (朝鮮語)"
    },
    ku: {
      name: "Kurdish",
      nativeName: "Kurdî, كوردی‎"
    },
    kj: {
      name: "Kuanyama",
      nativeName: "Kuanyama"
    },
    la: {
      name: "Latin",
      nativeName: "latine, lingua latina"
    },
    lb: {
      name: "Luxembourgish",
      nativeName: "Lëtzebuergesch"
    },
    lg: {
      name: "Luganda",
      nativeName: "Luganda"
    },
    li: {
      name: "Limburgish",
      nativeName: "Limburgs"
    },
    ln: {
      name: "Lingala",
      nativeName: "Lingála"
    },
    lo: {
      name: "Lao",
      nativeName: "ພາສາລາວ"
    },
    lt: {
      name: "Lithuanian",
      nativeName: "lietuvių kalba"
    },
    lu: {
      name: "Luba-Katanga",
      nativeName: ""
    },
    lv: {
      name: "Latvian",
      nativeName: "latviešu valoda"
    },
    gv: {
      name: "Manx",
      nativeName: "Gaelg, Gailck"
    },
    mk: {
      name: "Macedonian",
      nativeName: "македонски јазик"
    },
    mg: {
      name: "Malagasy",
      nativeName: "Malagasy fiteny"
    },
    ms: {
      name: "Malay",
      nativeName: "bahasa Melayu, بهاس ملايو‎"
    },
    ml: {
      name: "Malayalam",
      nativeName: "മലയാളം"
    },
    mt: {
      name: "Maltese",
      nativeName: "Malti"
    },
    mi: {
      name: "Māori",
      nativeName: "te reo Māori"
    },
    mr: {
      name: "Marathi",
      nativeName: "मराठी"
    },
    mh: {
      name: "Marshallese",
      nativeName: "Kajin M̧ajeļ"
    },
    mn: {
      name: "Mongolian",
      nativeName: "монгол"
    },
    na: {
      name: "Nauru",
      nativeName: "Ekakairũ Naoero"
    },
    nv: {
      name: "Navajo",
      nativeName: "Diné bizaad, Dinékʼehǰí"
    },
    nb: {
      name: "Norwegian Bokmål",
      nativeName: "Norsk bokmål"
    },
    nd: {
      name: "North Ndebele",
      nativeName: "isiNdebele"
    },
    ne: {
      name: "Nepali",
      nativeName: "नेपाली"
    },
    ng: {
      name: "Ndonga",
      nativeName: "Owambo"
    },
    nn: {
      name: "Norwegian Nynorsk",
      nativeName: "Norsk nynorsk"
    },
    no: {
      name: "Norwegian",
      nativeName: "Norsk"
    },
    ii: {
      name: "Nuosu",
      nativeName: "ꆈꌠ꒿ Nuosuhxop"
    },
    nr: {
      name: "South Ndebele",
      nativeName: "isiNdebele"
    },
    oc: {
      name: "Occitan",
      nativeName: "Occitan"
    },
    oj: {
      name: "Ojibwe",
      nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ"
    },
    cu: {
      name: "Church Slavonic",
      nativeName: "ѩзыкъ словѣньскъ"
    },
    om: {
      name: "Oromo",
      nativeName: "Afaan Oromoo"
    },
    or: {
      name: "Oriya",
      nativeName: "ଓଡ଼ିଆ"
    },
    os: {
      name: "Ossetian",
      nativeName: "ирон æвзаг"
    },
    pa: {
      name: "Punjabi",
      nativeName: "ਪੰਜਾਬੀ, پنجابی‎"
    },
    pi: {
      name: "Pāli",
      nativeName: "पाऴि"
    },
    fa: {
      name: "Persian",
      nativeName: "فارسی"
    },
    pl: {
      name: "Polish",
      nativeName: "polski"
    },
    ps: {
      name: "Pashto",
      nativeName: "پښتو"
    },
    pt: {
      name: "Portuguese",
      nativeName: "Português"
    },
    qu: {
      name: "Quechua",
      nativeName: "Runa Simi, Kichwa"
    },
    rm: {
      name: "Romansh",
      nativeName: "rumantsch grischun"
    },
    rn: {
      name: "Kirundi",
      nativeName: "kiRundi"
    },
    ro: {
      name: "Romanian",
      nativeName: "română"
    },
    ru: {
      name: "Russian",
      nativeName: "русский язык"
    },
    sa: {
      name: "Sanskrit",
      nativeName: "संस्कृतम्"
    },
    sc: {
      name: "Sardinian",
      nativeName: "sardu"
    },
    sd: {
      name: "Sindhi",
      nativeName: "सिन्धी, سنڌي، سندھی‎"
    },
    se: {
      name: "Northern Sami",
      nativeName: "Davvisámegiella"
    },
    sm: {
      name: "Samoan",
      nativeName: "gagana faa Samoa"
    },
    sg: {
      name: "Sango",
      nativeName: "yângâ tî sängö"
    },
    sr: {
      name: "Serbian",
      nativeName: "српски језик"
    },
    gd: {
      name: "Gaelic",
      nativeName: "Gàidhlig"
    },
    sn: {
      name: "Shona",
      nativeName: "chiShona"
    },
    si: {
      name: "Sinhalese",
      nativeName: "සිංහල"
    },
    sk: {
      name: "Slovak",
      nativeName: "slovenčina"
    },
    sl: {
      name: "Slovene",
      nativeName: "slovenščina"
    },
    so: {
      name: "Somali",
      nativeName: "Soomaaliga, af Soomaali"
    },
    st: {
      name: "Southern Sotho",
      nativeName: "Sesotho"
    },
    es: {
      name: "Spanish",
      nativeName: "español, castellano"
    },
    su: {
      name: "Sundanese",
      nativeName: "Basa Sunda"
    },
    sw: {
      name: "Swahili",
      nativeName: "Kiswahili"
    },
    ss: {
      name: "Swati",
      nativeName: "SiSwati"
    },
    sv: {
      name: "Swedish",
      nativeName: "svenska"
    },
    ta: {
      name: "Tamil",
      nativeName: "தமிழ்"
    },
    te: {
      name: "Telugu",
      nativeName: "తెలుగు"
    },
    tg: {
      name: "Tajik",
      nativeName: "тоҷикӣ, toğikī, تاجیکی‎"
    },
    th: {
      name: "Thai",
      nativeName: "ไทย"
    },
    ti: {
      name: "Tigrinya",
      nativeName: "ትግርኛ"
    },
    bo: {
      name: "Tibetan",
      nativeName: "བོད་ཡིག"
    },
    tk: {
      name: "Turkmen",
      nativeName: "Türkmen, Түркмен"
    },
    tl: {
      name: "Tagalog",
      nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
    },
    tn: {
      name: "Tswana",
      nativeName: "Setswana"
    },
    to: {
      name: "Tonga",
      nativeName: "faka Tonga"
    },
    tr: {
      name: "Turkish",
      nativeName: "Türkçe"
    },
    ts: {
      name: "Tsonga",
      nativeName: "Xitsonga"
    },
    tt: {
      name: "Tatar",
      nativeName: "татарча, tatarça, تاتارچا‎"
    },
    tw: {
      name: "Twi",
      nativeName: "Twi"
    },
    ty: {
      name: "Tahitian",
      nativeName: "Reo Tahiti"
    },
    ug: {
      name: "Uyghur",
      nativeName: "Uyƣurqə, ئۇيغۇرچە‎"
    },
    uk: {
      name: "Ukrainian",
      nativeName: "українська"
    },
    ur: {
      name: "Urdu",
      nativeName: "اردو"
    },
    uz: {
      name: "Uzbek",
      nativeName: "zbek, Ўзбек, أۇزبېك‎"
    },
    ve: {
      name: "Venda",
      nativeName: "Tshivenḓa"
    },
    vi: {
      name: "Vietnamese",
      nativeName: "Tiếng Việt"
    },
    vo: {
      name: "Volapük",
      nativeName: "Volapük"
    },
    wa: {
      name: "Walloon",
      nativeName: "Walon"
    },
    cy: {
      name: "Welsh",
      nativeName: "Cymraeg"
    },
    wo: {
      name: "Wolof",
      nativeName: "Wollof"
    },
    fy: {
      name: "Western Frisian",
      nativeName: "Frysk"
    },
    xh: {
      name: "Xhosa",
      nativeName: "isiXhosa"
    },
    yi: {
      name: "Yiddish",
      nativeName: "ייִדיש"
    },
    yo: {
      name: "Yoruba",
      nativeName: "Yorùbá"
    },
    za: {
      name: "Zhuang",
      nativeName: "Saɯ cueŋƅ, Saw cuengh"
    }
  }, AblePlayer.prototype.getLanguageName = function (t) {
    t = t.slice(0, 2);
    var e = isoLangs[t];
    return e ? e.name : void 0;
  }, AblePlayer.prototype.getLanguageNativeName = function (t) {
    t = t.slice(0, 2);
    var e = isoLangs[t];
    return e ? e.nativeName : void 0;
  }, function ($) {
    AblePlayer.prototype.getSupportedLangs = function () {
      return ["ca", "de", "en", "es", "fr", "he", "it", "ja", "nb", "zh-tw"];
    }, AblePlayer.prototype.getTranslationText = function () {
      var deferred, thisObj, lang, thisObj, msg, translationFile;
      return deferred = $.Deferred(), thisObj = this, lang = $("body").attr("lang") ? $("body").attr("lang") : $("html").attr("lang") ? $("html").attr("lang") : null, this.forceLang || lang && lang !== this.lang && (msg = "Language of web page (" + lang + ") ", -1 !== $.inArray(lang, this.getSupportedLangs()) ? (msg += " has a translation table available.", this.lang = lang) : msg += " is not currently supported. Using default language (" + this.lang + ")", this.debug && console.log(msg)), this.searchLang || (this.searchLang = this.lang), translationFile = this.rootPath + "translations/" + this.lang + ".js", this.importTranslationFile(translationFile).then(function (result) {
        thisObj.tt = eval(thisObj.lang), deferred.resolve();
      }), deferred.promise();
    }, AblePlayer.prototype.importTranslationFile = function (t) {
      var e = $.Deferred();
      return $.getScript(t).done(function (t, i) {
        e.resolve(t);
      }).fail(function (t, i, s) {
        e.fail();
      }), e.promise();
    };
  }(_jquery.default), AblePlayer.prototype.computeEndTime = function (t, e) {
    var i = t.split(":").reverse().map(function (t) {
        return parseFloat(t);
      }),
      s = e.split(":").reverse().map(function (t) {
        return parseFloat(t);
      });
    return i.reduce(function (t, e, i) {
      var a = e + s[i];
      return 0 === i && (a > 60 && (s[i + 1] += 1, a -= 60), a = a.toFixed(3)), 1 === i && a > 60 && (s[i + 1] += 1, a -= 60), a < 10 && (a = "0" + a), t.push(a), t;
    }, []).reverse().join(":");
  }, AblePlayer.prototype.ttml2webvtt = function (t) {
    var e = this,
      i = e.convert.xml2json(t, {
        ignoreComment: !0,
        alwaysChildren: !0,
        compact: !0,
        spaces: 2
      });
    return JSON.parse(i).tt.body.div.p.reduce(function (t, i, s) {
      var a = i._text,
        n = Array.isArray(a),
        r = i._attributes;
      return e.computeEndTime(r.begin, r.dur), t + (e.computeEndTime(r.begin, "00:00:0") + " --\x3e ") + e.computeEndTime(r.begin, r.dur) + "\n" + (n ? a.join("\n") : a) + "\n\n";
    }, "WEBVTT\n\n\n");
  }, function (t) {
    t.doWhen = function (e) {
      return t.Deferred(function (i) {
        var s = t.extend({}, {
            when: null,
            exec: function exec() {},
            interval: 100,
            attempts: 100,
            delayed: 0
          }, e, {
            checkId: null
          }),
          a = function a() {
            if (!0 === s.when()) return s.exec.call(i.promise()), void i.resolve();
            s.checkId = setInterval(function () {
              0 === s.attempts ? (clearInterval(s.checkId), i.reject()) : (--s.attempts, !0 === s.when() && (s.attempts = 0, clearInterval(s.checkId), s.exec.call(i.promise()), i.resolve()));
            }, s.interval);
          };
        s.delayed > 0 ? setTimeout(a, Number(s.delayed)) : a();
      }).promise();
    };
  }(_jquery.default), function (t) {
    AblePlayer.prototype.injectVTS = function () {
      var e, i, s, a, n, r, o, l, h, p, c, d, u, f, g, v, m;
      if (e = this, t("#able-vts").length && this.vtsTracks.length) {
        for (k in this.langs = [], this.getAllLangs(this.vtsTracks), this.vtsLang = this.lang, i = t("<h2>").text("Video Transcript Sorter"), t("#able-vts").append(i), this.$vtsAlert = t("<div>", {
          id: "able-vts-alert",
          "aria-live": "polite",
          "aria-atomic": "true"
        }), t("#able-vts").append(this.$vtsAlert), s = t("<div>", {
          id: "able-vts-instructions"
        }), a = t("<p>").text("Use the Video Transcript Sorter to perform any of the following tasks:"), r = t("<ul>"), o = t("<li>").text("Reorder chapters, descriptions, captions, and/or subtitles so they appear in the proper sequence in Able Player's auto-generated transcript."), l = t("<li>").text("Modify content or start/end times (all are directly editable within the table)."), h = t("<li>").text("Insert new content, such as chapters or descriptions."), n = t("<p>").text('When finished editing, click the "Save Changes" button. This will auto-generate new content for all relevant timed text files (chapters, descriptions, captions, and/or subtitles), which can be copied and pasted into separate WebVTT files for use by Able Player.'), r.append(o, l, h), s.append(a, r, n), t("#able-vts").append(s), p = t("<fieldset>"), c = t("<legend>").text("Select a language"), p.append(c), this.langs) u = "vts-lang-radio-" + this.langs[k], d = t("<div>", {}), g = t("<input>", {
          type: "radio",
          name: "vts-lang",
          id: u,
          value: this.langs[k]
        }).on("click", function () {
          e.vtsLang = t(this).val(), e.showVtsAlert("Loading " + e.getLanguageName(e.vtsLang) + " tracks"), e.injectVtsTable("update", e.vtsLang);
        }), this.langs[k] == this.lang && g.prop("checked", !0), f = t("<label>", {
          for: u
        }).text(this.getLanguageName(this.langs[k])), d.append(g, f), p.append(d);
        var b, y, w, P, k;
        t("#able-vts").append(p), v = t("<button>", {
          type: "button",
          id: "able-vts-save",
          value: "save"
        }).text("Save Changes"), t("#able-vts").append(v), this.injectVtsTable("add", this.vtsLang), b = ["captions", "chapters", "descriptions", "subtitles"], t('td[contenteditable="true"]').on("focus", function () {
          y = t(this).text();
        }).on("blur", function () {
          y != t(this).text() && (w = t(this).index(), P = t(this).text(), 1 === w ? -1 === t.inArray(P, b) && ("s" === P.substr(0, 1) ? t(this).text("subtitles") : "d" === P.substr(0, 1) ? t(this).text("descriptions") : "ch" === P.substr(0, 2) ? t(this).text("chapters") : t(this).text("captions")) : 2 !== w && 3 !== w || t(this).text(e.formatTimestamp(P)));
        }).on("keydown", function (t) {
          t.stopPropagation();
        }), t("#able-vts-save").on("click", function (i) {
          i.stopPropagation(), "save" == t(this).attr("value") ? (t(this).attr("value", "cancel").text("Return to Editor"), m = t("#able-vts table"), t("#able-vts-instructions").hide(), t("#able-vts > fieldset").hide(), t("#able-vts table").remove(), t("#able-vts-icon-credit").remove(), e.parseVtsOutput(m)) : (t(this).attr("value", "save").text("Save Changes"), t("#able-vts-output").remove(), t("#able-vts-instructions").show(), t("#able-vts > fieldset").show(), t("#able-vts").append(m), t("#able-vts").append(e.getIconCredit()), e.showVtsAlert("Cancelling saving. Any edits you made have been restored in the VTS table."));
        });
      }
    }, AblePlayer.prototype.setupVtsTracks = function (t, e, i, s, a) {
      var n, r;
      n = this.getFilenameFromPath(s), r = this.parseVtsTracks(a), this.vtsTracks.push({
        kind: t,
        language: e,
        label: i,
        srcFile: n,
        cues: r
      });
    }, AblePlayer.prototype.getFilenameFromPath = function (t) {
      var e;
      return -1 === (e = t.lastIndexOf("/")) ? t : t.substr(e + 1);
    }, AblePlayer.prototype.getFilenameFromTracks = function (t, e) {
      for (var i = 0; i < this.vtsTracks.length; i++) if (this.vtsTracks[i].kind === t && this.vtsTracks[i].language === e) return this.vtsTracks[i].srcFile;
      return !1;
    }, AblePlayer.prototype.parseVtsTracks = function (t) {
      var e, i, s, a, n, r, o, l, h;
      for (e = t.split("\n"), s = [], a = 0; a < e.length;) if (-1 !== (r = e[a]).indexOf(" --\x3e ")) {
        if (i = r.trim().split(" "), this.isValidTimestamp(i[0]) && this.isValidTimestamp(i[2])) {
          for (l = "", n = a + 1, h = !1; n < e.length && !h;) (o = e[n].trim()).length > 0 ? l.length > 0 ? l += "\n" + o : l += o : h = !0, n++;
          s.push({
            start: i[0],
            end: i[2],
            content: l
          }), a = n;
        }
      } else a++;
      return s;
    }, AblePlayer.prototype.isValidTimestamp = function (t) {
      return !!/^[0-9:,.]*$/.test(t);
    }, AblePlayer.prototype.formatTimestamp = function (t) {
      var e,
        i = t.substr(0, t.lastIndexOf(".") + 1);
      if ((e = t.substr(t.lastIndexOf(".") + 1)).length > 3) e = e.substr(0, 3);else if (e.length < 3) for (; e.length < 3;) e += "0";
      return i + e;
    }, AblePlayer.prototype.injectVtsTable = function (e, i) {
      var s, a, n, r, o, l, h, p;
      for ("update" === e && (t("#able-vts table").remove(), t("#able-vts-icon-credit").remove()), s = t("<table>", {
        lang: i
      }), r = t("<tr>", {
        lang: "en"
      }), a = ["Row #", "Kind", "Start", "End", "Content", "Actions"], n = 0; n < a.length; n++) o = t("<th>", {
        scope: "col"
      }).text(a[n]), "Actions" === a[n] && o.addClass("actions"), r.append(o);
      for (s.append(r), h = this.getAllRows(i), n = 0; n < h.length; n++) r = t("<tr>", {
        id: "able-vts-row-" + (p = n + 1),
        class: "kind-" + h[n].kind
      }), l = t("<td>").text(p), r.append(l), l = t("<td>", {
        contenteditable: "true"
      }).text(h[n].kind), r.append(l), l = t("<td>", {
        contenteditable: "true"
      }).text(h[n].start), r.append(l), l = t("<td>", {
        contenteditable: "true"
      }).text(h[n].end), r.append(l), l = t("<td>", {
        contenteditable: "true"
      }).text(h[n].content), r.append(l), l = this.addVtsActionButtons(p, h.length), r.append(l), s.append(r);
      t("#able-vts").append(s), t("#able-vts").append(this.getIconCredit());
    }, AblePlayer.prototype.addVtsActionButtons = function (e, i) {
      var s, a, n, r, o, l, h, p, c, d;
      for (s = this, a = t("<td>"), n = ["up", "down", "insert", "delete"], r = 0; r < n.length; r++) "up" === (o = n[r]) ? e > 1 && (l = t("<button>", {
        id: "able-vts-button-up-" + e,
        title: "Move up",
        "aria-label": "Move Row " + e + " up"
      }).on("click", function (t) {
        s.onClickVtsActionButton(t.currentTarget);
      }), h = t("<svg>", {
        focusable: "false",
        "aria-hidden": "true",
        x: "0px",
        y: "0px",
        width: "254.296px",
        height: "254.296px",
        viewBox: "0 0 254.296 254.296",
        style: "enable-background:new 0 0 254.296 254.296"
      }), c = t("<path>", {
        d: "M249.628,176.101L138.421,52.88c-6.198-6.929-16.241-6.929-22.407,0l-0.381,0.636L4.648,176.101c-6.198,6.897-6.198,18.052,0,24.981l0.191,0.159c2.892,3.305,6.865,5.371,11.346,5.371h221.937c4.577,0,8.613-2.161,11.41-5.594l0.064,0.064C255.857,194.153,255.857,182.998,249.628,176.101z"
      }), p = t("<g>").append(c), h.append(p), l.append(h), l.html(l.html()), a.append(l)) : "down" === o ? e < i && (l = t("<button>", {
        id: "able-vts-button-down-" + e,
        title: "Move down",
        "aria-label": "Move Row " + e + " down"
      }).on("click", function (t) {
        s.onClickVtsActionButton(t.currentTarget);
      }), h = t("<svg>", {
        focusable: "false",
        "aria-hidden": "true",
        x: "0px",
        y: "0px",
        width: "292.362px",
        height: "292.362px",
        viewBox: "0 0 292.362 292.362",
        style: "enable-background:new 0 0 292.362 292.362"
      }), c = t("<path>", {
        d: "M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"
      }), p = t("<g>").append(c), h.append(p), l.append(h), l.html(l.html()), a.append(l)) : "insert" === o ? (l = t("<button>", {
        id: "able-vts-button-insert-" + e,
        title: "Insert row below",
        "aria-label": "Insert row before Row " + e
      }).on("click", function (t) {
        s.onClickVtsActionButton(t.currentTarget);
      }), h = t("<svg>", {
        focusable: "false",
        "aria-hidden": "true",
        x: "0px",
        y: "0px",
        width: "401.994px",
        height: "401.994px",
        viewBox: "0 0 401.994 401.994",
        style: "enable-background:new 0 0 401.994 401.994"
      }), c = t("<path>", {
        d: "M394,154.175c-5.331-5.33-11.806-7.994-19.417-7.994H255.811V27.406c0-7.611-2.666-14.084-7.994-19.414C242.488,2.666,236.02,0,228.398,0h-54.812c-7.612,0-14.084,2.663-19.414,7.993c-5.33,5.33-7.994,11.803-7.994,19.414v118.775H27.407c-7.611,0-14.084,2.664-19.414,7.994S0,165.973,0,173.589v54.819c0,7.618,2.662,14.086,7.992,19.411c5.33,5.332,11.803,7.994,19.414,7.994h118.771V374.59c0,7.611,2.664,14.089,7.994,19.417c5.33,5.325,11.802,7.987,19.414,7.987h54.816c7.617,0,14.086-2.662,19.417-7.987c5.332-5.331,7.994-11.806,7.994-19.417V255.813h118.77c7.618,0,14.089-2.662,19.417-7.994c5.329-5.325,7.994-11.793,7.994-19.411v-54.819C401.991,165.973,399.332,159.502,394,154.175z"
      }), p = t("<g>").append(c), h.append(p), l.append(h), l.html(l.html()), a.append(l)) : "delete" === o && (l = t("<button>", {
        id: "able-vts-button-delete-" + e,
        title: "Delete row ",
        "aria-label": "Delete Row " + e
      }).on("click", function (t) {
        s.onClickVtsActionButton(t.currentTarget);
      }), h = t("<svg>", {
        focusable: "false",
        "aria-hidden": "true",
        x: "0px",
        y: "0px",
        width: "508.52px",
        height: "508.52px",
        viewBox: "0 0 508.52 508.52",
        style: "enable-background:new 0 0 508.52 508.52"
      }), c = t("<path>", {
        d: "M397.281,31.782h-63.565C333.716,14.239,319.478,0,301.934,0h-95.347c-17.544,0-31.782,14.239-31.782,31.782h-63.565c-17.544,0-31.782,14.239-31.782,31.782h349.607C429.063,46.021,414.825,31.782,397.281,31.782z"
      }), "M79.456,476.737c0,17.544,14.239,31.782,31.782,31.782h286.042c17.544,0,31.782-14.239,31.782-31.782V95.347H79.456V476.737z M333.716,174.804c0-8.772,7.151-15.891,15.891-15.891c8.74,0,15.891,7.119,15.891,15.891v254.26c0,8.74-7.151,15.891-15.891,15.891c-8.74,0-15.891-7.151-15.891-15.891V174.804zM238.369,174.804c0-8.772,7.119-15.891,15.891-15.891c8.74,0,15.891,7.119,15.891,15.891v254.26c0,8.74-7.151,15.891-15.891,15.891c-8.772,0-15.891-7.151-15.891-15.891V174.804z M143.021,174.804c0-8.772,7.119-15.891,15.891-15.891c8.772,0,15.891,7.119,15.891,15.891v254.26c0,8.74-7.119,15.891-15.891,15.891c-8.772,0-15.891-7.151-15.891-15.891V174.804z", d = t("<path>", {
        d: "M79.456,476.737c0,17.544,14.239,31.782,31.782,31.782h286.042c17.544,0,31.782-14.239,31.782-31.782V95.347H79.456V476.737z M333.716,174.804c0-8.772,7.151-15.891,15.891-15.891c8.74,0,15.891,7.119,15.891,15.891v254.26c0,8.74-7.151,15.891-15.891,15.891c-8.74,0-15.891-7.151-15.891-15.891V174.804zM238.369,174.804c0-8.772,7.119-15.891,15.891-15.891c8.74,0,15.891,7.119,15.891,15.891v254.26c0,8.74-7.151,15.891-15.891,15.891c-8.772,0-15.891-7.151-15.891-15.891V174.804z M143.021,174.804c0-8.772,7.119-15.891,15.891-15.891c8.772,0,15.891,7.119,15.891,15.891v254.26c0,8.74-7.119,15.891-15.891,15.891c-8.772,0-15.891-7.151-15.891-15.891V174.804z"
      }), p = t("<g>").append(c, d), h.append(p), l.append(h), l.html(l.html()), a.append(l));
      return a;
    }, AblePlayer.prototype.updateVtsActionButtons = function (t, e) {
      var i, s, a, n, r, o;
      for (i = 0; i < t.length; i++) a = (s = t.eq(i)).attr("id"), n = s.attr("aria-label"), r = a.replace(/[0-9]+/g, e), o = n.replace(/[0-9]+/g, e), s.attr("id", r), s.attr("aria-label", o);
    }, AblePlayer.prototype.getIconCredit = function () {
      return '<div id="able-vts-icon-credit">Action buttons made by <a href="https://www.flaticon.com/authors/elegant-themes">Elegant Themes</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> are licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>', '<div id="able-vts-icon-credit">Action buttons made by <a href="https://www.flaticon.com/authors/elegant-themes">Elegant Themes</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> are licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>';
    }, AblePlayer.prototype.getAllLangs = function (e) {
      var i;
      for (i in e) e[i].hasOwnProperty("language") && -1 === t.inArray(e[i].language, this.langs) && (this.langs[this.langs.length] = e[i].language);
    }, AblePlayer.prototype.getAllRows = function (t) {
      var e, i, s, a;
      for (a = [], e = 0; e < this.vtsTracks.length; e++) if ((i = this.vtsTracks[e]).language == t) for (s in i.cues) a.push({
        kind: i.kind,
        lang: t,
        id: i.cues[s].id,
        start: i.cues[s].start,
        end: i.cues[s].end,
        content: i.cues[s].content
      });
      return a.sort(function (t, e) {
        return t.start > e.start ? 1 : -1;
      }), a;
    }, AblePlayer.prototype.onClickVtsActionButton = function (e) {
      var i, s, a;
      s = (i = t(e).attr("id").split("-"))[3], a = i[4], "up" == s ? this.moveRow(a, "up") : "down" == s ? this.moveRow(a, "down") : "insert" == s ? this.insertRow(a) : "delete" == s && this.deleteRow(a);
    }, AblePlayer.prototype.insertRow = function (e) {
      var i, s, a, n, r, o, l, h, p, c, d, u, f, g, v;
      for (a = (s = (i = t("#able-vts table")).find("tr")).length - 1, n = parseInt(e) + 1, r = t("<tr>", {
        id: "able-vts-row-" + n
      }), o = t("<td>").text(n), r.append(o), c = null, l = t("<select>", {
        id: "able-vts-kind-" + n,
        "aria-label": "What kind of track is this?",
        placeholder: "Select a kind"
      }).on("change", function () {
        c = t(this).val(), d = "kind-" + c, u = t(this).closest("tr"), t(this).parent().text(c), u.addClass(d);
      }), h = ["", "captions", "chapters", "descriptions", "subtitles"], f = 0; f < h.length; f++) p = t("<option>", {
        value: h[f]
      }).text(h[f]), l.append(p);
      for (o = t("<td>").append(l), r.append(o), o = t("<td>", {
        contenteditable: "true"
      }), r.append(o), o = t("<td>", {
        contenteditable: "true"
      }), r.append(o), o = t("<td>", {
        contenteditable: "true"
      }), r.append(o), o = this.addVtsActionButtons(n, a), r.append(o), i.find("tr").eq(e).after(r), f = n; f <= a; f++) g = f + 1, s.eq(f).attr("id", "able-vts-row-" + g), s.eq(f).find("td").eq(0).text(g), v = s.eq(f).find("button"), this.updateVtsActionButtons(v, g);
      this.adjustTimes(n), this.showVtsAlert("A new row " + n + " has been inserted"), l.focus();
    }, AblePlayer.prototype.deleteRow = function (e) {
      var i, s, a, n, r, o;
      for ((i = t("#able-vts table"))[0].deleteRow(e), a = (s = i.find("tr")).length - 1, n = e; n <= a; n++) r = n, s.eq(n).attr("id", "able-vts-row-" + r), s.eq(n).find("td").eq(0).text(r), o = s.eq(n).find("button"), this.updateVtsActionButtons(o, r);
      this.showVtsAlert("Row " + e + " has been deleted");
    }, AblePlayer.prototype.moveRow = function (e, i) {
      var s, a, n, r;
      t("#able-vts table").find("tr"), s = t("#able-vts table").find("tr").eq(e), "up" == i ? (a = parseInt(e) - 1, (n = t("#able-vts table").find("tr").eq(a)).before(s)) : "down" == i && (a = parseInt(e) + 1, (n = t("#able-vts table").find("tr").eq(a)).after(s)), s.attr("id", "able-vts-row-" + a), s.find("td").eq(0).text(a), this.updateVtsActionButtons(s.find("button"), a), n.attr("id", "able-vts-row-" + e), n.find("td").eq(0).text(e), this.updateVtsActionButtons(n.find("button"), e), this.adjustTimes(a), r = "Row " + e + " has been moved " + i, r += " and is now Row " + a, this.showVtsAlert(r);
    }, AblePlayer.prototype.adjustTimes = function (e) {
      var i, s, a, n, r, o, l, h, p, c, d, u, f, g, v, m;
      (i = []).captions = .001, i.descriptions = .001, i.chapters = .001, h = (r = (s = t("#able-vts table").find("tr")).eq(e)).is('[class^="kind-"]') ? this.getKindFromClass(r.attr("class")) : "captions", d = this.getSecondsFromColonTime(r.find("td").eq(2).text()), g = this.getSecondsFromColonTime(r.find("td").eq(3).text()), e > 1 ? (a = e - 1, p = (o = s.eq(a)).is('[class^="kind-"]') ? this.getKindFromClass(o.attr("class")) : null, u = this.getSecondsFromColonTime(o.find("td").eq(2).text()), v = this.getSecondsFromColonTime(o.find("td").eq(3).text())) : (a = null, o = null, p = null, u = null, v = null), e < s.length - 1 ? (n = e + 1, c = (l = s.eq(n)).is('[class^="kind-"]') ? this.getKindFromClass(l.attr("class")) : null, f = this.getSecondsFromColonTime(l.find("td").eq(2).text()), m = this.getSecondsFromColonTime(l.find("td").eq(3).text())) : (n = null, l = null, c = null, f = null, m = null), isNaN(d) ? (null == p && (p = "captions", o.attr("class", "kind-captions"), o.find("td").eq(1).html("captions")), "captions" === p ? (d = (parseFloat(v) + .001).toFixed(3), g = f ? (parseFloat(f) - .001).toFixed(3) : (parseFloat(d) + i[h]).toFixed(3)) : "chapters" === p ? (d = (parseFloat(u) + .001).toFixed(3), g = f ? (parseFloat(f) - .001).toFixed(3) : (parseFloat(d) + minDurartion[h]).toFixed(3)) : "descriptions" === p && (d = (parseFloat(u) + i.descriptions).toFixed(3), g = (parseFloat(d) + i.descriptions).toFixed(3))) : u ? u < d ? d < f || (f = (parseFloat(d) + i[h]).toFixed(3), m = (parseFloat(f) + i[c]).toFixed(3)) : (d = (parseFloat(u) + i[p]).toFixed(3), g = (parseFloat(d) + i[h]).toFixed(3)) : d < f || (f = (parseFloat(d) + i[h]).toFixed(3), m = (parseFloat(f) + i[c]).toFixed(3)), g - d < i[h] && (g = (parseFloat(d) + i[h]).toFixed(3), f && (f = (parseFloat(g) + .001).toFixed(3))), r.find("td").eq(2).text(this.formatSecondsAsColonTime(d, !0)), r.find("td").eq(3).text(this.formatSecondsAsColonTime(g, !0)), o && (o.find("td").eq(2).text(this.formatSecondsAsColonTime(u, !0)), o.find("td").eq(3).text(this.formatSecondsAsColonTime(v, !0))), l && (l.find("td").eq(2).text(this.formatSecondsAsColonTime(f, !0)), l.find("td").eq(3).text(this.formatSecondsAsColonTime(m, !0)));
    }, AblePlayer.prototype.getKindFromClass = function (t) {
      var e, i, s;
      return e = t.indexOf("kind-") + 5, s = -1 == (i = t.indexOf(" ", e)) ? t.length - e : i - e, t.substr(e, s);
    }, AblePlayer.prototype.showVtsAlert = function (t) {
      this.$vtsAlert.text(t).show().delay(3e3).fadeOut("slow");
    }, AblePlayer.prototype.parseVtsOutput = function (e) {
      var i, s, a, n, r, o, l, h, p, c;
      for (i = e.attr("lang"), a = ["captions", "chapters", "descriptions", "subtitles"], r = {}, s = 0; s < a.length; s++) r[n = a[s]] = "WEBVTT\n\n";
      if ((o = e.find("tr")).length > 0) for (s = 0; s < o.length; s++) n = o.eq(s).find("td").eq(1).text(), -1 !== t.inArray(n, a) && (l = o.eq(s).find("td").eq(2).text(), h = o.eq(s).find("td").eq(3).text(), p = o.eq(s).find("td").eq(4).text(), void 0 !== l && void 0 !== h && (r[n] += l + " --\x3e " + h + "\n", "undefined" !== p && (r[n] += p), r[n] += "\n\n"));
      for (c = t("<div>", {
        id: "able-vts-output"
      }), t("#able-vts").append(c), s = 0; s < a.length; s++) r[n = a[s]].length > 8 && this.showWebVttOutput(n, r[n], i);
    }, AblePlayer.prototype.showWebVttOutput = function (e, i, s) {
      var a, n, r, o, l;
      a = t("<h3>").text(e.charAt(0).toUpperCase() + e.slice(1)), o = "If you made changes, copy/paste the following content ", (n = this.getFilenameFromTracks(e, s)) ? (o += "to replace the original content of your " + this.getLanguageName(s) + " ", o += "<em>" + e + "</em> WebVTT file (<strong>" + n + "</strong>).") : o += "into a new " + this.getLanguageName(s) + " <em>" + e + "</em> WebVTT file.", r = t("<p>", {
        class: "able-vts-output-instructions"
      }).html(o), l = t("<textarea>").text(i), t("#able-vts-output").append(a, r, l);
    };
  }(_jquery.default);
}

},{"jquery":"jquery","js-cookie":"js-cookie","xml-js":121}],91:[function(require,module,exports){
'use strict';

exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}

// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }
  return parts.join('');
}

},{}],92:[function(require,module,exports){

},{}],93:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict';

var base64 = require('base64-js');
var ieee754 = require('ieee754');
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
  console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
}
function typedArraySupport() {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = {
      __proto__: Uint8Array.prototype,
      foo: function () {
        return 42;
      }
    };
    return arr.foo() === 42;
  } catch (e) {
    return false;
  }
}
Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.buffer;
  }
});
Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.byteOffset;
  }
});
function createBuffer(length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"');
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length);
  buf.__proto__ = Buffer.prototype;
  return buf;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError('The "string" argument must be of type string. Received type number');
    }
    return allocUnsafe(arg);
  }
  return from(arg, encodingOrOffset, length);
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null && Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  });
}
Buffer.poolSize = 8192; // not used by this implementation

function from(value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset);
  }
  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value);
  }
  if (value == null) {
    throw TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
  }
  if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('The "value" argument must not be of type number. Received type number');
  }
  var valueOf = value.valueOf && value.valueOf();
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length);
  }
  var b = fromObject(value);
  if (b) return b;
  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
  }
  throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + typeof value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length);
};

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype;
Buffer.__proto__ = Uint8Array;
function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number');
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"');
  }
}
function alloc(size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
  }
  return createBuffer(size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
  assertSize(size);
  return createBuffer(size < 0 ? 0 : checked(size) | 0);
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size);
};
function fromString(string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }
  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding);
  }
  var length = byteLength(string, encoding) | 0;
  var buf = createBuffer(length);
  var actual = buf.write(string, encoding);
  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
  }
  return buf;
}
function fromArrayLike(array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  var buf = createBuffer(length);
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255;
  }
  return buf;
}
function fromArrayBuffer(array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds');
  }
  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds');
  }
  var buf;
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array);
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset);
  } else {
    buf = new Uint8Array(array, byteOffset, length);
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype;
  return buf;
}
function fromObject(obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    var buf = createBuffer(len);
    if (buf.length === 0) {
      return buf;
    }
    obj.copy(buf, 0, 0, len);
    return buf;
  }
  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0);
    }
    return fromArrayLike(obj);
  }
  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data);
  }
}
function checked(length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
  }
  return length | 0;
}
function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
  return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
};
Buffer.compare = function compare(a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};
Buffer.concat = function concat(list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list.length === 0) {
    return Buffer.alloc(0);
  }
  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }
  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf);
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};
function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + typeof string);
  }
  var len = string.length;
  var mustMatch = arguments.length > 2 && arguments[2] === true;
  if (!mustMatch && len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
        }
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }
  if (end === undefined || end > this.length) {
    end = this.length;
  }
  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;
  if (end <= start) {
    return '';
  }
  if (!encoding) encoding = 'utf8';
  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);
      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);
      case 'ascii':
        return asciiSlice(this, start, end);
      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);
      case 'base64':
        return base64Slice(this, start, end);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};
Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};
Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};
Buffer.prototype.toString = function toString() {
  var length = this.length;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
  if (this.length > max) str += ' ... ';
  return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength);
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + typeof target);
  }
  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }
  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }
  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }
  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }
  throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }
  var strLen = string.length;
  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (numberIsNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}
function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0;
    if (isFinite(length)) {
      length = length >>> 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }
  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;
  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }
  if (!encoding) encoding = 'utf8';
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);
      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);
      case 'ascii':
        return asciiWrite(this, string, offset, length);
      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);
      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}
function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];
  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}
function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}
function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice(buf, start, end) {
  var len = buf.length;
  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;
  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}
function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;
  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }
  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }
  if (end < start) end = start;
  var newBuf = this.subarray(start, end);
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype;
  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }
  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }
  return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset + 3] = value >>> 24;
  this[offset + 2] = value >>> 16;
  this[offset + 1] = value >>> 8;
  this[offset] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  this[offset + 2] = value >>> 16;
  this[offset + 3] = value >>> 24;
  return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }
  var len = end - start;
  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
  }
  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code;
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }
  if (end <= start) {
    return this;
  }
  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
    var len = bytes.length;
    if (len === 0) {
      throw new TypeError('The value "' + val + '" is invalid for argument "value"');
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }
  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0];
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}
function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}
function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;
        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }
    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }
  return bytes;
}
function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}
function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
  return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
  // For IE11 support
  return obj !== obj; // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"base64-js":91,"buffer":93,"ieee754":97}],94:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill;
var objectKeys = Object.keys || objectKeysPolyfill;
var bind = Function.prototype.bind || functionBindPolyfill;
function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', {
    value: 0
  });
  hasDefineProperty = o.x === 0;
} catch (err) {
  hasDefineProperty = false;
}
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function () {
      return defaultMaxListeners;
    },
    set: function (arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg) throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};
function $getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn) handler.call(self);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn) handler.call(self, arg1);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn) handler.call(self, arg1, arg2);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn) handler.call(self, arg1, arg2, arg3);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) listeners[i].call(self, arg1, arg2, arg3);
  }
}
function emitMany(handler, isFn, self, args) {
  if (isFn) handler.apply(self, args);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) listeners[i].apply(self, args);
  }
}
EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = type === 'error';
  events = this._events;
  if (events) doError = doError && events.error == null;else if (!doError) return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1) er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }
  handler = events[type];
  if (!handler) return false;
  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++) args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }
  return true;
};
function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }
  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' "' + String(type) + '" listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }
  return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};
function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}
function _onceWrap(target, type, listener) {
  var state = {
    fired: false,
    wrapFn: undefined,
    target: target,
    type: type,
    listener: listener
  };
  var wrapped = bind.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  events = this._events;
  if (!events) return this;
  list = events[type];
  if (!list) return this;
  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0) this._events = objectCreate(null);else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;
    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0) return this;
    if (position === 0) list.shift();else spliceOne(list, position);
    if (list.length === 1) events[type] = list[0];
    if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
  }
  return this;
};
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events, i;
  events = this._events;
  if (!events) return this;

  // not listening for removeListener, no need to emit
  if (!events.removeListener) {
    if (arguments.length === 0) {
      this._events = objectCreate(null);
      this._eventsCount = 0;
    } else if (events[type]) {
      if (--this._eventsCount === 0) this._events = objectCreate(null);else delete events[type];
    }
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    var keys = objectKeys(events);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = objectCreate(null);
    this._eventsCount = 0;
    return this;
  }
  listeners = events[type];
  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    for (i = listeners.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners[i]);
    }
  }
  return this;
};
function _listeners(target, type, unwrap) {
  var events = target._events;
  if (!events) return [];
  var evlistener = events[type];
  if (!evlistener) return [];
  if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};
EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;
  if (events) {
    var evlistener = events[type];
    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) list[i] = list[k];
  list.pop();
}
function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i) copy[i] = arr[i];
  return copy;
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
function objectCreatePolyfill(proto) {
  var F = function () {};
  F.prototype = proto;
  return new F();
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

},{}],95:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  timeout.close();
};
function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};
exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};
exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);
  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function (fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
  immediateIds[id] = true;
  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });
  return id;
};
exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function (id) {
  delete immediateIds[id];
};

}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":101,"timers":95}],96:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;
function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;
function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;
function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;
function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
function isError(e) {
  return objectToString(e) === '[object Error]' || e instanceof Error;
}
exports.isError = isError;
function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' ||
  // ES6 symbol
  typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = require('buffer').Buffer.isBuffer;
function objectToString(o) {
  return Object.prototype.toString.call(o);
}

},{"buffer":93}],97:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
  buffer[offset + i - d] |= s * 128;
};

},{}],98:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  };
}

},{}],99:[function(require,module,exports){
var toString = {}.toString;
module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],100:[function(require,module,exports){
(function (process){(function (){
'use strict';

if (typeof process === 'undefined' || !process.version || process.version.indexOf('v0.') === 0 || process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = {
    nextTick: nextTick
  };
} else {
  module.exports = process;
}
function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
    case 0:
    case 1:
      return process.nextTick(fn);
    case 2:
      return process.nextTick(function afterTickOne() {
        fn.call(null, arg1);
      });
    case 3:
      return process.nextTick(function afterTickTwo() {
        fn.call(null, arg1, arg2);
      });
    case 4:
      return process.nextTick(function afterTickThree() {
        fn.call(null, arg1, arg2, arg3);
      });
    default:
      args = new Array(len - 1);
      i = 0;
      while (i < args.length) {
        args[i++] = arguments[i];
      }
      return process.nextTick(function afterTick() {
        fn.apply(null, args);
      });
  }
}

}).call(this)}).call(this,require('_process'))
},{"_process":101}],101:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}
(function () {
  try {
    if (typeof setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    if (typeof clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  }
  // if setTimeout wasn't available but was latter defined
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  }
  // if clearTimeout wasn't available but was latter defined
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
process.nextTick = function (fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
};

// v8 likes predictible objects
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function (name) {
  return [];
};
process.binding = function (name) {
  throw new Error('process.binding is not supported');
};
process.cwd = function () {
  return '/';
};
process.chdir = function (dir) {
  throw new Error('process.chdir is not supported');
};
process.umask = function () {
  return 0;
};

},{}],102:[function(require,module,exports){
module.exports = require('./lib/_stream_duplex.js');

},{"./lib/_stream_duplex.js":103}],103:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/
var pna = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }
  return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');
util.inherits(Duplex, Readable);
{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  if (options && options.readable === false) this.readable = false;
  if (options && options.writable === false) this.writable = false;
  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
  this.once('end', onend);
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();
  pna.nextTick(cb, err);
};

},{"./_stream_readable":105,"./_stream_writable":107,"core-util-is":96,"inherits":98,"process-nextick-args":100}],104:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;
var Transform = require('./_stream_transform');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

},{"./_stream_transform":106,"core-util-is":96,"inherits":98}],105:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/
var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;
var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/BufferList');
var destroyImpl = require('./internal/streams/destroy');
var StringDecoder;
util.inherits(Readable, Stream);
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');
  if (!(this instanceof Readable)) return new Readable(options);
  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }
  return needMoreData(state);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}
function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      });
    }
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }
  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }
  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./_stream_duplex":103,"./internal/streams/BufferList":108,"./internal/streams/destroy":109,"./internal/streams/stream":110,"_process":101,"core-util-is":96,"events":94,"inherits":98,"isarray":99,"process-nextick-args":100,"safe-buffer":115,"string_decoder/":118,"util":92}],106:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;
var Duplex = require('./_stream_duplex');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
  return stream.push(null);
}

},{"./_stream_duplex":103,"core-util-is":96,"inherits":98}],107:[function(require,module,exports){
(function (process,global,setImmediate){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/
var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = require('./internal/streams/destroy');
util.inherits(Writable, Stream);
function nop() {}
function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }
  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};
function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;
  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  var state = this._writableState;
  state.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"./_stream_duplex":103,"./internal/streams/destroy":109,"./internal/streams/stream":110,"_process":101,"core-util-is":96,"inherits":98,"process-nextick-args":100,"safe-buffer":115,"timers":95,"util-deprecate":119}],108:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var Buffer = require('safe-buffer').Buffer;
var util = require('util');
function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}
module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  BufferList.prototype.push = function push(v) {
    var entry = {
      data: v,
      next: null
    };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };
  BufferList.prototype.unshift = function unshift(v) {
    var entry = {
      data: v,
      next: this.head
    };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };
  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };
  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };
  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }
    return ret;
  };
  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };
  return BufferList;
}();
if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({
      length: this.length
    });
    return this.constructor.name + ' ' + obj;
  };
}

},{"safe-buffer":115,"util":92}],109:[function(require,module,exports){
'use strict';

/*<replacement>*/
var pna = require('process-nextick-args');
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        pna.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        pna.nextTick(emitErrorNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, _this, err);
      }
    } else if (cb) {
      cb(err);
    }
  });
  return this;
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

},{"process-nextick-args":100}],110:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":94}],111:[function(require,module,exports){
module.exports = require('./readable').PassThrough;

},{"./readable":112}],112:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

},{"./lib/_stream_duplex.js":103,"./lib/_stream_passthrough.js":104,"./lib/_stream_readable.js":105,"./lib/_stream_transform.js":106,"./lib/_stream_writable.js":107}],113:[function(require,module,exports){
module.exports = require('./readable').Transform;

},{"./readable":112}],114:[function(require,module,exports){
module.exports = require('./lib/_stream_writable.js');

},{"./lib/_stream_writable.js":107}],115:[function(require,module,exports){
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer');
var Buffer = buffer.Buffer;

// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
  for (var key in src) {
    dst[key] = src[key];
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer;
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports);
  exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length);
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number');
  }
  return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  var buf = Buffer(size);
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding);
    } else {
      buf.fill(fill);
    }
  } else {
    buf.fill(0);
  }
  return buf;
};
SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  return buffer.SlowBuffer(size);
};

},{"buffer":93}],116:[function(require,module,exports){
(function (Buffer){(function (){
;
(function (sax) {
  // wrapper for non-node envs
  sax.parser = function (strict, opt) {
    return new SAXParser(strict, opt);
  };
  sax.SAXParser = SAXParser;
  sax.SAXStream = SAXStream;
  sax.createStream = createStream;

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024;
  var buffers = ['comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype', 'procInstName', 'procInstBody', 'entity', 'attribName', 'attribValue', 'cdata', 'script'];
  sax.EVENTS = ['text', 'processinginstruction', 'sgmldeclaration', 'doctype', 'comment', 'opentagstart', 'attribute', 'opentag', 'closetag', 'opencdata', 'cdata', 'closecdata', 'error', 'end', 'ready', 'script', 'opennamespace', 'closenamespace'];
  function SAXParser(strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt);
    }
    var parser = this;
    clearBuffers(parser);
    parser.q = parser.c = '';
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
    parser.opt = opt || {};
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase';
    parser.tags = [];
    parser.closed = parser.closedRoot = parser.sawRoot = false;
    parser.tag = parser.error = null;
    parser.strict = !!strict;
    parser.noscript = !!(strict || parser.opt.noscript);
    parser.state = S.BEGIN;
    parser.strictEntities = parser.opt.strictEntities;
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
    parser.attribList = [];

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS);
    }

    // disallow unquoted attribute values if not otherwise configured
    // and strict mode is true
    if (parser.opt.unquotedAttributeValues === undefined) {
      parser.opt.unquotedAttributeValues = !strict;
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false;
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0;
    }
    emit(parser, 'onready');
  }
  if (!Object.create) {
    Object.create = function (o) {
      function F() {}
      F.prototype = o;
      var newf = new F();
      return newf;
    };
  }
  if (!Object.keys) {
    Object.keys = function (o) {
      var a = [];
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i);
      return a;
    };
  }
  function checkBufferLength(parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
    var maxActual = 0;
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length;
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser);
            break;
          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata);
            parser.cdata = '';
            break;
          case 'script':
            emitNode(parser, 'onscript', parser.script);
            parser.script = '';
            break;
          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i]);
        }
      }
      maxActual = Math.max(maxActual, len);
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual;
    parser.bufferCheckPosition = m + parser.position;
  }
  function clearBuffers(parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = '';
    }
  }
  function flushBuffers(parser) {
    closeText(parser);
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata);
      parser.cdata = '';
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script);
      parser.script = '';
    }
  }
  SAXParser.prototype = {
    end: function () {
      end(this);
    },
    write: write,
    resume: function () {
      this.error = null;
      return this;
    },
    close: function () {
      return this.write(null);
    },
    flush: function () {
      flushBuffers(this);
    }
  };
  var Stream;
  try {
    Stream = require('stream').Stream;
  } catch (ex) {
    Stream = function () {};
  }
  if (!Stream) Stream = function () {};
  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end';
  });
  function createStream(strict, opt) {
    return new SAXStream(strict, opt);
  }
  function SAXStream(strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt);
    }
    Stream.apply(this);
    this._parser = new SAXParser(strict, opt);
    this.writable = true;
    this.readable = true;
    var me = this;
    this._parser.onend = function () {
      me.emit('end');
    };
    this._parser.onerror = function (er) {
      me.emit('error', er);

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null;
    };
    this._decoder = null;
    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev];
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev);
            me._parser['on' + ev] = h;
            return h;
          }
          me.on(ev, h);
        },
        enumerable: true,
        configurable: false
      });
    });
  }
  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  });
  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = require('string_decoder').StringDecoder;
        this._decoder = new SD('utf8');
      }
      data = this._decoder.write(data);
    }
    this._parser.write(data.toString());
    this.emit('data', data);
    return true;
  };
  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk);
    }
    this._parser.end();
    return true;
  };
  SAXStream.prototype.on = function (ev, handler) {
    var me = this;
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
        args.splice(0, 0, ev);
        me.emit.apply(me, args);
      };
    }
    return Stream.prototype.on.call(me, ev, handler);
  };

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA[';
  var DOCTYPE = 'DOCTYPE';
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/';
  var rootNS = {
    xml: XML_NAMESPACE,
    xmlns: XMLNS_NAMESPACE
  };

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
  function isWhitespace(c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t';
  }
  function isQuote(c) {
    return c === '"' || c === '\'';
  }
  function isAttribEnd(c) {
    return c === '>' || isWhitespace(c);
  }
  function isMatch(regex, c) {
    return regex.test(c);
  }
  function notMatch(regex, c) {
    return !isMatch(regex, c);
  }
  var S = 0;
  sax.STATE = {
    BEGIN: S++,
    // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++,
    // leading whitespace
    TEXT: S++,
    // general stuff
    TEXT_ENTITY: S++,
    // &amp and such.
    OPEN_WAKA: S++,
    // <
    SGML_DECL: S++,
    // <!BLARG
    SGML_DECL_QUOTED: S++,
    // <!BLARG foo "bar
    DOCTYPE: S++,
    // <!DOCTYPE
    DOCTYPE_QUOTED: S++,
    // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++,
    // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++,
    // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++,
    // <!-
    COMMENT: S++,
    // <!--
    COMMENT_ENDING: S++,
    // <!-- blah -
    COMMENT_ENDED: S++,
    // <!-- blah --
    CDATA: S++,
    // <![CDATA[ something
    CDATA_ENDING: S++,
    // ]
    CDATA_ENDING_2: S++,
    // ]]
    PROC_INST: S++,
    // <?hi
    PROC_INST_BODY: S++,
    // <?hi there
    PROC_INST_ENDING: S++,
    // <?hi "there" ?
    OPEN_TAG: S++,
    // <strong
    OPEN_TAG_SLASH: S++,
    // <strong /
    ATTRIB: S++,
    // <a
    ATTRIB_NAME: S++,
    // <a foo
    ATTRIB_NAME_SAW_WHITE: S++,
    // <a foo _
    ATTRIB_VALUE: S++,
    // <a foo=
    ATTRIB_VALUE_QUOTED: S++,
    // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++,
    // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++,
    // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++,
    // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++,
    // <foo bar=&quot
    CLOSE_TAG: S++,
    // </a
    CLOSE_TAG_SAW_WHITE: S++,
    // </a   >
    SCRIPT: S++,
    // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  };
  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  };
  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  };
  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key];
    var s = typeof e === 'number' ? String.fromCharCode(e) : e;
    sax.ENTITIES[key] = s;
  });
  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s;
  }

  // shorthand
  S = sax.STATE;
  function emit(parser, event, data) {
    parser[event] && parser[event](data);
  }
  function emitNode(parser, nodeType, data) {
    if (parser.textNode) closeText(parser);
    emit(parser, nodeType, data);
  }
  function closeText(parser) {
    parser.textNode = textopts(parser.opt, parser.textNode);
    if (parser.textNode) emit(parser, 'ontext', parser.textNode);
    parser.textNode = '';
  }
  function textopts(opt, text) {
    if (opt.trim) text = text.trim();
    if (opt.normalize) text = text.replace(/\s+/g, ' ');
    return text;
  }
  function error(parser, er) {
    closeText(parser);
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line + '\nColumn: ' + parser.column + '\nChar: ' + parser.c;
    }
    er = new Error(er);
    parser.error = er;
    emit(parser, 'onerror', er);
    return parser;
  }
  function end(parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag');
    if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) {
      error(parser, 'Unexpected end');
    }
    closeText(parser);
    parser.c = '';
    parser.closed = true;
    emit(parser, 'onend');
    SAXParser.call(parser, parser.strict, parser.opt);
    return parser;
  }
  function strictFail(parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail');
    }
    if (parser.strict) {
      error(parser, message);
    }
  }
  function newTag(parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
    var parent = parser.tags[parser.tags.length - 1] || parser;
    var tag = parser.tag = {
      name: parser.tagName,
      attributes: {}
    };

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns;
    }
    parser.attribList.length = 0;
    emitNode(parser, 'onopentagstart', tag);
  }
  function qname(name, attribute) {
    var i = name.indexOf(':');
    var qualName = i < 0 ? ['', name] : name.split(':');
    var prefix = qualName[0];
    var local = qualName[1];

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns';
      local = '';
    }
    return {
      prefix: prefix,
      local: local
    };
  }
  function attrib(parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]();
    }
    if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = '';
      return;
    }
    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true);
      var prefix = qn.prefix;
      var local = qn.local;
      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser, 'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' + 'Actual: ' + parser.attribValue);
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser, 'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' + 'Actual: ' + parser.attribValue);
        } else {
          var tag = parser.tag;
          var parent = parser.tags[parser.tags.length - 1] || parser;
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns);
          }
          tag.ns[local] = parser.attribValue;
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue]);
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue;
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      });
    }
    parser.attribName = parser.attribValue = '';
  }
  function openTag(parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag;

      // add namespace info to tag
      var qn = qname(parser.tagName);
      tag.prefix = qn.prefix;
      tag.local = qn.local;
      tag.uri = tag.ns[qn.prefix] || '';
      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' + JSON.stringify(parser.tagName));
        tag.uri = qn.prefix;
      }
      var parent = parser.tags[parser.tags.length - 1] || parser;
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          });
        });
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i];
        var name = nv[0];
        var value = nv[1];
        var qualName = qname(name, true);
        var prefix = qualName.prefix;
        var local = qualName.local;
        var uri = prefix === '' ? '' : tag.ns[prefix] || '';
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        };

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' + JSON.stringify(prefix));
          a.uri = prefix;
        }
        parser.tag.attributes[name] = a;
        emitNode(parser, 'onattribute', a);
      }
      parser.attribList.length = 0;
    }
    parser.tag.isSelfClosing = !!selfClosing;

    // process the tag
    parser.sawRoot = true;
    parser.tags.push(parser.tag);
    emitNode(parser, 'onopentag', parser.tag);
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT;
      } else {
        parser.state = S.TEXT;
      }
      parser.tag = null;
      parser.tagName = '';
    }
    parser.attribName = parser.attribValue = '';
    parser.attribList.length = 0;
  }
  function closeTag(parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.');
      parser.textNode += '</>';
      parser.state = S.TEXT;
      return;
    }
    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>';
        parser.tagName = '';
        parser.state = S.SCRIPT;
        return;
      }
      emitNode(parser, 'onscript', parser.script);
      parser.script = '';
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length;
    var tagName = parser.tagName;
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]();
    }
    var closeTo = tagName;
    while (t--) {
      var close = parser.tags[t];
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag');
      } else {
        break;
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName);
      parser.textNode += '</' + parser.tagName + '>';
      parser.state = S.TEXT;
      return;
    }
    parser.tagName = tagName;
    var s = parser.tags.length;
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop();
      parser.tagName = parser.tag.name;
      emitNode(parser, 'onclosetag', parser.tagName);
      var x = {};
      for (var i in tag.ns) {
        x[i] = tag.ns[i];
      }
      var parent = parser.tags[parser.tags.length - 1] || parser;
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p];
          emitNode(parser, 'onclosenamespace', {
            prefix: p,
            uri: n
          });
        });
      }
    }
    if (t === 0) parser.closedRoot = true;
    parser.tagName = parser.attribValue = parser.attribName = '';
    parser.attribList.length = 0;
    parser.state = S.TEXT;
  }
  function parseEntity(parser) {
    var entity = parser.entity;
    var entityLC = entity.toLowerCase();
    var num;
    var numStr = '';
    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity];
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC];
    }
    entity = entityLC;
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2);
        num = parseInt(entity, 16);
        numStr = num.toString(16);
      } else {
        entity = entity.slice(1);
        num = parseInt(entity, 10);
        numStr = num.toString(10);
      }
    }
    entity = entity.replace(/^0+/, '');
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity');
      return '&' + parser.entity + ';';
    }
    return String.fromCodePoint(num);
  }
  function beginWhiteSpace(parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA;
      parser.startTagPosition = parser.position;
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.');
      parser.textNode = c;
      parser.state = S.TEXT;
    }
  }
  function charAt(chunk, i) {
    var result = '';
    if (i < chunk.length) {
      result = chunk.charAt(i);
    }
    return result;
  }
  function write(chunk) {
    var parser = this;
    if (this.error) {
      throw this.error;
    }
    if (parser.closed) {
      return error(parser, 'Cannot write after close. Assign an onready handler.');
    }
    if (chunk === null) {
      return end(parser);
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString();
    }
    var i = 0;
    var c = '';
    while (true) {
      c = charAt(chunk, i++);
      parser.c = c;
      if (!c) {
        break;
      }
      if (parser.trackPosition) {
        parser.position++;
        if (c === '\n') {
          parser.line++;
          parser.column = 0;
        } else {
          parser.column++;
        }
      }
      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE;
          if (c === '\uFEFF') {
            continue;
          }
          beginWhiteSpace(parser, c);
          continue;
        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c);
          continue;
        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1;
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++);
              if (c && parser.trackPosition) {
                parser.position++;
                if (c === '\n') {
                  parser.line++;
                  parser.column = 0;
                } else {
                  parser.column++;
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1);
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.');
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY;
            } else {
              parser.textNode += c;
            }
          }
          continue;
        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING;
          } else {
            parser.script += c;
          }
          continue;
        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG;
          } else {
            parser.script += '<' + c;
            parser.state = S.SCRIPT;
          }
          continue;
        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL;
            parser.sgmlDecl = '';
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG;
            parser.tagName = c;
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG;
            parser.tagName = '';
          } else if (c === '?') {
            parser.state = S.PROC_INST;
            parser.procInstName = parser.procInstBody = '';
          } else {
            strictFail(parser, 'Unencoded <');
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition;
              c = new Array(pad).join(' ') + c;
            }
            parser.textNode += '<' + c;
            parser.state = S.TEXT;
          }
          continue;
        case S.SGML_DECL:
          if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT;
            parser.comment = '';
            parser.sgmlDecl = '';
            continue;
          }
          if (parser.doctype && parser.doctype !== true && parser.sgmlDecl) {
            parser.state = S.DOCTYPE_DTD;
            parser.doctype += '<!' + parser.sgmlDecl + c;
            parser.sgmlDecl = '';
          } else if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata');
            parser.state = S.CDATA;
            parser.sgmlDecl = '';
            parser.cdata = '';
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE;
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser, 'Inappropriately located doctype declaration');
            }
            parser.doctype = '';
            parser.sgmlDecl = '';
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl);
            parser.sgmlDecl = '';
            parser.state = S.TEXT;
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED;
            parser.sgmlDecl += c;
          } else {
            parser.sgmlDecl += c;
          }
          continue;
        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL;
            parser.q = '';
          }
          parser.sgmlDecl += c;
          continue;
        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT;
            emitNode(parser, 'ondoctype', parser.doctype);
            parser.doctype = true; // just remember that we saw it.
          } else {
            parser.doctype += c;
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD;
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED;
              parser.q = c;
            }
          }
          continue;
        case S.DOCTYPE_QUOTED:
          parser.doctype += c;
          if (c === parser.q) {
            parser.q = '';
            parser.state = S.DOCTYPE;
          }
          continue;
        case S.DOCTYPE_DTD:
          if (c === ']') {
            parser.doctype += c;
            parser.state = S.DOCTYPE;
          } else if (c === '<') {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
          } else if (isQuote(c)) {
            parser.doctype += c;
            parser.state = S.DOCTYPE_DTD_QUOTED;
            parser.q = c;
          } else {
            parser.doctype += c;
          }
          continue;
        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c;
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD;
            parser.q = '';
          }
          continue;
        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING;
          } else {
            parser.comment += c;
          }
          continue;
        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED;
            parser.comment = textopts(parser.opt, parser.comment);
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment);
            }
            parser.comment = '';
          } else {
            parser.comment += '-' + c;
            parser.state = S.COMMENT;
          }
          continue;
        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment');
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c;
            parser.state = S.COMMENT;
          } else if (parser.doctype && parser.doctype !== true) {
            parser.state = S.DOCTYPE_DTD;
          } else {
            parser.state = S.TEXT;
          }
          continue;
        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING;
          } else {
            parser.cdata += c;
          }
          continue;
        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2;
          } else {
            parser.cdata += ']' + c;
            parser.state = S.CDATA;
          }
          continue;
        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata);
            }
            emitNode(parser, 'onclosecdata');
            parser.cdata = '';
            parser.state = S.TEXT;
          } else if (c === ']') {
            parser.cdata += ']';
          } else {
            parser.cdata += ']]' + c;
            parser.state = S.CDATA;
          }
          continue;
        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING;
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY;
          } else {
            parser.procInstName += c;
          }
          continue;
        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue;
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING;
          } else {
            parser.procInstBody += c;
          }
          continue;
        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            });
            parser.procInstName = parser.procInstBody = '';
            parser.state = S.TEXT;
          } else {
            parser.procInstBody += '?' + c;
            parser.state = S.PROC_INST_BODY;
          }
          continue;
        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c;
          } else {
            newTag(parser);
            if (c === '>') {
              openTag(parser);
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH;
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name');
              }
              parser.state = S.ATTRIB;
            }
          }
          continue;
        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true);
            closeTag(parser);
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >');
            parser.state = S.ATTRIB;
          }
          continue;
        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue;
          } else if (c === '>') {
            openTag(parser);
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH;
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c;
            parser.attribValue = '';
            parser.state = S.ATTRIB_NAME;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue;
        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE;
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value');
            parser.attribValue = parser.attribName;
            attrib(parser);
            openTag(parser);
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE;
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue;
        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE;
          } else if (isWhitespace(c)) {
            continue;
          } else {
            strictFail(parser, 'Attribute without value');
            parser.tag.attributes[parser.attribName] = '';
            parser.attribValue = '';
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            });
            parser.attribName = '';
            if (c === '>') {
              openTag(parser);
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c;
              parser.state = S.ATTRIB_NAME;
            } else {
              strictFail(parser, 'Invalid attribute name');
              parser.state = S.ATTRIB;
            }
          }
          continue;
        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue;
          } else if (isQuote(c)) {
            parser.q = c;
            parser.state = S.ATTRIB_VALUE_QUOTED;
          } else {
            if (!parser.opt.unquotedAttributeValues) {
              error(parser, 'Unquoted attribute value');
            }
            parser.state = S.ATTRIB_VALUE_UNQUOTED;
            parser.attribValue = c;
          }
          continue;
        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q;
            } else {
              parser.attribValue += c;
            }
            continue;
          }
          attrib(parser);
          parser.q = '';
          parser.state = S.ATTRIB_VALUE_CLOSED;
          continue;
        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB;
          } else if (c === '>') {
            openTag(parser);
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH;
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes');
            parser.attribName = c;
            parser.attribValue = '';
            parser.state = S.ATTRIB_NAME;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue;
        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U;
            } else {
              parser.attribValue += c;
            }
            continue;
          }
          attrib(parser);
          if (c === '>') {
            openTag(parser);
          } else {
            parser.state = S.ATTRIB;
          }
          continue;
        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue;
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c;
                parser.state = S.SCRIPT;
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.');
              }
            } else {
              parser.tagName = c;
            }
          } else if (c === '>') {
            closeTag(parser);
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c;
          } else if (parser.script) {
            parser.script += '</' + parser.tagName;
            parser.tagName = '';
            parser.state = S.SCRIPT;
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag');
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE;
          }
          continue;
        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue;
          }
          if (c === '>') {
            closeTag(parser);
          } else {
            strictFail(parser, 'Invalid characters in closing tag');
          }
          continue;
        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState;
          var buffer;
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT;
              buffer = 'textNode';
              break;
            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED;
              buffer = 'attribValue';
              break;
            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED;
              buffer = 'attribValue';
              break;
          }
          if (c === ';') {
            var parsedEntity = parseEntity(parser);
            if (parser.opt.unparsedEntities && !Object.values(sax.XML_ENTITIES).includes(parsedEntity)) {
              parser.entity = '';
              parser.state = returnState;
              parser.write(parsedEntity);
            } else {
              parser[buffer] += parsedEntity;
              parser.entity = '';
              parser.state = returnState;
            }
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c;
          } else {
            strictFail(parser, 'Invalid character in entity name');
            parser[buffer] += '&' + parser.entity + c;
            parser.entity = '';
            parser.state = returnState;
          }
          continue;
        default:
          /* istanbul ignore next */{
            throw new Error(parser, 'Unknown state: ' + parser.state);
          }
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser);
    }
    return parser;
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode;
      var floor = Math.floor;
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000;
        var codeUnits = [];
        var highSurrogate;
        var lowSurrogate;
        var index = -1;
        var length = arguments.length;
        if (!length) {
          return '';
        }
        var result = '';
        while (++index < length) {
          var codePoint = Number(arguments[index]);
          if (!isFinite(codePoint) ||
          // `NaN`, `+Infinity`, or `-Infinity`
          codePoint < 0 ||
          // not a valid Unicode code point
          codePoint > 0x10FFFF ||
          // not a valid Unicode code point
          floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint);
          }
          if (codePoint <= 0xFFFF) {
            // BMP code point
            codeUnits.push(codePoint);
          } else {
            // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000;
            highSurrogate = (codePoint >> 10) + 0xD800;
            lowSurrogate = codePoint % 0x400 + 0xDC00;
            codeUnits.push(highSurrogate, lowSurrogate);
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits);
            codeUnits.length = 0;
          }
        }
        return result;
      };
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        });
      } else {
        String.fromCodePoint = fromCodePoint;
      }
    })();
  }
})(typeof exports === 'undefined' ? this.sax = {} : exports);

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":93,"stream":117,"string_decoder":118}],117:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;
var EE = require('events').EventEmitter;
var inherits = require('inherits');
inherits(Stream, EE);
Stream.Readable = require('readable-stream/readable.js');
Stream.Writable = require('readable-stream/writable.js');
Stream.Duplex = require('readable-stream/duplex.js');
Stream.Transform = require('readable-stream/transform.js');
Stream.PassThrough = require('readable-stream/passthrough.js');

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;

// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}
Stream.prototype.pipe = function (dest, options) {
  var source = this;
  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }
  source.on('data', ondata);
  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }
  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }
  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;
    dest.end();
  }
  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;
    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }
  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);
    source.removeListener('end', onend);
    source.removeListener('close', onclose);
    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);
    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);
    dest.removeListener('close', cleanup);
  }
  source.on('end', cleanup);
  source.on('close', cleanup);
  dest.on('close', cleanup);
  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":94,"inherits":98,"readable-stream/duplex.js":102,"readable-stream/passthrough.js":111,"readable-stream/readable.js":112,"readable-stream/transform.js":113,"readable-stream/writable.js":114}],118:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/
var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
    case 'raw':
      return true;
    default:
      return false;
  }
};
function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
}
;

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};
StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}
function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}
function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}
function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

},{"safe-buffer":115}],119:[function(require,module,exports){
(function (global){(function (){
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate(fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }
  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }
  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config(name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],120:[function(require,module,exports){
module.exports = {
  isArray: function (value) {
    if (Array.isArray) {
      return Array.isArray(value);
    }
    // fallback for older browsers like  IE 8
    return Object.prototype.toString.call(value) === '[object Array]';
  }
};

},{}],121:[function(require,module,exports){
/*jslint node:true */

var xml2js = require('./xml2js');
var xml2json = require('./xml2json');
var js2xml = require('./js2xml');
var json2xml = require('./json2xml');
module.exports = {
  xml2js: xml2js,
  xml2json: xml2json,
  js2xml: js2xml,
  json2xml: json2xml
};

},{"./js2xml":122,"./json2xml":123,"./xml2js":125,"./xml2json":126}],122:[function(require,module,exports){
var helper = require('./options-helper');
var isArray = require('./array-helper').isArray;
var currentElement, currentElementName;
function validateOptions(userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('indentText', options);
  helper.ensureFlagExists('indentCdata', options);
  helper.ensureFlagExists('indentAttributes', options);
  helper.ensureFlagExists('indentInstruction', options);
  helper.ensureFlagExists('fullTagEmptyElement', options);
  helper.ensureFlagExists('noQuotesForNativeAttributes', options);
  helper.ensureSpacesExists(options);
  if (typeof options.spaces === 'number') {
    options.spaces = Array(options.spaces + 1).join(' ');
  }
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  helper.checkFnExists('doctype', options);
  helper.checkFnExists('instruction', options);
  helper.checkFnExists('cdata', options);
  helper.checkFnExists('comment', options);
  helper.checkFnExists('text', options);
  helper.checkFnExists('instructionName', options);
  helper.checkFnExists('elementName', options);
  helper.checkFnExists('attributeName', options);
  helper.checkFnExists('attributeValue', options);
  helper.checkFnExists('attributes', options);
  helper.checkFnExists('fullTagEmptyElement', options);
  return options;
}
function writeIndentation(options, depth, firstLine) {
  return (!firstLine && options.spaces ? '\n' : '') + Array(depth + 1).join(options.spaces);
}
function writeAttributes(attributes, options, depth) {
  if (options.ignoreAttributes) {
    return '';
  }
  if ('attributesFn' in options) {
    attributes = options.attributesFn(attributes, currentElementName, currentElement);
  }
  var key,
    attr,
    attrName,
    quote,
    result = [];
  for (key in attributes) {
    if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== undefined) {
      quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== 'string' ? '' : '"';
      attr = '' + attributes[key]; // ensure number and boolean are converted to String
      attr = attr.replace(/"/g, '&quot;');
      attrName = 'attributeNameFn' in options ? options.attributeNameFn(key, attr, currentElementName, currentElement) : key;
      result.push(options.spaces && options.indentAttributes ? writeIndentation(options, depth + 1, false) : ' ');
      result.push(attrName + '=' + quote + ('attributeValueFn' in options ? options.attributeValueFn(attr, key, currentElementName, currentElement) : attr) + quote);
    }
  }
  if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) {
    result.push(writeIndentation(options, depth, false));
  }
  return result.join('');
}
function writeDeclaration(declaration, options, depth) {
  currentElement = declaration;
  currentElementName = 'xml';
  return options.ignoreDeclaration ? '' : '<?' + 'xml' + writeAttributes(declaration[options.attributesKey], options, depth) + '?>';
}
function writeInstruction(instruction, options, depth) {
  if (options.ignoreInstruction) {
    return '';
  }
  var key;
  for (key in instruction) {
    if (instruction.hasOwnProperty(key)) {
      break;
    }
  }
  var instructionName = 'instructionNameFn' in options ? options.instructionNameFn(key, instruction[key], currentElementName, currentElement) : key;
  if (typeof instruction[key] === 'object') {
    currentElement = instruction;
    currentElementName = instructionName;
    return '<?' + instructionName + writeAttributes(instruction[key][options.attributesKey], options, depth) + '?>';
  } else {
    var instructionValue = instruction[key] ? instruction[key] : '';
    if ('instructionFn' in options) instructionValue = options.instructionFn(instructionValue, key, currentElementName, currentElement);
    return '<?' + instructionName + (instructionValue ? ' ' + instructionValue : '') + '?>';
  }
}
function writeComment(comment, options) {
  return options.ignoreComment ? '' : '<!--' + ('commentFn' in options ? options.commentFn(comment, currentElementName, currentElement) : comment) + '-->';
}
function writeCdata(cdata, options) {
  return options.ignoreCdata ? '' : '<![CDATA[' + ('cdataFn' in options ? options.cdataFn(cdata, currentElementName, currentElement) : cdata.replace(']]>', ']]]]><![CDATA[>')) + ']]>';
}
function writeDoctype(doctype, options) {
  return options.ignoreDoctype ? '' : '<!DOCTYPE ' + ('doctypeFn' in options ? options.doctypeFn(doctype, currentElementName, currentElement) : doctype) + '>';
}
function writeText(text, options) {
  if (options.ignoreText) return '';
  text = '' + text; // ensure Number and Boolean are converted to String
  text = text.replace(/&amp;/g, '&'); // desanitize to avoid double sanitization
  text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return 'textFn' in options ? options.textFn(text, currentElementName, currentElement) : text;
}
function hasContent(element, options) {
  var i;
  if (element.elements && element.elements.length) {
    for (i = 0; i < element.elements.length; ++i) {
      switch (element.elements[i][options.typeKey]) {
        case 'text':
          if (options.indentText) {
            return true;
          }
          break;
        // skip to next key
        case 'cdata':
          if (options.indentCdata) {
            return true;
          }
          break;
        // skip to next key
        case 'instruction':
          if (options.indentInstruction) {
            return true;
          }
          break;
        // skip to next key
        case 'doctype':
        case 'comment':
        case 'element':
          return true;
        default:
          return true;
      }
    }
  }
  return false;
}
function writeElement(element, options, depth) {
  currentElement = element;
  currentElementName = element.name;
  var xml = [],
    elementName = 'elementNameFn' in options ? options.elementNameFn(element.name, element) : element.name;
  xml.push('<' + elementName);
  if (element[options.attributesKey]) {
    xml.push(writeAttributes(element[options.attributesKey], options, depth));
  }
  var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
  if (!withClosingTag) {
    if ('fullTagEmptyElementFn' in options) {
      withClosingTag = options.fullTagEmptyElementFn(element.name, element);
    } else {
      withClosingTag = options.fullTagEmptyElement;
    }
  }
  if (withClosingTag) {
    xml.push('>');
    if (element[options.elementsKey] && element[options.elementsKey].length) {
      xml.push(writeElements(element[options.elementsKey], options, depth + 1));
      currentElement = element;
      currentElementName = element.name;
    }
    xml.push(options.spaces && hasContent(element, options) ? '\n' + Array(depth + 1).join(options.spaces) : '');
    xml.push('</' + elementName + '>');
  } else {
    xml.push('/>');
  }
  return xml.join('');
}
function writeElements(elements, options, depth, firstLine) {
  return elements.reduce(function (xml, element) {
    var indent = writeIndentation(options, depth, firstLine && !xml);
    switch (element.type) {
      case 'element':
        return xml + indent + writeElement(element, options, depth);
      case 'comment':
        return xml + indent + writeComment(element[options.commentKey], options);
      case 'doctype':
        return xml + indent + writeDoctype(element[options.doctypeKey], options);
      case 'cdata':
        return xml + (options.indentCdata ? indent : '') + writeCdata(element[options.cdataKey], options);
      case 'text':
        return xml + (options.indentText ? indent : '') + writeText(element[options.textKey], options);
      case 'instruction':
        var instruction = {};
        instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
        return xml + (options.indentInstruction ? indent : '') + writeInstruction(instruction, options, depth);
    }
  }, '');
}
function hasContentCompact(element, options, anyContent) {
  var key;
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      switch (key) {
        case options.parentKey:
        case options.attributesKey:
          break;
        // skip to next key
        case options.textKey:
          if (options.indentText || anyContent) {
            return true;
          }
          break;
        // skip to next key
        case options.cdataKey:
          if (options.indentCdata || anyContent) {
            return true;
          }
          break;
        // skip to next key
        case options.instructionKey:
          if (options.indentInstruction || anyContent) {
            return true;
          }
          break;
        // skip to next key
        case options.doctypeKey:
        case options.commentKey:
          return true;
        default:
          return true;
      }
    }
  }
  return false;
}
function writeElementCompact(element, name, options, depth, indent) {
  currentElement = element;
  currentElementName = name;
  var elementName = 'elementNameFn' in options ? options.elementNameFn(name, element) : name;
  if (typeof element === 'undefined' || element === null || element === '') {
    return 'fullTagEmptyElementFn' in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? '<' + elementName + '></' + elementName + '>' : '<' + elementName + '/>';
  }
  var xml = [];
  if (name) {
    xml.push('<' + elementName);
    if (typeof element !== 'object') {
      xml.push('>' + writeText(element, options) + '</' + elementName + '>');
      return xml.join('');
    }
    if (element[options.attributesKey]) {
      xml.push(writeAttributes(element[options.attributesKey], options, depth));
    }
    var withClosingTag = hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
    if (!withClosingTag) {
      if ('fullTagEmptyElementFn' in options) {
        withClosingTag = options.fullTagEmptyElementFn(name, element);
      } else {
        withClosingTag = options.fullTagEmptyElement;
      }
    }
    if (withClosingTag) {
      xml.push('>');
    } else {
      xml.push('/>');
      return xml.join('');
    }
  }
  xml.push(writeElementsCompact(element, options, depth + 1, false));
  currentElement = element;
  currentElementName = name;
  if (name) {
    xml.push((indent ? writeIndentation(options, depth, false) : '') + '</' + elementName + '>');
  }
  return xml.join('');
}
function writeElementsCompact(element, options, depth, firstLine) {
  var i,
    key,
    nodes,
    xml = [];
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      nodes = isArray(element[key]) ? element[key] : [element[key]];
      for (i = 0; i < nodes.length; ++i) {
        switch (key) {
          case options.declarationKey:
            xml.push(writeDeclaration(nodes[i], options, depth));
            break;
          case options.instructionKey:
            xml.push((options.indentInstruction ? writeIndentation(options, depth, firstLine) : '') + writeInstruction(nodes[i], options, depth));
            break;
          case options.attributesKey:
          case options.parentKey:
            break;
          // skip
          case options.textKey:
            xml.push((options.indentText ? writeIndentation(options, depth, firstLine) : '') + writeText(nodes[i], options));
            break;
          case options.cdataKey:
            xml.push((options.indentCdata ? writeIndentation(options, depth, firstLine) : '') + writeCdata(nodes[i], options));
            break;
          case options.doctypeKey:
            xml.push(writeIndentation(options, depth, firstLine) + writeDoctype(nodes[i], options));
            break;
          case options.commentKey:
            xml.push(writeIndentation(options, depth, firstLine) + writeComment(nodes[i], options));
            break;
          default:
            xml.push(writeIndentation(options, depth, firstLine) + writeElementCompact(nodes[i], key, options, depth, hasContentCompact(nodes[i], options)));
        }
        firstLine = firstLine && !xml.length;
      }
    }
  }
  return xml.join('');
}
module.exports = function (js, options) {
  options = validateOptions(options);
  var xml = [];
  currentElement = js;
  currentElementName = '_root_';
  if (options.compact) {
    xml.push(writeElementsCompact(js, options, 0, true));
  } else {
    if (js[options.declarationKey]) {
      xml.push(writeDeclaration(js[options.declarationKey], options, 0));
    }
    if (js[options.elementsKey] && js[options.elementsKey].length) {
      xml.push(writeElements(js[options.elementsKey], options, 0, !xml.length));
    }
  }
  return xml.join('');
};

},{"./array-helper":120,"./options-helper":124}],123:[function(require,module,exports){
(function (Buffer){(function (){
var js2xml = require('./js2xml.js');
module.exports = function (json, options) {
  if (json instanceof Buffer) {
    json = json.toString();
  }
  var js = null;
  if (typeof json === 'string') {
    try {
      js = JSON.parse(json);
    } catch (e) {
      throw new Error('The JSON structure is invalid');
    }
  } else {
    js = json;
  }
  return js2xml(js, options);
};

}).call(this)}).call(this,require("buffer").Buffer)
},{"./js2xml.js":122,"buffer":93}],124:[function(require,module,exports){
var isArray = require('./array-helper').isArray;
module.exports = {
  copyOptions: function (options) {
    var key,
      copy = {};
    for (key in options) {
      if (options.hasOwnProperty(key)) {
        copy[key] = options[key];
      }
    }
    return copy;
  },
  ensureFlagExists: function (item, options) {
    if (!(item in options) || typeof options[item] !== 'boolean') {
      options[item] = false;
    }
  },
  ensureSpacesExists: function (options) {
    if (!('spaces' in options) || typeof options.spaces !== 'number' && typeof options.spaces !== 'string') {
      options.spaces = 0;
    }
  },
  ensureAlwaysArrayExists: function (options) {
    if (!('alwaysArray' in options) || typeof options.alwaysArray !== 'boolean' && !isArray(options.alwaysArray)) {
      options.alwaysArray = false;
    }
  },
  ensureKeyExists: function (key, options) {
    if (!(key + 'Key' in options) || typeof options[key + 'Key'] !== 'string') {
      options[key + 'Key'] = options.compact ? '_' + key : key;
    }
  },
  checkFnExists: function (key, options) {
    return key + 'Fn' in options;
  }
};

},{"./array-helper":120}],125:[function(require,module,exports){
var sax = require('sax');
var expat /*= require('node-expat');*/ = {
  on: function () {},
  parse: function () {}
};
var helper = require('./options-helper');
var isArray = require('./array-helper').isArray;
var options;
var pureJsParser = true;
var currentElement;
function validateOptions(userOptions) {
  options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('alwaysChildren', options);
  helper.ensureFlagExists('addParent', options);
  helper.ensureFlagExists('trim', options);
  helper.ensureFlagExists('nativeType', options);
  helper.ensureFlagExists('nativeTypeAttributes', options);
  helper.ensureFlagExists('sanitize', options);
  helper.ensureFlagExists('instructionHasAttributes', options);
  helper.ensureFlagExists('captureSpacesBetweenElements', options);
  helper.ensureAlwaysArrayExists(options);
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  helper.ensureKeyExists('parent', options);
  helper.checkFnExists('doctype', options);
  helper.checkFnExists('instruction', options);
  helper.checkFnExists('cdata', options);
  helper.checkFnExists('comment', options);
  helper.checkFnExists('text', options);
  helper.checkFnExists('instructionName', options);
  helper.checkFnExists('elementName', options);
  helper.checkFnExists('attributeName', options);
  helper.checkFnExists('attributeValue', options);
  helper.checkFnExists('attributes', options);
  return options;
}
function nativeType(value) {
  var nValue = Number(value);
  if (!isNaN(nValue)) {
    return nValue;
  }
  var bValue = value.toLowerCase();
  if (bValue === 'true') {
    return true;
  } else if (bValue === 'false') {
    return false;
  }
  return value;
}
function addField(type, value) {
  var key;
  if (options.compact) {
    if (!currentElement[options[type + 'Key']] && (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(options[type + 'Key']) !== -1 : options.alwaysArray)) {
      currentElement[options[type + 'Key']] = [];
    }
    if (currentElement[options[type + 'Key']] && !isArray(currentElement[options[type + 'Key']])) {
      currentElement[options[type + 'Key']] = [currentElement[options[type + 'Key']]];
    }
    if (type + 'Fn' in options && typeof value === 'string') {
      value = options[type + 'Fn'](value, currentElement);
    }
    if (type === 'instruction' && ('instructionFn' in options || 'instructionNameFn' in options)) {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          if ('instructionFn' in options) {
            value[key] = options.instructionFn(value[key], key, currentElement);
          } else {
            var temp = value[key];
            delete value[key];
            value[options.instructionNameFn(key, temp, currentElement)] = temp;
          }
        }
      }
    }
    if (isArray(currentElement[options[type + 'Key']])) {
      currentElement[options[type + 'Key']].push(value);
    } else {
      currentElement[options[type + 'Key']] = value;
    }
  } else {
    if (!currentElement[options.elementsKey]) {
      currentElement[options.elementsKey] = [];
    }
    var element = {};
    element[options.typeKey] = type;
    if (type === 'instruction') {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          break;
        }
      }
      element[options.nameKey] = 'instructionNameFn' in options ? options.instructionNameFn(key, value, currentElement) : key;
      if (options.instructionHasAttributes) {
        element[options.attributesKey] = value[key][options.attributesKey];
        if ('instructionFn' in options) {
          element[options.attributesKey] = options.instructionFn(element[options.attributesKey], key, currentElement);
        }
      } else {
        if ('instructionFn' in options) {
          value[key] = options.instructionFn(value[key], key, currentElement);
        }
        element[options.instructionKey] = value[key];
      }
    } else {
      if (type + 'Fn' in options) {
        value = options[type + 'Fn'](value, currentElement);
      }
      element[options[type + 'Key']] = value;
    }
    if (options.addParent) {
      element[options.parentKey] = currentElement;
    }
    currentElement[options.elementsKey].push(element);
  }
}
function manipulateAttributes(attributes) {
  if ('attributesFn' in options && attributes) {
    attributes = options.attributesFn(attributes, currentElement);
  }
  if ((options.trim || 'attributeValueFn' in options || 'attributeNameFn' in options || options.nativeTypeAttributes) && attributes) {
    var key;
    for (key in attributes) {
      if (attributes.hasOwnProperty(key)) {
        if (options.trim) attributes[key] = attributes[key].trim();
        if (options.nativeTypeAttributes) {
          attributes[key] = nativeType(attributes[key]);
        }
        if ('attributeValueFn' in options) attributes[key] = options.attributeValueFn(attributes[key], key, currentElement);
        if ('attributeNameFn' in options) {
          var temp = attributes[key];
          delete attributes[key];
          attributes[options.attributeNameFn(key, attributes[key], currentElement)] = temp;
        }
      }
    }
  }
  return attributes;
}
function onInstruction(instruction) {
  var attributes = {};
  if (instruction.body && (instruction.name.toLowerCase() === 'xml' || options.instructionHasAttributes)) {
    var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
    var match;
    while ((match = attrsRegExp.exec(instruction.body)) !== null) {
      attributes[match[1]] = match[2] || match[3] || match[4];
    }
    attributes = manipulateAttributes(attributes);
  }
  if (instruction.name.toLowerCase() === 'xml') {
    if (options.ignoreDeclaration) {
      return;
    }
    currentElement[options.declarationKey] = {};
    if (Object.keys(attributes).length) {
      currentElement[options.declarationKey][options.attributesKey] = attributes;
    }
    if (options.addParent) {
      currentElement[options.declarationKey][options.parentKey] = currentElement;
    }
  } else {
    if (options.ignoreInstruction) {
      return;
    }
    if (options.trim) {
      instruction.body = instruction.body.trim();
    }
    var value = {};
    if (options.instructionHasAttributes && Object.keys(attributes).length) {
      value[instruction.name] = {};
      value[instruction.name][options.attributesKey] = attributes;
    } else {
      value[instruction.name] = instruction.body;
    }
    addField('instruction', value);
  }
}
function onStartElement(name, attributes) {
  var element;
  if (typeof name === 'object') {
    attributes = name.attributes;
    name = name.name;
  }
  attributes = manipulateAttributes(attributes);
  if ('elementNameFn' in options) {
    name = options.elementNameFn(name, currentElement);
  }
  if (options.compact) {
    element = {};
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = {};
      var key;
      for (key in attributes) {
        if (attributes.hasOwnProperty(key)) {
          element[options.attributesKey][key] = attributes[key];
        }
      }
    }
    if (!(name in currentElement) && (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(name) !== -1 : options.alwaysArray)) {
      currentElement[name] = [];
    }
    if (currentElement[name] && !isArray(currentElement[name])) {
      currentElement[name] = [currentElement[name]];
    }
    if (isArray(currentElement[name])) {
      currentElement[name].push(element);
    } else {
      currentElement[name] = element;
    }
  } else {
    if (!currentElement[options.elementsKey]) {
      currentElement[options.elementsKey] = [];
    }
    element = {};
    element[options.typeKey] = 'element';
    element[options.nameKey] = name;
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = attributes;
    }
    if (options.alwaysChildren) {
      element[options.elementsKey] = [];
    }
    currentElement[options.elementsKey].push(element);
  }
  element[options.parentKey] = currentElement; // will be deleted in onEndElement() if !options.addParent
  currentElement = element;
}
function onText(text) {
  if (options.ignoreText) {
    return;
  }
  if (!text.trim() && !options.captureSpacesBetweenElements) {
    return;
  }
  if (options.trim) {
    text = text.trim();
  }
  if (options.nativeType) {
    text = nativeType(text);
  }
  if (options.sanitize) {
    text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  addField('text', text);
}
function onComment(comment) {
  if (options.ignoreComment) {
    return;
  }
  if (options.trim) {
    comment = comment.trim();
  }
  addField('comment', comment);
}
function onEndElement(name) {
  var parentElement = currentElement[options.parentKey];
  if (!options.addParent) {
    delete currentElement[options.parentKey];
  }
  currentElement = parentElement;
}
function onCdata(cdata) {
  if (options.ignoreCdata) {
    return;
  }
  if (options.trim) {
    cdata = cdata.trim();
  }
  addField('cdata', cdata);
}
function onDoctype(doctype) {
  if (options.ignoreDoctype) {
    return;
  }
  doctype = doctype.replace(/^ /, '');
  if (options.trim) {
    doctype = doctype.trim();
  }
  addField('doctype', doctype);
}
function onError(error) {
  error.note = error; //console.error(error);
}
module.exports = function (xml, userOptions) {
  var parser = pureJsParser ? sax.parser(true, {}) : parser = new expat.Parser('UTF-8');
  var result = {};
  currentElement = result;
  options = validateOptions(userOptions);
  if (pureJsParser) {
    parser.opt = {
      strictEntities: true
    };
    parser.onopentag = onStartElement;
    parser.ontext = onText;
    parser.oncomment = onComment;
    parser.onclosetag = onEndElement;
    parser.onerror = onError;
    parser.oncdata = onCdata;
    parser.ondoctype = onDoctype;
    parser.onprocessinginstruction = onInstruction;
  } else {
    parser.on('startElement', onStartElement);
    parser.on('text', onText);
    parser.on('comment', onComment);
    parser.on('endElement', onEndElement);
    parser.on('error', onError);
    //parser.on('startCdata', onStartCdata);
    //parser.on('endCdata', onEndCdata);
    //parser.on('entityDecl', onEntityDecl);
  }
  if (pureJsParser) {
    parser.write(xml).close();
  } else {
    if (!parser.parse(xml)) {
      throw new Error('XML parsing error: ' + parser.getError());
    }
  }
  if (result[options.elementsKey]) {
    var temp = result[options.elementsKey];
    delete result[options.elementsKey];
    result[options.elementsKey] = temp;
    delete result.text;
  }
  return result;
};

},{"./array-helper":120,"./options-helper":124,"sax":116}],126:[function(require,module,exports){
var helper = require('./options-helper');
var xml2js = require('./xml2js');
function validateOptions(userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureSpacesExists(options);
  return options;
}
module.exports = function (xml, userOptions) {
  var options, js, json, parentKey;
  options = validateOptions(userOptions);
  js = xml2js(xml, options);
  parentKey = 'compact' in options && options.compact ? '_parent' : 'parent';
  // parentKey = ptions.compact ? '_parent' : 'parent'; // consider this
  if ('addParent' in options && options.addParent) {
    json = JSON.stringify(js, function (k, v) {
      return k === parentKey ? '_' : v;
    }, options.spaces);
  } else {
    json = JSON.stringify(js, null, options.spaces);
  }
  return json.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
};

},{"./options-helper":124,"./xml2js":125}]},{},[88]);
